webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return langs; });
/* harmony export (immutable) */ __webpack_exports__["b"] = i10n;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__db_db_js__ = __webpack_require__(18);


var repos = {
  db: {
    err_no_resp: {
      en: 'no response',
      fi: 'ei vastausta'
    },
    err_not_supported: {
      en: 'not supported',
      fi: 'ei tuettu'
    },
    err_no_results: {
      en: 'no results',
      fi: 'ei tuloksia'
    },
    err_unknown: {
      en: 'unknown error',
      fi: 'tuntematon virhe'
    }
  },

  navbar: {
    results: {
      en: 'Results',
      fi: 'Tulokset'
    },

    logout: {
      en: 'Log out',
      fi: 'Kirjaudu ulos'
    }
  },

  home: {
    hdr_subtitle: {
      en: 'A reading aid for students and teachers',
      fi: 'Lukemisen apuväline oppilaille ja opettajille'
    },
    hdr_info_title: {
      en: function en(p1) {
        return 'As a ' + p1.toLowerCase() + ', you can';
      },
      fi: function fi(p1) {
        return p1 + ' voi';
      }
    },
    hdr_password_reset: {
      en: 'Send password reset notification to this email:',
      fi: 'Lähetä salasanan asetusviesti tähän osoitteeseen:'
    },

    btn_request_account: {
      en: 'Request an account',
      fi: 'Pyydä tilin luomista'
    },
    btn_forgot_password: {
      en: 'Forgot password?',
      fi: 'Unohditko salasanasi?'
    },
    btn_send: {
      en: 'Send',
      fi: 'Lähetä'
    },

    info_adm_1: {
      en: 'Add and list teachers',
      fi: 'Lisätä opettajia'
    },
    info_adm_2: {
      en: 'Move teachers to other school',
      fi: 'Siirtää opettajia toiseen kouluun'
    },
    info_adm_3: {
      en: 'Add and list students',
      fi: 'Lisätä oppilaita'
    },
    info_adm_4: {
      en: 'Move students to other school',
      fi: 'Siirtää oppilaita toiseen kouluun'
    },
    info_tch_1: {
      en: 'Add, list, edit and remove instructions',
      fi: 'Muokata tehtävien ohjeita'
    },
    info_tch_2: {
      en: 'Add, list, edit and remove classes',
      fi: 'Lisätä ja poistaa luokkia'
    },
    info_tch_3: {
      en: 'Add, list, edit and remove tasks',
      fi: 'Muokata tehtäviä'
    },
    info_tch_4: {
      en: 'Add students to classes, list them and remove',
      fi: 'Lisätä ja poistaa oppilaita luokista'
    },
    info_tch_5: {
      en: 'Assign tasks to students',
      fi: 'Lisätä tehtäviä oppilaille'
    },
    info_tch_6: {
      en: 'Create visalizations from data of tasks completed by students',
      fi: 'Luoda visualisointeja suoritetuista tehtävistä'
    },
    info_std_1: {
      en: 'List tasks assigned to complete',
      fi: 'Listata suorittamista odottavat tehtävät'
    },
    info_std_2: {
      en: 'Complete assignments',
      fi: 'Tehdä tehtäviä'
    },
    info_std_3: {
      en: 'List completed assignments',
      fi: 'Listata suoritetut tehtävät'
    },

    msg_connecting: {
      en: 'Connecting to database...',
      fi: 'Muodostetaan yhteyttä tietokantaan...'
    },
    msg_test_info: {
      en: 'Tested with',
      fi: 'Testattu selaimilla'
    },
    msg_contact_info: {
      en: 'School rectors and teachers, please contact us directly.',
      fi: 'Pyydämme että rehtorit ja opettajat ottavat meihin suoraan yhteyttä.'
    },
    msg_contact_uta: {
      en: 'University of Tampere',
      fi: 'Tampereen yliopisto'
    },
    msg_request_sent: {
      en: function en(p1) {
        return 'The registration request for "' + p1 + '" has been sent.';
      },
      fi: function fi(p1) {
        return 'Pyynt\xE4 rekister\xF6id\xE4 "' + p1 + '" on l\xE4hetetty.';
      }
    },
    msg_password_reset: {
      en: function en(p1) {
        return 'The password reset request has been sent to "' + p1 + '".';
      },
      fi: function fi(p1) {
        return 'Salasanan vaihtopyynt\xE4 on l\xE4hetetty k\xE4ytt\xF6j\xE4lle "' + p1 + '".';
      }
    },

    tit_registration: {
      en: 'Registration',
      fi: 'Rekisteröinti'
    },
    tit_pass_reset: {
      en: 'Password reset',
      fi: 'Salasanan vaihto'
    },

    err_password_reset: {
      en: function en(p1) {
        return 'Cannot send the password reset request to "' + p1 + '".';
      },
      fi: function fi(p1) {
        return 'Salasanan vaihtopyynn\xE4n l\xE4hetys k\xE4ytt\xF6j\xE4lle "' + p1 + '" ei onnistunut.';
      }
    },

    ws_err_title: {
      en: 'Communication with gaze tracker is blocked by the browser',
      fi: 'Selain estää yhteyden katseenseurantalaitteeseen'
    },
    ws_err_subtitle: {
      en: 'Please enable the communication and reload the page',
      fi: 'Salli yhteys ja lataa sivu uudestaan'
    },
    ws_unblock_1: {
      en: ['Navigate to', 'page. Agree to be careful if the browsers asks you to be so.'],
      fi: ['Navigoi sivulle', '. Lupaa olla varovainen jos selain pyytää sitä.']
    },
    ws_unblock_2: {
      en: ['Type', 'in the search box.'],
      fi: ['Kirjoita', 'hakuikkunaan.']
    },
    ws_unblock_3: {
      en: ['If the value of this parameter is', ', then double-click on it to change it to', '.'],
      fi: ['Jos tämän parametrin arvo on', ', kaksoisklikkaa sitä, jolloin arvoksi muuttuu', '.']
    },
    ws_unblock_4: {
      en: '(search "how to enable websocket over https" for you browser)',
      fi: '(etsi "how to enable websocket over https" selaimessasi)'
    }
  },

  assignments: {
    msg_removed_account: {
      en: 'This student account was removed from all schools and is considered as frozen. No tasks will be assigned to this account in future.',
      fi: 'Oppilaan tili on suljettu eikä sille voida antaa enää uusia tehtäviä.'
    },
    msg_no_assignments: {
      en: 'No assigned tasks yet',
      fi: 'Ei tehtäviä'
    },
    msg_no_completed: {
      en: 'No completed tasks yet',
      fi: 'Ei tehtäviä'
    },

    hdr_assignments: {
      en: 'Tasks to complete',
      fi: 'Tehtävät'
    },
    hdr_completed: {
      en: 'Completed tasks',
      fi: 'Valmiit tehtävät'
    },
    hdr_wpm: {
      en: 'WPM',
      fi: 'Sanat/Min'
    },

    tit_syllab: {
      en: 'Syllabifications',
      fi: 'Tavutuksia'
    },
    tit_voice: {
      en: 'Voice',
      fi: 'Ääni'
    },
    tit_rec: {
      en: 'Recording',
      fi: 'Äänitallenne'
    }
  },

  assignment: {
    btn_calib: {
      en: 'Calibrate',
      fi: 'Kalibroi'
    },
    btn_skip_calib: {
      en: 'Skip calibration',
      fi: 'Ohita kalibrointi'
    },
    btn_next: {
      en: 'Next',
      fi: 'Seuraava'
    },
    btn_finish: {
      en: 'Finish',
      fi: 'Lopeta'
    },
    btn_thanks: {
      en: 'Thank you!',
      fi: 'Kiitos!'
    },

    msg_tracking_lost: {
      en: 'Gaze tracking is not available',
      fi: 'Katseenseuranta ei ole käytettävissä'
    },
    msg_tracker_not_calibrated: {
      en: 'The tracker is not calibrated yet',
      fi: 'Katseenseurantaa ei ole vielä kalibroitu'
    },
    msg_calib_window_not_visible: {
      en: 'If you pressed CALIBRATE and calibration window is not visible, please minimize the browser: the calibration window is located below it.',
      fi: 'Jos valitsit KALIBROI ja kalibrointi-ikkuna ei ole näkyvissä, minimoi selaimen ikkuna: kalibrointi-ikkuna on sen alla.'
    },
    hdr_cannot_conect: {
      en: 'Cannot connect to a gaze tracker',
      fi: 'Katseenseurannan yhdistäminen ei onnistu'
    },
    msg_cannot_conect_1: {
      en: 'Possible reasons:',
      fi: 'Mahdollisia syitä:'
    },
    msg_cannot_conect_2: {
      en: 'ETU-Driver service is not running',
      fi: 'ETU-Driver service ei ole käynnissä'
    },
    msg_cannot_conect_3: {
      en: 'ETU-Driver service is running, but its WebSocket server is not enabled',
      fi: 'ETU-Driver service on käynnissä, mutta sen WebSocket serveriä ei ole sallittu'
    }
  },

  modal_error: {
    title: {
      en: 'Assignment error',
      fi: 'Tehtävän liittämisvirhe'
    }
  },

  teachers: {
    hdr_new: {
      en: 'Add teacher',
      fi: 'Uusi opettaja'
    },

    msg_no_teachers: {
      en: 'No teachers exists yet',
      fi: 'Opettajia ei ole vielä olemassa'
    },
    msg_moved: {
      en: 'The teacher was moved to another school',
      fi: 'Opettaja siirrettiin toiseen kouluun'
    },

    err_exists: {
      en: 'A teacher with this email exists already',
      fi: 'Opettaja, jolla on tämä osoite, on jo olemassa'
    },
    err_move: {
      en: 'Failed to move the teacher to another school',
      fi: 'Opettajan siirto toiseen kouluun ei onnistunut'
    }
  },

  students: {
    hdr_new: {
      en: 'New student',
      fi: 'Uusi oppilas'
    },

    msg_no_students: {
      en: 'No students exists yet',
      fi: 'Ei vielä oppilaita'
    },
    msg_moved: {
      en: 'The student was moved to another school',
      fi: 'Oppilas siirrettiin toiseen kouluun'
    },

    err_load_teacher: {
      en: 'Failed to load teacher\'s school',
      fi: 'Opettajan koulun lataus ei onnistunut'
    },
    err_exists: {
      en: 'A student with this email or ID exists already',
      fi: 'Oppilas, jolla on sama osoite tai tunnus, on jo olemassa'
    },
    err_move: {
      en: 'Failed to move the student to another school',
      fi: 'Oppilaan siirto toiseen kouluun ei onnistunut'
    },
    err_access_school: {
      en: 'Failed to access the student school',
      fi: 'Oppilaan kouluun ei saatu yhteyttä'
    }
  },

  instructions: {
    hdr_new: {
      en: 'New instruction',
      fi: 'Uusi ohje'
    },
    hdr_editor: {
      en: 'Instruction editor',
      fi: 'Ohjeiden muokkaus'
    },

    msg_no_instructions: {
      en: 'No instructions exists yet',
      fi: 'Ohjeita ei vielä olemassa'
    },

    err_exists: {
      en: 'An instructions of this name exists already',
      fi: 'Tämän niminen ohje on jo olemassa'
    },

    tit_edit: {
      en: 'Edit instruction',
      fi: 'Muokkaa ohjetta'
    },
    tit_delete: {
      en: 'Delete instruction',
      fi: 'Poista ohje'
    }
  },

  instruction_editor: {
    hdr_texts: {
      en: 'Texts',
      fi: 'Tekstit'
    },

    msg_instruction_invalid: {
      en: 'instruction is too short',
      fi: 'ohje on liian lyhyt'
    },

    ph_calib_inst: {
      en: 'Calibration instruction',
      fi: 'Kalibrointiohje'
    },
    ph_start_inst: {
      en: 'Start instruction',
      fi: 'Aloitusohje'
    },
    ph_first_page: {
      en: 'First page',
      fi: 'Ensimmäinen sivu'
    }
  },

  classes: {
    hdr_new: {
      en: 'New class',
      fi: 'Uusi luokka'
    },

    tit_delete_class: {
      en: 'Delete the class',
      fi: 'Poista luokka'
    },

    err_name_exists: {
      en: 'A class of this name exists already',
      fi: 'Tämän niminen luokka on jo olemassa'
    }
  },

  task_list: {
    btn_new: {
      en: 'Create new',
      fi: 'Luo uusi'
    },

    lbl_pages: {
      en: function en(p1) {
        return p1 + ' pages';
      },
      fi: function fi(p1) {
        return p1 + ' sivua';
      }
    },

    tit_edit: {
      en: function en(p1) {
        return p1 ? 'This task has recorded sessions' : 'Edit the task';
      },
      fi: function fi(p1) {
        return p1 ? 'Tätä tehtävää on jo suoritettu' : 'Muokkaa tehtävää';
      }
    },
    tit_copy: {
      en: 'Create a new task from the existing',
      fi: 'Luo uusi tehtävä vanhan perusteella'
    },
    tit_delete: {
      en: 'Delete the task',
      fi: 'Poista tehtävä'
    },

    msg_delete_warning: {
      en: 'All students assignments completed on this task will be deleted as well',
      fi: 'Myös kaikki tämän tehtävän suoritukset poistetaan'
    },
    msg_cancel_warning: {
      en: 'All changes will be lost. OK to continue?',
      fi: 'Muutoksia ei talletata. Jatketaanko?'
    },

    hdr_editor: {
      en: function en(p1) {
        return 'Task editor' + p1;
      },
      fi: function fi(p1) {
        return 'Teht\xE4vien muokkaus' + p1;
      }
    },

    err_same_name: {
      en: 'A task with the same name exists already',
      fi: 'Tämän niminen tehtävä on jo olemassa'
    }
  },

  student_list: {
    lbl_add: {
      en: 'Add an assignment',
      fi: 'Lisää tehtävä'
    },

    tit_remove: {
      en: 'Remove the student from this class',
      fi: 'Poista oppilas tästä luokasta'
    },
    tit_students: {
      en: 'Available students',
      fi: 'Mahdolliset oppilaat'
    },

    data_grade: {
      en: 'grade',
      fi: 'luokka-aste'
    },
    data_student: {
      en: 'student',
      fi: 'oppilas'
    },

    err_load_school: {
      en: 'Failed to load the teacher\'s school',
      fi: 'Opettajan koulun lataus ei onnistunut'
    },
    err_load_school_students: {
      en: 'Failed to load the school\'s students',
      fi: 'Koulun oppilaiden lataus ei onnistunut'
    },
    err_add_assig: {
      en: 'Failed to assign the task',
      fi: 'Tehtävän lisäys oppilaalle ei onnistunut'
    },
    err_remove_assig: {
      en: 'Failed to remove the assignment',
      fi: 'Tehtävän poisto ei onnistunut'
    },

    msg_students_added: {
      en: 'Students were added',
      fi: 'Oppilaat lisättiin'
    },
    msg_assig_added: {
      en: 'The task was assigned',
      fi: 'Tehtävä lisättiin oppilaalle'
    },
    msg_assig_removed: {
      en: 'The assignment was removed',
      fi: 'Tehtävä poistettiin oppilaalta'
    }
  },

  remove_warning: {
    header: {
      en: function en(p1) {
        return 'Deleting ' + p1;
      },
      fi: function fi(p1) {
        return 'Poistetaan ' + p1;
      }
    },
    warning: {
      en: function en(p1, p2) {
        return 'The ' + p1 + ' "' + p2 + '" will be deleted permanently';
      },
      fi: function fi(p1, p2) {
        return p1 + ' "' + p2 + '" poistetaan pysyv\xE4sti';
      } },
    continue: {
      en: 'Continue?',
      fi: 'Jatketaanko?'
    }
  },

  task_editor: {
    btn_preview: {
      en: 'Preview',
      fi: 'Esikatselu'
    },
    btn_set_default: {
      en: 'Set as default',
      fi: 'Muuta oletukseksi'
    },

    lbl_use_timeout: {
      en: 'Use timeout:',
      fi: 'Aikakatkaisu:'
    },
    lbl_minute: {
      en: 'min.',
      fi: 'min.'
    },
    lbl_record_audio: {
      en: 'Record audio',
      fi: 'Äänitä'
    },

    lbl_alignment: {
      en: 'Alignment',
      fi: 'Tasaus'
    },
    lbl_font: {
      en: 'Font',
      fi: 'Kirjasin'
    },
    lbl_formatting: {
      en: 'Formatting',
      fi: 'Muotoilu'
    },

    item_center: {
      en: 'center',
      fi: 'keskelle'
    },
    item_left: {
      en: 'left',
      fi: 'vasemmalle'
    },
    item_none: {
      en: 'none',
      fi: 'ei mitään'
    },

    msg_not_editable: {
      en: 'The task contains images bound to words and therefore its text cannot be modified.',
      fi: 'Tehtävässä on sanoihin sidottuja kuvia ja siksi sen tekstiä ei voi muokata.'
    }
  },

  task_editor_feedback: {
    lbl_speech: {
      en: 'Speech',
      fi: 'Puhe'
    },
    lbl_syllab: {
      en: 'Syllabification',
      fi: 'Tavutus'
    },
    lbl_highlight: {
      en: 'Highlighting',
      fi: 'Highlighting' },
    lbl_warning: {
      en: 'Warning',
      fi: 'Warning' },
    lbl_phrase: {
      en: 'Phrase',
      fi: 'Phrase' },
    lbl_syllabs: {
      en: 'Syllabifications',
      fi: 'Tavutukset'
    },
    lbl_temp: {
      en: 'temporary',
      fi: 'hetkellinen'
    },
    lbl_word: {
      en: 'word-length dependent',
      fi: 'sanan pituudesta riippuva'
    },
    lbl_exceptions: {
      en: 'Exceptions',
      fi: 'Poikkeukset'
    },
    lbl_example: {
      en: 'Example: maailma=maa il ma',
      fi: 'Esimerkki: maailma=maa il ma'
    },
    lbl_enabled: {
      en: 'Enabled',
      fi: 'Enabled' },

    item_none: {
      en: 'none',
      fi: 'ei käytössä'
    },
    item_fixed: {
      en: 'fixed',
      fi: 'kiinteä'
    },
    item_calib: {
      en: 'calibrated',
      fi: 'kalibroitu'
    },
    item_colors: {
      en: 'colors',
      fi: 'värit'
    },
    item_hyphen: {
      en: 'hyphen',
      fi: 'tavuviiva'
    }
  },

  task_editor_images: {
    lbl_preview: {
      en: 'Preview',
      fi: 'Esikatselu'
    },
    lbl_page: {
      en: 'Page',
      fi: 'Sivu'
    },
    lbl_location: {
      en: 'Location',
      fi: 'Paikka'
    },
    lbl_size: {
      en: 'Size',
      fi: 'Koko'
    },
    lbl_on: {
      en: 'On',
      fi: 'Käytössä'
    },
    lbl_off: {
      en: 'Off',
      fi: 'Ei käytössä'
    },
    lbl_keep_size: {
      en: function en(p1) {
        return p1 ? 'original' : 'shrinked';
      },
      fi: function fi(p1) {
        return p1 ? 'alkuperäinen' : 'pienennetty';
      }
    },
    lbl_bytes: {
      en: 'bytes',
      fi: 'tavua'
    },
    lbl_pixels: {
      en: 'pixels from',
      fi: 'pikseliä'
    },
    lbl_show: {
      en: 'Show',
      fi: 'Näytä'
    },
    lbl_at: {
      en: 'at',
      fi: 'sanassa'
    },
    lbl_longer: {
      en: 'longer than',
      fi: 'yli'
    },
    lbl_hide: {
      en: 'Hide',
      fi: 'Piilota'
    },
    lbl_seconds: {
      en: 'seconds',
      fi: 'sekuntia'
    },

    msg_no_images: {
      en: 'No images',
      fi: 'Ei kuvia'
    },
    msg_choose: {
      en: 'Choose an image…',
      fi: 'Valitse kuva…'
    },
    msg_drag: {
      en: 'or drag it here',
      fi: 'tai raahaa se tähän'
    },
    msg_fix_on_word: {
      en: 'fixation on word',
      fi: 'fiksaatio sanassa' },

    tit_params: {
      en: 'Edit the image appearance parameters',
      fi: 'Muokkaa kuvan esityksen parametreja'
    },
    tit_remove: {
      en: 'Remove the image',
      fi: 'Poista kuva'
    },

    item_any: {
      en: 'any',
      fi: 'kaikki'
    },
    item_left: {
      en: 'left',
      fi: 'vasemmalta'
    },
    item_bottom: {
      en: 'bottom',
      fi: 'alareunasta'
    },
    item_right: {
      en: 'right',
      fi: 'oikealta'
    },
    item_original: {
      en: 'original',
      fi: 'alkuperäinen'
    },
    item_15: {
      en: '15% of width / height',
      fi: '15% alkuperäisestä'
    },
    item_initially: {
      en: 'initially',
      fi: 'heti'
    },
    item_on_fix: {
      en: 'on fixation',
      fi: 'fiksaatiolle'
    },
    item_never: {
      en: 'never',
      fi: 'ei koskaan'
    },
    item_when_other: {
      en: 'when other image is shown',
      fi: 'kun toinen kuva näytetään'
    },
    item_after: {
      en: 'after',
      fi: 'kun on kulunut'
    },

    btn_upload: {
      en: 'Upload',
      fi: 'Lataa'
    },

    err_image_type: {
      en: 'Only JPEG and PNG images are supported',
      fi: 'Vain JPEG ja PNG kuvat sallitaan'
    },
    err_image_size: {
      en: 'File size must not exceed 100 kB',
      fi: 'Tiedoston koko saa olla enintään 100 kB'
    },
    err_upload: {
      en: 'Cannot upload the file',
      fi: 'Tiedoston lataus ei onnistu'
    }
  },

  task_editor_quest: {
    lbl_for: {
      en: 'For',
      fi: 'Kysytään'
    },
    lbl_text: {
      en: 'Text',
      fi: 'Teksti'
    },

    item_text: {
      en: 'whole text',
      fi: 'tekstin lopussa'
    },
    item_word: {
      en: 'long-gazed word',
      fi: 'jos sanaa on katsottu kauan'
    },

    ph_word: {
      en: 'Word',
      fi: 'Sana'
    },
    ph_question: {
      en: 'Question',
      fi: 'Kysymys'
    },
    ph_answer: {
      en: 'answer',
      fi: 'vastaus'
    }
  },

  task_text_format: {
    rules: {
      en: 'Rules',
      fi: 'Säännöt'
    },
    empty_line: {
      en: 'Empty line',
      fi: 'Tyhjä rivi'
    },
    separator: {
      en: 'page separator',
      fi: 'erottaa sivut'
    },
    styles: {
      en: 'applies comma-separated styles listed afterward for',
      fi: 'edeltää pilkulla erotettuja muotoiluohjeita'
    },
    word: {
      en: 'a word',
      fi: 'sanalle'
    },
    line: {
      en: 'a line',
      fi: 'riville'
    },
    lighter: {
      en: '25% lighter than the normal text',
      fi: '25% vaaleampi kuin tekstin oletusväri'
    },
    darker: {
      en: '25% darker than the normal text',
      fi: '25% tummempi kuin tekstin oletusväri'
    },
    color: {
      en: 'font color',
      fi: 'tekstin väri'
    },
    size: {
      en: 'font size',
      fi: 'tekstikoko'
    },
    style: {
      en: 'font style',
      fi: 'tekstin kursivointi'
    },
    weight: {
      en: 'font weight',
      fi: 'tekstin lihavointi'
    },
    example: {
      en: 'Example',
      fi: 'Esimerkki'
    }
  },

  selection_box: {
    lbl_select: {
      en: function en(p1) {
        return 'Select a ' + p1;
      },
      fi: function fi(p1) {
        return 'Valitse ' + p1;
      }
    },
    lbl_no_avail: {
      en: function en(p1) {
        return 'Not available ' + p1;
      },
      fi: function fi(p1) {
        return p1 + ' ei k\xE4ytett\xE4viss\xE4';
      }
    },

    btn_select: {
      en: 'Select',
      fi: 'Valitse'
    },
    btn_select_all: {
      en: 'Select all',
      fi: 'Valitse kaikki'
    },
    btn_remove_all: {
      en: 'Remove all selections',
      fi: 'Poista kaikki valinnat'
    }
  },

  preview: {
    lbl_syllab_word: {
      en: 'Ctrl + click on a word to syllabify it',
      fi: 'Ctrl + click sanan kohdalla tavuttaa sen'
    },
    lbl_speak_word: {
      en: 'Alt + click on a word to pronounce it',
      fi: 'Alt + click sanan kohdalla puhuu sanan ääneen'
    },

    btn_syllab_all: {
      en: 'Syllabify all',
      fi: 'Tavuta kaikki'
    },
    btn_close: {
      en: 'Close',
      fi: 'Sulje'
    }
  },

  results: {
    msg_no_data: {
      en: 'No data was recorded yet',
      fi: 'Dataa ei vielä ole tallennettu'
    },

    btn_durations: {
      en: 'Durations',
      fi: 'Kestot'
    },
    btn_gaze_plot: {
      en: 'Gaze plot',
      fi: 'Katsepolku'
    },
    btn_gaze_replay: {
      en: 'Gaze replay',
      fi: 'Katsepolun toisto'
    },
    btn_audio_replay: {
      en: 'Audio replay',
      fi: 'Äänityksen toisto'
    },
    btn_word_replay: {
      en: 'Word replay',
      fi: 'Sanataulukko'
    },
    btn_questionnaire: {
      en: 'Questionnaire',
      fi: 'Kyselytulokset'
    },
    btn_summary: {
      en: 'Summary',
      fi: 'Yhteenveto'
    },
    btn_edit: {
      en: 'Edit',
      fi: 'Muokkaa'
    },

    data_grade: {
      en: 'grade',
      fi: 'luokka-aste'
    },
    data_student: {
      en: 'student',
      fi: 'oppilas'
    },
    data_session: {
      en: 'session',
      fi: 'suoritus'
    },

    tit_sessions: {
      en: function en(p1) {
        return 'Sessions by ' + p1;
      },
      fi: function fi(p1) {
        return 'Oppilaan ' + p1 + ' suoritukset';
      }
    },
    tit_students: {
      en: function en(p1) {
        return 'Students completed "' + p1 + '"';
      },
      fi: function fi(p1) {
        return 'Teht\xE4v\xE4n "' + p1 + '" suorittaneet';
      }
    },
    tit_students_of: {
      en: function en(p1) {
        return 'students of "' + p1 + '"';
      },
      fi: function fi(p1) {
        return 'luokan "' + p1 + '" oppilaat';
      }
    },

    err_load_classes: {
      en: 'Failed to load classes',
      fi: 'Luokkien lataus ei onnistunut'
    },
    err_load_student: {
      en: 'Failed to load student data',
      fi: 'Oppilaan datojen lataus ei onnistunut'
    }
  },

  session_box: {
    err_delete: {
      en: 'Failed to delete the session',
      fi: 'Suorituksen lataus ei onnistunut'
    }
  },

  audio: {
    play: {
      en: 'Play',
      fi: 'Toista'
    },
    pause: {
      en: 'Pause',
      fi: 'Pysäytä'
    }
  },

  control_panel: {
    tit_speech: {
      en: 'Speech output',
      fi: 'Äänivihjeet käytössä'
    },
    tit_syllab: {
      en: 'Syllabification',
      fi: 'Tavutus käytössä'
    },
    tit_quest: {
      en: 'Questionnaire correctness',
      fi: 'Kysely käytössä'
    },
    tit_prev: {
      en: 'Previous page',
      fi: 'Edellinen sivu'
    },
    tit_next: {
      en: 'Next page',
      fi: 'Seuraava sivu'
    },
    tit_settings: {
      en: 'Settings',
      fi: 'Asetukset'
    },
    tit_close: {
      en: 'Close this visualization',
      fi: 'Sulje tämä visualisointi'
    },

    lbl_intro: {
      en: 'intro',
      fi: 'intro'
    }
  },

  vis: {
    hdr_commons: {
      en: 'Common',
      fi: 'Yleiset'
    },
    hdr_reading: {
      en: function en(p1, p2, p3) {
        return p1 + ' reading "' + p2 + '" at ' + p3;
      },
      fi: function fi(p1, p2, p3) {
        return p1 + ' teht\xE4v\xE4ss\xE4 "' + p2 + '" kello ' + p3;
      }
    },
    hdr_quest: {
      en: function en(p1) {
        return 'Questionnaire results in "' + p1 + '"';
      },
      fi: function fi(p1) {
        return 'Kyselytulokset teht\xE4v\xE4ss\xE4 "' + p1 + '"';
      }
    },
    hdr_missing_data: {
      en: 'Missing data',
      fi: 'Data puuttuu'
    },
    hdr_total: {
      en: 'Total',
      fi: 'Yhteensä'
    },

    lbl_text_color: {
      en: 'Text color',
      fi: 'Tekstin väri'
    },
    lbl_hl_color: {
      en: 'Highlighting color',
      fi: 'Korostusväri'
    },
    lbl_frame_color: {
      en: 'Word frame color',
      fi: 'Sanan kehysväri'
    },
    lbl_draw_frame: {
      en: 'Draw word frame',
      fi: 'Piirrä sanoille kehys'
    },
    lbl_word_color: {
      en: 'Word color metric',
      fi: 'Sanojen väritysperuste'
    },
    lbl_syllab_back: {
      en: 'Syllabification background',
      fi: 'Tavutetun sanan tausta'
    },
    lbl_syllab_word: {
      en: 'Syllabification word color',
      fi: 'Tavutetun sanan väri'
    },

    msg_missing_data: {
      en: 'Fixation data is missing on this page',
      fi: 'Tällä sivulla ei ole katsedataa'
    },

    item_none: {
      en: 'none',
      fi: 'ei käytössä'
    },
    item_dur: {
      en: 'duration',
      fi: 'kesto'
    },
    item_char: {
      en: 'char speed',
      fi: 'nopeus (merkkiä)'
    },
    item_focus: {
      en: 'focus count',
      fi: 'lukukertojen määrä'
    }
  },

  vis_gaze_plot: {
    hdr_options: {
      en: 'Gaze Plot',
      fi: 'Katsepolku'
    },

    lbl_sacc_color: {
      en: 'Saccade color',
      fi: 'Sakkaadien väri'
    },
    lbl_reg_sacc_color: {
      en: 'Regressive saccade color',
      fi: 'Regressioiden väri'
    },
    lbl_show_conn: {
      en: 'Show word-fixation connections',
      fi: 'Näytä sana-fiksaatio viivat'
    },
    lbl_show_sacc: {
      en: 'Show saccades',
      fi: 'Näytä sakkaadit'
    },
    lbl_show_fix: {
      en: 'Show fixations',
      fi: 'Näytä fiksaatiot'
    }
  },

  vis_durations: {
    hdr_dur: {
      en: function en(p1, p2) {
        return 'Word reading durations in "' + p2 + '"' + (p1 ? ' for ' + p1 : '');
      },
      fi: function fi(p1, p2) {
        return 'Sanojen lukuajat teht\xE4v\xE4ss\xE4 "' + p2 + '"' + (p1 ? ' oppilaalle ' + p1 : '');
      }
    },
    hdr_options: {
      en: 'Durations',
      fi: 'Kestot'
    },

    item_seconds: {
      en: 'seconds',
      fi: 'sekuntia'
    },
    item_percentage: {
      en: 'percentage',
      fi: 'prosenttia'
    },
    item_ms_char: {
      en: 'ms/char',
      fi: 'ms/kirje'
    },

    lbl_units: {
      en: 'Units',
      fi: 'Yksiköt'
    }
  },

  vis_word_replay: {
    hdr_word_replay: {
      en: function en(p1, p2) {
        return 'Word replay in "' + p2 + '"' + (p1 ? ' for ' + p1 : '');
      },
      fi: function fi(p1, p2) {
        return 'Sanataulukko teht\xE4v\xE4ss\xE4 "' + p2 + '"' + (p1 ? ' oppilaalle ' + p1 : '');
      }
    },
    hdr_options: {
      en: 'Word replay',
      fi: 'Sanataulukko'
    },

    lbl_done: {
      en: 'done',
      fi: 'valmis'
    },
    lbl_no_data: {
      en: 'no data',
      fi: 'ei dataa'
    },
    lbl_level_dur: {
      en: 'Level duration',
      fi: 'Tason kesto'
    }
  },

  vis_gaze_replay: {
    lbl_font: {
      en: 'Name font',
      fi: 'Nimen fontti'
    },
    lbl_font_size: {
      en: 'Name font size',
      fi: 'Nimen fonttikoko'
    },
    lbl_spacing: {
      en: 'Name spacing',
      fi: 'Nimen rivinväli'
    },

    hdr_gaze_replay: {
      en: function en(p1, p2) {
        return 'Gaze replay in "' + p2 + '"' + (p1 ? ' for ' + p1 : '');
      },
      fi: function fi(p1, p2) {
        return 'Katsepolun toisto teht\xE4v\xE4ss\xE4 "' + p2 + '"' + (p1 ? ' oppilaalle ' + p1 : '');
      }
    },
    hdr_options: {
      en: 'Gaze Replay',
      fi: 'Katsepolun toisto'
    }
  },

  vis_summary: {
    tit_wpm: {
      en: 'Words per minute',
      fi: 'Sanoja minuutissa'
    },
    tit_sylpm: {
      en: 'Syllables per minute (sessions)',
      fi: 'Tavuja minuutissa (suorituksia)'
    },
    tit_spw: {
      en: 'Seconds per word',
      fi: 'Sekuntia per sana'
    },
    tit_fd: {
      en: 'Average fixation duration in milliseconds',
      fi: 'Fiksaation kesto keskimäärin (millisekuntia)'
    },
    tit_fsd: {
      en: 'Fixation standard deviation in milliseconds',
      fi: 'Fiksaatioiden keston keskihajonta (millisekuntia)'
    },
    tit_syllabs: {
      en: 'Syllabifications',
      fi: 'Tavutuksia'
    },
    tit_regrs: {
      en: 'Regressions',
      fi: 'Regressioita'
    },

    lbl_time: {
      en: 'Reading time',
      fi: 'Lukuaika'
    },
    lbl_wpm: {
      en: 'WPM',
      fi: 'WPM'
    },
    lbl_spm: {
      en: 'SPM',
      fi: 'SPM'
    },
    lbl_spw: {
      en: 'SPW',
      fi: 'SPW'
    },
    lbl_fix: {
      en: 'Fixation',
      fi: 'Fiksaatio'
    },
    lbl_fsd: {
      en: 'FSD',
      fi: 'FSD'
    }
  },

  player: {
    tit_restart: {
      en: 'Restart',
      fi: 'Käynnistä alusta'
    },
    tit_pause_cont: {
      en: 'Pause / Continue',
      fi: 'Pysäytä / Jatka'
    }
  },

  options: {
    hdr_settings: {
      en: 'Settings',
      fi: 'Asetukset'
    },

    btn_apply: {
      en: 'Apply',
      fi: 'Käytä'
    },
    btn_save_close: {
      en: 'Save and close',
      fi: 'Tallenna ja sulje'
    },
    btn_reset: {
      en: 'Reset',
      fi: 'Palauta'
    }
  },

  sgwm: {
    hdr_data_map: {
      en: 'Data mapping',
      fi: 'Datan tulkinta'
    },
    hdr_fix_proc: {
      en: 'Fixation processing',
      fi: 'Fiksaatioiden käsittely'
    },
    hdr_splitter: {
      en: 'Splitter',
      fi: 'Alue'
    },
    hdr_merger: {
      en: 'Merger',
      fi: 'Yhdistäminen'
    },
    hdr_word_map: {
      en: 'Word mapper',
      fi: 'Liittäminen sanoihin'
    },

    lbl_loc: {
      en: 'By location',
      fi: 'Paikan perusteella'
    },
    lbl_dur: {
      en: 'By duration',
      fi: 'Keston perusteella'
    },
    lbl_margin: {
      en: function en(p1) {
        return 'margin ' + p1 + ', px';
      },
      fi: function fi(p1) {
        return p1 + '-marginaali, px';
      }
    },
    lbl_merge_th: {
      en: 'merging threshold, ms',
      fi: 'yhdistämisen kynnysarvo, ms'
    },
    lbl_merge_dist: {
      en: 'merging distance, px',
      fi: 'yhdistämisetäisyys, px'
    },
    lbl_min_dur: {
      en: 'min duration, ms',
      fi: 'vähimmäiskesto, ms'
    },

    lbl_left_margin: {
      en: 'Left margin, chars',
      fi: 'Vasen reuna, merkkiä'
    },
    lbl_right_margin: {
      en: 'Right margin, chars',
      fi: 'Oikea reuna, merkkiä'
    },
    lbl_v_margin_char: {
      en: 'Vertical margin, chars',
      fi: 'Vertikaaliero, merkkiä'
    },
    lbl_v_margin_lines: {
      en: 'Vertical margin, lines',
      fi: 'Vertikaaliero, rivejä'
    },
    lbl_incline: {
      en: 'Max incline, rad',
      fi: 'Enimmäiskulma, astetta'
    },

    lbl_short_prog: {
      en: 'Shortest progression, fixations',
      fi: 'Fiksaatioita vähintään'
    },
    lbl_line_sep: {
      en: 'Line separation threshold, lines',
      fi: 'Rivivälin kynnysarvo, rivejä'
    },
    lbl_line_incline: {
      en: 'Max line incline, rad',
      fi: 'Rivin enimmäiskulma, astetta'
    },
    lbl_remove_fix: {
      en: 'Remove unmerged single fixations',
      fi: 'Poista yhdistämättämät yksittäiset fiksaatiot'
    },
    lbl_empty_lines: {
      en: 'Account for empty lines',
      fi: 'Käsittele tyhjät rivit'
    },
    lbl_support_line: {
      en: 'support current line by',
      fi: 'nykyisen rivin painokerroin'
    },
    lbl_empty_line: {
      en: 'empty line factor, lines',
      fi: 'tyhjien rivien kerroin, rivejä'
    },
    lbl_first_line: {
      en: 'Intelligent first reading line search',
      fi: 'Salli ensimmäisen rivin poikkeuskäsittely'
    },

    lbl_skip_start: {
      en: 'Skip from start, chars',
      fi: 'Alusta ohitettavia merkkejä'
    },
    lbl_skip_end: {
      en: 'Skip from end, chars',
      fi: 'Lopusta ohitettavia merkkejä'
    },
    lbl_scale: {
      en: 'Scaling diff limit',
      fi: 'Skaalausraja'
    },
    lbl_rescale: {
      en: 'Rescale fixations horizontally',
      fi: 'Skaalaa fiksaatiot uudelleen vaakasuunnassa'
    },
    lbl_short_word: {
      en: 'short word, chars',
      fi: 'lyhyet sanat, merkkejä'
    },
    lbl_limit: {
      en: 'limit to',
      fi: 'enintään'
    },
    lbl_ignore_trans: {
      en: 'Ignore transitions',
      fi: 'Älä huomioi siirtymiä'
    }
  },

  _utils: {
    num_student: {
      en: function en(p1) {
        return p1 && p1.length ? p1.length + ' student' + (p1.length !== 1 ? 's' : '') : 'No students';
      },
      fi: function fi(p1) {
        return p1 && p1.length ? p1.length + ' oppilas' + (p1.length !== 1 ? 'ta' : '') : 'Ei oppilaita';
      }
    },
    num_task: {
      en: function en(p1) {
        return p1 && p1.length ? p1.length + ' task' + (p1.length !== 1 ? 's' : '') : 'No tasks';
      },
      fi: function fi(p1) {
        return p1 && p1.length ? p1.length + ' tehtävä' + (p1.length !== 1 ? 'ä' : '') : 'Ei tehtäviä';
      }
    }
  },

  _buttons: {
    manual: {
      en: 'Manual',
      fi: 'Ohjesivut'
    },
    create: {
      en: 'Create',
      fi: 'Luo'
    },
    save: {
      en: 'Save',
      fi: 'Tallenna'
    },
    ok: {
      en: 'OK',
      fi: 'OK'
    },
    cancel: {
      en: 'Cancel',
      fi: 'Peruuta'
    },
    add: {
      en: 'Add',
      fi: 'Lisää'
    },
    start: {
      en: 'Start',
      fi: 'Aloita'
    }
  },

  _form: {
    name: {
      en: 'Name',
      fi: 'Nimi'
    },
    email: {
      en: 'Email',
      fi: 'Sähköposti'
    },
    email_id: {
      en: 'Email or ID',
      fi: 'Sähköposti tai tunnus'
    },
    password: {
      en: 'Password',
      fi: 'Salasana'
    },

    name_invalid: {
      en: 'name is too short',
      fi: 'nimi on liian lyhyt'
    },
    email_invalid: {
      en: 'email is not valid',
      fi: 'sähköposti on väärässä muodossa'
    },
    password_invalid: {
      en: 'password is too short',
      fi: 'salasana on liian lyhyt'
    }
  },

  _labels: {
    admin: {
      en: 'admin',
      fi: 'ylläpitäjä'
    },
    school: {
      en: 'School',
      fi: 'Koulu'
    },
    schools: {
      en: 'Schools',
      fi: 'Koulut'
    },
    teacher: {
      en: 'Teacher',
      fi: 'Opettaja'
    },
    teachers: {
      en: 'Teachers',
      fi: 'Opettajat'
    },
    student: {
      en: 'Student',
      fi: 'Oppilas'
    },
    students: {
      en: 'Students',
      fi: 'Oppilaat'
    },
    instruction: {
      en: 'Instruction',
      fi: 'Ohje'
    },
    instructions: {
      en: 'Instructions',
      fi: 'Ohjeet'
    },
    class: {
      en: 'Class',
      fi: 'Luokka'
    },
    classes: {
      en: 'Classes',
      fi: 'Luokat'
    },
    grade: {
      en: 'Grade',
      fi: 'Luokka-aste'
    },
    task: {
      en: 'Task',
      fi: 'Tehtävä'
    },
    tasks: {
      en: 'Tasks',
      fi: 'Tehtävät'
    },
    actions: {
      en: 'Actions',
      fi: 'Toimenpiteet'
    },
    text: {
      en: 'Text',
      fi: 'Teksti'
    },
    image: {
      en: 'Image',
      fi: 'Kuva'
    },
    images: {
      en: 'Images',
      fi: 'Kuvat'
    },
    assignments: {
      en: 'Assignments',
      fi: 'Tehtävät'
    },
    sessions: {
      en: 'Sessions',
      fi: 'Suoritukset'
    },
    date: {
      en: 'Date',
      fi: 'Aika'
    },
    feedback: {
      en: 'Feedback',
      fi: 'Palaute'
    },
    questionnaire: {
      en: 'Questionnaire',
      fi: 'Kysely'
    }
  },

  _failures: {
    load: {
      en: function en(p1) {
        return 'Failed to load ' + p1.toLowerCase();
      },
      fi: function fi(p1) {
        return 'Lataus ep\xE4onnistui: ' + p1.toLowerCase();
      }
    },
    create_new: {
      en: function en(p1) {
        return 'Failed to create ' + p1.toLowerCase();
      },
      fi: function fi(p1) {
        return 'Luonti ep\xE4onnistui: ' + p1.toLowerCase();
      }
    },
    add_new: {
      en: function en(p1) {
        return 'Failed to add a new ' + p1.toLowerCase();
      },
      fi: function fi(p1) {
        return 'Ei voitu luoda uutta: ' + p1.toLowerCase();
      }
    },
    update: {
      en: function en(p1) {
        return 'Failed to update the ' + p1.toLowerCase();
      },
      fi: function fi(p1) {
        return 'Ei voitu p\xE4ivitt\xE4\xE4: ' + p1.toLowerCase();
      }
    },
    delete: {
      en: function en(p1) {
        return 'Failed to delete the ' + p1.toLowerCase();
      },
      fi: function fi(p1) {
        return 'Ei voitu poistaa: ' + p1.toLowerCase();
      }
    },
    remove: {
      en: function en(p1) {
        return 'Failed to remove the ' + p1.toLowerCase();
      },
      fi: function fi(p1) {
        return 'Ei voitu poistaa: ' + p1.toLowerCase();
      }
    },

    added: {
      en: function en(p1) {
        return 'The ' + p1.toLowerCase() + ' was added';
      },
      fi: function fi(p1) {
        return p1 + ' lis\xE4ttiin';
      }
    },
    created: {
      en: function en(p1) {
        return 'The ' + p1.toLowerCase() + ' was created';
      },
      fi: function fi(p1) {
        return p1 + ' luotiin';
      }
    },
    updated: {
      en: function en(p1) {
        return 'The ' + p1.toLowerCase() + ' was updated';
      },
      fi: function fi(p1) {
        return p1 + ' p\xE4ivitettiin';
      }
    },
    deleted: {
      en: function en(p1) {
        return 'The ' + p1.toLowerCase() + ' was deleted';
      },
      fi: function fi(p1) {
        return p1 + ' poistettiin';
      }
    },
    removed: {
      en: function en(p1) {
        return 'The ' + p1.toLowerCase() + ' was removed';
      },
      fi: function fi(p1) {
        return p1 + ' poistettiin';
      }
    }
  }
};

function proxyHandler(repoNames) {
  return {
    get: function get(obj, prop) {
      if (!(prop in obj) && typeof prop === 'string' && prop != '_isVue') {
        console.error('[i10n] ' + prop + ' not in ' + repoNames);
      }
      return obj[prop];
    }
  };
}

var langs = ['en', 'fi'];

function i10n() {
  var result = {};

  var lang = __WEBPACK_IMPORTED_MODULE_0__db_db_js__["a" /* default */].user ? __WEBPACK_IMPORTED_MODULE_0__db_db_js__["a" /* default */].user.prefs.lang : 'en';

  lang = lang.toLowerCase();
  if (langs.indexOf(lang) < 0) {
    lang = langs[0];
  }

  for (var _len = arguments.length, repoNames = Array(_len), _key = 0; _key < _len; _key++) {
    repoNames[_key] = arguments[_key];
  }

  repoNames.forEach(function (name) {
    var repo = repos[name];
    if (repo) {
      for (var token in repo) {
        result[token] = repo[token][lang];
      }
    }
  });

  return new Proxy(result, proxyHandler(repoNames));
}

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_recordable_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__session_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__db_db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_session_question__ = __webpack_require__(26);


















var Student = function (_Recordable) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Student, _Recordable);

  function Student(id) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Student);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Student.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Student)).call(this, id));

    _this.name = '';

    _this.school = '';

    _this.email = '';

    _this.grade = '';

    _this.classes = {};

    _this.sessions = {};

    _this.assignments = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Student, [{
    key: 'addClass',
    value: function addClass(id, name, cb) {
      this.classes[id] = name;
      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].updateField(this, 'classes/' + id, name, cb);
    }
  }, {
    key: 'removeClass',
    value: function removeClass(id, cb) {
      delete this.classes[id];

      this.setAssignment(id, null, function (err) {
        if (err) {
          return console.error(err);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].deleteField(this, 'classes/' + id, cb);
    }
  }, {
    key: 'addAssignment',
    value: function addAssignment(task, cls, cb) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].setField(this, 'assignments/' + task, cls, function (err) {
        if (err) {
          console.error('@/model/student.js/.addAssignment', err);
        } else {
          _this2.assignments[task] = cls;
        }

        cb(err);
      });
    }
  }, {
    key: 'removeAssignment',
    value: function removeAssignment(task, cb) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].deleteField(this, 'assignments/' + task, function (err) {
        if (err) {
          console.error('@/model/student.js/.removeAssignment', err);
        } else {
          delete _this3.assignments[task];
        }

        cb(err);
      });
    }
  }, {
    key: 'setAssignment',
    value: function setAssignment(cls, task, cb) {
      var _this4 = this;

      var prevAssignment = this.assignments[cls];
      if (!task) {
        delete this.assignments[cls];
      } else {
        this.assignments[cls] = task;
      }

      var onDone = function onDone(err) {
        if (err) {
          _this4.assignments[cls] = prevAssignment;
          console.error('@/model/student.js/.setAssignment', err);
        }

        cb(err);
      };

      if (task) {
        return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].setField(this, 'assignments/' + cls, task, onDone);
      } else {
        return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].deleteField(this, 'assignments/' + cls, onDone);
      }
    }
  }, {
    key: 'loadAssignments',
    value: function loadAssignments(cb) {
      var taskIDs = [];
      if (Student.MULTICLASS) {
        for (var id in this.assignments) {
          taskIDs.push(id);
        }
      } else {
        for (var cls in this.assignments) {
          taskIDs.push(this.assignments[cls]);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_9__task_js__["a" /* default */], taskIDs, function (err, tasks) {
        if (err) {
          return cb(err);
        }

        var result = [];

        var promises = [];
        tasks.forEach(function (task) {
          promises.push(__WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_8__class_js__["a" /* default */], task.cls, function (err, cls) {
            if (err) {
              return console.error('@/model/student.js/.loadAssignments db.get Class', err);
            }
            result.push({ cls: cls, task: task });
          }));
        });

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function (_) {
          cb(null, result);
        });
      });
    }
  }, {
    key: 'loadSessions',
    value: function loadSessions(cb) {
      var sessionIDs = [];
      for (var id in this.sessions) {
        sessionIDs.push(id);
      }

      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_10__session_js__["a" /* default */], sessionIDs, function (err, sessions) {
        if (err) {
          return cb(err);
        }

        var result = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
        sessions.forEach(function (session) {
          result.set(session, {
            cls: {},
            task: {},
            session: null,
            data: null
          });
        });

        var promises = [];
        sessions.forEach(function (session) {
          promises.push(__WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_8__class_js__["a" /* default */], session.cls, function (err, cls) {
            if (err) {
              return console.error('@/model/student.js/.loadSessions db.get Class', err);
            }
            result.get(session).cls = cls;
          }));
          promises.push(__WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_9__task_js__["a" /* default */], session.task, function (err, task) {
            if (err) {
              return console.error('@/model/student.js/.loadSessions db.get Task', err);
            }
            result.get(session).task = task;
          }));
          promises.push(__WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_11__data_js__["a" /* default */], session.data, function (err, data) {
            if (err) {
              return console.error('@/model/student.js/.loadSessions db.get Data', err);
            }
            result.get(session).data = data;
          }));
        });

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function (_) {
          var arr = [];
          result.forEach(function (obj, session) {
            obj.session = session;
            arr.push(obj);
          });

          cb(null, arr);
        });
      });
    }
  }, {
    key: 'loadTask',
    value: function loadTask(task, cb) {
      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_9__task_js__["a" /* default */], task, cb);
    }
  }, {
    key: 'taskDone',
    value: function taskDone(task, session, cb) {
      var _this5 = this;

      this.sessions[session] = task;
      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].updateField(this, 'sessions/' + session, task, function (err) {
        if (err) {
          return cb(err);
        }

        if (Student.MULTICLASS) {
          _this5.removeAssignment(task, cb);
        } else {
          _this5.setAssignment(task, null, cb);
        }
      });
    }
  }, {
    key: 'addQuestionnaire',
    value: function addQuestionnaire(dataID, questionnaire, cb) {
      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].update('/' + __WEBPACK_IMPORTED_MODULE_11__data_js__["a" /* default */].db + '/' + dataID + '/questionnaire', questionnaire, function (err) {
        if (err) {
          return cb(err);
        }

        cb();
      });
    }
  }, {
    key: 'getSessions',
    value: function getSessions(cb) {
      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_10__session_js__["a" /* default */], this.sessions, cb);
    }
  }, {
    key: 'deleteSession',
    value: function deleteSession(id, cb) {
      var session = this.sessions[id];
      if (!session) {
        return cb(new Error('INTERNAL: Session does not exist'));
      }

      delete this.sessions[id];

      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].deleteField(this, 'sessions/' + id, function (err) {
        if (err) {
          return cb(err);
        }

        __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_10__session_js__["a" /* default */], id, function (err, session) {
          if (err) {
            return cb(err);
          }

          var promises = [];
          promises.push(__WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].deleteItems(__WEBPACK_IMPORTED_MODULE_11__data_js__["a" /* default */], [session.data]));
          promises.push(__WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].deleteItems(__WEBPACK_IMPORTED_MODULE_10__session_js__["a" /* default */], [id]));

          session.files.forEach(function (file) {
            return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].deleteFile(file, function (err) {
              if (err) {
                console.error('Student.deleteSession:', err);
              }
            });
          });

          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
            cb(null);
          });
        });
      });
    }
  }], [{
    key: 'list',
    value: function list(cb) {
      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].getAll(Student, cb);
    }
  }, {
    key: 'getData',
    value: function getData(ids, cb) {
      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_11__data_js__["a" /* default */], ids, cb);
    }
  }, {
    key: 'db',
    get: function get() {
      return 'students';
    }
  }, {
    key: 'MULTICLASS',
    get: function get() {
      return true;
    }
  }, {
    key: 'isLogged',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].user && __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].user.isStudent;
    }
  }, {
    key: 'instance',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].user && __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].user.isStudent ? __WEBPACK_IMPORTED_MODULE_12__db_db_js__["a" /* default */].user.ref : null;
    }
  }]);

  return Student;
}(__WEBPACK_IMPORTED_MODULE_7__commons_recordable_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Student);


__WEBPACK_IMPORTED_MODULE_7__commons_recordable_js__["a" /* default */].apply(Student);

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Feedbacks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SyllabOptions; });
/* unused harmony export SpeechOptions */
/* unused harmony export HighlightOptions */
/* unused harmony export WarningOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Threshold; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__speechFeedback__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syllabificationFeedback__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__highlightFeedback__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__warningFeedback__ = __webpack_require__(128);








var Feedbacks = function Feedbacks(speech, syllabification, highlight, warning) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Feedbacks);

  this.speech = speech;
  this.syllabification = syllabification;
  this.highlight = highlight;
  this.warning = warning;
};

var SyllabOptions = function () {
  function SyllabOptions() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SyllabOptions);

    this.language = '';

    this.exceptions = {};

    this.mode = '';

    this.temporary = false;

    this.threshold = null;
  }

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(SyllabOptions, null, [{
    key: 'from',
    value: function from(feedback) {
      var result = new SyllabOptions();
      result.language = feedback.language;
      result.mode = feedback.mode;
      result.threshold = feedback.threshold;
      result.temporary = feedback.temporary;
      result.exceptions = feedback.exceptions;
      return result;
    }
  }]);

  return SyllabOptions;
}();

var SpeechOptions = function SpeechOptions() {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SpeechOptions);

  this.language = '';

  this.threshold = null;
};

var HighlightOptions = function HighlightOptions() {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HighlightOptions);

  this.language = '';

  this.color = '#004080';

  this.threshold = null;
};

var WarningOptions = function WarningOptions() {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WarningOptions);

  this.language = '';

  this.phrase = '';

  this.threshold = null;
};

var Threshold = function Threshold(value) {
  var smart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var max = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var adjustForWordLength = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Threshold);

  this.value = value;
  this.smart = smart;
  this.min = min;
  this.max = max;
  this.adjustForWordLength = adjustForWordLength;
};;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_recordable_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__task_textPage_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__session_feedbacks_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__intro_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__db_db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__session_question_js__ = __webpack_require__(26);


















var Task = function (_Recordable) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Task, _Recordable);

  function Task(id) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Task);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Task.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Task)).call(this, id));

    _this.name = '';

    _this.owner = '';

    _this.cls = '';

    _this.type = '';

    _this.alignment = '';

    _this.fontname = 'Calibri';

    _this.intro = '';

    _this.pages = [];

    _this.syllab = Task.defaultSyllab;

    _this.speech = Task.defaultSpeech;

    _this.highlight = Task.defaultHighlight;

    _this.warning = Task.defaultWarning;

    _this.questionnaire = [];

    _this.useTimeout = false;

    _this.timeout = 5;

    _this.recordAudio = false;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Task, [{
    key: 'update',
    value: function update(task, cb) {
      var _task = {
        alignment: task.alignment,
        fontname: task.fontname,
        intro: task.intro,
        pages: Task.textToPages(task.text),
        syllab: task.syllab,
        speech: task.speech,
        highlight: task.highlight,
        warning: task.warning,
        questionnaire: task.questionnaire,
        useTimeout: task.useTimeout,
        timeout: task.timeout,
        recordAudio: task.recordAudio
      };

      Task.embedImagesIntoPages(_task.pages, task.images);

      _task.syllab.exceptions = Task.textToSyllabs(task.syllab.exceptions);

      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateFields(this, _task, cb);
    }
  }, {
    key: 'getIntro',
    value: function getIntro(cb) {
      if (this.intro) {
        return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_10__intro_js__["a" /* default */], this.intro, cb);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cb());
      }
    }
  }, {
    key: 'deleteAllImages',
    value: function deleteAllImages(cb) {
      var promises = [];

      this.pages.forEach(function (page) {
        if (!page.images) {
          return;
        }
        page.images.forEach(function (image) {
          var url = __WEBPACK_IMPORTED_MODULE_8__task_textPageImage_js__["a" /* TextPageImage */].urlFromName(image.src);
          promises.push(__WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].deleteFile(url, function (_) {}));
        });
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (_) {
        cb();
      });
    }
  }], [{
    key: 'get',
    value: function get(id, cb) {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].get(Task, id, cb);
    }
  }, {
    key: 'textToPages',
    value: function textToPages(text) {
      if (!text) {
        return [];
      }

      var pageIndex = 0;
      var page = new __WEBPACK_IMPORTED_MODULE_7__task_textPage_js__["a" /* default */](pageIndex);

      var pages = [page];
      var lines = text.split('\n');

      lines.forEach(function (line) {
        line = line.trim();

        if (!line) {
          if (page.lines.length > 0) {
            page = new __WEBPACK_IMPORTED_MODULE_7__task_textPage_js__["a" /* default */](++pageIndex);
            pages.push(page);
          }
          return;
        }

        page.lines.push(line);
      });

      if (!page.lines.length) {
        pages.pop();
      }

      return pages;
    }
  }, {
    key: 'pagesToText',
    value: function pagesToText(pages) {
      if (!pages.length) {
        return '';
      }

      var result = void 0;
      if ('lines' in pages[0]) {
        var source = pages;
        result = source.map(function (page) {
          return page.lines.join('\n');
        });
      } else {
        var _source = pages;
        result = _source.map(function (page) {
          return page.join('\n');
        });
      }

      return result.join('\n\n');
    }
  }, {
    key: 'textToSyllabs',
    value: function textToSyllabs(text) {
      if (!text) {
        return {};
      }

      var result = {};
      var lines = text.split('\n');

      lines.forEach(function (line) {
        line = line.trim();
        var parts = line.split(Task.wordSyllabSeparator);
        if (parts.length !== 2) {
          return;
        }

        var word = parts[0].trim();
        var syllabText = parts[1].trim();
        if (!word || !syllabText || word.split(Task.syllabSeparator).length > 1) {
          return;
        }

        result[word] = syllabText.split(Task.syllabSeparator).filter(function (item) {
          return item.length;
        }).join(Task.syllabSeparator);
      });

      return result;
    }
  }, {
    key: 'syllabsToText',
    value: function syllabsToText(syllabs) {
      var result = [];
      for (var word in syllabs) {
        result.push('' + word + Task.wordSyllabSeparator + syllabs[word]);
      }
      return result.join('\n');
    }
  }, {
    key: 'embedImagesIntoPages',
    value: function embedImagesIntoPages(pages, images) {
      if (!images) {
        return;
      }

      pages.forEach(function (page) {
        page.images = [];
      });

      images.forEach(function (image) {
        if (image.page < 0) {
          pages.forEach(function (page) {
            if (!page.images.find(function (img) {
              return img.src === image.src;
            })) {
              page.images.push(new __WEBPACK_IMPORTED_MODULE_8__task_textPageImage_js__["a" /* TextPageImage */](image));
            }
          });
        } else {
          var page = pages[image.page];
          if (!page) {
            return;
          }

          page.images.push(new __WEBPACK_IMPORTED_MODULE_8__task_textPageImage_js__["a" /* TextPageImage */](image));
        }
      });
    }
  }, {
    key: 'uploadImage',
    value: function uploadImage(file, meta, progressHandler, cb) {
      var prefix = __WEBPACK_IMPORTED_MODULE_8__task_textPageImage_js__["a" /* TextPageImage */].generatePrefix();
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].uploadFile(file, prefix, meta, progressHandler, cb);
    }
  }, {
    key: 'deleteImage',
    value: function deleteImage(image, cb) {
      var url = __WEBPACK_IMPORTED_MODULE_8__task_textPageImage_js__["a" /* TextPageImage */].urlFromName(image.src);
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].deleteFile(url, cb);
    }
  }, {
    key: 'db',
    get: function get() {
      return 'tasks';
    }
  }, {
    key: 'wordSyllabSeparator',
    get: function get() {
      return '=';
    }
  }, {
    key: 'syllabSeparator',
    get: function get() {
      return ' ';
    }
  }, {
    key: 'defaultSyllab',
    get: function get() {
      return {
        language: '',
        exceptions: {},
        mode: 'colors',
        temporary: false,
        threshold: new __WEBPACK_IMPORTED_MODULE_9__session_feedbacks_js__["a" /* Threshold */](3000, false, 1500, 3000, false)
      };
    }
  }, {
    key: 'defaultSpeech',
    get: function get() {
      return {
        language: '',
        threshold: new __WEBPACK_IMPORTED_MODULE_9__session_feedbacks_js__["a" /* Threshold */](4000, false, 3000, 4000, false)
      };
    }
  }, {
    key: 'defaultHighlight',
    get: function get() {
      return {
        language: '',
        color: '#1050A0',
        threshold: new __WEBPACK_IMPORTED_MODULE_9__session_feedbacks_js__["a" /* Threshold */](4000, false, 3000, 4000, false)
      };
    }
  }, {
    key: 'defaultWarning',
    get: function get() {
      return {
        language: '',
        phrase: 'Jatka lukemista!',
        threshold: new __WEBPACK_IMPORTED_MODULE_9__session_feedbacks_js__["a" /* Threshold */](5000)
      };
    }
  }]);

  return Task;
}(__WEBPACK_IMPORTED_MODULE_6__commons_recordable_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Task);


__WEBPACK_IMPORTED_MODULE_6__commons_recordable_js__["a" /* default */].apply(Task);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



function formatTimeComponent(timeComponent) {
  var formattedTimeComponent = '' + timeComponent;
  if (formattedTimeComponent.length < 2) {
    formattedTimeComponent = '0' + formattedTimeComponent;
  }
  return formattedTimeComponent;
}

var DataUtils = function () {
  function DataUtils() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DataUtils);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DataUtils, null, [{
    key: 'toArray',
    value: function toArray(list) {
      var result = [];
      for (var id in list) {
        result.push({
          id: id,
          name: list[id]
        });
      }
      return result;
    }
  }, {
    key: 'byName',
    value: function byName(a, b) {
      return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    }
  }, {
    key: 'sessionDate',
    value: function sessionDate(dateString) {
      var date = new Date(dateString);
      var hours = formatTimeComponent(date.getHours());
      var minutes = formatTimeComponent(date.getMinutes());
      return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear() + ' ' + hours + ':' + minutes + ' ';
    }
  }, {
    key: 'convertLegacy',
    value: function convertLegacy(lang) {
      return lang === 'Finnish' ? 'Suomi' : lang;
    }
  }]);

  return DataUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (DataUtils);

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);


var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (eventBus);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Word; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TextPageImageEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TextPageImageFixationEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TextPageImageDelayEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextPageImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_data_image_js__ = __webpack_require__(52);










function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

var FILE_ID_SPLITTER = '_';

var Word = function () {
  function Word(text, id) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Word);

    this.text = text;
    this.id = id;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(Word, [{
    key: 'isEqual',
    value: function isEqual(ref) {
      return this.text === ref.text && (ref.id ? this.id === ref.id : true);
    }
  }]);

  return Word;
}();

var TextPageImageEvent = function () {
  function TextPageImageEvent(name) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, TextPageImageEvent);

    this.name = name;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(TextPageImageEvent, [{
    key: 'setMeta',
    value: function setMeta(meta, type) {}
  }, {
    key: '_isGreaterThanInt',
    value: function _isGreaterThanInt(value, threshold) {
      if (value === '' || value === null || value === undefined) {
        return false;
      }

      var int = +value;
      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_nan___default()(int) || !__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default()(int)) {
        return false;
      }

      return int > threshold;
    }
  }, {
    key: 'isValid',
    get: function get() {
      return true;
    }
  }], [{
    key: 'hasParameters',
    value: function hasParameters(event) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(event).length > 1;
    }
  }]);

  return TextPageImageEvent;
}();

var TextPageImageFixationEvent = function (_TextPageImageEvent) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TextPageImageFixationEvent, _TextPageImageEvent);

  function TextPageImageFixationEvent(words, duration) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, TextPageImageFixationEvent);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TextPageImageFixationEvent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TextPageImageFixationEvent)).call(this, TextPageImage.EVENT.fixation));

    _this.words = words;
    _this.duration = duration;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(TextPageImageFixationEvent, [{
    key: 'isValid',
    get: function get() {
      return this.words && this.words.length > 0 && this._isGreaterThanInt(this.duration, 100);
    }
  }]);

  return TextPageImageFixationEvent;
}(TextPageImageEvent);

var TextPageImageDelayEvent = function (_TextPageImageEvent2) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(TextPageImageDelayEvent, _TextPageImageEvent2);

  function TextPageImageDelayEvent(duration) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, TextPageImageDelayEvent);

    var _this2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TextPageImageDelayEvent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TextPageImageDelayEvent)).call(this, TextPageImage.EVENT.delay));

    _this2.duration = duration;
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(TextPageImageDelayEvent, [{
    key: 'isValid',
    get: function get() {
      return this._isGreaterThanInt(this.duration, 0);
    }
  }]);

  return TextPageImageDelayEvent;
}(TextPageImageEvent);

var TextPageImage = function () {
  function TextPageImage(_ref) {
    var src = _ref.src,
        page = _ref.page,
        location = _ref.location,
        offset = _ref.offset,
        keepOriginalSize = _ref.keepOriginalSize,
        on = _ref.on,
        off = _ref.off;

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, TextPageImage);

    this.src = src;

    this.page = page;

    this.location = location;

    this.offset = offset || 0;

    this.keepOriginalSize = !!keepOriginalSize;

    this.on = on;

    this.off = off;

    this.file = null;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(TextPageImage, [{
    key: 'meta',
    get: function get() {
      var result = {
        page: this.page,
        location: this.location,
        offset: this.offset,
        keepOriginalSize: this.keepOriginalSize
      };

      this.on.setMeta(result, 'on');
      this.off.setMeta(result, 'off');

      return result;
    }
  }], [{
    key: 'getNameFromSource',
    value: function getNameFromSource(source) {
      var parts = source.split(FILE_ID_SPLITTER);
      parts.shift();
      return parts.join(FILE_ID_SPLITTER).split('?')[0];
    }
  }, {
    key: 'generatePrefix',
    value: function generatePrefix() {
      var uuid = uuidv4();
      return '' + uuid + FILE_ID_SPLITTER;
    }
  }, {
    key: 'from',
    value: function from(image, options) {
      options = options || { ignoreDisplayCondition: false };

      return new TextPageImage({
        src: image.src,
        page: -1,
        location: image.location,
        offset: image.offset,
        keepOriginalSize: image.keepOriginalSize,
        on: new TextPageImageEvent(options.ignoreDisplayCondition ? TextPageImage.EVENT.none : image.on),
        off: new TextPageImageEvent(image.off)
      });
    }
  }, {
    key: 'nameFromURL',
    value: function nameFromURL(url) {
      return decodeURIComponent(url).split('/').pop();
    }
  }, {
    key: 'urlFromName',
    value: function urlFromName(name) {
      if (name.startsWith('https://')) {
        return name;
      } else {
        var path =  false ? 'https://firebasestorage.googleapis.com/v0/b/eye-school-test.appspot.com/o/image%2F' : 'https://firebasestorage.googleapis.com/v0/b/uta-gasp-silko.appspot.com/o/image%2F';
        return path + name;
      }
    }
  }, {
    key: 'EVENT',
    get: function get() {
      return {
        none: 'none',
        fixation: 'fixation',
        image: 'image',
        delay: 'delay'
      };
    }
  }]);

  return TextPageImage;
}();;

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showError: 0,
      errorMessage: ''
    };
  },


  methods: {
    setError: function setError(err, pre) {
      if (err.message) {
        err = err.message;
      }

      if (pre) {
        this.errorMessage = pre + ':\n\n' + err;
      } else {
        this.errorMessage = err;
      }

      this.showError = Math.random();
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_creator_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_user_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__userBase_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_commons_recordable_js__ = __webpack_require__(24);
















var configName =  false ? 'development' : 'production';
var config = __webpack_require__(162)("./db." + configName + '.js').config;
console.log('Connecting to ' + config.projectId);

var DEFAULT_PASSWORD = 'gdfvgdfv';
var ADMIN_UID = configName === 'development' ? 'd1wjPNPQ0CVOssWFwqSm1r1inC62' : 'sp4j975g5uWGUozTRhpHKgyaG8m2';
function ctor(obj) {
  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(obj).constructor;
}

var DB = function () {
  function DB() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DB);

    this._connected = false;

    this.fb = null;
    this.storage = null;
    this.auth = null;

    this._user = null;
    this.ignoreUserSwitch = false;
    this.currentPassword = '';

    if (!window['firebase']) {
      window.alert('Cannot access Firebase');
      return;
    }

    if (!firebase.apps.length) {
      this._init(firebase.initializeApp(config));
    } else {
      firebase.apps[0].delete().then(function () {
        _this._init(firebase.initializeApp(config));
      }).catch(function (err) {
        console.log('@/db/db.js/.ctor firebase.App.delete', err);
      });
    }
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(DB, [{
    key: '_init',
    value: function _init(app) {
      this.fb = firebase.database(app).ref();
      this.storage = firebase.storage().ref();
      this.auth = firebase.auth();

      this.auth.onAuthStateChanged(this._onUserChanged.bind(this));
    }
  }, {
    key: 'logIn',
    value: function logIn(email, password, cb) {
      var _this2 = this;

      if (!this.fb) {
        cb(new Error('Not connected to the database'));
      }

      if (email.indexOf('@') < 0) {
        email += this.FAKE_EMAIL_DOMAIN;
      }

      return this.auth.signInWithEmailAndPassword(email, password).then(function (user) {
        _this2.currentPassword = password;
        cb(null, user);
      }).catch(function (err) {
        cb(err);
      });
    }
  }, {
    key: 'logOut',
    value: function logOut() {
      if (!this.auth) {
        return;
      }

      this.auth.signOut();
    }
  }, {
    key: 'resetPassword',
    value: function resetPassword(email, cb) {
      return this.auth.sendPasswordResetEmail(email).then(function (_) {
        cb(null);
      }).catch(function (err) {
        cb(err);
      });
    }
  }, {
    key: 'add',
    value: function add(cls, obj, cb) {
      var _this3 = this;

      if (cls.validate && !cls.validate(obj)) {
        var objString = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(obj);
        objString = objString.substr(0, Math.min(objString.length, 50));
        return cb(new Error('INTERNAL: ' + objString + '" is not of a class \'' + cls.name + '\''));
      }

      if (obj.email) {
        this.ignoreUserSwitch = true;

        var password = obj.password || DEFAULT_PASSWORD;
        delete obj.password;

        this.auth.createUserWithEmailAndPassword(obj.email, password).then(function (user) {

          if (obj.email.indexOf('@') > 0 && obj.email.indexOf(_this3.FAKE_EMAIL_DOMAIN) < 0) {
            setTimeout(function () {
              _this3.auth.sendPasswordResetEmail(obj.email);
            }, 1000);
          }

          var ref = _this3.fb.child(cls.db).push(obj);

          var userRecord = {};
          userRecord[user.uid] = {
            path: cls.db,
            id: ref.key,
            prefs: new __WEBPACK_IMPORTED_MODULE_7__model_user_js__["a" /* UserPrefs */]()
          };
          _this3.fb.child('users').update(userRecord);

          cb(null, ref.key);
        }).catch(function (err) {
          cb(err);
        });
      } else {
        var ref = this.fb.child(cls.db).push(obj);
        cb(null, ref.key);
      }
    }
  }, {
    key: 'update',
    value: function update(path, value, cb) {
      var updates = {};
      updates[path] = value;
      return this.fb.update(updates, cb);
    }
  }, {
    key: 'updateField',
    value: function updateField(obj, field, value, cb) {
      var updates = {};
      updates['/' + ctor(obj).db + '/' + obj.id + '/' + field] = value;
      return this.fb.update(updates, cb);
    }
  }, {
    key: 'updateFields',
    value: function updateFields(obj, upd, cb) {
      var updates = {};

      if (upd instanceof Array) {
        upd.forEach(function (item) {
          updates['/' + ctor(obj).db + '/' + obj.id + '/' + item.field] = item.value;
        });
      } else {
        for (var field in upd) {
          updates['/' + ctor(obj).db + '/' + obj.id + '/' + field] = upd[field];
        }
      }

      return this.fb.update(updates, cb);
    }
  }, {
    key: 'setField',
    value: function setField(obj, field, value, cb) {
      var ref = this.fb.child('/' + ctor(obj).db + '/' + obj.id);
      return ref.child(field).set(value, cb);
    }
  }, {
    key: 'get',
    value: function get(cls, id, cb) {
      var ref = this.fb.child(cls.db + '/' + id);
      return ref.once('value', function (snapshot) {
        if (!snapshot.exists()) {
          return cb(new Error('INTERNAL: ' + cls.db + '/' + id + ' do not exist'));
        }

        cb(null, cls.from(snapshot));
      }, function (err) {
        cb(err);
      });
    }
  }, {
    key: 'getFromIDs',
    value: function getFromIDs(cls, ids, cb) {
      var _this4 = this;

      var results = [];

      var promises = [];

      var errors = [];

      this._toArray(ids).forEach(function (id) {
        var ref = _this4.fb.child(cls.db + '/' + id);
        promises.push(ref.once('value', function (snapshot) {
          if (!snapshot.exists()) {
            errors.push(cls.db + '/' + id);
            return;
          }

          results.push(cls.from(snapshot));
        }, function (err) {
          errors.push(err);
        }));
      });

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function (_) {
        cb(errors.join(', '), results);
      });
    }
  }, {
    key: 'getFieldAll',
    value: function getFieldAll(path, cls, cb) {
      var ref = this.fb.child(path);
      return ref.once('value', function (snapshot) {
        var objs = [];

        snapshot.forEach(function (childSnapshot) {
          objs.push(cls.from(childSnapshot));
        });

        cb(null, objs);
      }, function (err) {
        cb(err);
      });
    }
  }, {
    key: 'getAll',
    value: function getAll(cls, cb) {
      var ref = this.fb.child(cls.db);
      return ref.once('value', function (snapshot) {
        if (!snapshot.exists()) {
          return cb(null, []);
        }

        var objs = [];

        snapshot.forEach(function (childSnapshot) {
          objs.push(cls.from(childSnapshot));
        });

        cb(null, objs);
      }, function (err) {
        cb(err);
      });
    }
  }, {
    key: 'deleteItems',
    value: function deleteItems(cls, ids) {
      var _this5 = this;

      var promises = [];

      this._toArray(ids).forEach(function (id) {
        var ref = _this5.fb.child(cls.db + '/' + id);
        promises.push(ref.remove());
      });

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises);
    }
  }, {
    key: 'delete',
    value: function _delete(obj, cb) {
      var ref = this.fb.child(ctor(obj).db + '/' + obj.id);
      return ref.remove().then(function () {
        return cb();
      }).catch(function (err) {
        return cb(err);
      });
    }
  }, {
    key: 'deleteField',
    value: function deleteField(obj, field, cb) {
      var ref = this.fb.child(ctor(obj).db + '/' + obj.id + '/' + field);
      return ref.remove().then(function () {
        return cb();
      }).catch(function (err) {
        return cb(err);
      });
    }
  }, {
    key: 'deleteUser',
    value: function deleteUser(id) {
      var query = this.fb.child('users').orderByChild('id').equalTo(id);
      return query.once('value', function (snapshot) {
        if (snapshot.exists()) {
          snapshot.forEach(function (user) {
            user.ref.remove();
          });
        }
      }, function (err) {
        console.log('@/db/db.js/.deleteUser firebase.Query.once', err);
      });
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(file, prefix, meta, progressHandler, cb) {
      var folder = 'file';
      if (/image\//.test(file.type)) {
        folder = 'image';
      } else if (/audio\//.test(file.type)) {
        folder = 'sound';
      }

      var metadata = meta ? {
        customMetadata: meta
      } : undefined;

      var uploadTask = this.storage.child(folder + '/' + prefix + file.name).put(file, metadata);
      uploadTask.on('state_changed', function (snapshot) {
        if (snapshot.state === firebase.storage.TaskState.PROGRESS && progressHandler) {
          progressHandler(100 * (snapshot.bytesTransferred / snapshot.totalBytes));
        }
      }, function (err) {
        cb(err);
      }, function (_) {
        cb(null, uploadTask.snapshot.downloadURL);
      });

      return uploadTask.then().catch(function (err) {
        cb(err);
      });
    }
  }, {
    key: 'uploadAudio',
    value: function uploadAudio(audio, name, progressHandler, cb) {
      var uploadTask = this.storage.child('sound/' + name).put(audio);
      uploadTask.on('state_changed', function (snapshot) {
        if (snapshot.state === firebase.storage.TaskState.PROGRESS && progressHandler) {
          progressHandler(100 * (snapshot.bytesTransferred / snapshot.totalBytes));
        }
      }, function (err) {
        cb(err);
      }, function (_) {
        cb(null, uploadTask.snapshot.downloadURL);
      });

      return uploadTask.then().catch(function (err) {
        cb(err);
      });
    }
  }, {
    key: 'deleteFile',
    value: function deleteFile(url, cb) {
      var pathParts = new window.URL(url).pathname.split('/');
      var filename = pathParts[pathParts.length - 1];
      if (!filename) {
        return cb(new Error('INTERNAL: invalid url'));
      }

      return this.storage.child(decodeURIComponent(filename)).delete().then(function (_) {
        return cb();
      }).catch(function (err) {
        return cb(err);
      });
    }
  }, {
    key: '_onUserChanged',
    value: function _onUserChanged(user) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_8__utils_event_bus_js__["a" /* default */].$emit('connected', { user: user });
      this._connected = true;

      if (user) {
        if (this.ignoreUserSwitch) {
          this.ignoreUserSwitch = false;
          setTimeout(function () {
            _this6.auth.signInWithEmailAndPassword(_this6.user.email, _this6.currentPassword).catch(function (err) {
              if (err) {
                console.log('@/db/db.js/._onUserChanged firebase.Auth.signInWithEmailAndPassword', err);
              }
              _this6.logOut();
            });
          }, 100);
          return;
        }

        this.fb.child('users/' + user.uid).once('value', function (snapshot) {
          var userRef = new __WEBPACK_IMPORTED_MODULE_7__model_user_js__["b" /* User */](snapshot.val(), user.uid, user.uid === ADMIN_UID);
          __WEBPACK_IMPORTED_MODULE_6__user_creator_js__["a" /* default */].create(user, userRef, function (err, result) {
            if (err) {
              _this6.logOut();
            }

            _this6._user = result;
            __WEBPACK_IMPORTED_MODULE_8__utils_event_bus_js__["a" /* default */].$emit('login');
          });
        });
      } else if (this._user) {
        this._user = null;
        __WEBPACK_IMPORTED_MODULE_8__utils_event_bus_js__["a" /* default */].$emit('logout');
      }
    }
  }, {
    key: '_toArray',
    value: function _toArray(obj) {
      var result = void 0;
      if (obj instanceof Array) {
        result = obj;
      } else if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
        result = [];
        for (var key in obj) {
          result.push(key);
        }
      } else if (typeof obj === 'boolean' || typeof obj === 'number' || typeof obj === 'string') {
        result = [obj];
      } else {
        result = [];
      }

      return result;
    }
  }, {
    key: 'FAKE_EMAIL_DOMAIN',
    get: function get() {
      return '@fake.com';
    }
  }, {
    key: 'user',
    get: function get() {
      return this._user;
    }
  }, {
    key: 'isConnected',
    get: function get() {
      return this._connected;
    }
  }]);

  return DB;
}();

var db = new DB();
/* harmony default export */ __webpack_exports__["a"] = (db);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  "data-v-8df17170",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__db_db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_createParams_js__ = __webpack_require__(60);











var Intro = function (_Recordable) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Intro, _Recordable);

  function Intro(id) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Intro);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Intro.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Intro)).call(this, id));

    _this.owner = '';

    _this.name = '';

    _this.calibInstruction = '';

    _this.startInstruction = '';

    _this.firstPage = [];
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Intro, [{
    key: 'textsSummary',
    value: function textsSummary() {
      var result = [];
      var MAX_CHARS_START = 40;
      var MAX_CHARS_END = 20;
      var MAX_CHARS = MAX_CHARS_START + MAX_CHARS_END;

      function copressText(text) {
        text = text.replace(/\n/g, ' ');
        var length = text.length;

        if (length > MAX_CHARS) {
          var spaceTo = text.indexOf(' ', MAX_CHARS_START);
          var spaceFrom = text.slice(0, -MAX_CHARS_END).lastIndexOf(' ');
          text = text.substr(0, spaceTo) + ' ... ' + text.slice(-length + spaceFrom);
        }

        return text;
      }

      if (this.calibInstruction) {
        result.push(copressText(this.calibInstruction));
      }
      if (this.startInstruction) {
        result.push(copressText(this.startInstruction));
      }
      if (this.firstPage && this.firstPage[0]) {
        result.push(copressText(this.firstPage.join(' ')));
      }

      return result.join('\n');
    }
  }, {
    key: 'firstPageAsText',
    value: function firstPageAsText() {
      return this.firstPage ? this.firstPage.join('\n') : '';
    }
  }, {
    key: 'update',
    value: function update(name, texts, cb) {
      this.name = name;

      var fields = Intro.validateTexts(texts);
      this.calibInstruction = fields.calibInstruction;
      this.startInstruction = fields.startInstruction;
      this.firstPage = fields.firstPage;

      fields.name = name;

      return __WEBPACK_IMPORTED_MODULE_6__db_db_js__["a" /* default */].updateFields(this, fields, cb);
    }
  }], [{
    key: 'validateTexts',
    value: function validateTexts(texts) {
      if (!texts) {
        return {
          calibInstruction: '',
          startInstruction: '',
          firstPage: []
        };
      } else {
        return {
          calibInstruction: texts.calibInstruction || '',
          startInstruction: texts.startInstruction || '',
          firstPage: texts.firstPage ? texts.firstPage.split('\n').map(function (line) {
            return line.trim();
          }) : []
        };
      }
    }
  }, {
    key: 'db',
    get: function get() {
      return 'intros';
    }
  }]);

  return Intro;
}(__WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Intro);


__WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__["a" /* default */].apply(Intro);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_recordable_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_createParams_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__db_db_js__ = __webpack_require__(18);















var Class = function (_Recordable) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Class, _Recordable);

  function Class(id) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Class);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Class.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Class)).call(this, id));

    _this.name = '';

    _this.owner = '';

    _this.tasks = {};

    _this.students = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Class, [{
    key: 'createTask',
    value: function createTask(task, type, cb) {
      var _this2 = this;

      task.syllab.exceptions = __WEBPACK_IMPORTED_MODULE_8__task_js__["a" /* default */].textToSyllabs(task.syllabExceptions);

      var taskObj = {
        name: task.name,
        owner: this.owner,
        cls: this.id,
        type: type,
        alignment: task.alignment,
        fontname: task.fontname,
        intro: task.intro,
        pages: __WEBPACK_IMPORTED_MODULE_8__task_js__["a" /* default */].textToPages(task.text),
        syllab: task.syllab,
        speech: task.speech,
        highlight: task.highlight,
        warning: task.warning,
        questionnaire: task.questionnaire,
        useTimeout: task.useTimeout,
        timeout: task.timeout,
        recordAudio: task.recordAudio
      };

      __WEBPACK_IMPORTED_MODULE_8__task_js__["a" /* default */].embedImagesIntoPages(taskObj.pages, task.images);

      return __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].add(__WEBPACK_IMPORTED_MODULE_8__task_js__["a" /* default */], taskObj, function (err, id) {
        if (err) {
          return cb(err);
        }

        _this2.tasks[id] = task.name;
        __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].updateField(_this2, 'tasks/' + id, task.name, function (err) {
          if (err) {
            delete _this2.tasks[id];
          }

          cb(err, id);
        });
      });
    }
  }, {
    key: 'getTasks',
    value: function getTasks(cb) {
      return __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_8__task_js__["a" /* default */], this.tasks, cb);
    }
  }, {
    key: 'deleteTask',
    value: function deleteTask(task, cb) {
      var _this3 = this;

      delete this.tasks[task.id];
      __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].deleteField(this, 'tasks/' + task.id, cb);

      __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_9__student_js__["a" /* default */], this.students, function (err, students) {
        if (err) {
          return console.error(err);
        }

        students.forEach(function (student) {
          if (__WEBPACK_IMPORTED_MODULE_9__student_js__["a" /* default */].MULTICLASS) {
            if (task.id in student.assignments) {
              student.removeAssignment(task.id, function (err) {
                if (err) {
                  return console.error(err);
                }
              });
            }
          } else {
            if (student.assignments[_this3.id] === task.id) {
              student.setAssignment(_this3.id, null, function (err) {
                if (err) {
                  return console.error(err);
                }
              });
            }
          }
        });
      });

      task.deleteAllImages(function (err) {
        if (err) {
          console.error(err);
        }
      });

      __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].delete(task, function (err) {
        if (err) {
          console.error(err);
        }
      });
    }
  }, {
    key: 'getStudents',
    value: function getStudents(cb) {
      return __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_9__student_js__["a" /* default */], this.students, cb);
    }
  }, {
    key: 'addStudents',
    value: function addStudents(newStudents, cb) {
      var _this4 = this;

      var joinedStudents = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.students, newStudents);

      return __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].updateField(this, 'students', joinedStudents, function (err) {
        if (!err) {
          _this4.students = joinedStudents;

          __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_9__student_js__["a" /* default */], newStudents, function (err, students) {
            if (err) {
              return console.error(err);
            }

            students.forEach(function (student) {
              student.addClass(_this4.id, _this4.name, function (err) {
                if (err) {
                  return console.error(err);
                }
              });
            });
          });
        }

        cb(err);
      });
    }
  }, {
    key: 'removeStudent',
    value: function removeStudent(student, cb) {
      var _this5 = this;

      delete this.students[student.id];
      __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].deleteField(this, 'students/' + student.id, cb);

      return __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_9__student_js__["a" /* default */], student.id, function (err, _) {
        if (err) {
          return console.error(err);
        }

        student.removeClass(_this5.id, function (err) {
          if (err) {
            return console.error(err);
          }
        });

        student.setAssignment(_this5.id, null, function (err) {
          if (err) {
            return console.error(err);
          }
        });
      });
    }
  }], [{
    key: 'list',
    value: function list(cb) {
      return __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].getAll(Class, cb);
    }
  }, {
    key: 'get',
    value: function get(id, cb) {
      return __WEBPACK_IMPORTED_MODULE_10__db_db_js__["a" /* default */].get(Class, id, cb);
    }
  }, {
    key: 'db',
    get: function get() {
      return 'classes';
    }
  }]);

  return Class;
}(__WEBPACK_IMPORTED_MODULE_6__commons_recordable_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Class);


__WEBPACK_IMPORTED_MODULE_6__commons_recordable_js__["a" /* default */].apply(Class);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__school_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__intro_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__db_db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commons_createParams_js__ = __webpack_require__(60);

















var Teacher = function (_Recordable) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Teacher, _Recordable);

  function Teacher(id) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Teacher);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Teacher.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Teacher)).call(this, id));

    _this.name = '';

    _this.email = '';

    _this.school = '';

    _this.intros = {};

    _this.classes = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Teacher, [{
    key: 'getSchool',
    value: function getSchool(cb) {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_6__school_js__["a" /* default */], this.school, cb);
    }
  }, {
    key: 'createStudent',
    value: function createStudent(_ref, cb) {
      var _this2 = this;

      var _ref$name = _ref.name,
          name = _ref$name === undefined ? '' : _ref$name,
          _ref$email = _ref.email,
          email = _ref$email === undefined ? '' : _ref$email,
          _ref$password = _ref.password,
          password = _ref$password === undefined ? '' : _ref$password,
          _ref$grade = _ref.grade,
          grade = _ref$grade === undefined ? '' : _ref$grade;

      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].add(__WEBPACK_IMPORTED_MODULE_7__student_js__["a" /* default */], {
        name: name,
        email: email,
        password: password,
        grade: grade,
        school: this.school,
        classes: {},
        sessions: {},
        assignments: {}
      }, function (err, id) {
        if (err) {
          return cb(err);
        }

        __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_6__school_js__["a" /* default */], _this2.school, function (err, school) {
          if (err) {
            return cb(err);
          }

          school.students[id] = name;

          __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(school, 'students/' + id, name, function (errUpdate) {
            err = errUpdate;
          });

          cb(err, id);
        });
      });
    }
  }, {
    key: 'createIntro',
    value: function createIntro(name, texts, cb) {
      var _this3 = this;

      var introTexts = __WEBPACK_IMPORTED_MODULE_8__intro_js__["a" /* default */].validateTexts(texts);

      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].add(__WEBPACK_IMPORTED_MODULE_8__intro_js__["a" /* default */], {
        name: name,
        owner: this.id,
        calibInstruction: introTexts.calibInstruction,
        startInstruction: introTexts.startInstruction,
        firstPage: introTexts.firstPage
      }, function (err, id) {
        if (err) {
          return cb(err);
        }

        _this3.intros[id] = name;
        __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(_this3, 'intros/' + id, name, function (err) {
          if (err) {
            delete _this3.intros[id];
          }

          cb(err);
        });
      });
    }
  }, {
    key: 'getIntros',
    value: function getIntros(cb) {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_8__intro_js__["a" /* default */], this.intros, cb);
    }
  }, {
    key: 'deleteIntro',
    value: function deleteIntro(intro, cb) {
      delete this.intros[intro.id];

      __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].deleteField(this, 'intros/' + intro.id, cb);

      __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_9__class_js__["a" /* default */], this.classes, function (err, classes) {
        if (err) {
          return console.error(err);
        }

        classes.forEach(function (cls) {
          __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_10__task_js__["a" /* default */], cls.tasks, function (err, tasks) {
            if (err) {
              return console.error(err);
            }

            tasks.forEach(function (task) {
              if (task.intro === intro.id) {
                task.intro = '';
                __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(task, 'intro', task.intro, function (err) {
                  if (err) {
                    return console.error(err);
                  }
                });
              }
            });
          });
        });
      });

      __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].delete(intro, function (err) {
        if (err) {
          console.error(err);
        }
      });
    }
  }, {
    key: 'createClass',
    value: function createClass(name, cb) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].add(__WEBPACK_IMPORTED_MODULE_9__class_js__["a" /* default */], {
        name: name,
        owner: this.id,
        tasks: {},
        students: {}
      }, function (err, id) {
        if (err) {
          return cb(err);
        }

        _this4.classes[id] = name;
        __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(_this4, 'classes/' + id, name, function (err) {
          if (err) {
            delete _this4.classes[id];
          }

          cb(err);
        });
      });
    }
  }, {
    key: 'getClasses',
    value: function getClasses(cb) {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_9__class_js__["a" /* default */], this.classes, cb);
    }
  }, {
    key: 'deleteClass',
    value: function deleteClass(cls, cb) {
      delete this.classes[cls.id];
      __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].deleteField(this, 'classes/' + cls.id, cb);

      __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].deleteItems(__WEBPACK_IMPORTED_MODULE_10__task_js__["a" /* default */], cls.tasks);

      __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_7__student_js__["a" /* default */], cls.students, function (err, students) {
        if (err) {
          return console.error(err);
        }

        students.forEach(function (student) {
          student.removeClass(cls.id, function (err) {
            if (err) {
              return console.error(err);
            }
          });
        });
      });

      __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].delete(cls, function (err) {
        if (err) {
          console.error(err);
        }
      });
    }
  }], [{
    key: 'list',
    value: function list(cb) {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].getAll(Teacher, cb);
    }
  }, {
    key: 'db',
    get: function get() {
      return 'teachers';
    }
  }, {
    key: 'isLogged',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user && __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user.isTeacher;
    }
  }, {
    key: 'instance',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user && __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user.isTeacher ? __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user.ref : null;
    }
  }]);

  return Teacher;
}(__WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Teacher);


__WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__["a" /* default */].apply(Teacher);

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var Recordable = function () {
  function Recordable(id) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Recordable);

    this.id = id;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Recordable, null, [{
    key: 'validate',
    value: function validate(_) {
      return false;
    }
  }, {
    key: 'from',
    value: function from(_) {
      return null;
    }
  }, {
    key: 'apply',
    value: function apply(cls) {
      cls.validate = function (obj) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(new cls.prototype.constructor()).every(function (key) {
          if (key === 'id') {
            return true;
          }

          if (!obj.hasOwnProperty(key)) {
            return false;
          }

          return true;
        });
      };

      cls.from = function (snapshot) {
        var record = snapshot.val();

        var obj = new cls(snapshot.key);

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(obj, record);
      };
    }
  }, {
    key: 'db',
    get: function get() {
      return '';
    }
  }]);

  return Recordable;
}();

/* harmony default export */ __webpack_exports__["a"] = (Recordable);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_recordable_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__db_db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commons_createParams_js__ = __webpack_require__(60);

















var School = function (_Recordable) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(School, _Recordable);

  function School(id) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, School);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (School.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(School)).call(this, id));

    _this.name = '';

    _this.email = '';

    _this.teachers = {};

    _this.students = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(School, [{
    key: 'createTeacher',
    value: function createTeacher(name, email, cb) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].add(__WEBPACK_IMPORTED_MODULE_8__teacher_js__["a" /* default */], {
        name: name,
        email: email,
        school: this.id,
        intros: {},
        classes: {}
      }, function (err, id) {
        if (!err) {
          _this2.teachers[id] = name;

          __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(_this2, 'teachers/' + id, name, function (errUpdate) {
            if (errUpdate) {
              delete _this2.teachers[id];
            }
            err = errUpdate;
          });
        }

        cb(err, id);
      });
    }
  }, {
    key: 'getTeachers',
    value: function getTeachers(cb) {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_8__teacher_js__["a" /* default */], this.teachers, function (err, teachers) {
        if (err) {
          return cb(err);
        }

        cb(null, teachers);
      });
    }
  }, {
    key: 'createStudent',
    value: function createStudent(_ref, cb) {
      var _this3 = this;

      var _ref$name = _ref.name,
          name = _ref$name === undefined ? '' : _ref$name,
          _ref$email = _ref.email,
          email = _ref$email === undefined ? '' : _ref$email,
          _ref$password = _ref.password,
          password = _ref$password === undefined ? '' : _ref$password,
          _ref$grade = _ref.grade,
          grade = _ref$grade === undefined ? '' : _ref$grade;

      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].add(__WEBPACK_IMPORTED_MODULE_9__student_js__["a" /* default */], {
        name: name,
        email: email,
        password: password,
        grade: grade,
        school: this.id,
        classes: {},
        sessions: {},
        assignments: {}
      }, function (err, id) {
        if (!err) {
          _this3.students[id] = name;

          __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(_this3, 'students/' + id, name, function (errUpdate) {
            if (errUpdate) {
              delete _this3.students[id];
            }
            err = errUpdate;
          });
        }

        cb(err, id);
      });
    }
  }, {
    key: 'getStudents',
    value: function getStudents(cb) {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].getFromIDs(__WEBPACK_IMPORTED_MODULE_9__student_js__["a" /* default */], this.students, function (err, students) {
        if (err) {
          return cb(err);
        }

        cb(null, students);
      });
    }
  }, {
    key: 'deleteStudent',
    value: function deleteStudent(student, cb) {
      delete this.students[student.id];

      var errorHandler = function errorHandler(err) {
        if (err) console.log('@/model/school.js/.deleteStudent db.updateField', err);
      };

      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(this, 'students', this.students, function (err) {
        if (err) {
          return cb(err);
        }

        __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(student, 'deleted', true, errorHandler);

        if (student.assignments) {
          student.assignments = {};
          __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(student, 'assignments', {}, errorHandler);
        }

        if (student.classes) {
          var promises = [];
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(student.classes).map(function (id) {
            promises.push(__WEBPACK_IMPORTED_MODULE_10__class_js__["a" /* default */].get(id, function (err, cls) {
              if (err) {
                return;
              }

              delete cls.students[student.id];
              __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(cls, 'students', cls.students, errorHandler);
            }));
          });

          student.classes = {};
          __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].updateField(student, 'classes', {}, errorHandler);

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
            cb(null);
          }).catch(function (err) {
            cb(err);
          });
        }
      });
    }
  }], [{
    key: 'list',
    value: function list(cb) {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].getAll(School, cb);
    }
  }, {
    key: 'get',
    value: function get(id, cb) {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].get(School, id, cb);
    }
  }, {
    key: 'db',
    get: function get() {
      return 'schools';
    }
  }, {
    key: 'isLogged',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user && __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user.isSchool;
    }
  }, {
    key: 'instance',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user && __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user.isSchool ? __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].user.ref : null;
    }
  }]);

  return School;
}(__WEBPACK_IMPORTED_MODULE_7__commons_recordable_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (School);


__WEBPACK_IMPORTED_MODULE_7__commons_recordable_js__["a" /* default */].apply(School);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QuestionType */
/* unused harmony export AnswerCandidate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Question; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);


var QuestionType = function QuestionType(name, text) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, QuestionType);

  this.name = name;
  this.text = text;
};

var TYPES = {
  text: new QuestionType('text', 'whole text'),
  word: new QuestionType('word', 'long-gazed word')
};

var AnswerCandidate = function AnswerCandidate(text, isCorrect) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AnswerCandidate);

  this.text = text;
  this.isCorrect = isCorrect;
};

var Question = function () {
  function Question(type, word, question, answers) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Question);

    this.type = type;
    this.word = word;
    this.question = question;
    this.answers = answers;

    this.answer = null;
  }

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(Question, null, [{
    key: 'types',
    get: function get() {
      return TYPES;
    }
  }]);

  return Question;
}();;

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(310)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(404),
  /* scopeId */
  "data-v-0c2f8a1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dataPageTextWord_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dataPageFocusedWord__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fixation__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__feedbackEvent__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__image__ = __webpack_require__(52);










var WORD_SELECTOR = '.word';

var DataPage = function () {
  function DataPage() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DataPage);

    this.text = __WEBPACK_IMPORTED_MODULE_3__dataPageTextWord_js__["a" /* default */].fromAll(WORD_SELECTOR);

    this.words = [];

    this.fixations = [];

    this.syllabifications = [];

    this.speech = [];

    this.images = [];

    this.isIntro = false;

    this.audio = null;

    this.ts = 0;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DataPage, [{
    key: 'filterFixations',
    value: function filterFixations(threshold) {
      var result = [];

      var lastFix = null;
      var fixTimestamp = 0;
      var fixTimestampSync = 0;
      var ignoreTheEntranceFIxation = true;

      this.fixations.forEach(function (fixation) {
        if (lastFix && lastFix.ts !== fixation.ts) {
          lastFix.tsSync = fixTimestampSync;
          result.push(lastFix);
          lastFix = null;
        }

        if (!ignoreTheEntranceFIxation && fixation.duration >= threshold) {
          lastFix = fixation;
        }

        if (fixTimestamp !== fixation.ts) {
          if (fixation.duration < threshold) {
            ignoreTheEntranceFIxation = false;
          }

          fixTimestamp = fixation.ts;
          fixTimestampSync = fixation.tsSync;
        }
      });

      if (lastFix) {
        lastFix.tsSync = fixTimestampSync;
        result.push(lastFix);
      }

      this.fixations = result;
    }
  }, {
    key: 'setWords',
    value: function setWords(words) {
      var focusedWords = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(words.values()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var word = _step.value;

          focusedWords.push(word);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.words = focusedWords;
    }
  }]);

  return DataPage;
}();

/* harmony default export */ __webpack_exports__["a"] = (DataPage);

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showSuccess: 0,
      successMessage: ''
    };
  },


  methods: {
    setSuccess: function setSuccess(message) {
      this.successMessage = message;
      this.showSuccess = Math.random();
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_user_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_admin_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_school_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_student_js__ = __webpack_require__(5);









var UserBase = function () {
  function UserBase(user, _user) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserBase);

    if (!user) {
      return;
    }

    this._user = _user;

    this.name = user.displayName || user.email;

    this.email = user.email;

    this._ref = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UserBase, [{
    key: 'update',
    value: function update(cb) {
      this._user.update(cb);
    }
  }, {
    key: 'ref',
    get: function get() {
      return this._ref;
    }
  }, {
    key: 'prefs',
    get: function get() {
      return this._user.prefs;
    }
  }, {
    key: 'isAdmin',
    get: function get() {
      return false;
    }
  }, {
    key: 'isSchool',
    get: function get() {
      return false;
    }
  }, {
    key: 'isTeacher',
    get: function get() {
      return false;
    }
  }, {
    key: 'isStudent',
    get: function get() {
      return false;
    }
  }]);

  return UserBase;
}();

/* harmony default export */ __webpack_exports__["a"] = (UserBase);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OptionItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OptionGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptionsCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);



var OptionItem = function OptionItem(_ref) {
  var type = _ref.type,
      label = _ref.label,
      _ref$items = _ref.items,
      items = _ref$items === undefined ? [''] : _ref$items,
      _ref$step = _ref.step,
      step = _ref$step === undefined ? 0 : _ref$step;

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OptionItem);

  this.type = type;
  this.label = label;
  this.items = items;
  this.step = step;

  this.min = undefined;

  this.max = undefined;

  this.ref = undefined;
};

var OptionGroup = function OptionGroup(_ref2) {
  var _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? '' : _ref2$id,
      _ref2$title = _ref2.title,
      title = _ref2$title === undefined ? '' : _ref2$title,
      _ref2$options = _ref2.options,
      options = _ref2$options === undefined ? {} : _ref2$options,
      _ref2$defaults = _ref2.defaults,
      defaults = _ref2$defaults === undefined ? [{}] : _ref2$defaults;

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OptionGroup);

  this.title = title;

  this.options = options;
  this.defaults = defaults;
  this.id = id;
};

var OptionsCreator = function () {
  function OptionsCreator() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OptionsCreator);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(OptionsCreator, null, [{
    key: 'createOptions',
    value: function createOptions(options, receiver) {
      var result = void 0;
      if (options instanceof Array) {
        result = options.map(function (item) {
          return new OptionGroup({
            title: item.title,
            options: OptionsCreator.createOptions(item.options, receiver),
            defaults: item.defaults
          });
        });
      } else {
        for (var id in options) {
          options[id].ref = createOptionReference(id, receiver);
        }

        result = options;
      }

      return result;
    }
  }, {
    key: 'createDefaults',
    value: function createDefaults(source, subKeys, header) {
      var result = {};
      for (var key in source) {
        var targetKey = key[0] === '_' ? key.substr(1) : key;
        if (subKeys && !subKeys.includes(targetKey)) {
          continue;
        }

        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source[key]) === 'object') {
          copyPlaneKeys(result, source, key, header);
        } else {
          if (header) {
            targetKey = header + '.' + targetKey;
          }
          result[targetKey] = source[key];
        }
      }

      return result;
    }
  }, {
    key: 'restoreDefaults',
    value: function restoreDefaults(chapters) {
      var restore = function restore(chapter) {
        if (chapter.defaults) {
          clone(chapter.defaults, chapter.options);
        } else if (Array.isArray(chapter.options)) {
          OptionsCreator.restoreDefaults(chapter.options);
        }
      };

      if (Array.isArray(chapters)) {
        chapters.forEach(restore);
      } else {
        for (var id in chapters) {
          restore(chapters[id]);
        }
      }
    }
  }]);

  return OptionsCreator;
}();

function createOptionReference(id, receiver) {
  return function (value) {
    var ids = id.split('.');
    if (value === undefined) {
      var v = receiver;
      ids.forEach(function (_) {
        if (!v) {
          console.error('Option GET: Path \'' + id + ' has no match in receiver');
        }
        v = v[_];
      });
      return v;
    } else {
      var _v = receiver;
      for (var i = 0; i < ids.length - 1; i++) {
        if (!_v) {
          console.error('Option SET: Path \'' + id + ' has no match in receiver');
        }
        _v = _v[ids[i]];
      }
      _v[ids[ids.length - 1]] = value;
    }
  };
};

function copyPlaneKeys(result, source, id, header) {
  var ref = source[id];
  for (var key in ref) {
    if (ref[key] === 'object') {
      copyPlaneKeys(result, ref, id + '.' + key, header);
    } else {
      var targetKey = key[0] === '_' ? key.substr(1) : key;
      var targetID = id[0] === '_' ? id.substr(1) : id;
      if (header) {
        targetID = header + '.' + targetID;
      }
      result[targetID + '.' + targetKey] = ref[key];
    }
  }
}

function clone(from, to) {
  for (var key in from) {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(from[key]) === 'object') {
      clone(from[key], to[key]);
    } else {
      to[key].ref(from[key]);
    }
  }
}

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserPrefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return User; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_recordable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__db_db_js__ = __webpack_require__(18);








var UserPrefs = function UserPrefs(source) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UserPrefs);

  this.lang = source ? source.lang : 'en';
};

var User = function (_Recordable) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(User, _Recordable);

  function User(obj, uid, isAdmin) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, User);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (User.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(User)).call(this, obj ? obj.id : isAdmin ? 'admin' : ''));

    _this.uid = uid;

    _this.path = obj ? obj.path : '';

    _this.prefs = obj ? obj.prefs : null;
    if (!_this.prefs) {
      _this.prefs = new UserPrefs();
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(User, [{
    key: 'update',
    value: function update(cb) {
      __WEBPACK_IMPORTED_MODULE_6__db_db_js__["a" /* default */].update('/' + User.db + '/' + this.uid + '/prefs', this.prefs, cb);
    }
  }], [{
    key: 'db',
    get: function get() {
      return 'users';
    }
  }]);

  return User;
}(__WEBPACK_IMPORTED_MODULE_5__commons_recordable__["a" /* default */]);

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_school_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__db_db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_teacher_js__ = __webpack_require__(22);









var Admin = function () {
  function Admin() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Admin);

    this.name = 'Admin';
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Admin, null, [{
    key: 'createSchool',
    value: function createSchool(name, email, cb) {
      return __WEBPACK_IMPORTED_MODULE_3__db_db_js__["a" /* default */].add(__WEBPACK_IMPORTED_MODULE_2__model_school_js__["a" /* default */], {
        name: name,
        email: email,
        teachers: {},
        students: {}
      }, function (err, id) {
        cb(err, id);
      });
    }
  }, {
    key: 'moveStudent',
    value: function moveStudent(student, newSchoolID, schools, cb) {
      return Admin.move(student, newSchoolID, schools, 'students', cb);
    }
  }, {
    key: 'moveTeacher',
    value: function moveTeacher(teacher, newSchoolID, schools, cb) {
      return Admin.move(teacher, newSchoolID, schools, 'teachers', cb);
    }
  }, {
    key: 'move',
    value: function move(user, newSchoolID, schools, list, cb) {
      var prevSchoolID = user.school;
      user.school = newSchoolID;

      return __WEBPACK_IMPORTED_MODULE_3__db_db_js__["a" /* default */].updateField(user, 'school', newSchoolID, function (err) {
        if (err) {
          user.school = prevSchoolID;
          return cb(err);
        }

        var prevSchool = schools.find(function (school) {
          return school.id === prevSchoolID;
        });
        var newSchool = schools.find(function (school) {
          return school.id === newSchoolID;
        });

        delete prevSchool[list][user.id];
        newSchool[list][user.id] = user.name;

        __WEBPACK_IMPORTED_MODULE_3__db_db_js__["a" /* default */].updateField(newSchool, list + '/' + user.id, user.name, function (err) {
          if (err) {
            return cb(err);
          }

          __WEBPACK_IMPORTED_MODULE_3__db_db_js__["a" /* default */].deleteField(prevSchool, list + '/' + user.id, function (err) {
            if (err) {
              return cb(err);
            }

            cb(null);
          });
        });
      });
    }
  }, {
    key: 'isLogged',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3__db_db_js__["a" /* default */].user && __WEBPACK_IMPORTED_MODULE_3__db_db_js__["a" /* default */].user.isAdmin;
    }
  }]);

  return Admin;
}();

/* harmony default export */ __webpack_exports__["a"] = (Admin);
;

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_dataPage_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_question_js__ = __webpack_require__(26);










var Data = function (_Recordable) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Data, _Recordable);

  function Data(id) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Data);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Data.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Data)).call(this, id));

    _this.task = null;

    _this.student = null;

    _this.pages = null;

    _this.questionnaire = null;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Data, null, [{
    key: 'db',
    get: function get() {
      return 'data';
    }
  }]);

  return Data;
}(__WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Data);


__WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__["a" /* default */].apply(Data);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Fixation = function () {
  function Fixation(ts, tsSync, x, y, duration) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Fixation);

    this.ts = ts;
    this.tsSync = tsSync;
    this.x = x;
    this.y = y;
    this.duration = duration;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Fixation, null, [{
    key: "from",
    value: function from(gazePoint, ts) {
      return new Fixation(gazePoint.ts, ts, Math.round(gazePoint.x), Math.round(gazePoint.y), gazePoint.duration);
    }
  }]);

  return Fixation;
}();

/* harmony default export */ __webpack_exports__["a"] = (Fixation);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_task_textPageImage_js__ = __webpack_require__(14);





var Image = function () {
  function Image(image, ts) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Image);

    this.src = image.src;

    this.location = image.location;

    this.offset = image.offset || 0;

    this.keepOriginalSize = !!image.keepOriginalSize;

    this.on = image.on.name;

    this.off = image.off.name;

    this.shown = ts;

    this.hidden = 0;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Image, [{
    key: 'hide',
    value: function hide(ts) {
      this.hidden = ts;
    }
  }, {
    key: 'isCurrent',
    get: function get() {
      return !this.hidden;
    }
  }]);

  return Image;
}();

/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__record_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__params_js__ = __webpack_require__(134);





var Data = function Data(name, records, params) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Data);

  this.name = name;

  this.records = records;

  this.params = params;
};

/* harmony default export */ __webpack_exports__["a"] = (Data);
;

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_session_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__task_js__ = __webpack_require__(78);







var Session = function Session(ref, student, task, cls) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Session);

  this.ref = ref;

  this.student = student;

  this.task = task;

  this.cls = cls;
};

/* harmony default export */ __webpack_exports__["a"] = (Session);
;

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(331)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(423),
  /* scopeId */
  "data-v-57815d2f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TaskCreateParams */
/* unused harmony export StudentCreateParams */
/* unused harmony export IntroCreateParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_session_feedbacks_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_task_textPageImage_js__ = __webpack_require__(14);





var TaskCreateParams = function TaskCreateParams() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TaskCreateParams);

  this.name = '';

  this.alignment = '';

  this.fontname = '';

  this.intro = '';

  this.text = '';

  this.syllab = null;

  this.speech = null;

  this.highlight = null;

  this.warning = null;

  this.questionnaire = null;

  this.syllabExceptions = null;

  this.images = null;

  this.useTimeout = false;

  this.timeout = 5;

  this.recordAudio = false;
};

var StudentCreateParams = function StudentCreateParams() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StudentCreateParams);

  this.name = '';

  this.email = '';

  this.password = '';

  this.grade = '';
};

var IntroCreateParams = function IntroCreateParams() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, IntroCreateParams);

  this.calibInstruction = '';

  this.startInstruction = '';

  this.firstPage = '';
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_font_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_feedbacks_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__session_screenSize_js__ = __webpack_require__(94);











var Session = function (_Recordable) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Session, _Recordable);

  function Session(id) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Session);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Session.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Session)).call(this, id));

    _this.date = new Date().toJSON();

    _this.student = '';

    _this.cls = '';

    _this.task = '';

    _this.font = null;

    _this.feedbacks = null;

    _this.screen = null;

    _this.data = '';

    _this.files = [];
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Session, null, [{
    key: 'db',
    get: function get() {
      return 'sessions';
    }
  }]);

  return Session;
}(__WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Session);


__WEBPACK_IMPORTED_MODULE_5__commons_recordable_js__["a" /* default */].apply(Session);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FeedbackOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Feedback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__feedbacks__ = __webpack_require__(7);





var FeedbackOptions = function FeedbackOptions() {
  var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FeedbackOptions);

  this.enabled = enabled;
  this.language = language;
  this.threshold = threshold;
};

var Feedback = function Feedback(options) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Feedback);

  this.enabled = options.enabled;
  this.language = options.language;
  this.threshold = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options.threshold);
};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_session_syllabificationFeedback_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_logger_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__wordFocus_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_session_feedbacks_js__ = __webpack_require__(7);













var logger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_logger_js__["a" /* default */])('syllabifier');

var RESTORE_INTERVAL = 3000;
var LONG_WORD_MIN_LENGTH = 7;
var EXTRA_THRESHOLD_FOR_CHAR = 0.05;

var Syllabifier = function () {
  function Syllabifier(options) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Syllabifier);

    this._options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, options);
    this._options.threshold.factor = 4;

    this._hyphen = Syllabifier.MODES['hyphen'];

    this._hyphenHtml = '<span class="hyphen">' + this._hyphen + '</span>';

    this._rule = rules[__WEBPACK_IMPORTED_MODULE_6__utils_data_utils_js__["a" /* default */].convertLegacy(this._options.language)];

    this._exceptions = {};
    for (var word in this._options.exceptions) {
      this._exceptions[word.toLowerCase()] = this._options.exceptions[word].replace(/ /g, this._hyphen).toLowerCase();
    }

    logger.info('created', options);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Syllabifier, [{
    key: 'prepareWord',
    value: function prepareWord(word) {
      if (!word || !this._rule || this._options.mode !== 'hyphen') {
        return word;
      }

      logger.info('preparing');

      var syllabifiedWord = this.syllabifyWord(word, this._hyphen);
      var hyphenCount = syllabifiedWord.length - word.length;
      var halfHyphenCount = Math.round(hyphenCount / 2);

      return '<span class="hyphens">' + Array(halfHyphenCount + 1).join(this._hyphen) + '</span>' + word + '<span class="hyphens">' + Array(hyphenCount - halfHyphenCount + 1).join(this._hyphen) + '</span>';
    }
  }, {
    key: 'prepareText',
    value: function prepareText(text) {
      var _this = this;

      if (!this._rule || this._options.mode !== 'hyphen') {
        return text;
      }

      return text.map(function (line) {
        var words = line.split(' ').map(function (word) {
          return word.toLowerCase();
        });
        return words.map(_this.prepareWord).join(' ');
      });
    }
  }, {
    key: 'unprepare',
    value: function unprepare(text) {
      return text.replace(new RegExp(this._hyphen, 'g'), '');
    }
  }, {
    key: 'inspect',
    value: function inspect(el, wordFocus) {
      var _this2 = this;

      if (!this._rule) {
        return false;
      }

      var threshold = this._options.threshold.value;
      if (this._options.threshold.adjustForWordLength) {
        threshold *= Math.max(1, 1 + (wordFocus.word.length - LONG_WORD_MIN_LENGTH) * EXTRA_THRESHOLD_FOR_CHAR);
      }

      var mustSyllabify = !wordFocus.syllabified && wordFocus.accumulatedTime > threshold;

      if (!mustSyllabify) {
        return false;
      }

      wordFocus.syllabified = true;

      el.innerHTML = this.syllabifyWord(wordFocus.word, this._hyphenHtml);

      if (this._options.temporary) {
        setTimeout(function () {
          _this2._restore(el);
        }, RESTORE_INTERVAL);
      }

      return true;
    }
  }, {
    key: 'syllabifyElementText',
    value: function syllabifyElementText(el, word) {
      if (!this._rule) {
        return false;
      }

      el.innerHTML = this.syllabifyWord(word, this._hyphenHtml);

      return true;
    }
  }, {
    key: 'setAvgWordReadingDuration',
    value: function setAvgWordReadingDuration(wordReadingDuration) {
      if (!this._options.threshold.smart || !wordReadingDuration) {
        return;
      }

      this._options.threshold.value = Math.max(this._options.threshold.min, Math.min(this._options.threshold.max, wordReadingDuration * this._options.threshold.factor));
    }
  }, {
    key: 'syllabifyWord',
    value: function syllabifyWord(word, hyphen) {
      var _this3 = this;

      logger.info('syllabifying', word);

      if (this._options.mode === 'colors') {
        hyphen = this._hyphen;
      }

      var result = void 0;
      var exception = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this._exceptions).find(function (exception) {
        return _this3._isException(word, exception);
      });
      if (exception) {
        logger.info('is exception');
        result = this._formatException(word, exception, this._exceptions[exception], hyphen);
      } else {
        result = this._rule(word, hyphen);
      }

      if (this._options.mode === 'colors') {
        var syllabs = result.split(this._hyphen);
        result = this._colorize(syllabs);
      }

      return result;
    }
  }, {
    key: 'getSyllabCount',
    value: function getSyllabCount(text) {
      var _this4 = this;

      if (!this._rule) {
        return 0;
      }

      logger.info('counting syllab');

      var countWordSyllabs = function countWordSyllabs(acc, word) {
        if (!word) {
          return acc;
        }

        var result = void 0;
        var exception = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4._exceptions).find(function (exception) {
          return _this4._isException(word, exception);
        });
        if (exception) {
          result = _this4._exceptions[exception];
        } else {
          result = _this4._rule(word, ' ');
        }

        return acc + result.split(' ').length;
      };

      if (text instanceof Array) {
        return text.reduce(function (acc, line) {
          var words = line.split(' ').map(function (word) {
            return word.toLowerCase();
          });
          return words.reduce(countWordSyllabs, acc);
        }, 0);
      } else {
        return text.split(' ').reduce(countWordSyllabs, 0);
      }
    }
  }, {
    key: '_restore',
    value: function _restore(el) {
      var text = null;
      try {
        text = el.textContent;
      } catch (e) {
        logger.error('restoring: element do not exist');
      }

      logger.info('restoring', text);

      if (text) {
        var syllabs = text.split(this._hyphen);
        el.innerHTML = syllabs.join('');
      }
    }
  }, {
    key: '_isException',
    value: function _isException(word, exception) {
      return word.toLowerCase().indexOf(exception) >= 0;
    }
  }, {
    key: '_formatException',
    value: function _formatException(word, exception, syllabified, hyphen) {
      logger.info('params:', word, exception, syllabified, hyphen);
      var start = word.toLowerCase().indexOf(exception);
      var length = exception.length;
      var prefix = word.substr(0, start);
      var postfix = word.substr(start + length);
      var chars = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(syllabified);
      logger.info('info:', start, length, prefix, postfix);

      for (var i = start, j = 0; i < start + length; i++) {
        var c = word.charAt(i);
        if (c === c.toUpperCase()) {
          chars[j] = c;
        }

        while (chars[++j] === this._hyphen) {}
      }

      var result = chars.join('');
      if (this._hyphen !== hyphen) {
        var re = new RegExp(this._hyphen, 'g');
        result = result.replace(re, hyphen);
      }

      return prefix + result + postfix;
    }
  }, {
    key: '_colorize',
    value: function _colorize(syllabs) {
      var colors = Syllabifier.MODES['colors'];
      var colorIndex = 0;

      var colorizedSyllabs = syllabs.map(function (syllab) {
        var result = '<span style="color: ' + colors[colorIndex] + '">' + syllab + '</span>';
        if (++colorIndex === colors.length) {
          colorIndex = 0;
        }
        return result;
      });

      return colorizedSyllabs.join('');
    }
  }, {
    key: 'enabled',
    get: function get() {
      return !!this._rule;
    }
  }, {
    key: 'setup',
    get: function get() {
      return new __WEBPACK_IMPORTED_MODULE_5__model_session_syllabificationFeedback_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this._options, { hyphen: this._hyphen, enabled: !!this._rule }));
    }
  }], [{
    key: 'getPrefixAndSuffix',
    value: function getPrefixAndSuffix(word, hyphen) {
      var chars = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(word);
      var prefix = [];
      var postfix = [];

      var i = 0;
      while (i < chars.length && chars[i++] === hyphen) {
        prefix.push(hyphen);
      }
      i = chars.length - 1;
      while (i >= 0 && chars[i--] === hyphen) {
        postfix.push(hyphen);
      }

      return [prefix.join(''), postfix.join('')];
    }
  }, {
    key: 'MODES',
    get: function get() {
      return {
        hyphen: String.fromCharCode(0x00B7),
        colors: ['black', 'red'] };
    }
  }, {
    key: 'LANGS',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules);
    }
  }]);

  return Syllabifier;
}();

/* harmony default export */ __webpack_exports__["a"] = (Syllabifier);
;

var rules = {
  Suomi: function Suomi(word, hyphen) {
    var vowels = ['a', 'o', 'u', 'i', 'e', 'ä', 'ö', 'y'];
    var consonants = ['b', 'c', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'n', 'p', 'q', 'r', 's', 't', 'v', 'w', 'x', 'z'];
    var diftongs = ['ai', 'ei', 'oi', 'ui', 'yi', 'äi', 'öi', 'au', 'eu', 'iu', 'ou', 'ey', 'iy', 'äy', 'öy', 'ie', 'uo', 'yö'];

    var getType = function getType(c) {
      return vowels.includes(c) ? 'V' : consonants.includes(c) ? 'C' : '_';
    };

    var result = [];

    var hasVowel = false;
    var vowelsInRow = 0;

    for (var i = word.length - 1; i >= 0; i--) {
      var separate = false;
      var char = word[i];
      var type = getType(char);
      var charNext = i > 0 ? word[i - 1] : null;
      var typeNext = charNext ? getType(charNext) : '_';

      if (type === 'V') {
        hasVowel = true;
        vowelsInRow++;

        if (i < word.length - 1) {
          var charPrevious = word[i + 1];
          var typePrevious = getType(charPrevious);
          if (charPrevious !== char && typePrevious === type && !diftongs.includes(char + charPrevious)) {
            result.unshift(hyphen);
            vowelsInRow = 0;
          } else if (char === 'i' && result[0] === 'e' && result[1] === 'n') {
            result.unshift(hyphen);
            vowelsInRow = 0;
          } else if (vowelsInRow === 3) {
            result.unshift(hyphen);
            vowelsInRow = 0;
          }
        }
      } else if (type === 'C' && hasVowel) {
        vowelsInRow = 0;

        separate = i > 0;
        if (i === 1) {
          if (typeNext === type) {
            separate = false;
          }
        }
      }

      result.unshift(char);

      if (separate) {
        if (type !== '_' && typeNext !== '_') {
          result.unshift(hyphen);
        }
        hasVowel = false;
      }
    }

    return result.join('');
  }
};

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);





var RECONNECT_INTERVAL = 3000;

var callbackLists = {
  started: {},
  stopped: {},
  stateUpdated: {},
  wordFocused: {},
  wordLeft: {},
  gazePoint: {},
  customValue: {}
};

var callbacks = {
  started: null,

  stopped: null,

  stateUpdated: null,

  wordFocused: null,

  wordLeft: null,

  gazePoint: null,

  customValue: null
};

var _loop = function _loop(name) {
  callbacks[name] = function (arg) {
    for (var id in callbackLists[name]) {
      callbackLists[name][id](arg);
    }
  };
};

for (var name in callbacks) {
  _loop(name);
}

var lastState = {};

var GazeTracking = function () {
  function GazeTracking() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GazeTracking);

    this._serviceCheckTimer = null;

    this._wsOK = GazeTargets.init({
      etudPanel: {
        show: false
      },
      pointer: {
        show: false
      },
      targets: [{
        selector: '.word',
        selection: {
          type: GazeTargets.selection.types.none
        },
        mapping: {
          className: ''
        }
      }],
      mapping: {
        type: GazeTargets.mapping.types.expanded,
        source: GazeTargets.mapping.sources.samples,
        expansion: 30
      }
    }, {
      state: function state(_state) {
        lastState = _state;


        if (_state.isTracking) {
          callbacks.started();
        } else if (_state.isStopped) {
          callbacks.stopped();
        }

        callbacks.stateUpdated(_state);

        if (_state.isDisconnected) {
          _this.scheduleReconnection();
        }
      },

      target: function target(event, _target) {
        if (event === 'focused') {
          callbacks.wordFocused(_target);
        } else if (event === 'left') {
          callbacks.wordLeft(_target);
        }
      },

      fixation: function fixation(fix) {
        callbacks.gazePoint(fix);
      },

      customValue: function customValue(code, value) {
        callbacks.customValue({ code: code, value: value });
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GazeTracking, [{
    key: 'listCallbacks',
    value: function listCallbacks() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(callbacks);
    }
  }, {
    key: 'setCallback',
    value: function setCallback(name, id, cb) {
      callbackLists[name][id] = cb;
    }
  }, {
    key: 'clearCallback',
    value: function clearCallback(name, id) {
      delete callbackLists[name][id];
    }
  }, {
    key: 'showOptions',
    value: function showOptions() {
      GazeTargets.ETUDriver.showOptions();
    }
  }, {
    key: 'calibrate',
    value: function calibrate() {
      GazeTargets.ETUDriver.calibrate();
    }
  }, {
    key: 'start',
    value: function start() {
      if (!lastState.isTracking) {
        GazeTargets.ETUDriver.toggleTracking();
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (lastState.isTracking) {
        GazeTargets.ETUDriver.toggleTracking();
      }
    }
  }, {
    key: 'updateTargets',
    value: function updateTargets() {
      GazeTargets.updateTargets();
    }
  }, {
    key: 'scheduleReconnection',
    value: function scheduleReconnection() {
      var _this2 = this;

      if (this._serviceCheckTimer) {
        return;
      }

      this._serviceCheckTimer = setTimeout(function () {
        _this2._serviceCheckTimer = null;
        if (!lastState.isServiceRunning) {
          _this2.wsOK = GazeTargets.reconnect();
        }
      }, RECONNECT_INTERVAL);
    }
  }, {
    key: 'getCustomValue',
    value: function getCustomValue(customValueType, cb) {
      var tempID = '' + Math.random();
      callbackLists['customValue'][tempID] = function (e) {
        delete callbackLists['customValue'][tempID];
        cb(null, e);
      };

      GazeTargets.ETUDriver.getCustomValue(customValueType);
    }
  }, {
    key: 'setCustomValue',
    value: function setCustomValue(customValueType, value) {
      GazeTargets.ETUDriver.setCustomValue(customValueType, value);
    }
  }, {
    key: 'listCustomValueTypes',
    value: function listCustomValueTypes() {
      return GazeTargets.ETUDriver.listAvailableCustomValue();
    }
  }, {
    key: 'isWebSocketOK',
    get: function get() {
      return this._wsOK;
    }
  }, {
    key: 'state',
    get: function get() {
      return lastState;
    }
  }]);

  return GazeTracking;
}();

var gazeTracking = new GazeTracking();

/* harmony default export */ __webpack_exports__["a"] = (gazeTracking);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__db_db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__db_userBase__ = __webpack_require__(35);






var Login = function () {
  function Login() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Login);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Login, [{
    key: 'logIn',
    value: function logIn(email, password, cb) {
      return __WEBPACK_IMPORTED_MODULE_2__db_db_js__["a" /* default */].logIn(email, password, cb);
    }
  }, {
    key: 'logOut',
    value: function logOut() {
      __WEBPACK_IMPORTED_MODULE_2__db_db_js__["a" /* default */].logOut();
    }
  }, {
    key: 'resetPassword',
    value: function resetPassword(email, cb) {
      return __WEBPACK_IMPORTED_MODULE_2__db_db_js__["a" /* default */].resetPassword(email, cb);
    }
  }, {
    key: 'user',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_2__db_db_js__["a" /* default */].user;
    }
  }, {
    key: 'isConnected',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_2__db_db_js__["a" /* default */].isConnected;
    }
  }, {
    key: 'DEFAULT_EMAIL_DOMAIN',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_2__db_db_js__["a" /* default */].FAKE_EMAIL_DOMAIN;
    }
  }]);

  return Login;
}();

var login = new Login();
/* harmony default export */ __webpack_exports__["a"] = (login);

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(340)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(431),
  /* scopeId */
  "data-v-65739ed1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  "data-v-fc7e7726",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Font = function () {
  function Font(family, size, style, weight) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Font);

    this.family = family;
    this.size = size;
    this.style = style;
    this.weight = weight;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Font, null, [{
    key: 'from',
    value: function from(style) {
      return new Font(style['font-family'], style['font-size'], style['font-style'], style['font-weight']);
    }
  }]);

  return Font;
}();

/* harmony default export */ __webpack_exports__["a"] = (Font);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var WordFocus = function () {
  function WordFocus(el) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WordFocus);

    this.accumulatedTime = 0;

    this.focusCount = 0;

    this.focusRecorded = false;

    this.entries = 1;

    this.lastSample = window.performance.now();

    this.syllabified = false;

    this.pronounced = false;

    this.highlighted = false;

    this.word = this._getWordFromElement(el);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WordFocus, [{
    key: '_getWordFromElement',
    value: function _getWordFromElement(el) {
      var textNodes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(el.childNodes).filter(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          return true;
        }
        if (node.nodeType === Node.ELEMENT_NODE) {
          return !node.classList.contains('hyphens');
        }
        return false;
      });

      return textNodes.map(function (node) {
        return node.textContent.trim();
      }).join('');
    }
  }]);

  return WordFocus;
}();

/* harmony default export */ __webpack_exports__["a"] = (WordFocus);
;

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__task_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_data_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_session_js__ = __webpack_require__(61);









var Record = function Record(session, data) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Record);

  this.student = session.student;

  this.session = session.ref;

  this.task = session.task;

  this.cls = session.cls;

  this.data = data.find(function (item) {
    return item.id === session.ref.data;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Record);
;

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__session_js__ = __webpack_require__(54);





var Student = function Student(ref) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Student);

  this.ref = ref;

  this.sessions = [];
};

/* harmony default export */ __webpack_exports__["a"] = (Student);
;

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__student_js__ = __webpack_require__(77);







var Task = function Task(id, name) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Task);

  this.id = id;

  this.name = name;

  this.students = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();

  this.sessions = [];

  this.hasQuestionnaire = false;

  this.hasAudio = false;

  __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].get(id, function (err, task) {
    if (!err) {
      _this.hasQuestionnaire = task.questionnaire && task.questionnaire.length;
      _this.hasAudio = task.recordAudio;
    } else {
      console.error('@/vis/datal/task.js/.ctor model/Task.get', err);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Task);
;

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__ = __webpack_require__(3);






var tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__["b" /* i10n */])('vis');

var DURATION_TRANSPARENT = 100;

var Type = {
  NONE: tokens['item_none'],
  DURATION: tokens['item_dur'],
  CHAR_SPEED: tokens['item_char'],
  FOCUS_COUNT: tokens['item_focus']
};

var alphaComputers = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
alphaComputers.set(Type.NONE, function () {
  return 0;
});
alphaComputers.set(Type.DURATION, mapDurationToAlpha);
alphaComputers.set(Type.CHAR_SPEED, mapCharSpeedTAlpha);
alphaComputers.set(Type.FOCUS_COUNT, mapFocusCountToAlpha);


__WEBPACK_IMPORTED_MODULE_3__utils_event_bus_js__["a" /* default */].$on('login', function () {
  tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__["b" /* i10n */])('vis');

  Type = {
    NONE: tokens['item_none'],
    DURATION: tokens['item_dur'],
    CHAR_SPEED: tokens['item_char'],
    FOCUS_COUNT: tokens['item_focus']
  };

  alphaComputers.set(Type.NONE, function () {
    return 0;
  });
  alphaComputers.set(Type.DURATION, mapDurationToAlpha);
  alphaComputers.set(Type.CHAR_SPEED, mapCharSpeedTAlpha);
  alphaComputers.set(Type.FOCUS_COUNT, mapFocusCountToAlpha);
});

function mapDurationToAlpha(word, maxDuration) {
  var result = 0;
  if (word.focusing && word.focusing.duration > DURATION_TRANSPARENT) {
    result = (word.focusing.duration - DURATION_TRANSPARENT) / (maxDuration - DURATION_TRANSPARENT);
  }
  return result;
}

function mapCharSpeedTAlpha(word, maxCharSpeed) {
  var result = 0;
  if (word.reading && word.reading.charSpeed > 0) {
    result = 1 - word.reading.charSpeed / maxCharSpeed;
  }
  return result;
}

function mapFocusCountToAlpha(word, mapFocusCount) {
  var result = 0;
  if (word.focusing && word.focusing.count > 0) {
    result = 1 - word.focusing.count / mapFocusCount;
  }
  return result;
}

var Metric = function () {
  function Metric() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Metric);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Metric, null, [{
    key: 'computeRange',
    value: function computeRange(words, metricType) {
      var maxRange = 0;

      if (metricType === Metric.Type.NONE) {
        return maxRange;
      }

      words.forEach(function (word) {
        if (word.focusing) {
          word.reading = {
            charSpeed: 1000 * word.text.length / word.focusing.duration,
            syllableSpeed: 1000 * word.text.length / 2.5 / word.focusing.duration
          };

          var metricValue = 0;
          switch (metricType) {
            case Metric.Type.DURATION:
              metricValue = word.focusing.duration;
              break;
            case Metric.Type.CHAR_SPEED:
              metricValue = word.reading.charSpeed;
              break;
            case Metric.Type.FOCUS_COUNT:
              metricValue = word.focusing.count;
              break;
          }

          if (maxRange < metricValue) {
            maxRange = metricValue;
          }
        }
      });

      return maxRange;
    }
  }, {
    key: 'getAlpha',
    value: function getAlpha(word, metricType, metricRange) {
      var ac = alphaComputers.get(metricType) || alphaComputers.get(Type.NONE);
      return ac(word, metricRange);
    }
  }, {
    key: 'Type',
    get: function get() {
      return Type;
    }
  }, {
    key: 'Types',
    get: function get() {
      var result = [];
      for (var key in Type) {
        result.push(Type[key]);
      }
      return result;
    }
  }]);

  return Metric;
}();

/* harmony default export */ __webpack_exports__["a"] = (Metric);
;

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(335)
__webpack_require__(334)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(426),
  /* scopeId */
  "data-v-5bad2478",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wordFocusing_js__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wordFeedback_js__ = __webpack_require__(226);





var DataPageFocusedWord = function DataPageFocusedWord(el, page) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DataPageFocusedWord);

  this.text = el ? el.textContent : '';

  this.rect = __WEBPACK_IMPORTED_MODULE_1__rect_js__["a" /* default */].from(el);

  this.page = page;

  this.focusing = new __WEBPACK_IMPORTED_MODULE_2__wordFocusing_js__["a" /* default */]();

  this.feedback = new __WEBPACK_IMPORTED_MODULE_3__wordFeedback_js__["a" /* default */]();
};

/* harmony default export */ __webpack_exports__["a"] = (DataPageFocusedWord);
;

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rect_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wordFont_js__ = __webpack_require__(124);





var DataPageTextWord = function () {
  function DataPageTextWord(id, text, rect, font) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DataPageTextWord);

    this.id = id;
    this.text = text;
    this.rect = rect;
    this.font = font;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DataPageTextWord, null, [{
    key: 'from',
    value: function from(el, id) {
      return el ? new DataPageTextWord(id, el.textContent, __WEBPACK_IMPORTED_MODULE_2__rect_js__["a" /* default */].from(el), __WEBPACK_IMPORTED_MODULE_3__wordFont_js__["a" /* default */].fromEl(el)) : null;
    }
  }, {
    key: 'fromAll',
    value: function fromAll(selector) {
      var list = [];
      var words = document.querySelectorAll(selector);

      for (var i = 0; i < words.length; i += 1) {
        var word = words.item(i);
        list.push(DataPageTextWord.from(word, i));
      }

      return list;
    }
  }]);

  return DataPageTextWord;
}();

/* harmony default export */ __webpack_exports__["a"] = (DataPageTextWord);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rect__ = __webpack_require__(93);




var FeedbackEvent = function FeedbackEvent(ts, text, rect) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FeedbackEvent);

  this.ts = ts;
  this.text = text;
  this.rect = rect;
};

/* harmony default export */ __webpack_exports__["a"] = (FeedbackEvent);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Rect = function () {
  function Rect(x, y, width, height) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Rect);

    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Rect, null, [{
    key: "from",
    value: function from(el) {
      if (!el) {
        return null;
      }

      var rect = el.getBoundingClientRect();
      return new Rect(Math.round(rect.left), Math.round(rect.top), Math.round(rect.width), Math.round(rect.height));
    }
  }]);

  return Rect;
}();

/* harmony default export */ __webpack_exports__["a"] = (Rect);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ScreenSize = function () {
  function ScreenSize(width, height) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ScreenSize);

    this.width = width;
    this.height = height;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ScreenSize, null, [{
    key: "full",
    get: function get() {
      return new ScreenSize(window.screen.width, window.screen.height);
    }
  }]);

  return ScreenSize;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScreenSize);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__textPageImage__ = __webpack_require__(14);




var TextPage = function TextPage(id) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TextPage);

  this.id = id;

  this.lines = [];

  this.images = [];
};

/* harmony default export */ __webpack_exports__["a"] = (TextPage);
;

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_session_speechFeedback_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__wordFocus_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_session_feedbacks_js__ = __webpack_require__(7);













var LONG_WORD_MIN_LENGTH = 7;
var EXTRA_THRESHOLD_FOR_CHAR = 0.05;

var Speaker = function () {
  function Speaker(options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Speaker);

    this._options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options);
    this._options.threshold.factor = 4;

    this.voice = voices[__WEBPACK_IMPORTED_MODULE_4__utils_data_utils_js__["a" /* default */].convertLegacy(this._options.language)];
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Speaker, [{
    key: 'inspect',
    value: function inspect(_, wordFocus) {
      if (!this.voice) {
        return false;
      }

      var threshold = this._options.threshold.value;
      if (this._options.threshold.adjustForWordLength) {
        threshold *= Math.max(1, 1 + (wordFocus.word.length - LONG_WORD_MIN_LENGTH) * EXTRA_THRESHOLD_FOR_CHAR);
      }

      var mustPronounce = !wordFocus.pronounced && wordFocus.accumulatedTime > threshold;

      if (!mustPronounce) {
        return false;
      }

      wordFocus.pronounced = true;
      this.voice(wordFocus.word);

      return true;
    }
  }, {
    key: 'say',
    value: function say(word) {
      if (!this.voice) {
        return;
      }

      this.voice(word);
    }
  }, {
    key: 'setAvgWordReadingDuration',
    value: function setAvgWordReadingDuration(wordReadingDuration) {
      if (!this._options.threshold.smart || !wordReadingDuration) {
        return;
      }

      var threshold = this._options.threshold;
      threshold.value = Math.max(threshold.min, Math.min(threshold.max, wordReadingDuration * threshold.factor));
    }
  }, {
    key: 'enabled',
    get: function get() {
      return !!this.voice;
    }
  }, {
    key: 'setup',
    get: function get() {
      return new __WEBPACK_IMPORTED_MODULE_5__model_session_speechFeedback_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this._options, { enabled: !!this.voice }));
    }
  }], [{
    key: 'LANGS',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(voices);
    }
  }]);

  return Speaker;
}();

/* harmony default export */ __webpack_exports__["a"] = (Speaker);
;

var voices = {
  Suomi: function Suomi(word) {
    responsiveVoice.speak(word, 'Finnish Female');
  },
  English: function English(word) {
    responsiveVoice.speak(word, 'US English Female');
  }
};

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);





var COLORS = ['#5DA5DA', '#FAA43A', '#60BD68', '#F17CB0', '#B2912F', '#B276B2', '#DECF3F', '#4D4D4D', '#F15854'];

function rgb2cmyk(color) {
  color = color.substr(1);

  var compLength = color.length === 3 ? 1 : 2;
  var r = parseInt(clone(color.substr(0 * compLength, compLength), 3 - compLength), 16);
  var g = parseInt(clone(color.substr(1 * compLength, compLength), 3 - compLength), 16);
  var b = parseInt(clone(color.substr(2 * compLength, compLength), 3 - compLength), 16);
  var c = 255 - r;
  var m = 255 - g;
  var y = 255 - b;
  var k = Math.min(c, m, y);
  c = (c - k) / (255 - k);
  m = (m - k) / (255 - k);
  y = (y - k) / (255 - k);

  return {
    c: c,
    m: m,
    y: y,
    k: k / 255
  };
}

function cmyk2rgb(color) {
  var r = color.c * (1.0 - color.k) + color.k;
  var g = color.m * (1.0 - color.k) + color.k;
  var b = color.y * (1.0 - color.k) + color.k;
  r = Math.round((1.0 - r) * 255.0 + 0.5);
  g = Math.round((1.0 - g) * 255.0 + 0.5);
  b = Math.round((1.0 - b) * 255.0 + 0.5);
  return '#' + decToHex(r) + decToHex(g) + decToHex(b);
}

function decToHex(value, n) {
  var hex = Number(value).toString(16);
  n = !n && n !== 0 ? 2 : n;

  while (hex.length < n) {
    hex = '0' + hex;
  }

  return hex;
}

function clone(str, count) {
  var result = '';
  for (var i = 0; i < count; i += 1) {
    result += str;
  }
  return result;
}

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

function rgbaToHex(r, g, b, a) {
  return {
    hex: '#' + componentToHex(r) + componentToHex(g) + componentToHex(b),
    a: a === undefined ? 1 : a
  };
}

var Colors = function () {
  function Colors() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Colors);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Colors, null, [{
    key: 'mix',
    value: function mix(colors) {
      var c = 0;
      var m = 0;
      var y = 0;
      var k = 0;
      var w = 0;
      for (var i = 0; i < colors.length; i += 1) {
        var color = rgb2cmyk(colors[i].color);
        var weight = colors[i].weight;
        c += color.c * weight;
        m += color.m * weight;
        y += color.y * weight;
        k += color.k * weight;
        w += weight;
      }
      var cmyk = {
        c: c / w,
        m: m / w,
        y: y / w,
        k: k / w
      };
      return cmyk2rgb(cmyk);
    }
  }, {
    key: 'rgb2rgba',
    value: function rgb2rgba(color, alpha) {
      var cmyk = rgb2cmyk(color);

      var r = cmyk.c * (1.0 - cmyk.k) + cmyk.k;
      var g = cmyk.m * (1.0 - cmyk.k) + cmyk.k;
      var b = cmyk.y * (1.0 - cmyk.k) + cmyk.k;
      r = Math.round((1.0 - r) * 255.0);
      g = Math.round((1.0 - g) * 255.0);
      b = Math.round((1.0 - b) * 255.0);
      return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
    }
  }, {
    key: 'validateColor',
    value: function validateColor(color) {
      if (color[0] !== '#') {
        return '#000000';
      }
      if (color.length === 7) {
        return color;
      }
      if (color.length === 4) {
        var r = color[1];
        var g = color[2];
        var b = color[3];
        return '#' + r + r + g + g + b + b;
      }
      return '#000000';
    }
  }, {
    key: 'cssColorToHex',
    value: function cssColorToHex(cssColor) {
      var colorRegex = /^\D+(\d+)\D+(\d+)\D+(\d+)\D*(\d|.+)\D+$/gim;
      var colorComps = colorRegex.exec(cssColor);

      return rgbaToHex(parseInt(colorComps[1]), parseInt(colorComps[2]), parseInt(colorComps[3]), colorComps[4] ? parseFloat(colorComps[4]) : undefined);
    }
  }, {
    key: 'hexToRgba',
    value: function hexToRgba(rgb, a) {
      var r = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(rgb.substr(1, 2), 16);
      var g = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(rgb.substr(3, 2), 16);
      var b = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(rgb.substr(5, 2), 16);
      return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    }
  }, {
    key: 'colors',
    get: function get() {
      return COLORS;
    }
  }]);

  return Colors;
}();

/* harmony default export */ __webpack_exports__["a"] = (Colors);
;

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Painter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__task_syllabifier_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vis_metric_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vis_colors_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_data_wordFont_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_session_feedbacks_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_session_font_js__ = __webpack_require__(74);














var LINE_COLOR_A = 0.5;
var LINE_COLORS = ['rgba(255,0,0,' + LINE_COLOR_A, 'rgba(255,255,0,' + LINE_COLOR_A, 'rgba(0,255,0,' + LINE_COLOR_A, 'rgba(0,255,224,' + LINE_COLOR_A, 'rgba(0,128,255,' + LINE_COLOR_A, 'rgba(255,0,255,' + LINE_COLOR_A];

var UNMAPPED_FIXATION_COLOR = 'rgba(0,0,0,0.5)';
var MERGED_FIXATION_BORDER_COLOR = '#808';

var CHECK_MARK = String.fromCharCode(0x2713);
var NO_DATA_MARK = String.fromCharCode(0x26A0);

var Painter = function () {
  function Painter(el, settings) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Painter);

    this._width = document.body.offsetWidth;
    this._height = parseInt(window.getComputedStyle(el).height);
    el.setAttribute('width', this._width + '');
    el.setAttribute('height', this._height + '');

    this._offsetX = 0;
    this._offsetY = 0;

    this._font = null;

    this._syllabifier = new __WEBPACK_IMPORTED_MODULE_4__task_syllabifier_js__["a" /* default */](settings.syllab);

    this._ctx = el.getContext('2d');

    this.clean();
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Painter, [{
    key: 'clean',
    value: function clean() {
      this._ctx.clearRect(0, 0, this._width, this._height);
    }
  }, {
    key: 'setFont',
    value: function setFont(font) {
      this._font = font;
      this._ctx.font = font.style + ' ' + font.weight + ' ' + font.size + ' ' + font.family;
    }
  }, {
    key: 'drawWords',
    value: function drawWords(words, settings) {
      var _this = this;

      var metricRange = __WEBPACK_IMPORTED_MODULE_5__vis_metric_js__["a" /* default */].computeRange(words, settings.colorMetric);

      words.forEach(function (word) {
        var wordSettings = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
          alpha: __WEBPACK_IMPORTED_MODULE_5__vis_metric_js__["a" /* default */].getAlpha(word, settings.colorMetric, metricRange)
        }, settings);

        _this._drawWord(word, wordSettings);
      });
    }
  }, {
    key: 'drawSyllabifications',
    value: function drawSyllabifications(events, settings) {
      var _this2 = this;

      events.forEach(function (event) {
        _this2.drawSyllabification(event, settings);
      });
    }
  }, {
    key: 'drawSyllabification',
    value: function drawSyllabification(event, settings) {
      var ctx = this._ctx;

      ctx.textAlign = 'start';
      ctx.textBaseline = 'alphabetic';

      var rc = event.rect;
      var word = settings.isSyllabified ? this._syllabifier.syllabifyWord(event.text, settings.hyphen) : event.text;

      var _offset2 = this._offset(rc),
          x = _offset2.x,
          y = _offset2.y;

      ctx.fillStyle = settings.background;
      ctx.fillRect(x, y, rc.width, rc.height);

      this._autoAdjustFontSize(rc.width, event.text);

      var _offset3 = this._offset(rc, { dy: 0.8 * rc.height }),
          x = _offset3.x,
          y = _offset3.y;

      ctx.fillStyle = settings.wordColor;
      ctx.fillText(word, x, y);
    }
  }, {
    key: 'drawFixations',
    value: function drawFixations(fixations, settings) {
      var _this3 = this;

      var prevFix = void 0;

      fixations.forEach(function (fix) {
        if (fix.x <= 0 && fix.y <= 0) {
          return;
        }

        if (settings.showSaccades && prevFix) {
          _this3._drawSaccade(prevFix, fix, settings);
        }

        if (settings.showConnections && fix.word) {
          _this3._drawConnection(fix, {
            x: (fix.word.left + fix.word.right) / 2,
            y: fix.word.bottom
          }, {
            left: fix.word.left,
            right: fix.word.right,
            y: fix.word.bottom
          }, settings);
        }

        _this3._drawFixation(fix, settings);

        prevFix = fix;
      });
    }
  }, {
    key: 'drawNames',
    value: function drawNames(names, settings) {
      var ctx = this._ctx;

      names.forEach(function (name, index) {
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        ctx.fillStyle = name.color;
        ctx.font = 'bold ' + settings.fontSize + 'px ' + settings.fontFamily;

        var location = {
          x: settings.location.x + settings.fontSize,
          y: settings.location.y + settings.nameSpacing * settings.fontSize * index
        };

        ctx.fillText(name.text, location.x, location.y);
      });
    }
  }, {
    key: 'checkName',
    value: function checkName(name, settings) {
      var ctx = this._ctx;

      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      ctx.strokeStyle = '#000';
      ctx.fillStyle = name.color;

      var fontFamily = settings.isNoData ? 'Segoe UI' : settings.fontFamily;
      ctx.font = 'bold ' + settings.fontSize + 'px ' + fontFamily;

      var location = {
        x: settings.location.x,
        y: settings.location.y + settings.nameSpacing * settings.fontSize * name.index
      };

      ctx.fillText(settings.isNoData ? NO_DATA_MARK : CHECK_MARK, location.x, location.y);
    }
  }, {
    key: 'setScreenSize',
    value: function setScreenSize(screenSize) {
      this._offsetX = (this._width - screenSize.width) / 2;
      this._offsetY = (this._height - screenSize.height) / 2;
    }
  }, {
    key: '_offset',
    value: function _offset(_ref) {
      var _ref$x = _ref.x,
          x = _ref$x === undefined ? 0 : _ref$x,
          _ref$y = _ref.y,
          y = _ref$y === undefined ? 0 : _ref$y;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { dx: 0, dy: 0 },
          _ref2$dx = _ref2.dx,
          dx = _ref2$dx === undefined ? 0 : _ref2$dx,
          _ref2$dy = _ref2.dy,
          dy = _ref2$dy === undefined ? 0 : _ref2$dy;

      return { x: x + this._offsetX + dx, y: y + this._offsetY + dy };
    }
  }, {
    key: '_autoAdjustFontSize',
    value: function _autoAdjustFontSize(realWidth, word) {
      var wordObj = word;
      if (wordObj.font) {
        var font = wordObj.font;
        this._ctx.font = font.style + ' ' + font.weight + ' ' + font.size + ' ' + this._font.family;
      } else {
        var text = wordObj.text ? wordObj.text : word;
        var _font = this._font;
        this._ctx.font = _font.style + ' ' + _font.weight + ' ' + _font.size + ' ' + _font.family;

        var wordSizeOfDefaultSize = this._ctx.measureText(text);
        var ratioToRealSize = realWidth / wordSizeOfDefaultSize.width;

        var p = /(\d+)(\w+)/.exec(_font.size);
        var newSize = (parseFloat(p[1]) * ratioToRealSize).toFixed(2) + p[2];

        this._ctx.font = _font.style + ' ' + _font.weight + ' ' + newSize + ' ' + this._font.family;
      }
    }
  }, {
    key: '_drawWord',
    value: function _drawWord(word, settings) {
      var ctx = this._ctx;
      var rc = word.rect;

      this._autoAdjustFontSize(rc.width, word);

      var _offset4 = this._offset(rc, { dy: 0.8 * rc.height }),
          x = _offset4.x,
          y = _offset4.y;

      ctx.textAlign = 'start';
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = word.font ? word.font.color : settings.wordColor;
      ctx.fillText(word.text, x, y);

      if (settings.alpha > 0) {
        ctx.fillStyle = __WEBPACK_IMPORTED_MODULE_6__vis_colors_js__["a" /* default */].rgb2rgba(settings.wordHighlightColor, settings.alpha);
        ctx.fillText(word.text, x, y);
      }

      ctx.fillStyle = '#fff';

      var _Syllabifier$getPrefi = __WEBPACK_IMPORTED_MODULE_4__task_syllabifier_js__["a" /* default */].getPrefixAndSuffix(word.text, settings.hyphen),
          _Syllabifier$getPrefi2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_Syllabifier$getPrefi, 2),
          prefix = _Syllabifier$getPrefi2[0],
          suffix = _Syllabifier$getPrefi2[1];

      if (prefix) {
        ctx.fillText(prefix, x, y);
      }
      if (suffix) {
        var _offset5 = this._offset(rc, { dx: rc.width, dy: 0.8 * rc.height }),
            _x2 = _offset5.x,
            _y = _offset5.y;

        ctx.textAlign = 'end';
        ctx.fillText(suffix, _x2, _y);
      }

      if (settings.drawWordFrame) {
        var _offset6 = this._offset(rc),
            _x3 = _offset6.x,
            _y2 = _offset6.y;

        ctx.strokeStyle = settings.wordRectColor;
        ctx.lineWidth = 1;
        ctx.strokeRect(_x3, _y2, rc.width, rc.height);
      }
    }
  }, {
    key: '_drawSaccade',
    value: function _drawSaccade(from, to, settings) {
      var ctx = this._ctx;

      ctx.strokeStyle = to.isRegression ? settings.regressionColor : settings.saccadeColor;
      ctx.beginPath();

      var _offset7 = this._offset(from),
          x = _offset7.x,
          y = _offset7.y;

      ctx.moveTo(x, y);

      var _offset8 = this._offset(to),
          x = _offset8.x,
          y = _offset8.y;

      ctx.lineTo(x, y);
      ctx.stroke();
    }
  }, {
    key: '_drawConnection',
    value: function _drawConnection(from, to, underline, settings) {
      var ctx = this._ctx;

      ctx.strokeStyle = settings.connectionColor;
      ctx.beginPath();

      var _offset9 = this._offset(from),
          x = _offset9.x,
          y = _offset9.y;

      ctx.moveTo(x, y);

      var _offset10 = this._offset(to),
          x = _offset10.x,
          y = _offset10.y;

      ctx.lineTo(x, y);

      ctx.stroke();

      ctx.strokeStyle = settings.connectionColor;
      ctx.lineWidth = 2;
      ctx.beginPath();

      var _offset11 = this._offset({ x: underline.left, y: underline.y }),
          x = _offset11.x,
          y = _offset11.y;

      ctx.moveTo(x, y);

      var _offset12 = this._offset({ x: underline.right, y: underline.y }),
          x = _offset12.x,
          y = _offset12.y;

      ctx.lineTo(x, y);
      ctx.stroke();
    }
  }, {
    key: '_drawFixation',
    value: function _drawFixation(fixation, settings) {
      var ctx = this._ctx;

      if (fixation.line !== undefined) {
        ctx.fillStyle = LINE_COLORS[fixation.line % LINE_COLORS.length];
      } else {
        ctx.fillStyle = UNMAPPED_FIXATION_COLOR;
      }

      var circleSize = Math.round(Math.sqrt(fixation.duration)) / 2;

      var _offset13 = this._offset(fixation),
          x = _offset13.x,
          y = _offset13.y;

      ctx.beginPath();
      ctx.arc(x, y, circleSize, 0, 2 * Math.PI);
      ctx.fill();

      if (fixation.isRegression) {
        ctx.strokeStyle = settings.regressionColor;
        ctx.stroke();
      }

      if (fixation.merged) {
        ctx.strokeStyle = MERGED_FIXATION_BORDER_COLOR;
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.arc(x, y, circleSize + 3, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.lineWidth = 1;
      }
    }
  }, {
    key: 'offset',
    get: function get() {
      return {
        x: this._offsetX,
        y: this._offsetY
      };
    }
  }]);

  return Painter;
}();;

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_data_dataPage__ = __webpack_require__(30);










var _SGWM = {};

var sgwmController = function () {
  function sgwmController() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, sgwmController);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(sgwmController, null, [{
    key: 'initializeSettings',
    value: function initializeSettings() {
      var settings = void 0;

      settings = new SGWM.FixationProcessorSettings();
      _SGWM.FixationProcessorSettings = settings;
      if (!settings.isInitialized) {
        settings.location.enabled = true;
        settings.location.marginX = 290;
        settings.location.marginY = 290;
        settings.duration.enabled = false;
        settings.save();
      }

      settings = new SGWM.SplitToProgressionsSettings();
      _SGWM.SplitToProgressionsSettings = settings;
      if (!settings.isInitialized) {
        settings.bounds = {
          left: -0.5,
          right: 8,
          verticalChar: 2,
          verticalLine: 0.6
        };
        settings.angle = Math.sin(15 * Math.PI / 180);
        settings.save();
      }

      settings = new SGWM.ProgressionMergerSettings();
      _SGWM.ProgressionMergerSettings = settings;
      if (!settings.isInitialized) {
        settings.minLongSetLength = 3;
        settings.fitThreshold = 0.14;
        settings.maxLinearGradient = 0.15;
        settings.removeSingleFixationLines = false;
        settings.correctForEmptyLines = true;
        settings.currentLineSupportInCorrection = 0.15;
        settings.emptyLineDetectorFactor = 1.6;
        settings.intelligentFirstLineMapping = true;
        settings.save();
      }

      settings = new SGWM.WordMapperSettings();
      _SGWM.WordMapperSettings = settings;
      if (!settings.isInitialized) {
        settings.wordCharSkipStart = 3;
        settings.wordCharSkipEnd = 6;
        settings.scalingDiffLimit = 0.9;
        settings.rescaleFixationX = false;
        settings.partialLengthMaxWordLength = 2;
        settings.effectiveLengthFactor = 0.7;
        settings.ignoreTransitions = false;
        settings.save();
      }

      return _SGWM;
    }
  }, {
    key: 'createOptions',
    value: function createOptions() {
      var tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('sgwm');

      return new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["b" /* OptionGroup */]({
        id: '_sgwm',
        title: tokens['hdr_data_map'],
        options: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions([new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["b" /* OptionGroup */]({
          title: tokens['hdr_fix_proc'],
          options: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions({
            'FixationProcessorSettings.location.enabled': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: tokens['lbl_loc'] }),
            'FixationProcessorSettings.location.marginX': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 10, label: '\t' + tokens['lbl_margin']('X') }),
            'FixationProcessorSettings.location.marginY': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, label: '\t' + tokens['lbl_margin']('Y') }),
            'FixationProcessorSettings.duration.enabled': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: tokens['lbl_dur'] }),
            'FixationProcessorSettings.duration.mergingDurationThreshold': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, label: '\t' + tokens['lbl_merge_th'] }),
            'FixationProcessorSettings.duration.mergingDistanceThreshold': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, label: '\t' + tokens['lbl_merge_dist'] }),
            'FixationProcessorSettings.duration.removingDurationThreshold': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, label: '\t' + tokens['lbl_min_dur'] })
          }),
          defaults: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createDefaults(_SGWM.FixationProcessorSettings, ['location', 'duration'], 'FixationProcessorSettings')
        }), new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["b" /* OptionGroup */]({
          title: tokens['hdr_splitter'],
          options: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions({
            'SplitToProgressionsSettings.bounds.left': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.1, label: tokens['lbl_left_margin'] }),
            'SplitToProgressionsSettings.bounds.right': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.1, label: tokens['lbl_right_margin'] }),
            'SplitToProgressionsSettings.bounds.verticalChar': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.1, label: tokens['lbl_v_margin_char'] }),
            'SplitToProgressionsSettings.bounds.verticalLine': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.1, label: tokens['lbl_v_margin_lines'] }),
            'SplitToProgressionsSettings.angle': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.1, label: tokens['lbl_incline'] })
          }),
          defaults: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createDefaults(_SGWM.SplitToProgressionsSettings, ['bounds', 'angle'], 'SplitToProgressionsSettings')
        }), new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["b" /* OptionGroup */]({
          title: tokens['hdr_merger'],
          options: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions({
            'ProgressionMergerSettings.minLongSetLength': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, label: tokens['lbl_short_prog'] }),
            'ProgressionMergerSettings.fitThreshold': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.01, label: tokens['lbl_line_sep'] }),
            'ProgressionMergerSettings.maxLinearGradient': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.01, label: tokens['lbl_line_incline'] }),
            'ProgressionMergerSettings.removeSingleFixationLines': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: tokens['lbl_remove_fix'] }),
            'ProgressionMergerSettings.correctForEmptyLines': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: tokens['lbl_empty_lines'] }),
            'ProgressionMergerSettings.currentLineSupportInCorrection': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.05, label: '\t' + tokens['lbl_support_line'] }),
            'ProgressionMergerSettings.emptyLineDetectorFactor': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.05, label: '\t' + tokens['lbl_empty_line'] }),
            'ProgressionMergerSettings.intelligentFirstLineMapping': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: tokens['lbl_first_line'] })
          }),
          defaults: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createDefaults(_SGWM.ProgressionMergerSettings, ['minLongSetLength', 'fitThreshold', 'maxLinearGradient', 'removeSingleFixationLines', 'correctForEmptyLines', 'currentLineSupportInCorrection', 'emptyLineDetectorFactor', 'intelligentFirstLineMapping'], 'ProgressionMergerSettings')
        }), new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["b" /* OptionGroup */]({
          title: tokens['hdr_word_map'],
          options: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions({
            'WordMapperSettings.wordCharSkipStart': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, label: tokens['lbl_skip_start'] }),
            'WordMapperSettings.wordCharSkipEnd': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, label: tokens['lbl_skip_end'] }),
            'WordMapperSettings.scalingDiffLimit': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.1, label: tokens['lbl_scale'] }),
            'WordMapperSettings.rescaleFixationX': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: tokens['lbl_rescale'] }),
            'WordMapperSettings.partialLengthMaxWordLength': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, label: '\t' + tokens['lbl_short_word'] }),
            'WordMapperSettings.effectiveLengthFactor': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.1, label: '\t' + tokens['lbl_limit'] }),
            'WordMapperSettings.ignoreTransitions': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: tokens['lbl_ignore_trans'] })
          }),
          defaults: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createDefaults(_SGWM.WordMapperSettings, ['wordCharSkipStart', 'wordCharSkipEnd', 'scalingDiffLimit', 'rescaleFixationX', 'partialLengthMaxWordLength', 'effectiveLengthFactor', 'ignoreTransitions'], 'WordMapperSettings')
        })], _SGWM)
      });
    }
  }, {
    key: 'save',
    value: function save() {
      for (var name in _SGWM) {
        var settings = _SGWM[name];
        settings.save();
      }
    }
  }, {
    key: 'map',
    value: function map(page) {
      var sgwmSession = {
        fixations: page.fixations,
        words: page.text.map(function (word) {
          return {
            id: word.id,
            x: word.rect.x,
            y: word.rect.y,
            width: word.rect.width,
            height: word.rect.height,
            text: word.text
          };
        })
      };

      var sgwm = new SGWM();
      var result = sgwm.map(sgwmSession);

      return result;
    }
  }, {
    key: 'settings',
    get: function get() {
      return _SGWM;
    }
  }]);

  return sgwmController;
}();

/* harmony default export */ __webpack_exports__["a"] = (sgwmController);
;

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(323)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(416),
  /* scopeId */
  "data-v-3f92b272",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  "data-v-948d5b90",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(326)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  "data-v-4e966ac5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  methods: {
    makeFullscreen: function makeFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    closeFullscreen: function closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    onFullscreenChanges: function onFullscreenChanges(cb) {
      var handler = function handler(e) {
        if (document.fullscreenElement) {
          return cb(!!document.fullscreenElement);
        } else if (document.mozFullScreenEnabled) {
          return cb(!!document.mozFullScreenEnabled);
        } else if (document.webkitFullscreenEnabled) {
          return cb(!!document.webkitFullscreenEnabled);
        } else if (document.msFullscreenEnabled) {
          return cb(!!document.msFullscreenEnabled);
        }
      };

      if (document.onfullscreenchange !== undefined) {
        document.onfullscreenchange = handler;
      } else if (document.onmozfullscreenchange !== undefined) {
        document.onmozfullscreenchange = handler;
      } else if (document.onwebkitfullscreenchange !== undefined) {
        document.onwebkitfullscreenchange = handler;
      } else if (document.onmsfullscreenchange !== undefined) {
        document.onmsfullscreenchange = handler;
      }
    }
  }

});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var WordFont = function () {
  function WordFont(color, size, style, weight) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, WordFont);

    this.color = color;
    this.size = size;
    this.style = style;
    this.weight = weight;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(WordFont, null, [{
    key: "fromEl",
    value: function fromEl(el) {
      var style = window.getComputedStyle(el);
      return new WordFont(style.color, style.fontSize, style.fontStyle, style.fontWeight);
    }
  }]);

  return WordFont;
}();

/* harmony default export */ __webpack_exports__["a"] = (WordFont);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__feedback_js__ = __webpack_require__(62);






var HighlightFeedback = function (_Feedback) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(HighlightFeedback, _Feedback);

  function HighlightFeedback(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HighlightFeedback);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HighlightFeedback.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(HighlightFeedback)).call(this, options));

    _this.color = options.color;
    return _this;
  }

  return HighlightFeedback;
}(__WEBPACK_IMPORTED_MODULE_4__feedback_js__["a" /* Feedback */]);

/* harmony default export */ __webpack_exports__["a"] = (HighlightFeedback);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__feedback_js__ = __webpack_require__(62);






var SpeechFeedback = function (_Feedback) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SpeechFeedback, _Feedback);

  function SpeechFeedback(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SpeechFeedback);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SpeechFeedback.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SpeechFeedback)).call(this, options));
  }

  return SpeechFeedback;
}(__WEBPACK_IMPORTED_MODULE_4__feedback_js__["a" /* Feedback */]);

/* harmony default export */ __webpack_exports__["a"] = (SpeechFeedback);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__feedback_js__ = __webpack_require__(62);






var SyllabificationFeedback = function (_Feedback) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SyllabificationFeedback, _Feedback);

  function SyllabificationFeedback(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SyllabificationFeedback);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SyllabificationFeedback.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SyllabificationFeedback)).call(this, options));

    _this.hyphen = options.hyphen;

    _this.mode = options.mode;

    _this.temporary = options.temporary;

    _this.exceptions = {};
    return _this;
  }

  return SyllabificationFeedback;
}(__WEBPACK_IMPORTED_MODULE_4__feedback_js__["a" /* Feedback */]);

/* harmony default export */ __webpack_exports__["a"] = (SyllabificationFeedback);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__feedback_js__ = __webpack_require__(62);






var WarningFeedback = function (_Feedback) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(WarningFeedback, _Feedback);

  function WarningFeedback(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WarningFeedback);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WarningFeedback.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WarningFeedback)).call(this, options));
  }

  return WarningFeedback;
}(__WEBPACK_IMPORTED_MODULE_4__feedback_js__["a" /* Feedback */]);

/* harmony default export */ __webpack_exports__["a"] = (WarningFeedback);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_session_feedbacks_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__syllabifier_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__speaker_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__highlighter_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__warningActor_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__wordFocus_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_session_feedbacks__ = __webpack_require__(7);
















var FOCUS_THRESHOLD = 150;
var REENTRY_THRESHOLD = 1000;
var SAMPLE_DURATION = 30;

var HIGHLIGHT_CLASS = 'currentWord';

var FeedbackProvider = function () {
  function FeedbackProvider(syllab, speech, highlight, warning) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FeedbackProvider);

    this._syllabifier = new __WEBPACK_IMPORTED_MODULE_5__syllabifier_js__["a" /* default */](syllab);

    this._speaker = new __WEBPACK_IMPORTED_MODULE_6__speaker_js__["a" /* default */](speech);

    this._highlighter = new __WEBPACK_IMPORTED_MODULE_7__highlighter_js__["a" /* default */](highlight);

    this._warningActor = new __WEBPACK_IMPORTED_MODULE_8__warningActor_js__["a" /* default */](warning);

    this._events = new EventEmitter();

    this.timer = null;

    this.currentWord = null;

    this.lastFocusedWord = null;

    this.lastWord = null;

    this.words = null;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FeedbackProvider, [{
    key: 'cleanup',
    value: function cleanup() {
      if (this.currentWord) {
        this.currentWord.classList.remove(HIGHLIGHT_CLASS);
        this.currentWord = null;
      }

      this.lastFocusedWord = null;
      this.lastWord = null;

      clearTimeout(this.timer);

      this.timer = null;
      this.words = null;
    }
  }, {
    key: 'init',
    value: function init() {
      var _this = this;

      this.words = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();

      if (this._syllabifier.enabled || this._speaker.enabled || this._highlighter.enabled || this._warningActor.enabled) {
        this.timer = setInterval(function () {
          _this._tick();
        }, 30);
      }
    }
  }, {
    key: 'reset',
    value: function reset(avgWordReadingDuration) {
      if (avgWordReadingDuration) {
        this._syllabifier.setAvgWordReadingDuration(avgWordReadingDuration);
        this._speaker.setAvgWordReadingDuration(avgWordReadingDuration);
        this._highlighter.setAvgWordReadingDuration(avgWordReadingDuration);
      }

      this.words = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
      this.currentWord = null;
      this.lastFocusedWord = null;
      this.lastWord = null;
    }
  }, {
    key: 'setFocusedWord',
    value: function setFocusedWord(el) {
      if (this.currentWord !== el) {

        this.currentWord = el;

        if (el) {
          if (!this.words.has(el)) {
            this.words.set(el, new __WEBPACK_IMPORTED_MODULE_9__wordFocus_js__["a" /* default */](el));
          } else {
            var wordFocus = this.words.get(el);

            if (this.currentWord !== this.lastFocusedWord) {
              wordFocus.focusRecorded = false;
            }

            var now = window.performance.now();
            if (now - wordFocus.lastSample > REENTRY_THRESHOLD) {
              wordFocus.entries++;
            }

            wordFocus.lastSample = now;
          }

          this.lastFocusedWord = el;
        }

        this.lastWord = el;
      }

      return this.currentWord ? this.words.get(this.currentWord).word : null;
    }
  }, {
    key: '_tick',
    value: function _tick() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.words.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var wordFocus = this.words.get(key);
          wordFocus.accumulatedTime = Math.max(0, wordFocus.accumulatedTime + (key === this.currentWord ? SAMPLE_DURATION : -SAMPLE_DURATION));

          if (wordFocus.accumulatedTime > FOCUS_THRESHOLD && !wordFocus.focusRecorded) {
            wordFocus.focusRecorded = true;
            wordFocus.focusCount++;
          }

          if (this._syllabifier.inspect(key, wordFocus)) {
            this._events.emitEvent('syllabified', [key]);
          }

          if (this._speaker.inspect(key, wordFocus)) {
            this._events.emitEvent('pronounced', [key]);
          }

          if (this._highlighter.inspect(key, wordFocus)) {
            this._events.emitEvent('highlighted', [key]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this._warningActor.inspect(this.lastWord)) {
        this._events.emitEvent('warned', []);
      }
    }
  }, {
    key: 'syllabifier',
    get: function get() {
      return this._syllabifier;
    }
  }, {
    key: 'speaker',
    get: function get() {
      return this._speaker;
    }
  }, {
    key: 'highlighter',
    get: function get() {
      return this._highlighter;
    }
  }, {
    key: 'waringActor',
    get: function get() {
      return this._warningActor;
    }
  }, {
    key: 'events',
    get: function get() {
      return this._events;
    }
  }, {
    key: 'setup',
    get: function get() {
      return new __WEBPACK_IMPORTED_MODULE_4__model_session_feedbacks_js__["b" /* Feedbacks */](this._speaker.setup, this._syllabifier.setup, this._highlighter.setup, this._warningActor.setup);
    }
  }]);

  return FeedbackProvider;
}();

/* harmony default export */ __webpack_exports__["a"] = (FeedbackProvider);
;

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_session_highlightFeedback_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wordFocus_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_session_feedbacks_js__ = __webpack_require__(7);








var LONG_WORD_MIN_LENGTH = 7;
var EXTRA_THRESHOLD_FOR_CHAR = 0.05;

var Highlighter = function () {
  function Highlighter(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Highlighter);

    this._options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options);
    this._options.threshold.factor = 4;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Highlighter, [{
    key: 'inspect',
    value: function inspect(el, wordFocus) {
      if (!this.enabled) {
        return false;
      }

      var threshold = this._options.threshold.value;
      if (this._options.threshold.adjustForWordLength) {
        threshold *= Math.max(1, 1 + (wordFocus.word.length - LONG_WORD_MIN_LENGTH) * EXTRA_THRESHOLD_FOR_CHAR);
      }

      var mustHighlight = !wordFocus.highlighted && wordFocus.accumulatedTime > threshold;

      if (!mustHighlight) {
        return false;
      }

      wordFocus.highlighted = true;

      el.setAttribute('style', 'color: ' + this._options.color + ' !important');

      return true;
    }
  }, {
    key: 'setAvgWordReadingDuration',
    value: function setAvgWordReadingDuration(wordReadingDuration) {
      if (!this._options.threshold.smart || !wordReadingDuration) {
        return;
      }

      var threshold = this._options.threshold;
      threshold.value = Math.max(threshold.min, Math.min(threshold.max, wordReadingDuration * threshold.factor));
    }
  }, {
    key: 'enabled',
    get: function get() {
      return !!this._options.language;
    }
  }, {
    key: 'setup',
    get: function get() {
      return new __WEBPACK_IMPORTED_MODULE_3__model_session_highlightFeedback_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._options, { enabled: !!this._options.language }));
    }
  }]);

  return Highlighter;
}();

/* harmony default export */ __webpack_exports__["a"] = (Highlighter);
;

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_task_textPage_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__task_syllabifier_js__ = __webpack_require__(63);











var RE_WORD = /(\S+)(\|)([\w,#]+)\b/g;
var RE_LINE = /^(.+)(\s\|)([\w,#]+)$/gm;

var WORD_CLASS = 'word';
var LINE_CLASS = 'line';

var CLASS_NAMES = ['light', 'dark'];
var WEIGHT_NAMES = ['bold', 'b', 'bolder', 'normal', 'n', 'lighter'];
var STYLE_NAMES = ['regular=normal', 'r', 'italic', 'i'];

var TextPresenter = function () {
  function TextPresenter(task, firstPage, container, syllabifier) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, TextPresenter);

    this._container = container;

    this._syllabifier = syllabifier;

    this._pages = task.pages;

    this._hasInstructionPage = !!(firstPage && firstPage.length);

    if (this._hasInstructionPage) {
      var textPage = new __WEBPACK_IMPORTED_MODULE_6__model_task_textPage_js__["a" /* default */](-1);
      textPage.lines = firstPage;
      this._pages.unshift(textPage);
    }

    if (task.alignment === 'left') {
      this._container.classList.add('alignLeft');
    }

    if (task.fontname) {
      this._container.style.fontFamily = '"' + task.fontname + '", Calibri, sans-serif';
    }

    this._pageIndex = -1;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(TextPresenter, [{
    key: 'nextPage',
    value: function nextPage() {
      var newPageIndex = this._pageIndex + 1;
      if (newPageIndex >= this._pages.length) {
        return;
      }

      this._pageIndex = newPageIndex;

      this._createLines(this._container);
    }
  }, {
    key: 'prevPage',
    value: function prevPage() {
      var newPageIndex = this._pageIndex - 1;
      if (newPageIndex < 0) {
        return;
      }

      this._pageIndex = newPageIndex;

      this._createLines(this._container);
    }
  }, {
    key: '_createLines',
    value: function _createLines(el) {
      var _this = this;

      el.innerHTML = '';

      var page = this._pages[this._pageIndex];

      var lines = void 0;
      if ('lines' in page) {
        lines = page.lines;
      } else {
        lines = page;
      }

      lines.forEach(function (line) {
        el.appendChild(_this._lineToElement(line));
      });

      this._splitText();
    }
  }, {
    key: '_lineToElement',
    value: function _lineToElement(line) {
      var styledLine = this._parseStyles(line);

      var el = document.createElement('div');
      el.innerHTML = styledLine;
      el.classList.add(LINE_CLASS);

      return el;
    }
  }, {
    key: '_parseStyles',
    value: function _parseStyles(line) {
      function applyStyleAndSpace() {
        return applyStyle.apply(undefined, Array.prototype.slice.call(arguments).concat([true]));
      }

      function applyStyle(match, p1, p2, p3, offset, string, addSpace) {
        var text = p1;
        var styles = p3;

        var css = [];

        var classes = [];
        styles.split(',').forEach(function (style) {
          var styleAsNumber = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default()(style);
          var isNumber = !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(styleAsNumber);

          if (CLASS_NAMES.includes(style)) {
            classes.push(style);
          } else if (WEIGHT_NAMES.includes(style) || (isNumber && styleAsNumber % 100) === 0) {
            if (style.length === 1) {
              style = WEIGHT_NAMES[WEIGHT_NAMES.indexOf(style) - 1];
            }
            css.push('font-weight:' + style + ' !important');
          } else if (STYLE_NAMES.includes(style)) {
            if (style.length === 1) {
              style = STYLE_NAMES[STYLE_NAMES.indexOf(style) - 1];
            }
            if (style.indexOf('=') >= 0) {
              style = style.split('=')[1];
            }
            css.push('font-style:' + style + ' !important');
          } else {
            css.push((isNumber ? 'font-size:' : 'color:') + style);
          }
        });

        var s = addSpace ? ' ' : '';
        return '<span class="' + classes.join(' ') + '" style="' + css.join(';') + '">' + s + text + '</span>' + s;
      }

      return line.replace(RE_WORD, applyStyleAndSpace).replace(RE_LINE, applyStyle);
    }
  }, {
    key: '_splitText',
    value: function _splitText() {
      var re = /[^\s]+/gi;

      var nodeIterator = document.createNodeIterator(this._container, NodeFilter.SHOW_TEXT, { acceptNode: function acceptNode(node) {
          if (!/^\s*$/.test(node.nodeValue)) {
            return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_REJECT;
        } });

      var node = void 0;
      var wordID = 0;
      var docFrags = [];

      while (node = nodeIterator.nextNode()) {
        var word = void 0;
        var index = 0;
        var docFrag = document.createDocumentFragment();

        while ((word = re.exec(node.textContent)) !== null) {
          if (index < word.index) {
            var space = document.createTextNode(node.textContent.substring(index, word.index));
            docFrag.appendChild(space);
          }

          var wordText = this._syllabifier.prepareWord(word[0]);

          var span = document.createElement('span');
          span.classList.add(WORD_CLASS);
          span.dataset.wordId = wordID++ + '';
          span.innerHTML = wordText;
          docFrag.appendChild(span);

          index = re.lastIndex;
        }

        docFrags.push({ node: node, docFrag: docFrag });
      }

      docFrags.forEach(function (item) {
        item.node.parentNode.replaceChild(item.docFrag, item.node);
      });
    }
  }, {
    key: 'page',
    get: function get() {
      return this._pageIndex;
    }
  }, {
    key: 'originalPageIndex',
    get: function get() {
      return this._hasInstructionPage ? this._pageIndex - 1 : this._pageIndex;
    }
  }, {
    key: 'isInstructionPage',
    get: function get() {
      return this._pageIndex === 0 && this._hasInstructionPage;
    }
  }, {
    key: 'hasNextPage',
    get: function get() {
      return this._pageIndex + 1 < this._pages.length;
    }
  }, {
    key: 'hasPrevPage',
    get: function get() {
      return this._pageIndex - 1 >= 0;
    }
  }, {
    key: 'words',
    get: function get() {
      var _this2 = this;

      var result = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();

      var els = document.querySelectorAll('.' + WORD_CLASS);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(els).forEach(function (el) {
        result.set(el, _this2._syllabifier.unprepare(el.textContent));
      });

      return result;
    }
  }]);

  return TextPresenter;
}();

/* harmony default export */ __webpack_exports__["a"] = (TextPresenter);
;

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_session_warningFeedback_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__task_speaker_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_session_feedbacks_js__ = __webpack_require__(7);








var LONG_WORD_MIN_LENGTH = 7;
var EXTRA_THRESHOLD_FOR_CHAR = 0.05;

var MAX_UNATTENDED_TEXT = 5000;

var WarningActor = function () {
  function WarningActor(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WarningActor);

    this._options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options);

    this.lastFocusedWord = null;

    this.textLeftTime = 0;

    this.warningSpeaker = options.language ? new __WEBPACK_IMPORTED_MODULE_4__task_speaker_js__["a" /* default */]({
      language: options.language,
      threshold: new __WEBPACK_IMPORTED_MODULE_5__model_session_feedbacks_js__["a" /* Threshold */](options.threshold.value)
    }) : null;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WarningActor, [{
    key: 'inspect',
    value: function inspect(el) {
      if (!this.enabled) {
        return false;
      }

      if (el) {
        this.textLeftTime = 0;
        this.lastFocusedWord = el;
        return false;
      }

      if (this.lastFocusedWord && !el) {
        this.textLeftTime = performance.now();
      }

      this.lastFocusedWord = el;

      if (!this.textLeftTime) {
        return false;
      }

      var threshold = this._options.threshold.value;
      var duration = performance.now() - this.textLeftTime;
      if (duration < threshold) {
        return false;
      }

      this.warningSpeaker.say('Jatka lukemista!');
      this.textLeftTime = 0;
      return true;
    }
  }, {
    key: 'enabled',
    get: function get() {
      return !!this._options.language;
    }
  }, {
    key: 'setup',
    get: function get() {
      return new __WEBPACK_IMPORTED_MODULE_3__model_session_warningFeedback_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._options, { enabled: !!this._options.language }));
    }
  }]);

  return WarningActor;
}();

/* harmony default export */ __webpack_exports__["a"] = (WarningActor);
;

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var SelectionBoxItem = function SelectionBoxItem(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === undefined ? '' : _ref$id,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? '' : _ref$text,
      _ref$selected = _ref.selected,
      selected = _ref$selected === undefined ? false : _ref$selected,
      _ref$group = _ref.group,
      group = _ref$group === undefined ? '' : _ref$group;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SelectionBoxItem);

  this.id = id;

  this.text = text;

  this.selected = !!selected;

  this.group = group;
};

/* harmony default export */ __webpack_exports__["a"] = (SelectionBoxItem);
;

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Params = function Params(args) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Params);

  this.student = args.student;

  this.session = args.session;

  this.grade = args.grade;
};

/* harmony default export */ __webpack_exports__["a"] = (Params);
;

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Regressions = function () {
  function Regressions() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Regressions);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Regressions, null, [{
    key: "compute",
    value: function compute(mappedFixations) {
      var regressionCount = 0;
      var lastWordID = -1;
      var lastWordLine = -1;
      var isPrevFixProgressive = true;

      mappedFixations.forEach(function (fix) {
        if (!fix.word) {
          lastWordID = -1;
          lastWordLine = -1;
          isPrevFixProgressive = true;
          return;
        }

        var direction = fix.word.id - lastWordID;
        if (direction < 0 && lastWordLine === fix.line) {
          fix.isRegression = true;
          if (isPrevFixProgressive) {
            regressionCount++;
          }
          isPrevFixProgressive = false;
        } else {
          isPrevFixProgressive = true;
        }

        lastWordID = fix.word.id;
        lastWordLine = fix.line;
      });

      return regressionCount;
    }
  }]);

  return Regressions;
}();

/* harmony default export */ __webpack_exports__["a"] = (Regressions);
;

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  "data-v-d0862f26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(329)
__webpack_require__(328)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(421),
  /* scopeId */
  "data-v-565edc6d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./db.development.js": 217,
	"./db.production.js": 218
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tabs_Home_vue__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tabs_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tabs_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tabs_Schools_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tabs_Schools_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tabs_Schools_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tabs_Teachers_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tabs_Teachers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tabs_Teachers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tabs_Students_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tabs_Students_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_tabs_Students_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tabs_Instructions_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tabs_Instructions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_tabs_Instructions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tabs_Classes_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tabs_Classes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_tabs_Classes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tabs_Results_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tabs_Results_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_tabs_Results_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_tabs_Assignments_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_tabs_Assignments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_tabs_Assignments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tabs_Assignment_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tabs_Assignment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_tabs_Assignment_vue__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_2__components_tabs_Home_vue___default.a }, { path: '/schools', component: __WEBPACK_IMPORTED_MODULE_3__components_tabs_Schools_vue___default.a }, { path: '/teachers', component: __WEBPACK_IMPORTED_MODULE_4__components_tabs_Teachers_vue___default.a }, { path: '/students', component: __WEBPACK_IMPORTED_MODULE_5__components_tabs_Students_vue___default.a }, { path: '/instructions', component: __WEBPACK_IMPORTED_MODULE_6__components_tabs_Instructions_vue___default.a }, { path: '/classes', component: __WEBPACK_IMPORTED_MODULE_7__components_tabs_Classes_vue___default.a }, { path: '/results', component: __WEBPACK_IMPORTED_MODULE_8__components_tabs_Results_vue___default.a }, { path: '/assignments', component: __WEBPACK_IMPORTED_MODULE_9__components_tabs_Assignments_vue___default.a }, { path: '/assignment/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_tabs_Assignment_vue___default.a }],
  base: "/silko" + '/',
  linkActiveClass: 'is-active',
  mode: 'history'
}));

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  "data-v-93315f94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_login_js__ = __webpack_require__(65);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue___default.a
  },

  data: function data() {
    return {
      isLoggedIn: !!__WEBPACK_IMPORTED_MODULE_2__utils_login_js__["a" /* default */].user
    };
  },
  created: function created() {
    var _this = this;

    console.log('App component created');
    __WEBPACK_IMPORTED_MODULE_1__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this.isLoggedIn = false;
    });
    __WEBPACK_IMPORTED_MODULE_1__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this.isLoggedIn = true;
    });
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_login_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__db_userBase__ = __webpack_require__(35);








var MANUAL_PAGES = {
  'admin': {
    '/': ''
  },
  'school': {
    '/': '',
    '/teachers': 'maintain-teachers.html',
    '/students': 'maintain-students.html'
  },
  'teacher': {
    '/': '',
    '/students': 'listing-students.html',
    '/instructions': 'introductions.html',
    '/classes': 'classes.html',
    '/results': 'results.html'
  },
  'student': {
    '/': '',
    '/assignments': 'assignments.html'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbar',

  data: function data() {
    return {
      user: null,
      langs: __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["a" /* langs */],
      isUsermenuDropped: false,
      isUsermenuHover: false,
      manualTopic: '',

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('navbar', '_buttons', '_labels')
    };
  },


  computed: {
    isAdmin: function isAdmin() {
      return this.user ? this.user.isAdmin : false;
    },
    isSchool: function isSchool() {
      return this.user ? this.user.isSchool : false;
    },
    isTeacher: function isTeacher() {
      return this.user ? this.user.isTeacher : false;
    },
    isStudent: function isStudent() {
      return this.user ? this.user.isStudent : false;
    },
    isAssignment: function isAssignment() {
      return this.$route.path.indexOf('/assignment/') >= 0;
    },
    manualLink: function manualLink() {
      var userType = 'teacher';
      if (this.user) {
        if (this.user.isSchool) {
          userType = 'school';
        } else if (this.user.isStudent) {
          userType = 'student';
        }
      }

      var lang = this.user ? this.user.prefs.lang : 'en';
      var manualPage = MANUAL_PAGES[userType][this.manualTopic] || '';

      return 'https://uta-gasp.gitbooks.io/silko/' + lang + '/' + userType + '/' + manualPage;
    }
  },

  methods: {
    logOut: function logOut(e) {
      __WEBPACK_IMPORTED_MODULE_1__utils_login_js__["a" /* default */].logOut();
    },
    updateLanguage: function updateLanguage(e) {
      this.user.prefs.lang = e.target.value;
      this.user.update(function (err) {
        __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$emit('lang');
      });
    }
  },

  created: function created() {
    var _this = this;

    this.user = __WEBPACK_IMPORTED_MODULE_1__utils_login_js__["a" /* default */].user;

    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('navbar', '_buttons', '_labels');
      _this.user = __WEBPACK_IMPORTED_MODULE_1__utils_login_js__["a" /* default */].user;
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this.user = null;
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('navbar', '_buttons', '_labels');
    });

    document.addEventListener('click', function (e) {
      _this.isUsermenuDropped = false;
    });

    this.$router.onReady(function () {
      _this.manualTopic = _this.$router.currentRoute.path;
    });

    this.$router.beforeResolve(function (to, from, next) {
      _this.manualTopic = to.path;
      next();
    });
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_intro_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_ModalError_vue__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_ModalError_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_ModalError_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_task_CalibPage_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_task_CalibPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_task_CalibPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_task_StartPage_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_task_StartPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_task_StartPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_task_QuestionnairePage_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_task_QuestionnairePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_task_QuestionnairePage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_task_FinishedPage_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_task_FinishedPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_task_FinishedPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_session_question_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_router__ = __webpack_require__(160);



















var STATES = {
  calibrate: {},
  start: {},
  questionnaire: {},
  finished: {}
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assignments',

  components: {
    'modal-error': __WEBPACK_IMPORTED_MODULE_4__components_widgets_ModalError_vue___default.a,
    'calib-page': __WEBPACK_IMPORTED_MODULE_5__components_task_CalibPage_vue___default.a,
    'start-page': __WEBPACK_IMPORTED_MODULE_6__components_task_StartPage_vue___default.a,
    'questionnaire-page': __WEBPACK_IMPORTED_MODULE_7__components_task_QuestionnairePage_vue___default.a,
    'finished-page': __WEBPACK_IMPORTED_MODULE_8__components_task_FinishedPage_vue___default.a
  },

  data: function data() {
    return {
      student: null,

      task: null,

      intro: null,

      state: STATES.calibrate,
      isDataSaved: false,

      errorText: null,

      keys: null,

      questionnaire: null,

      longGazedWords: [],

      STATES: STATES
    };
  },


  computed: {
    introTexts: function introTexts() {
      return this.intro ? this.intro : {};
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      this.student = __WEBPACK_IMPORTED_MODULE_0__model_student_js__["a" /* default */].instance;
      if (this.student) {
        var taskID = void 0;
        if (__WEBPACK_IMPORTED_MODULE_0__model_student_js__["a" /* default */].MULTICLASS) {
          taskID = this.$route.params.id;
          if (!(taskID in this.student.assignments)) {
            return this.$router.replace('assignments');
          }
        } else {
          taskID = this.student.assignments[this.$route.params.id];
          if (!taskID) {
            return this.$router.replace('assignments');
          }
        }

        this.student.loadTask(taskID, function (err, task) {
          if (err) {
            _this.errorText = err;
            return;
          }
          _this.task = task;
        }).then(function (_) {
          _this.task.getIntro(function (err, intro) {
            if (err) {
              _this.errorText = err.message ? err.message : err;
            } else if (intro) {
              _this.intro = intro;
            } else {
              _this.intro = new __WEBPACK_IMPORTED_MODULE_1__model_intro_js__["a" /* default */]();
            }
          });
        });
      }
    },
    checkAccess: function checkAccess() {
      if (!__WEBPACK_IMPORTED_MODULE_0__model_student_js__["a" /* default */].isLogged) {
        this.$router.replace('/');
      }
    },
    exit: function exit(e) {
      this.errorText = null;
      this.$router.replace('/assignments');
    },
    calibrate: function calibrate(e) {
      if (!e.skip) {
        __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].calibrate();
      }

      this.state = STATES.start;
    },
    startPageClosed: function startPageClosed(e) {
      if (e.finished) {
        if (this.task.questionnaire && this.task.questionnaire.length) {
          this.longGazedWords = e.longGazedWords;
          this.state = STATES.questionnaire;
        } else {
          this.state = STATES.finished;
        }
      } else if (e.cancelled) {
        this.state = STATES.calibrate;
      }
    },
    gazeDataSaved: function gazeDataSaved(e) {
      if (!e.err) {
        this.keys = e.keys;
        if (this.state === STATES.finished) {
          this.taskDone();
        }
      } else {
        this.errorText = e.err;
      }

      this.isDataSaved = true;
    },
    questionnaireDone: function questionnaireDone(e) {
      this.questionnaire = e.questionnaire;
      this.state = STATES.finished;

      this.taskDone();
    },
    taskDone: function taskDone() {
      var _this2 = this;

      if (!this.keys) {
        return;
      }

      if (this.questionnaire) {
        this.student.addQuestionnaire(this.keys.data, this.questionnaire, function (err) {
          if (err) {
            _this2.errorText = err;
          }
        });
      }

      var id = __WEBPACK_IMPORTED_MODULE_0__model_student_js__["a" /* default */].MULTICLASS ? this.task.id : this.task.cls;
      this.student.taskDone(id, this.keys.session, function (err) {
        if (err) {
          _this2.errorText = err;
        }
      });
    }
  },

  created: function created() {
    var _this3 = this;

    console.log('Assignment component created');
    __WEBPACK_IMPORTED_MODULE_3__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this3.checkAccess();
    });
    __WEBPACK_IMPORTED_MODULE_3__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this3.init();
    });

    this.checkAccess();
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_TemporalNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_data_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_data_dataPage_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_task_js__ = __webpack_require__(8);


















var __needed_only_to_make_vscode_happy_about_Assignment__ = null;

var __needed_only_to_make_vscode_happy_about_Session__ = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assignments',

  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_6__components_widgets_TemporalNotification_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__["a" /* default */]],

  data: function data() {
    return {
      student: null,

      assignments: null,
      sessions: null,
      assignment: '',

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('assignments', '_labels', '_buttons', '_failures')
    };
  },


  filters: {
    prettifyDate: function prettifyDate(value) {
      return __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].sessionDate(value);
    }
  },

  methods: {
    init: function init() {
      this.student = __WEBPACK_IMPORTED_MODULE_3__model_student_js__["a" /* default */].instance;
      if (this.student) {
        this.loadAssignments();
        this.loadSessions();
      }
    },
    loadAssignments: function loadAssignments() {
      var _this = this;

      this.student.loadAssignments(function (err, assignments) {
        _this.assignments = [];
        if (err) {
          return _this.setError(err, _this.tokens['load'](_this.tokens['assignments']));
        }

        _this.assignments = assignments;
      });
    },
    loadSessions: function loadSessions() {
      var _this2 = this;

      this.student.loadSessions(function (err, sessions) {
        _this2.sessions = [];
        if (err) {
          return _this2.setError(err, _this2.tokens['load'](_this2.tokens['sessions']));
        }

        _this2.sessions = sessions;
      });
    },
    checkAccess: function checkAccess() {
      if (!__WEBPACK_IMPORTED_MODULE_3__model_student_js__["a" /* default */].isLogged) {
        this.$router.replace('/');
      }
    },
    start: function start(assignment, e) {
      if (__WEBPACK_IMPORTED_MODULE_3__model_student_js__["a" /* default */].MULTICLASS) {
        this.$router.replace('/assignment/' + assignment.task.id);
      } else {
        this.$router.replace('/assignment/' + assignment.cls.id);
      }
    },
    getWPM: function getWPM(data) {
      var pages = data.pages;

      var firstPage = void 0;

      var lastPage = void 0;
      var wordCount = 0;
      pages.forEach(function (page) {
        if (!firstPage && page.fixations) {
          firstPage = page;
        }
        if (page.fixations) {
          lastPage = page;
          wordCount += page.text.length;
        }
      });

      if (!firstPage || !lastPage) {
        return '-';
      }

      var firstFixation = firstPage.fixations[0];
      var lastFixation = lastPage.fixations[lastPage.fixations.length - 1];
      var duration = lastFixation.ts + lastFixation.duration - firstFixation.ts;

      return (wordCount / (duration / 60000)).toFixed(0);
    }
  },

  created: function created() {
    var _this3 = this;

    console.log('Assignments component created');
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this3.checkAccess();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this3.init();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this3.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('assignments', '_labels', '_buttons', '_failures');
    });

    this.checkAccess();
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_actionSuccess__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_TaskList_vue__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_TaskList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_TaskList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_StudentList_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_StudentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_StudentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_intro_js__ = __webpack_require__(20);




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'classes',

  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue___default.a,
    'task-list': __WEBPACK_IMPORTED_MODULE_8__components_widgets_TaskList_vue___default.a,
    'student-list': __WEBPACK_IMPORTED_MODULE_9__components_widgets_StudentList_vue___default.a,
    'remove-warning': __WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_mixins_actionSuccess__["a" /* default */]],

  data: function data() {
    return {
      teacher: null,

      newName: '',

      isCreating: false,
      refreshStudents: 0,

      classes: null,

      intros: [],

      toDelete: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('classes', '_form', '_buttons', '_labels', '_failures')
    };
  },


  computed: {
    canCreate: function canCreate() {
      return this.newName.length > 2;
    },
    toDeleteName: function toDeleteName() {
      return this.toDelete ? this.toDelete.name : '';
    }
  },

  methods: {
    init: function init() {
      this.teacher = __WEBPACK_IMPORTED_MODULE_3__model_teacher_js__["a" /* default */].instance;
      if (this.teacher) {
        this.loadClasses();
        this.loadIntros();
      }
    },
    loadClasses: function loadClasses() {
      var _this = this;

      this.teacher.getClasses(function (err, classes) {
        if (err) {
          _this.classes = [];
          return _this.setError(err, _this.tokens['load'](_this.tokens['classes']));
        }

        _this.classes = classes.sort(__WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].byName);
      });
    },
    loadIntros: function loadIntros() {
      var _this2 = this;

      this.teacher.getIntros(function (err, intros) {
        if (err) {
          return _this2.setError(err, _this2.tokens['load'](_this2.tokens['instructions']));
        }

        _this2.intros = intros.sort(__WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].byName);
      });
    },
    checkAccess: function checkAccess() {
      if (!__WEBPACK_IMPORTED_MODULE_3__model_teacher_js__["a" /* default */].isLogged) {
        this.$router.replace('/');
      }
    },
    tryToCreate: function tryToCreate(e) {
      var _this3 = this;

      if (!this.canCreate) {
        return;
      }

      var exists = this.classes.some(function (cls) {
        return cls.name.toLowerCase() === _this3.newName.toLowerCase();
      });

      if (exists) {
        this.setError(this.tokens['msg_name_exists'], this.tokens['create_new'](this.tokens['class']));
      } else {
        this.createClass(this.newName);
      }
    },
    createClass: function createClass(name) {
      var _this4 = this;

      this.isCreating = true;

      this.teacher.createClass(name, function (err, _) {
        _this4.isCreating = false;

        if (err) {
          _this4.setError(err, _this4.tokens['create_new'](_this4.tokens['class']));
        } else {
          _this4.loadClasses();

          _this4.setSuccess(_this4.tokens['created'](_this4.tokens['class']));

          _this4.newName = '';
        }
      });
    },
    removeClass: function removeClass(item, e) {
      this.toDelete = item;
    },
    removeWarningClosed: function removeWarningClosed(e) {
      var _this5 = this;

      if (e.confirm) {
        this.teacher.deleteClass(this.toDelete, function (err) {
          if (err) {
            _this5.setError(err, _this5.tokens['delete'](_this5.tokens['class']));
          } else {
            _this5.setSuccess(_this5.tokens['deleted'](_this5.tokens['class']));
          }

          _this5.loadClasses();
        });
      }

      this.toDelete = null;
    },
    taskSaved: function taskSaved(e) {
      if (e.err) {
        this.setError(e.err, this.tokens['update'](this.tokens['task']));
      } else {
        this.setSuccess(this.tokens['updated'](this.tokens['task']));
      }
    },
    taskCreated: function taskCreated(e) {
      if (e.err) {
        this.setError(e.err, this.tokens['create_new'](this.tokens['task']));
      } else {
        this.setSuccess(this.tokens['created'](this.tokens['task']));
        this.refreshStudents = Math.random();
      }
    },
    taskDeleted: function taskDeleted(e) {
      this.refreshStudents = Math.random();
    }
  },

  created: function created() {
    var _this6 = this;

    console.log('Classes component created');
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this6.checkAccess();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this6.init();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this6.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('classes', '_form', '_buttons', '_labels', '_failures');
    });

    this.checkAccess();
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_login_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_actionSuccess__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Login_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_ModalContainer_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_ModalContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_ModalContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_TemporalNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__db_userBase_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_school_js__ = __webpack_require__(25);


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',

  components: {
    'login': __WEBPACK_IMPORTED_MODULE_6__components_widgets_Login_vue___default.a,
    'modal-container': __WEBPACK_IMPORTED_MODULE_7__components_widgets_ModalContainer_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_8__components_widgets_TemporalNotification_vue___default.a,
    'loading': __WEBPACK_IMPORTED_MODULE_9__components_widgets_Loading_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_mixins_actionSuccess__["a" /* default */]],

  data: function data() {
    return {
      showWsSecurityError: !__WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].isWebSocketOK,
      isConnecting: true,

      isLoginVisible: true,

      user: null,

      schools: null,

      schoolToRegester: null,

      isGettingEmail: false,
      email: '',

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('home', '_form', '_buttons', '_labels')
    };
  },


  computed: {
    isAdmin: function isAdmin() {
      return this.user && this.user.isAdmin;
    },
    isSchool: function isSchool() {
      return this.user && this.user.isSchool;
    },
    isTeacher: function isTeacher() {
      return this.user && this.user.isTeacher;
    },
    isStudent: function isStudent() {
      return this.user && this.user.isStudent;
    },
    userTitle: function userTitle() {
      if (this.isAdmin) {
        return this.tokens['admin'];
      } else if (this.isSchool) {
        return this.tokens['school'];
      } else if (this.isTeacher) {
        return this.tokens['teacher'];
      } else if (this.isStudent) {
        return this.tokens['student'];
      } else {
        return '';
      }
    },
    isEmailValid: function isEmailValid() {
      return !this.email || /(.{2,})@(\w{2,}\.\w{2,})/.test(this.email);
    },
    isFirefox: function isFirefox() {
      var ua = window.navigator && window.navigator.userAgent || '';
      return ua.indexOf('Mozilla') >= 0;
    }
  },

  methods: {
    register: function register(e) {
      this.schools = true;
    },
    sendResistrationRequest: function sendResistrationRequest(e) {
      this.closeSelectionBox(null);

      this.schoolToRegester = e.selected;

      this.isGettingEmail = true;
    },
    remindPassword: function remindPassword(e) {
      this.isGettingEmail = true;
    },
    closeSelectionBox: function closeSelectionBox(e) {
      this.schools = null;
    },
    closeEmailBox: function closeEmailBox(e) {
      this.isGettingEmail = false;
    },
    sendPasswordResetRequest: function sendPasswordResetRequest(e) {
      var _this = this;

      if (this.schoolToRegester) {
        this.setSuccess(this.tokens['msg_request_sent'](this.email));
        this.schoolToRegester = null;
      } else {
        __WEBPACK_IMPORTED_MODULE_1__utils_login_js__["a" /* default */].resetPassword(this.email, function (err) {
          if (err) {
            _this.setError(err, _this.tokens['err_password_reset'](_this.email));
          } else {
            _this.setSuccess(_this.tokens['msg_password_reset']);
          }
          _this.email = '';
        });
      }

      this.closeEmailBox(null);
    },
    passwordResetAppeared: function passwordResetAppeared(e) {
      this.$refs.email.focus();
    }
  },

  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('connected', function (e) {
      _this2.isConnecting = false;
      if (e.user) {
        _this2.user = e.user;
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this2.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('home', '_form', '_buttons', '_labels');
      _this2.user = __WEBPACK_IMPORTED_MODULE_1__utils_login_js__["a" /* default */].user;
      _this2.isConnecting = false;
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this2.user = null;
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this2.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('home', '_form', '_buttons', '_labels');
    });

    this.user = __WEBPACK_IMPORTED_MODULE_1__utils_login_js__["a" /* default */].user;
    this.isConnecting = !__WEBPACK_IMPORTED_MODULE_1__utils_login_js__["a" /* default */].isConnected;
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_actionSuccess__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_ModalContainer_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_ModalContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_ModalContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_IntroEditor_vue__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_IntroEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_IntroEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_intro_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_commons_createParams_js__ = __webpack_require__(60);




















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'instructions',

  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue___default.a,
    'modal-container': __WEBPACK_IMPORTED_MODULE_8__components_widgets_ModalContainer_vue___default.a,
    'intro-editor': __WEBPACK_IMPORTED_MODULE_9__components_widgets_IntroEditor_vue___default.a,
    'remove-warning': __WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_mixins_actionSuccess__["a" /* default */]],

  data: function data() {
    return {
      teacher: null,

      resetNew: 0,

      isCreating: false,

      intros: null,

      toDelete: null,

      toEdit: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('instructions', '_form', '_buttons', '_labels', '_failures')
    };
  },


  computed: {
    toDeleteName: function toDeleteName() {
      return this.toDelete ? this.toDelete.name : '';
    }
  },

  methods: {
    init: function init() {
      this.teacher = __WEBPACK_IMPORTED_MODULE_3__model_teacher_js__["a" /* default */].instance;
      if (this.teacher) {
        this.loadIntros();
      }
    },
    loadIntros: function loadIntros() {
      var _this = this;

      this.teacher.getIntros(function (err, intros) {
        if (err) {
          _this.intros = [];
          return _this.setError(err, _this.tokens['load'](_this.tokens['instructions']));
        }

        _this.intros = intros.sort(__WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].byName);
      });
    },
    checkAccess: function checkAccess() {
      if (!__WEBPACK_IMPORTED_MODULE_3__model_teacher_js__["a" /* default */].isLogged) {
        this.$router.replace('/');
      }
    },
    tryToCreate: function tryToCreate(e) {
      var exists = this.intros.some(function (intro) {
        return intro.name.toLowerCase() === e.name.toLowerCase();
      });

      if (exists) {
        this.setError(this.tokens['err_exists'], this.tokens['create_new'](this.tokens['instruction']));
      } else {
        this.createIntro(e);
      }
    },
    createIntro: function createIntro(newIntro) {
      var _this2 = this;

      this.isCreating = true;

      this.teacher.createIntro(newIntro.name, newIntro.texts, function (err) {
        _this2.isCreating = false;

        if (err) {
          _this2.setError(err, _this2.tokens['create_new'](_this2.tokens['instruction']));
        } else {
          _this2.loadIntros();
          _this2.setSuccess(_this2.tokens['created'](_this2.tokens['instruction']));
          _this2.resetNew = Math.random();
        }
      });
    },
    remove: function remove(item, e) {
      this.toDelete = item;
    },
    edit: function edit(item, e) {
      this.toEdit = item;
    },
    saveEdited: function saveEdited(e) {
      var _this3 = this;

      this.toEdit.update(e.name, e.texts, function (err) {
        if (err) {
          _this3.setError(err, _this3.tokens['update'](_this3.tokens['instruction']));
        } else {
          _this3.setSuccess(_this3.tokens['updated'](_this3.tokens['instruction']));
        }

        _this3.loadIntros();
      });

      this.closeEditor(null);
    },
    closeEditor: function closeEditor(e) {
      this.toEdit = null;
    },
    removeWarningClosed: function removeWarningClosed(e) {
      var _this4 = this;

      if (e.confirm) {
        this.teacher.deleteIntro(this.toDelete, function (err) {
          if (err) {
            _this4.setError(err, _this4.tokens['delete'](_this4.tokens['instruction']));
          } else {
            _this4.setSuccess(_this4.tokens['deleted'](_this4.tokens['instruction']));
          }

          _this4.loadIntros();
        });
      }
      this.toDelete = null;
    }
  },

  created: function created() {
    var _this5 = this;

    console.log('Instructions component created');
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this5.checkAccess();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this5.init();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this5.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('instructions', '_form', '_buttons', '_labels', '_failures');
    });

    this.checkAccess();
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_selectionBoxItem_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vis_data_data_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vis_data_record_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vis_data_task_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vis_data_class_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vis_data_params_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_widgets_TemporalNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_widgets_ModalContainer_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_widgets_ModalContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_widgets_ModalContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_widgets_SessionEditBox_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_widgets_SessionEditBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_widgets_SessionEditBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_widgets_ItemSelectionBox_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_widgets_ItemSelectionBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_widgets_ItemSelectionBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_vis_GazePlot_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_vis_GazePlot_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_vis_GazePlot_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_vis_GazeWithAudio_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_vis_GazeWithAudio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_vis_GazeWithAudio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_vis_Durations_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_vis_Durations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_vis_Durations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_vis_GazeReplay_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_vis_GazeReplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_vis_GazeReplay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_vis_WordReplay_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_vis_WordReplay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_vis_WordReplay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_vis_StudentsSummary_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_vis_StudentsSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_vis_StudentsSummary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_vis_QuestionnaireResults_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_vis_QuestionnaireResults_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_vis_QuestionnaireResults_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__model_data_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__model_class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__vis_data_session_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__vis_data_student_js__ = __webpack_require__(77);








































var _VisualizationInitialData = function _VisualizationInitialData(name, sessions) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _VisualizationInitialData);

  this.name = name;
  this.sessions = sessions;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'results',

  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_14__components_widgets_Loading_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_15__components_widgets_TemporalNotification_vue___default.a,
    'modal-container': __WEBPACK_IMPORTED_MODULE_16__components_widgets_ModalContainer_vue___default.a,
    'session-editing-box': __WEBPACK_IMPORTED_MODULE_17__components_widgets_SessionEditBox_vue___default.a,
    'item-selection-box': __WEBPACK_IMPORTED_MODULE_18__components_widgets_ItemSelectionBox_vue___default.a,
    'gaze-plot': __WEBPACK_IMPORTED_MODULE_19__components_vis_GazePlot_vue___default.a,
    'gaze-with-audio': __WEBPACK_IMPORTED_MODULE_20__components_vis_GazeWithAudio_vue___default.a,
    'durations': __WEBPACK_IMPORTED_MODULE_21__components_vis_Durations_vue___default.a,
    'gaze-replay': __WEBPACK_IMPORTED_MODULE_22__components_vis_GazeReplay_vue___default.a,
    'word-replay': __WEBPACK_IMPORTED_MODULE_23__components_vis_WordReplay_vue___default.a,
    'students-summary': __WEBPACK_IMPORTED_MODULE_24__components_vis_StudentsSummary_vue___default.a,
    'questionnaire-results': __WEBPACK_IMPORTED_MODULE_25__components_vis_QuestionnaireResults_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_13__components_mixins_actionError__["a" /* default */]],

  data: function data() {
    return {
      teacher: null,
      isLoaded: false,

      deferredVisualization: null,

      editingStudent: null,
      reloadAfterEditing: false,

      gradeWithStudents: null,

      studentWithSessions: null,

      visualization: null,
      classes: null,
      students: [],

      VISUALIZATIONS: {
        gazePlot: 'GazePlot',
        audioReplay: 'GazeWithAudio',
        durations: 'Durations',
        gazeReplay: 'GazeReplay',
        wordReplay: 'WordReplay',
        studentsSummary: 'StudentsSummary',
        questionnaireResults: 'QuestionnaireResults'
      },

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__["b" /* i10n */])('results', '_labels')
    };
  },


  computed: {
    isMultipleSessions: function isMultipleSessions() {
      return this.deferredVisualization ? this.deferredVisualization.name === this.VISUALIZATIONS.gazePlot || this.deferredVisualization.name === this.VISUALIZATIONS.audioReplay : false;
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      this.teacher = __WEBPACK_IMPORTED_MODULE_6__model_teacher_js__["a" /* default */].instance;
      if (this.teacher) {
        this.loadClasses(function (err) {
          if (err) {
            _this.classes = [];
            return _this.setError(err, _this.tokens['err_load_classes']);
          }

          _this.isLoaded = true;
        });
      }
    },
    loadClasses: function loadClasses(cb) {
      var _this2 = this;

      this.teacher.getClasses(function (err, classes) {
        if (err) {
          return cb(err);
        }

        var _classes = [];

        classes.sort(__WEBPACK_IMPORTED_MODULE_3__utils_data_utils_js__["a" /* default */].byName);

        classes.forEach(function (cls) {
          if (!cls.tasks) {
            return;
          }

          var tasks = [];
          for (var taskID in cls.tasks) {
            tasks.push(new __WEBPACK_IMPORTED_MODULE_10__vis_data_task_js__["a" /* default */](taskID, cls.tasks[taskID]));
          }

          var _cls = new __WEBPACK_IMPORTED_MODULE_11__vis_data_class_js__["a" /* default */](cls, tasks);
          _classes.push(_cls);

          _cls.loadStudents(cb);
        });

        _this2.classes = _classes;
      });
    },
    checkAccess: function checkAccess() {
      if (!__WEBPACK_IMPORTED_MODULE_6__model_teacher_js__["a" /* default */].isLogged) {
        this.$router.replace('/');
      }
    },
    tasksWithSessions: function tasksWithSessions(tasks) {
      return tasks.filter(function (task) {
        var sessionCount = 0;
        task.students.forEach(function (student) {
          sessionCount += student.sessions.length;
        });
        return sessionCount > 0;
      });
    },
    closeStudentSelectionBox: function closeStudentSelectionBox(e) {
      this.gradeWithStudents = null;
      this.deferredVisualization = null;
    },
    closeSessionSelectionBox: function closeSessionSelectionBox(e) {
      this.studentWithSessions = null;
      this.deferredVisualization = null;
    },
    closeSessionEditingBox: function closeSessionEditingBox(e) {
      this.editingStudent = null;

      if (this.reloadAfterEditing) {
        this.init();
      }

      this.reloadAfterEditing = false;
    },
    editSessions: function editSessions(student, e) {
      this.editingStudent = student;
    },
    selectTaskStudents: function selectTaskStudents(task, visualizationName) {
      this.deferredVisualization = new _VisualizationInitialData(visualizationName, task.sessions);

      var grade = {
        text: this.tokens['tit_students'](task.name),
        multiGroup: true,

        subitems: []
      };

      task.students.forEach(function (student) {
        student.sessions.forEach(function (session) {
          if (session.task.id === task.id) {
            grade.subitems.push(new __WEBPACK_IMPORTED_MODULE_5__utils_selectionBoxItem_js__["a" /* default */]({
              id: session.ref.id,
              text: '' + __WEBPACK_IMPORTED_MODULE_3__utils_data_utils_js__["a" /* default */].sessionDate(session.ref.date),
              selected: false,
              group: student.ref.name
            }));
          }
        });
      });

      this.studentWithSessions = [grade];
    },
    selectClassStudents: function selectClassStudents(cls, visualizationName) {
      var sessions = [];
      cls.students.forEach(function (student) {
        sessions.push.apply(sessions, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(student.sessions));
      });

      this.deferredVisualization = new _VisualizationInitialData(visualizationName, sessions);

      var grade = {
        text: this.tokens['tit_students_of'](cls.ref.name),

        subitems: []
      };

      cls.students.forEach(function (student) {
        grade.subitems.push(new __WEBPACK_IMPORTED_MODULE_5__utils_selectionBoxItem_js__["a" /* default */]({
          id: student.ref.id,
          text: student.ref.name,
          selected: true
        }));
      });

      this.gradeWithStudents = [grade];
    },
    selectSession: function selectSession(student, visualizationName, filter) {
      if (student.sessions.length === 1) {
        this.visualizeSessions(student.sessions, visualizationName, new __WEBPACK_IMPORTED_MODULE_12__vis_data_params_js__["a" /* default */]({
          student: student.ref.name
        }));
        return;
      }

      this.deferredVisualization = new _VisualizationInitialData(visualizationName, student.sessions);

      var studentWithSessions = {
        text: this.tokens['tit_sessions'](student.ref.name),

        subitems: []
      };

      student.sessions.forEach(function (session) {
        if (filter && !filter(session)) {
          return;
        }
        studentWithSessions.subitems.push(new __WEBPACK_IMPORTED_MODULE_5__utils_selectionBoxItem_js__["a" /* default */]({
          id: session.ref.id,
          text: '' + __WEBPACK_IMPORTED_MODULE_3__utils_data_utils_js__["a" /* default */].sessionDate(session.ref.date),
          selected: false,
          group: session.task.name
        }));
      });

      this.studentWithSessions = [studentWithSessions];
    },
    hasItems: function hasItems(student, filter) {
      return student.sessions.filter(filter).length > 0;
    },
    continueDeferredWithStudents: function continueDeferredWithStudents(e) {
      var sessions = this.deferredVisualization.sessions.filter(function (session) {
        return e.subitems[session.student.id];
      });

      var grade = {
        name: this.gradeWithStudents[0].text,
        studentCount: this.gradeWithStudents[0].subitems.length
      };

      this.visualizeSessions(sessions, this.deferredVisualization.name, new __WEBPACK_IMPORTED_MODULE_12__vis_data_params_js__["a" /* default */]({
        student: e.subitems.length === 1 ? e.subitems[0] : null,
        grade: grade
      }));

      this.closeStudentSelectionBox(null);
    },
    continueDeferredWithSessions: function continueDeferredWithSessions(e) {
      var sessions = this.deferredVisualization.sessions.filter(function (session) {
        return e.subitems[session.ref.id];
      });

      this.visualizeSessions(sessions, this.deferredVisualization.name, new __WEBPACK_IMPORTED_MODULE_12__vis_data_params_js__["a" /* default */]({
        student: sessions.length === 1 ? sessions[0].student.name : null,
        session: e.subitems.length === 1 ? e.subitems[0] : null
      }));

      this.closeSessionSelectionBox(null);
    },
    sessionDeleted: function sessionDeleted(e) {
      this.reloadAfterEditing = true;
    },
    visualizeSessions: function visualizeSessions(sessions, name, params) {
      var _this3 = this;

      if (!sessions || !sessions.length) {
        return;
      }

      var dataIDs = sessions.map(function (session) {
        return session.ref.data;
      });
      __WEBPACK_IMPORTED_MODULE_7__model_student_js__["a" /* default */].getData(dataIDs, function (err, data) {
        if (err) {
          return _this3.setError(err, _this3.tokens['err_load_student']);
        }

        var records = sessions.map(function (session) {
          return new __WEBPACK_IMPORTED_MODULE_9__vis_data_record_js__["a" /* default */](session, data);
        });
        _this3.visualization = new __WEBPACK_IMPORTED_MODULE_8__vis_data_data_js__["a" /* default */](name, records, params);
      });
    },
    isShowing: function isShowing(visualizationName) {
      return this.visualization ? this.visualization.name === visualizationName : false;
    },
    closeVisualization: function closeVisualization(e) {
      this.visualization = null;
    },
    filterHasAudio: function filterHasAudio(session) {
      return session.task.hasAudio;
    }
  },

  created: function created() {
    var _this4 = this;

    console.log('Results component created');
    __WEBPACK_IMPORTED_MODULE_2__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this4.checkAccess();
    });
    __WEBPACK_IMPORTED_MODULE_2__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this4.init();
    });
    __WEBPACK_IMPORTED_MODULE_2__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this4.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__["b" /* i10n */])('results', '_labels');
    });

    this.checkAccess();
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_admin_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_school_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_actionSuccess__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_TemporalNotification_vue__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'schools',

  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_8__components_widgets_TemporalNotification_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_actionError__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_mixins_actionSuccess__["a" /* default */]],

  data: function data() {
    return {
      newName: '',
      newEmail: '',

      isCreating: false,

      schools: null
    };
  },


  computed: {
    isNewNameValid: function isNewNameValid() {
      return this.newName.trim().length > 2;
    },
    isNewEmailValid: function isNewEmailValid() {
      return (/(.{2,})@(\w{2,}\.\w{2,})/.test(this.newEmail.trim())
      );
    },
    canCreate: function canCreate() {
      return !this.isCreating && this.isNewNameValid && this.isNewEmailValid;
    }
  },

  methods: {
    loadSchools: function loadSchools() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__model_school_js__["a" /* default */].list(function (err, schools) {
        if (err) {
          _this.schools = [];
          return _this.setError(err, 'Failed to load schools');
        }

        _this.schools = schools.sort(__WEBPACK_IMPORTED_MODULE_2__utils_data_utils_js__["a" /* default */].byName);
      });
    },
    checkAccess: function checkAccess() {
      if (!__WEBPACK_IMPORTED_MODULE_3__model_admin_js__["a" /* default */].isLogged) {
        this.$router.replace('/');
      }
    },
    tryToCreate: function tryToCreate(e) {
      var _this2 = this;

      if (!this.canCreate) {
        return;
      }

      var exists = this.schools.some(function (school) {
        return false || school.name.toLowerCase() === _this2.newName.toLowerCase().trim() || school.email.toLowerCase() === _this2.newEmail.toLowerCase().trim();
      });

      if (exists) {
        this.setError('A school with this name or email exists already', 'Failed to add new school');
      } else {
        this.createSchool();
      }
    },
    createSchool: function createSchool() {
      var _this3 = this;

      this.isCreating = true;
      __WEBPACK_IMPORTED_MODULE_3__model_admin_js__["a" /* default */].createSchool(this.newName.trim(), this.newEmail.trim(), function (err) {
        _this3.isCreating = false;

        if (err) {
          _this3.setError(err, 'Failed to add new school');
        } else {
          _this3.newName = '';
          _this3.newEmail = '';
          _this3.loadSchools();

          _this3.setSuccess('New school was created');
        }
      });
    }
  },

  filters: {
    count: function count(obj) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).length;
    }
  },

  created: function created() {
    var _this4 = this;

    console.log('Schools component created');
    __WEBPACK_IMPORTED_MODULE_1__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this4.checkAccess();
    });
    __WEBPACK_IMPORTED_MODULE_1__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this4.loadSchools();
    });

    this.checkAccess();
  },
  mounted: function mounted() {
    this.loadSchools();
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_login_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_admin_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_school_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_mixins_actionSuccess__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_widgets_TemporalNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_RemoveWarning_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_RemoveWarning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_widgets_RemoveWarning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_class_js__ = __webpack_require__(21);





















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'students',

  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_10__components_widgets_Loading_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_11__components_widgets_TemporalNotification_vue___default.a,
    'remove-warning': __WEBPACK_IMPORTED_MODULE_12__components_widgets_RemoveWarning_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_mixins_actionError__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__components_mixins_actionSuccess__["a" /* default */]],

  data: function data() {
    return {
      teacher: null,

      school: null,

      newName: '',
      newEmail: '',
      newPassword: '',
      newGrade: '',
      newSchool: '',

      isCreating: false,

      toDelete: null,

      schools: [],

      students: null,

      classes: [],

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('students', '_form', '_buttons', '_labels', '_failures')
    };
  },


  computed: {
    isAdmin: function isAdmin() {
      return __WEBPACK_IMPORTED_MODULE_4__model_admin_js__["a" /* default */].isLogged;
    },
    isNewNameValid: function isNewNameValid() {
      return this.newName.trim().length > 2;
    },
    isNewEmailValid: function isNewEmailValid() {
      if (this.newEmail.indexOf('@') > 0) {
        return (/(.{2,})@(\w{2,}\.\w{2,})/.test(this.newEmail.trim())
        );
      } else {
        return this.newEmail.length > 4;
      }
    },
    isNewPasswordValid: function isNewPasswordValid() {
      return this.newPassword.length >= 6 || this.isRealEmail;
    },
    isNewGradeValid: function isNewGradeValid() {
      return !!this.newGrade.trim().length;
    },
    isSchoolValid: function isSchoolValid() {
      return !__WEBPACK_IMPORTED_MODULE_4__model_admin_js__["a" /* default */].isLogged || !!this.newSchool;
    },
    isRealEmail: function isRealEmail() {
      return this.newEmail.indexOf('@') > 0 && this.newEmail.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_login_js__["a" /* default */].DEFAULT_EMAIL_DOMAIN) < 0;
    },
    canCreateStudent: function canCreateStudent() {
      return !this.isCreating && this.isNewNameValid && this.isNewEmailValid && this.isNewPasswordValid && this.isNewGradeValid && this.isSchoolValid;
    },
    schoolItems: function schoolItems() {
      if (!this.schools) {
        return [];
      }
      return this.schools.map(function (school) {
        return {
          value: school.id,
          text: school.name
        };
      });
    },
    toDeleteName: function toDeleteName() {
      return this.toDelete ? this.toDelete.name : '';
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_4__model_admin_js__["a" /* default */].isLogged) {
        this.loadSchools().then(function () {
          _this.loadStudents();
        });
      } else if (__WEBPACK_IMPORTED_MODULE_5__model_school_js__["a" /* default */].isLogged) {
        this.school = __WEBPACK_IMPORTED_MODULE_5__model_school_js__["a" /* default */].instance;
        this.loadStudents();
      } else if (__WEBPACK_IMPORTED_MODULE_7__model_teacher_js__["a" /* default */].isLogged) {
        this.teacher = __WEBPACK_IMPORTED_MODULE_7__model_teacher_js__["a" /* default */].instance;
        this.loadStudents();
      }
    },
    loadSchools: function loadSchools() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5__model_school_js__["a" /* default */].list(function (err, schools) {
        if (err) {
          return _this2.setError(err, _this2.tokens['load'](_this2.tokens['schools']));
        }

        _this2.schools = schools.sort(__WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].byName);
      });
    },
    loadStudents: function loadStudents() {
      var _this3 = this;

      var onDone = function onDone(err, students) {
        if (err) {
          _this3.students = [];
          return _this3.setError(err, _this3.tokens['load'](_this3.tokens['students']));
        }

        _this3.students = students.sort(function (a, b) {
          if (a.school !== b.school) {
            return a.school > b.school ? 1 : -1;
          } else if (a.grade !== b.grade) {
            return a.grade > b.grade ? 1 : -1;
          } else {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
          }
        });
      };

      if (this.school) {
        this.school.getStudents(onDone);
      } else if (this.teacher) {
        this.teacher.getSchool(function (err, school) {
          if (err) {
            return _this3.setError(err, _this3.tokens['err_load_teacher']);
          }
          school.getStudents(onDone);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_6__model_student_js__["a" /* default */].list(onDone);
      }
    },
    checkAccess: function checkAccess() {
      if (!__WEBPACK_IMPORTED_MODULE_4__model_admin_js__["a" /* default */].isLogged && !__WEBPACK_IMPORTED_MODULE_7__model_teacher_js__["a" /* default */].isLogged && !__WEBPACK_IMPORTED_MODULE_5__model_school_js__["a" /* default */].isLogged) {
        this.$router.replace('/');
      }
    },
    tryToCreateStudent: function tryToCreateStudent(e) {
      if (!this.canCreateStudent) {
        return;
      }

      var email = this.newEmail.trim();
      if (email.indexOf('@') < 0) {
        email += __WEBPACK_IMPORTED_MODULE_2__utils_login_js__["a" /* default */].DEFAULT_EMAIL_DOMAIN;
      }

      var exists = this.students.some(function (student) {
        return student.email.toLowerCase() === email.toLowerCase();
      });

      if (exists) {
        this.setError(this.tokens['err_exists'], this.tokens['add_new'](this.tokens['student']));
      } else {
        this.createStudent(email);
      }
    },
    createStudent: function createStudent(email) {
      var _this4 = this;

      this.isCreating = true;

      var onFinished = function onFinished(err) {
        _this4.isCreating = false;

        if (err) {
          _this4.setError(err, _this4.tokens['add_new'](_this4.tokens['student']));
        } else {
          _this4.newName = '';
          _this4.newEmail = '';
          _this4.newPassword = '';
          _this4.newGrade = '';
          _this4.loadStudents();

          _this4.setSuccess(_this4.tokens['added'](_this4.tokens['student']));
        }
      };

      var password = this.isRealEmail ? null : this.newPassword;
      var studentObject = {
        name: this.newName.trim(),
        email: email,
        password: password,
        grade: this.newGrade.trim()
      };

      if (this.school) {
        this.school.createStudent(studentObject, onFinished);
      } else if (this.teacher) {
        this.teacher.createStudent(studentObject, onFinished);
      } else {
        __WEBPACK_IMPORTED_MODULE_5__model_school_js__["a" /* default */].get(this.newSchool, function (err, school) {
          if (err) {
            return onFinished(err);
          }

          school.createStudent(studentObject, onFinished);
        });
      }
    },
    moveStudent: function moveStudent(student, e) {
      var _this5 = this;

      var el = e.target;
      __WEBPACK_IMPORTED_MODULE_4__model_admin_js__["a" /* default */].moveStudent(student, el.value, this.schools, function (err) {
        if (err) {
          _this5.setError(err, _this5.tokens['err_move']);
        } else {
          _this5.setSuccess(_this5.tokens['msg_moved']);
        }
      });
    },
    getListOfStudentClasses: function getListOfStudentClasses(student) {
      var classes = [];
      for (var id in student.classes) {
        classes.push(student.classes[id]);
      }
      return classes.join(', ');
    },
    remove: function remove(student) {
      this.toDelete = student;
    },
    removeWarningClosed: function removeWarningClosed(e) {
      var _this6 = this;

      if (e.confirm) {
        var student = this.toDelete;

        __WEBPACK_IMPORTED_MODULE_5__model_school_js__["a" /* default */].get(student.school, function (err, school) {
          if (err) {
            return _this6.setError(err, _this6.tokens['err_access_school']);
          }

          school.deleteStudent(student, function (err) {
            if (err) {
              _this6.setError(err, _this6.tokens['delete'](_this6.tokens['student']));
            } else {
              _this6.setSuccess(_this6.tokens['deleted'](_this6.tokens['student']));
            }

            _this6.init();
          });
        });
      }

      this.toDelete = null;
    }
  },

  created: function created() {
    var _this7 = this;

    console.log('Students component created');
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this7.checkAccess();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this7.init();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this7.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('students', '_form', '_buttons', '_labels', '_failures');
    });

    this.checkAccess();
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_admin_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_school_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_actionSuccess__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_TemporalNotification_vue__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teachers',

  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_8__components_widgets_Loading_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_9__components_widgets_TemporalNotification_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_mixins_actionError__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_mixins_actionSuccess__["a" /* default */]],

  data: function data() {
    return {
      school: null,

      newName: '',
      newEmail: '',
      newSchool: '',

      isCreating: false,

      schools: [],

      teachers: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('teachers', '_form', '_buttons', '_labels', '_failures')
    };
  },


  computed: {
    isNewNameValid: function isNewNameValid() {
      return this.newName.trim().length > 2;
    },
    isNewEmailValid: function isNewEmailValid() {
      return (/(.{2,})@(\w{2,}\.\w{2,})/.test(this.newEmail.trim())
      );
    },
    isSchoolValid: function isSchoolValid() {
      return !this.isAdmin || !!this.newSchool;
    },
    canCreate: function canCreate() {
      return !this.isCreating && this.isNewNameValid && this.isNewEmailValid && this.isSchoolValid;
    },
    isAdmin: function isAdmin() {
      return __WEBPACK_IMPORTED_MODULE_3__model_admin_js__["a" /* default */].isLogged;
    },
    schoolItems: function schoolItems() {
      if (!this.schools) {
        return [];
      }
      return this.schools.map(function (school) {
        return {
          value: school.id,
          text: school.name
        };
      });
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_3__model_admin_js__["a" /* default */].isLogged) {
        this.loadSchools().then(function () {
          _this.loadTeachers();
        });
      } else if (__WEBPACK_IMPORTED_MODULE_4__model_school_js__["a" /* default */].isLogged) {
        this.school = __WEBPACK_IMPORTED_MODULE_4__model_school_js__["a" /* default */].instance;
        this.loadTeachers();
      }
    },
    loadSchools: function loadSchools() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4__model_school_js__["a" /* default */].list(function (err, schools) {
        if (err) {
          return _this2.setError(err, _this2.tokens['load'](_this2.tokens['schools']));
        }

        _this2.schools = schools.sort(__WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].byName);
      });
    },
    loadTeachers: function loadTeachers() {
      var _this3 = this;

      var onDone = function onDone(err, teachers) {
        if (err) {
          _this3.teachers = [];
          return _this3.setError(err, _this3.tokens['load'](_this3.tokens['teachers']));
        }

        _this3.teachers = teachers.sort(function (a, b) {
          if (a.school !== b.school) {
            return a.school > b.school ? 1 : -1;
          } else {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
          }
        });
      };

      if (!this.school) {
        return __WEBPACK_IMPORTED_MODULE_5__model_teacher_js__["a" /* default */].list(onDone);
      }

      return this.school.getTeachers(onDone);
    },
    checkAccess: function checkAccess() {
      if (!__WEBPACK_IMPORTED_MODULE_3__model_admin_js__["a" /* default */].isLogged && !__WEBPACK_IMPORTED_MODULE_4__model_school_js__["a" /* default */].isLogged) {
        this.$router.replace('/');
      }
    },
    tryToCreate: function tryToCreate(e) {
      var _this4 = this;

      if (!this.canCreate) {
        return;
      }

      var exists = this.teachers.some(function (teacher) {
        return teacher.email.toLowerCase() === _this4.newEmail.toLowerCase().trim();
      });

      if (exists) {
        this.setError(this.tokens['err_exists'], this.tokens['add_new'](this.tokens['teacher']));
      } else {
        this.createTeacher();
      }
    },
    createTeacher: function createTeacher() {
      var _this5 = this;

      this.isCreating = true;

      var onFinished = function onFinished(err) {
        _this5.isCreating = false;

        if (err) {
          _this5.setError(err, _this5.tokens['add_new'](_this5.tokens['teacher']));
        } else {
          _this5.newName = '';
          _this5.newEmail = '';
          _this5.loadTeachers();

          _this5.setSuccess(_this5.tokens['added'](_this5.tokens['teacher']));
        }
      };

      if (this.school) {
        this.school.createTeacher(this.newName.trim(), this.newEmail.trim(), onFinished);
      } else {
        __WEBPACK_IMPORTED_MODULE_4__model_school_js__["a" /* default */].get(this.newSchool, function (err, school) {
          if (err) {
            return onFinished(err);
          }

          school.createTeacher(_this5.newName.trim(), _this5.newEmail.trim(), onFinished);
        });
      }
    },
    moveTeacher: function moveTeacher(teacher, e) {
      var _this6 = this;

      var el = e.target;
      __WEBPACK_IMPORTED_MODULE_3__model_admin_js__["a" /* default */].moveTeacher(teacher, el.value, this.schools, function (err) {
        if (err) {
          _this6.setError(err, _this6.tokens['err_move']);
        } else {
          _this6.setSuccess(_this6.tokens['msg_moved']);
        }
      });
    },
    getListOfTeacherClasses: function getListOfTeacherClasses(teacher) {
      var classes = [];
      for (var id in teacher.classes) {
        classes.push(teacher.classes[id]);
      }
      return classes.join(', ');
    }
  },

  created: function created() {
    var _this7 = this;

    console.log('Teachers component created');
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('logout', function () {
      _this7.checkAccess();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('login', function () {
      _this7.init();
    });
    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this7.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('teachers', '_form', '_buttons', '_labels', '_failures');
    });

    this.checkAccess();
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_gazeTracking_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_intro_js__ = __webpack_require__(20);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'calib-page',

  data: function data() {
    return {
      isConnected: __WEBPACK_IMPORTED_MODULE_1__utils_gazeTracking_js__["a" /* default */].state.isConnected && !__WEBPACK_IMPORTED_MODULE_1__utils_gazeTracking_js__["a" /* default */].state.isTracking && !__WEBPACK_IMPORTED_MODULE_1__utils_gazeTracking_js__["a" /* default */].state.isBusy || false,
      isETUDConnected: __WEBPACK_IMPORTED_MODULE_1__utils_gazeTracking_js__["a" /* default */].state.isServiceRunning || false,
      isCalibrated: __WEBPACK_IMPORTED_MODULE_1__utils_gazeTracking_js__["a" /* default */].state.isCalibrated || false,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('assignment', '_buttons')
    };
  },


  props: {
    texts: {
      type: Object,
      required: true
    }
  },

  computed: {
    calibInstruction: function calibInstruction() {
      return this.texts.calibInstruction ? this.texts.calibInstruction.split('\n') : [];
    }
  },

  methods: {
    showETUDOptions: function showETUDOptions(e) {
      __WEBPACK_IMPORTED_MODULE_1__utils_gazeTracking_js__["a" /* default */].showOptions();
    },
    reload: function reload(e) {
      this.$router.replace('/assignments');
    },
    calibrate: function calibrate(e) {
      this.$emit('close', { skip: false });
    },
    skip: function skip(e) {
      this.$emit('close', { skip: true });
    },
    cancel: function cancel(e) {
      this.$router.replace('/assignments');
    }
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_gazeTracking_js__["a" /* default */].setCallback('stateUpdated', 'calib', function (state) {
      _this.isConnected = state.isConnected && !state.isTracking && !state.isBusy;
      _this.isETUDConnected = state.isServiceRunning;
      _this.isCalibrated = state.isCalibrated;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__utils_gazeTracking_js__["a" /* default */].clearCallback('stateUpdated', 'calib');
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_intro_js__ = __webpack_require__(20);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'finished-page',

  data: function data() {
    return {
      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('assignment')
    };
  },


  props: {
    saving: Boolean,
    texts: __WEBPACK_IMPORTED_MODULE_1__model_intro_js__["a" /* default */]
  },

  methods: {
    back: function back(e) {
      this.$router.replace('../assignments');
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_session_question_js__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'questionnaire-page',

  data: function data() {
    var _this = this;

    return {
      questionIndex: 0,

      questions: this.questionnaire.map(function (question) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ answer: null }, question);
      }).filter(function (question) {
        return question.type === __WEBPACK_IMPORTED_MODULE_1__model_session_question_js__["a" /* Question */].types.text.name || _this.longGazedWords.includes(question.word);
      })
    };
  },


  props: {
    questionnaire: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    longGazedWords: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  computed: {
    question: function question() {
      return this.questionIndex >= 0 && this.questionIndex < this.questions.length ? this.questions[this.questionIndex] : null;
    }
  },

  methods: {
    asnwerRevealedClass: function asnwerRevealedClass(answer) {
      return {
        'is-success': this.question.answer && this.question.answer.text === answer.text && answer.isCorrect,
        'is-danger': this.question.answer && this.question.answer.text === answer.text && !answer.isCorrect
      };
    },
    reply: function reply(answer) {
      var _this2 = this;

      if (this.question.answer) {
        return;
      }

      this.question.answer = answer;

      window.setTimeout(function () {
        if (_this2.questionIndex === _this2.questions.length - 1) {
          _this2.$emit('finished', { questionnaire: _this2.questions });
          return;
        }

        _this2.questionIndex++;
      }, 2000);
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_intro_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_task_TaskPage_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_task_TaskPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_task_TaskPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_fullscreen_js__ = __webpack_require__(123);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'start-page',

  mixins: [__WEBPACK_IMPORTED_MODULE_7__components_mixins_fullscreen_js__["a" /* default */]],

  components: {
    'task-page': __WEBPACK_IMPORTED_MODULE_6__components_task_TaskPage_vue___default.a
  },

  data: function data() {
    return {
      isConnected: __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].state.isConnected && !__WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].state.isTracking && !__WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].state.isBusy || false,
      isCalibrated: __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].state.isCalibrated && !__WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].state.isTracking && !__WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].state.isBusy || false,
      isRunning: __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].state.isConnected && __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].state.isTracking && !__WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].state.isBusy || false,
      isReading: false,
      isFullscreen: false,
      timeoutTimer: null,
      finilizeTask: false,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__["b" /* i10n */])('assignment', '_buttons')
    };
  },


  props: {
    texts: {
      type: __WEBPACK_IMPORTED_MODULE_3__model_intro_js__["a" /* default */],
      required: true
    },
    task: {
      type: __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */],
      required: true
    },
    student: {
      type: __WEBPACK_IMPORTED_MODULE_5__model_student_js__["a" /* default */],
      required: true
    }
  },

  computed: {
    startInstruction: function startInstruction() {
      return this.texts.startInstruction ? this.texts.startInstruction.split('\n') : [];
    }
  },

  methods: {
    start: function start(e) {
      var _this = this;

      this.isReading = true;
      this.makeFullscreen(this.$refs.fullscreen);
      __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].start();

      if (this.task.useTimeout) {
        this.timeoutTimer = setTimeout(function () {
          _this.timeoutTimer = null;
          _this.finilizeTask = true;
        }, this.task.timeout * 60000);
      }
    },
    cancel: function cancel(e) {
      this.$emit('close', { cancelled: true });
    },
    finishedReading: function finishedReading(e) {
      this.clearTaskTimeout();
      this.isReading = false;
      this.$emit('close', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ finished: true }, e));
      this.closeFullscreen();
      __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].stop();
    },
    gazeDataSaved: function gazeDataSaved(e) {
      this.$emit('saved', e);
    },
    clearTaskTimeout: function clearTaskTimeout() {
      if (this.timeoutTimer) {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
      }
    }
  },

  watch: {
    isRunning: function isRunning(value) {
      var _this2 = this;

      if (!value && this.isFullscreen && this.isReading) {
        this.clearTaskTimeout();

        setTimeout(function () {
          _this2.closeFullscreen();
          _this2.$router.replace('/assignments');
        }, 4000);
      }
    }
  },

  created: function created() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].setCallback('stateUpdated', 'start', function (state) {
      _this3.isConnected = state.isConnected && !state.isTracking && !state.isBusy;
      _this3.isCalibrated = state.isCalibrated && !state.isTracking && !state.isBusy;
      _this3.isRunning = state.isConnected && state.isTracking && !state.isBusy;
    });

    this.onFullscreenChanges(function (isFullscreen) {
      _this3.isFullscreen = isFullscreen;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__utils_gazeTracking_js__["a" /* default */].clearCallback('stateUpdated', 'start');
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_TaskText_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_TaskText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_widgets_TaskText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TaskImages_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TaskImages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_widgets_TaskImages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_intro_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__task_textPresenter_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__task_feedbackProvider_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__task_dataCollector_js__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__task_audioRecorder_js__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_gazeTracking_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_session_font_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__db_db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__model_data_image_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__(42);

























var FIX_UPDATE_INTERVAL = 25;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-page',

  components: {
    'task-text': __WEBPACK_IMPORTED_MODULE_0__components_widgets_TaskText_vue___default.a,
    'task-images': __WEBPACK_IMPORTED_MODULE_1__components_widgets_TaskImages_vue___default.a
  },

  data: function data() {
    return {
      textPresenter: null,

      feedbackProvider: null,

      collector: null,

      font: null,

      fixation: {
        word: null,
        duration: 0
      },

      fixationUpdateTimer: 0,

      isWaitingToFinilizePage: false,
      audioRecorder: null,
      audioFiles: [],

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_i10n_js__["b" /* i10n */])('assignment')
    };
  },


  props: {
    texts: {
      type: __WEBPACK_IMPORTED_MODULE_2__model_intro_js__["a" /* default */],
      required: true
    },
    task: {
      type: __WEBPACK_IMPORTED_MODULE_3__model_task_js__["a" /* default */],
      required: true
    },
    student: {
      type: __WEBPACK_IMPORTED_MODULE_4__model_student_js__["a" /* default */],
      required: true
    },
    finilize: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasNextPage: function hasNextPage() {
      return this.textPresenter ? this.textPresenter.hasNextPage : false;
    },
    isLastPage: function isLastPage() {
      return this.textPresenter ? !this.textPresenter.hasNextPage : false;
    },
    images: function images() {
      if (!this.textPresenter || this.textPresenter.isInstructionPage || this.textPresenter.page < 0) {
        return [];
      }

      return this.task.pages[this.textPresenter.page].images;
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      var container = this.$refs.container;

      this.font = __WEBPACK_IMPORTED_MODULE_11__model_session_font_js__["a" /* default */].from(container.$data.textStyle);

      this.feedbackProvider = new __WEBPACK_IMPORTED_MODULE_6__task_feedbackProvider_js__["a" /* default */](this.task.syllab, this.task.speech, this.task.highlight, this.task.warning);
      this.feedbackProvider.init();

      var textEl = container.$refs.text;
      this.textPresenter = new __WEBPACK_IMPORTED_MODULE_5__task_textPresenter_js__["a" /* default */](this.task, this.texts.firstPage, textEl, this.feedbackProvider.syllabifier);

      this.collector = new __WEBPACK_IMPORTED_MODULE_7__task_dataCollector_js__["a" /* default */](this.task, this.student, this.font, this.feedbackProvider.setup);
      this.feedbackProvider.events.addListener('syllabified', function (el) {
        return _this.collector.syllabified(el);
      });
      this.feedbackProvider.events.addListener('pronounced', function (el) {
        return _this.collector.pronounced(el);
      });

      __WEBPACK_IMPORTED_MODULE_10__utils_gazeTracking_js__["a" /* default */].setCallback('wordFocused', 'task-page', function (word) {
        var wordText = null;
        if (!_this.textPresenter.isInstructionPage) {
          wordText = _this.feedbackProvider.setFocusedWord(word);
        }
        _this.collector.setFocusedWord(word);

        var wordID = word ? word.dataset.wordId : '';
        _this.fixation = { word: wordText ? new __WEBPACK_IMPORTED_MODULE_12__model_task_textPageImage_js__["b" /* Word */](wordText, wordID) : null, duration: 0 };
      });

      __WEBPACK_IMPORTED_MODULE_10__utils_gazeTracking_js__["a" /* default */].setCallback('wordLeft', 'task-page', function (_) {
        if (!_this.textPresenter.isInstructionPage) {
          _this.feedbackProvider.setFocusedWord(null);
        }
        _this.collector.setFocusedWord(null);
        _this.fixation = { word: null, duration: 0 };
      });

      __WEBPACK_IMPORTED_MODULE_10__utils_gazeTracking_js__["a" /* default */].setCallback('gazePoint', 'task-page', function (gazePoint) {
        _this.collector.addGazePoint(gazePoint);
      });

      this.collector.start();
      this.fixationUpdateTimer = window.setInterval(function () {
        var word = _this.collector.focusedWord;
        if (!word) {
          if (_this.fixation.word) {
            _this.fixation = { word: null, duration: 0 };
          }
        } else {
          _this.fixation = { word: _this.fixation.word, duration: word.duration };
        }
      }, FIX_UPDATE_INTERVAL);
    },
    next: function next(e) {
      var _this2 = this;

      if (e && this.task.recordAudio) {
        this.isWaitingToFinilizePage = true;

        var container = this.$refs.container;
        var textEl = container.$refs.text;
        textEl.innerHTML = '';

        this.audioRecorder.stop().then(function (blob) {
          _this2.saveAudio(blob, function (url) {
            _this2.audioFiles.push(url);

            _this2.startPage();
            _this2.isWaitingToFinilizePage = false;
          });
        });
      } else {
        this.startPage();
      }
    },
    finish: function finish(e) {
      var _this3 = this;

      if (this.task.recordAudio) {
        this.isWaitingToFinilizePage = true;
        this.audioRecorder.stop().then(function (blob) {
          _this3.saveAudio(blob, function (url) {
            _this3.audioFiles.push(url);
            _this3.stop();
            _this3.isWaitingToFinilizePage = false;
          });
        });
      } else {
        this.stop();
      }
    },
    onImageShow: function onImageShow(e) {
      this.collector.imageShow(e.image);
    },
    onImageHide: function onImageHide(e) {
      this.collector.imageHide(e.image);
    },
    startPage: function startPage() {
      var _this4 = this;

      var wordReadingDuration = void 0;
      if (this.textPresenter.page === 0 && this.texts.firstPage && this.texts.firstPage.length) {
        wordReadingDuration = this.collector.wordReadingDuration;
      }

      this.textPresenter.nextPage();
      this.collector.nextPage();
      if (this.task.recordAudio) {
        this.audioRecorder.start(function () {
          _this4.collector.updatePageTimestamp();
        });
      }

      this.feedbackProvider.reset(wordReadingDuration);

      __WEBPACK_IMPORTED_MODULE_10__utils_gazeTracking_js__["a" /* default */].updateTargets();
    },
    stop: function stop() {
      var _this5 = this;

      this.$emit('finished', {
        longGazedWords: this.collector.longGazedWords(this.task.syllab.threshold.value)
      });

      if (this.task.recordAudio) {
        this.collector.setAudioFiles(this.audioFiles);
      }

      this.collector.stop(function (err, keys) {
        _this5.$emit('saved', { err: err, keys: keys });
      });

      window.clearInterval(this.fixationUpdateTimer);
      this.fixationUpdateTimer = 0;
    },
    saveAudio: function saveAudio(blob, cb) {
      var name = __WEBPACK_IMPORTED_MODULE_12__model_task_textPageImage_js__["a" /* TextPageImage */].generatePrefix() + '-' + this.textPresenter.page;
      __WEBPACK_IMPORTED_MODULE_13__db_db_js__["a" /* default */].uploadAudio(blob, name, null, function (err, url) {
        if (err) {
          console.error('AUDIO', err);
          cb('');
        } else if (url) {
          cb(url);
        }
      });
    }
  },

  watch: {
    finilize: function finilize(value) {
      if (value) {
        this.finish(null);
      }
    }
  },

  mounted: function mounted() {
    var _this6 = this;

    if (this.task.recordAudio) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__task_audioRecorder_js__["a" /* default */])().then(function (recorder) {
        _this6.audioRecorder = recorder;
        _this6.init();

        setTimeout(function () {
          return _this6.next(null);
        }, 2000);
      });
    } else {
      this.init();
      this.next(null);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.feedbackProvider.cleanup();

    __WEBPACK_IMPORTED_MODULE_10__utils_gazeTracking_js__["a" /* default */].clearCallback('stateUpdated', 'task-page');
    __WEBPACK_IMPORTED_MODULE_10__utils_gazeTracking_js__["a" /* default */].clearCallback('wordFocused', 'task-page');
    __WEBPACK_IMPORTED_MODULE_10__utils_gazeTracking_js__["a" /* default */].clearCallback('wordLeft', 'task-page');
    __WEBPACK_IMPORTED_MODULE_10__utils_gazeTracking_js__["a" /* default */].clearCallback('gazePoint', 'task-page');
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vis_optionsCreator_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_session_feedbacks__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_vis_controlPanel_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_vis_controlPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_vis_controlPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vis_Options_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vis_Options_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_vis_Options_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vis_data_data_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_data_dataPageFocusedWord_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_session_feedback__ = __webpack_require__(62);


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'durations',

  components: {
    'control-panel': __WEBPACK_IMPORTED_MODULE_7__components_vis_controlPanel_vue___default.a,
    'options': __WEBPACK_IMPORTED_MODULE_8__components_vis_Options_vue___default.a
  },

  data: function data() {
    return {
      pageIndex: -1,
      isOptionsDisplayed: false,

      defaultFeedback: this.data.records[0].session.feedbacks,

      words: [],

      options: null,
      UNITS: null,
      UI: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__["b" /* i10n */])('vis_durations')
    };
  },


  props: {
    data: {
      type: __WEBPACK_IMPORTED_MODULE_9__vis_data_data_js__["a" /* default */],
      required: true
    }
  },

  computed: {
    textLength: function textLength() {
      return this.data.records[0].data.pages.length;
    },
    initialPageIndex: function initialPageIndex() {
      return this.data.records[0].data.pages[0].isIntro ? 1 : 0;
    },
    title: function title() {
      var r = this.data.records[0];
      return this.tokens['hdr_dur'](this.data.params.student, r.task.name);
    },
    feedback: function feedback() {
      return new __WEBPACK_IMPORTED_MODULE_6__model_session_feedbacks__["b" /* Feedbacks */](this.defaultFeedback.speech, this.defaultFeedback.syllabification);
    }
  },

  methods: {
    setPage: function setPage(e) {
      this.pageIndex = e.index;
      this.makeList();
    },
    showOptions: function showOptions(e) {
      this.isOptionsDisplayed = true;
    },
    close: function close(e) {
      this.$emit('close');
    },
    applyOptions: function applyOptions(e) {
      this.makeList();
    },
    closeOptions: function closeOptions(e) {
      this.isOptionsDisplayed = false;
    },
    makeList: function makeList() {
      var _this = this;

      var words = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();

      var totalDuration = 0;
      this.data.records.forEach(function (record) {
        record.data.pages[_this.pageIndex].words.forEach(function (word) {
          totalDuration += _this.appendWord(words, word);
        });
      });

      this.words = this.compute(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(words.entries()))), totalDuration);
    },
    appendWord: function appendWord(words, word) {
      var hyphenRegExp = new RegExp('' + this.defaultFeedback.syllabification.hyphen, 'g');

      var id = '' + Math.floor(word.rect.x / 10) + '_' + Math.floor(word.rect.y / 10);

      var w = words.get(id);
      if (!w) {
        w = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, word, { focusing: { duration: word.focusing.duration } });
        w.text = w.text.replace(hyphenRegExp, '');
        words.set(id, w);
      } else {
        w.focusing.duration += word.focusing.duration;
      }

      return w.focusing.duration;
    },
    compute: function compute(words, totalDuration) {
      var _this2 = this;

      var result = [];

      words.forEach(function (word) {
        var value = void 0;
        var duration = word.focusing.duration;

        if (_this2.UI.units === _this2.UNITS.SECONDS) {
          value = Math.round(duration) / 1000;
          result.push({ text: word.text, value: value.toFixed(2), num: value });
        } else if (_this2.UI.units === _this2.UNITS.PERCENTAGE) {
          value = 100 * duration / totalDuration;
          result.push({ text: word.text, value: value.toFixed(1) + '%', num: value });
        } else if (_this2.UI.units === _this2.UNITS.MS_PER_CHAR) {
          value = duration / word.text.length;
          result.push({ text: word.text, value: value.toFixed(0), num: value });
        }
      });

      var descending = function descending(a, b) {
        return b.num - a.num;
      };

      return result.sort(descending);
    }
  },

  created: function created() {
    this.UNITS = {
      SECONDS: this.tokens['item_seconds'],
      PERCENTAGE: this.tokens['item_percentage'],
      MS_PER_CHAR: this.tokens['item_ms_char']
    };

    this.UI = {
      units: this.UNITS.SECONDS
    };

    this.options = {
      gazePlot: new __WEBPACK_IMPORTED_MODULE_5__vis_optionsCreator_js__["b" /* OptionGroup */]({
        id: 'durations',
        title: this.tokens['hdr_options'],
        options: __WEBPACK_IMPORTED_MODULE_5__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions({
          units: new __WEBPACK_IMPORTED_MODULE_5__vis_optionsCreator_js__["c" /* OptionItem */]({
            type: Array,
            items: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.UNITS),
            label: this.tokens['lbl_units']
          })
        }, this.UI),
        defaults: __WEBPACK_IMPORTED_MODULE_5__vis_optionsCreator_js__["a" /* OptionsCreator */].createDefaults(this.UI)
      })
    };
  },
  mounted: function mounted() {
    console.log('Durations created');
    this.setPage({ index: this.initialPageIndex });
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_vis_VisPlot_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_vis_VisPlot_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_vis_VisPlot_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vis_painter_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vis_metric_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vis_regressions_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_data_dataPageTextWord_js__ = __webpack_require__(91);
















var UI = {
  colorMetric: __WEBPACK_IMPORTED_MODULE_6__vis_metric_js__["a" /* default */].Type.DURATION,

  saccadeColor: '#08F',
  regressionColor: '#000',

  showConnections: true,
  showSaccades: true,
  showFixations: true,

  syllab: {
    background: '#fce',
    wordColor: '#060'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gaze-plot',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_vis_VisPlot_vue___default.a],

  data: function data() {
    return {
      record: this.data.records[0],

      painter: null,

      audio: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('vis', 'vis_gaze_plot')
    };
  },


  computed: {
    title: function title() {
      return this.tokens['hdr_reading'](this.record.student.name, this.record.task.name, __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].sessionDate(this.record.session.date));
    }
  },

  methods: {
    changePage: function changePage() {
      var _this = this;

      if (!this.painter) {
        this.painter = new __WEBPACK_IMPORTED_MODULE_5__vis_painter_js__["a" /* Painter */](this.$refs.canvas, {
          syllab: this.defaultFeedback.syllabification
        });
        this.painter.setFont(this.record.session.font);
        this.painter.setScreenSize(this.record.session.screen);
      }

      this.mapAndShow();

      this.visibleImages = this.currentImages.map(function (image) {
        return __WEBPACK_IMPORTED_MODULE_8__model_task_textPageImage_js__["a" /* TextPageImage */].from(image, { ignoreDisplayCondition: true });
      });

      this.audioPlayerProps.visible = false;
      if (this.data.records.length === 1 && this.data.records[0].data.pages[this.pageIndex].audio) {
        this.audio = new Audio(this.data.records[0].data.pages[this.pageIndex].audio);
        this.audio.addEventListener('loadeddata', function (e) {
          _this.audioPlayerProps.duration = (e.target || e.path[0]).duration;
          _this.audioPlayerProps.visible = true;
        });
        this.audio.addEventListener('timeupdate', function (e) {
          _this.audioPlayerProps.time = (e.target || e.path[0]).currentTime;
        });
        this.audio.addEventListener('play', function (e) {
          _this.audioPlayerProps.playing = !(e.target || e.path[0]).paused;
        });
        this.audio.addEventListener('pause', function (e) {
          _this.audioPlayerProps.playing = !(e.target || e.path[0]).paused;
        });
        this.audio.addEventListener('ended', function (e) {
          (e.target || e.path[0]).currentTime = 0;
        });
      }
    },
    redraw: function redraw() {
      this.mapAndShow();
    },
    mapAndShow: function mapAndShow() {
      this.painter.clean();

      var page = this.currentPages[0];

      var fixations = page.fixations ? this.map(page).fixations : null;

      if (fixations) {
        __WEBPACK_IMPORTED_MODULE_7__vis_regressions_js__["a" /* default */].compute(fixations);
      }

      var wordsWithGazingInfo = this.addGazeInfoToWords(page.text, fixations);

      this.painter.drawWords(wordsWithGazingInfo, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        colorMetric: UI.colorMetric,
        showConnections: UI.showConnections,
        hyphen: this.defaultFeedback.syllabification.hyphen
      }, this.commonUI));

      if (page.syllabifications) {
        this.painter.drawSyllabifications(page.syllabifications, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          isSyllabified: this.record.session.feedbacks.syllabification.mode === 'hyphen',
          hyphen: this.record.session.feedbacks.syllabification.hyphen
        }, UI.syllab));
      }

      if (!page.fixations) {
        this.isWarningMessageVisible = true;
        return;
      }

      this.isWarningMessageVisible = false;

      if (UI.showFixations && fixations) {
        this.painter.drawFixations(fixations, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          connectionColor: this.commonUI.wordRectColor
        }, UI));
      }
    },
    addGazeInfoToWords: function addGazeInfoToWords(words, fixations) {
      var result = [];

      words.forEach(function (word) {
        var focusing = {
          count: 0,
          duration: 0
        };

        if (fixations) {
          fixations.forEach(function (fix) {
            if (fix.word && fix.word.id === word.id) {
              focusing.count += 1;
              focusing.duration += fix.duration;
            }
          });
        }

        result.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ focusing: focusing }, word));
      });

      return result;
    }
  },

  created: function created() {
    var _this2 = this;

    this.options["gazePlot"] = new __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["b" /* OptionGroup */]({
      id: 'gazePlot',
      title: this.tokens['hdr_options'],
      options: __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions({
        colorMetric: new __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Array, items: __WEBPACK_IMPORTED_MODULE_6__vis_metric_js__["a" /* default */].Types, label: this.tokens['lbl_word_color'] }),

        saccadeColor: new __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["c" /* OptionItem */]({ type: '#', label: this.tokens['lbl_sacc_color'] }),
        regressionColor: new __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["c" /* OptionItem */]({ type: '#', label: this.tokens['lbl_reg_sacc_color'] }),

        showConnections: new __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: this.tokens['lbl_show_conn'] }),
        showSaccades: new __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: this.tokens['lbl_show_sacc'] }),
        showFixations: new __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Boolean, label: this.tokens['lbl_show_fix'] }),

        'syllab.background': new __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["c" /* OptionItem */]({ type: '#', label: this.tokens['lbl_syllab_back'] }),
        'syllab.wordColor': new __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["c" /* OptionItem */]({ type: '#', label: this.tokens['lbl_syllab_word'] })
      }, UI),
      defaults: __WEBPACK_IMPORTED_MODULE_4__vis_optionsCreator_js__["a" /* OptionsCreator */].createDefaults(UI)
    });

    this.audioPlayerProps.toggled = function (e) {
      if (_this2.audio) {
        e.isPlaying ? _this2.audio.play() : _this2.audio.pause();
      }
    };
    this.audioPlayerProps.slided = function (e) {
      if (_this2.audio) {
        _this2.audio.currentTime = e.time;
      }
    };
  },
  mounted: function mounted() {
    console.log('GazePlot created');
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vis_painter_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vis_metric_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vis_replayTrack_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vis_VisPlot_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vis_VisPlot_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_vis_VisPlot_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_data_fixation__ = __webpack_require__(51);
















var LEGEND_LOCATION = {
  x: 2,
  y: 56
};

var UI = {
  colorMetric: __WEBPACK_IMPORTED_MODULE_5__vis_metric_js__["a" /* default */].Type.NONE,

  nameFontFamily: 'Calibri, Arial, sans-serif',
  nameFontSize: 18,
  nameSpacing: 1.5,

  syllab: {
    background: '#fce',
    wordColor: '#060'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'gaze-replay',

  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_vis_VisPlot_vue___default.a],

  data: function data() {
    return {
      painter: null,

      tracks: [],

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('vis', 'vis_gaze_replay')
    };
  },


  computed: {
    title: function title() {
      var r = this.data.records[0];
      return this.tokens['hdr_gaze_replay'](this.data.params.student, r.task.name);
    }
  },

  methods: {
    restartPlayer: function restartPlayer(e) {
      this.stopAll();
      this.start();
    },
    togglePlayer: function togglePlayer(e) {
      this.isPlayerPaused = !this.isPlayerPaused;
      this.tracks.forEach(function (track) {
        return track.togglePause();
      });
    },
    changePage: function changePage() {
      this.isWarningMessageVisible = false;
      this.visibleImages = this.currentImages.filter(function (image) {
        return image.on === __WEBPACK_IMPORTED_MODULE_7__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.none;
      }).map(function (image) {
        return __WEBPACK_IMPORTED_MODULE_7__model_task_textPageImage_js__["a" /* TextPageImage */].from(image);
      });

      if (!this.painter) {
        this.painter = new __WEBPACK_IMPORTED_MODULE_4__vis_painter_js__["a" /* Painter */](this.$refs.canvas, {
          syllab: this.defaultFeedback.syllabification
        });
        this.painter.setScreenSize(this.data.records[0].session.screen);
      }

      if (this.tracks.length) {
        this.stopAll();
        this.start();
      }
    },
    redraw: function redraw() {
      this.painter.clean();

      this.drawText();
      this.drawNames();
    },
    createTracks: function createTracks() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__vis_replayTrack_js__["a" /* default */].resetColors();

      var studentsWithMultipleSessions = {};

      this.data.records.forEach(function (record) {
        var id = record.student.name;
        studentsWithMultipleSessions[id] = studentsWithMultipleSessions[id] !== undefined;
      });

      this.data.records.forEach(function (record) {
        var name = record.student.name;
        if (studentsWithMultipleSessions[name]) {
          name = name + ' ' + __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].sessionDate(record.session.date);
        }

        _this.tracks.push(new __WEBPACK_IMPORTED_MODULE_6__vis_replayTrack_js__["a" /* default */](_this.$refs.root, name, record.data.pages, _this.painter.offset));
      });
    },
    stopAll: function stopAll() {
      this.tracks.forEach(function (track) {
        return track.stop();
      });
    },
    start: function start() {
      var _this2 = this;

      this.isPlayerPaused = false;

      this.redraw();

      this.tracks.forEach(function (track, ti) {
        track.start(_this2.pageIndex, {
          fixation: function fixation(_fixation, pointer) {
            var missingImages = _this2.currentImages.filter(function (image) {
              return !_this2.visibleImages.find(function (img) {
                return img.src === image.src;
              }) && image.shown < _fixation.tsSync;
            });
            var imagesToHide = _this2.currentImages.filter(function (image) {
              return !!_this2.visibleImages.find(function (img) {
                return img.src === image.src;
              }) && image.hidden > 0 && image.hidden < _fixation.tsSync;
            });

            if (missingImages.length > 0 || imagesToHide.legnth > 0) {
              _this2.visibleImages = _this2.currentImages.filter(function (image) {
                return image.shown <= _fixation.tsSync && (image.hidden > 0 ? _fixation.tsSync < image.hidden : true);
              }).map(function (image) {
                return __WEBPACK_IMPORTED_MODULE_7__model_task_textPageImage_js__["a" /* TextPageImage */].from(image, { ignoreDisplayCondition: true });
              });
            }
          },
          completed: function completed(noData) {
            _this2.isWarningMessageVisible = !!noData;
            var name = {
              color: track.color,
              index: ti,
              text: ''
            };
            _this2.painter.checkName(name, {
              fontSize: UI.nameFontSize,
              fontFamily: UI.nameFontFamily,
              nameSpacing: UI.nameSpacing,
              location: LEGEND_LOCATION,
              isNoData: !!noData
            });
          },
          syllabification: function syllabification(_syllabification) {
            _this2.painter.setFont(_this2.defaultSession.font);
            _this2.painter.drawSyllabification(_syllabification, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
              syllab: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.defaultSession.feedbacks.syllabification)
            }, _this2.commonUI, UI.syllab));
          }
        });
      });
    },
    drawNames: function drawNames() {
      var names = this.tracks.map(function (track) {
        return {
          text: track.name,
          color: track.color
        };
      });

      this.painter.drawNames(names, {
        fontSize: UI.nameFontSize,
        fontFamily: UI.nameFontFamily,
        nameSpacing: UI.nameSpacing,
        location: LEGEND_LOCATION
      });
    },
    drawText: function drawText() {
      this.painter.setFont(this.defaultSession.font);
      this.painter.drawWords(this.currentPages[0].text, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        colorMetric: UI.colorMetric
      }, this.commonUI, {
        drawWordFrame: false
      }));
    }
  },

  created: function created() {
    this.options['gazeReplay'] = new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["b" /* OptionGroup */]({
      id: 'gazeReplay',
      title: this.tokens['hdr_options'],
      options: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions({
        colorMetric: new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Array, items: __WEBPACK_IMPORTED_MODULE_5__vis_metric_js__["a" /* default */].Types, label: this.tokens['lbl_word_color'] }),

        nameFontFamily: new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: String, label: this.tokens['lbl_font'] }),
        nameFontSize: new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 1, label: this.tokens['lbl_font_size'] }),
        nameSpacing: new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: Number, step: 0.1, label: this.tokens['lbl_spacing'] }),

        'syllab.background': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: '#', label: this.tokens['lbl_syllab_back'] }),
        'syllab.wordColor': new __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["c" /* OptionItem */]({ type: '#', label: this.tokens['lbl_syllab_word'] })
      }, UI),
      defaults: __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__["a" /* OptionsCreator */].createDefaults(UI)
    });
  },
  mounted: function mounted() {
    console.log('GazeReplay created');
    this.createTracks();
    this.start();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopAll();
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vis_optionsCreator_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vis_painter_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vis_replayTrack2_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vis_metric_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vis_VisPlot_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vis_VisPlot_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_vis_VisPlot_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_data_fixation__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vis_data_record_js__ = __webpack_require__(76);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'audio-replay',

  mixins: [__WEBPACK_IMPORTED_MODULE_8__components_vis_VisPlot_vue___default.a],

  data: function data() {
    return {
      painter: null,

      track: null,

      record: this.data.records[0],

      audio: null,
      offset: 0,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('vis')
    };
  },


  computed: {
    title: function title() {
      return this.tokens['hdr_reading'](this.record.student.name, this.record.task.name, __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].sessionDate(this.record.session.date));
    }
  },

  methods: {
    changePage: function changePage() {
      var _this = this;

      if (this.audio) {
        this.audio.pause();
        this.audio = null;
      }

      this.isWarningMessageVisible = false;
      this.visibleImages = this.currentImages.filter(function (image) {
        return image.on === __WEBPACK_IMPORTED_MODULE_7__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.none;
      }).map(function (image) {
        return __WEBPACK_IMPORTED_MODULE_7__model_task_textPageImage_js__["a" /* TextPageImage */].from(image);
      });

      if (!this.painter) {
        this.painter = new __WEBPACK_IMPORTED_MODULE_4__vis_painter_js__["a" /* Painter */](this.$refs.canvas, {
          syllab: this.defaultFeedback.syllabification
        });
        this.painter.setScreenSize(this.data.records[0].session.screen);
      }

      this.redraw();

      if (!this.track) {
        this.track = new __WEBPACK_IMPORTED_MODULE_5__vis_replayTrack2_js__["a" /* default */](this.$refs.root, this.record.data.pages, this.painter.offset);
      }

      this.track.setPage(this.pageIndex);
      this.loadAudio(function (err) {
        if (err) {
          console.error('GazeWithAudio', err);
        } else {
          _this.audio.play();
        }
      });
    },
    redraw: function redraw() {
      this.painter.clean();
      this.drawText();
    },
    createTrack: function createTrack() {},
    loadAudio: function loadAudio(cb) {
      var _this2 = this;

      var page = this.record.data.pages[this.pageIndex];
      if (this.pageIndex === 0) {
        this.offset = page.ts;
      }

      var audioFile = page.audio;

      if (audioFile) {
        this.audio = new Audio(audioFile);
        this.audio.autoplay = true;
        this.audio.addEventListener('loadeddata', function (e) {
          _this2.audioPlayerProps.duration = (e.target || e.path[0]).duration;
          cb();
        });
        this.audio.addEventListener('timeupdate', function (e) {
          _this2.audioPlayerProps.time = (e.target || e.path[0]).currentTime;
          _this2.track.setTime(page.ts + _this2.audio.currentTime * 1000);
          if (_this2.track.fixation) {
            _this2.updateImages(_this2.track.fixation.tsSync);
          }
        });
        this.audio.addEventListener('play', function (e) {
          _this2.audioPlayerProps.playing = !(e.target || e.path[0]).paused;
        });
        this.audio.addEventListener('pause', function (e) {
          _this2.audioPlayerProps.playing = !(e.target || e.path[0]).paused;
        });
        this.audio.addEventListener('ended', function (e) {
          (e.target || e.path[0]).currentTime = 0;
        });
      } else {
        cb('no audio');
      }
    },
    updateImages: function updateImages(time) {
      var _this3 = this;

      var missingImages = this.currentImages.filter(function (image) {
        return !_this3.visibleImages.find(function (img) {
          return img.src === image.src;
        }) && image.shown < time;
      });
      var imagesToHide = this.currentImages.filter(function (image) {
        return !!_this3.visibleImages.find(function (img) {
          return img.src === image.src;
        }) && image.hidden > 0 && image.hidden < time;
      });

      if (missingImages.length > 0 || imagesToHide.legnth > 0) {
        this.visibleImages = this.currentImages.filter(function (image) {
          return image.shown <= time && (image.hidden > 0 ? time < image.hidden : true);
        }).map(function (image) {
          return __WEBPACK_IMPORTED_MODULE_7__model_task_textPageImage_js__["a" /* TextPageImage */].from(image, { ignoreDisplayCondition: true });
        });
      }
    },
    drawText: function drawText() {
      this.painter.setFont(this.defaultSession.font);
      this.painter.drawWords(this.currentPages[0].text, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        colorMetric: __WEBPACK_IMPORTED_MODULE_6__vis_metric_js__["a" /* default */].Type.NONE
      }, this.commonUI, {
        drawWordFrame: false
      }));
    }
  },

  created: function created() {
    var _this4 = this;

    this.audioPlayerProps.visible = true;
    this.audioPlayerProps.toggled = function (e) {
      if (!_this4.audio) {
        return;
      }
      if (e.isPlaying && _this4.audio.paused) {
        _this4.audio.play();
      } else if (!e.isPlaying && !_this4.audio.paused) {
        _this4.audio.pause();
      }
    };
    this.audioPlayerProps.slided = function (e) {
      if (_this4.audio) {
        _this4.audio.currentTime = e.time;
      }

      _this4.track.setTime(e.time * 1000);
    };
  },
  mounted: function mounted() {
    console.log('GazeWithAudio created');
  },
  beforeDestroy: function beforeDestroy() {
    if (this.track) {
      this.track.cleanup();
    }
    if (this.audio && !this.audio.paused) {
      this.audio.pause();
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vis_colors_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vis_optionsCreator_js__ = __webpack_require__(36);











var ID = 'silko';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'options',

  data: function data() {
    return {
      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__["b" /* i10n */])('options')
    };
  },


  props: {
    values: {
      type: Object,
      required: true
    }
  },

  methods: {
    close: function close(e) {
      if (e.target === this.$el) {
        this.$emit('close');
      }
    },
    save: function save(e) {
      this.saveSettings();
      this.update();

      this.$emit('apply');
      this.$emit('close');
    },
    apply: function apply(e) {
      this.update();

      this.$emit('apply');
    },
    reset: function reset(e) {
      window.localStorage.removeItem(ID);

      __WEBPACK_IMPORTED_MODULE_6__vis_optionsCreator_js__["a" /* OptionsCreator */].restoreDefaults(this.values);

      this.$emit('apply');

      var container = this.$refs.container;
      container.innerHTML = '';
      this.bind();
    },
    loadSettings: function loadSettings() {
      var options = JSON.parse(window.localStorage.getItem(ID));
      if (!options) {
        return;
      }

      var pop = function pop(storage, values) {
        for (var name in storage) {
          var value = values[name];
          var saved = storage[name];
          if (!value) {
            continue;
          }

          if ((typeof saved === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(saved)) === 'object') {
            pop(saved, value);
          } else if (typeof value.ref === 'function') {
            value.ref(saved);
          }
        }
      };

      pop(options, this.values);
    },
    saveSettings: function saveSettings() {
      var options = {};

      var push = function push(storage, values) {
        for (var name in values) {
          var value = values[name];
          if (typeof value.ref === 'function') {
            storage[name] = value.ref();
          } else if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value)) === 'object') {
            storage[name] = {};
            push(storage[name], value);
          }
        }
      };

      push(options, this.values);

      window.localStorage.setItem(ID, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(options));
    },
    update: function update() {
      for (var valueID in this.values) {
        var val = this.values[valueID];
        if (typeof val.update === 'function') {
          val.update();
        }
      }
    },
    show: function show(activeVisID) {
      var container = this.$refs.container;
      var groups = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(container.querySelectorAll('.group'));
      groups.forEach(function (group) {
        var id = group.id;
        if (id[0] === '_' || !activeVisID || id.indexOf(activeVisID) === 0) {
          group.classList.remove('hidden');
        } else {
          group.classList.add('hidden');
        }
      });
    },
    bind: function bind() {
      var _this = this;

      var container = this.$refs.container;
      var groups = [];
      for (var visID in this.values) {
        groups.push(this.values[visID]);
      }

      groups = groups.sort(function (a, b) {
        if (a.id[0] === '_') {
          if (b.id[0] === '_') return a.id < b.id ? -1 : 1;else return 1;
        } else if (b.id[0] === '_') {
          return -1;
        } else {
          return a.id < b.id ? -1 : 1;
        }
      });

      groups.forEach(function (item) {
        var vis = item;

        var group = document.createElement('div');
        group.classList.add('group');
        group.id = vis.id + '_group';

        var name = document.createElement('div');
        name.classList.add('name');
        name.textContent = vis.title;
        group.appendChild(name);

        if (vis.options instanceof Array) {
          vis.options.forEach(function (item) {
            var subGroup = _this.createSubGroup(item, vis.id);
            group.appendChild(subGroup);
          });
        } else {
          for (var optionID in vis.options) {
            var option = vis.options[optionID];
            var row = _this.createRow(option, vis.id + '_' + optionID);
            group.appendChild(row);
          }
        }

        container.appendChild(group);
      });
    },
    createSubGroup: function createSubGroup(sub, visID) {
      var subgroup = document.createElement('div');
      subgroup.classList.add('subgroup');

      var name = document.createElement('div');
      name.classList.add('subname');
      name.textContent = sub.title;
      subgroup.appendChild(name);

      for (var optionID in sub.options) {
        var option = sub.options[optionID];
        var row = this.createRow(option, visID + '_' + optionID);
        subgroup.appendChild(row);
      }

      return subgroup;
    },
    createRow: function createRow(option, id) {
      var row = document.createElement('div');
      row.classList.add('row');

      var label = document.createElement('div');
      label.classList.add('row-label');
      label.textContent = option.label;
      row.appendChild(label);

      if (option.type === Array) {
        row.appendChild(this.createSelect(option, id));
      } else if (option.type === Boolean) {
        row.appendChild(this.createCheckbox(option, id));
      } else if (option.type === String) {
        row.appendChild(this.createTextInput(option, id));
      } else if (option.type === '#') {
        row.appendChild(this.createColorbox(option, id));
      } else if (option.type === Number) {
        row.appendChild(this.createNumberInput(option, id));
      } else if (option.type === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a) {
        row.appendChild(this.createSelectVal(option, id));
      }

      return row;
    },
    createSelect: function createSelect(option, id) {
      var select = document.createElement('select');
      select.classList.add('value');
      select.classList.add(id);

      var currentValue = option.ref();
      option.items.forEach(function (itemName) {
        var item = document.createElement('option');
        item.value = itemName;
        item.textContent = itemName;
        if (currentValue === itemName) {
          item.selected = true;
        }
        select.appendChild(item);
      });

      select.addEventListener('change', function (e) {
        option.ref(option.items[e.target.selectedIndex]);
      });

      return select;
    },
    createSelectMap: function createSelectMap(option, id) {
      var select = document.createElement('select');
      select.classList.add('value');
      select.classList.add(id);

      var currentValue = option.ref();
      option.items.forEach(function (val, key) {
        var item = document.createElement('option');
        item.value = key;
        item.textContent = val;
        if (currentValue === key) {
          item.selected = true;
        }
        select.appendChild(item);
      });

      select.addEventListener('change', function (e) {
        option.ref(option.items[e.target.selectedIndex]);
      });

      return select;
    },
    createCheckbox: function createCheckbox(option, id) {
      var container = document.createElement('span');

      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.classList.add(id);

      checkbox.checked = option.ref();
      checkbox.addEventListener('click', function (e) {
        option.ref(e.target.checked);
      });

      var label = document.createElement('label');
      var div = document.createElement('div');
      div.textContent = '\u2714';

      label.appendChild(div);
      container.appendChild(checkbox);
      container.appendChild(label);

      return container;
    },
    createTextInput: function createTextInput(option, id) {
      var input = document.createElement('input');
      input.type = 'text';
      input.classList.add('value');
      input.classList.add(id);

      var val = option.ref();
      input.value = val;
      input.addEventListener('click', function (e) {
        option.ref(e.target.value);
      });

      return input;
    },
    createColorbox: function createColorbox(option, id) {
      var input = document.createElement('input');
      input.type = 'color';
      input.classList.add('value');
      input.classList.add(id);

      var val = option.ref();
      if (val[0] === '#') {
        input.value = __WEBPACK_IMPORTED_MODULE_5__vis_colors_js__["a" /* default */].validateColor(val);
        input.addEventListener('change', function (e) {
          option.ref(e.target.value);
        });
      } else {
        var color = __WEBPACK_IMPORTED_MODULE_5__vis_colors_js__["a" /* default */].cssColorToHex(val);
        input.value = color.hex;
        input.setAttribute('alpha', color.a + '');

        input.addEventListener('change', function (e) {
          option.ref(__WEBPACK_IMPORTED_MODULE_5__vis_colors_js__["a" /* default */].hexToRgba(e.target.value, +e.target.getAttribute('alpha')));
        });
      }

      return input;
    },
    createNumberInput: function createNumberInput(option, id) {
      var number = document.createElement('input');
      number.type = 'number';
      if (option.step !== undefined) {
        number.step = option.step + '';
      }
      if (option.min !== undefined) {
        number.min = option.min.toString();
      }
      if (option.max !== undefined) {
        number.max = option.max.toString();
      }
      number.classList.add('value');
      number.classList.add(id);

      number.value = option.ref();
      number.addEventListener('change', function (e) {
        option.ref(+e.target.value);
      });

      return number;
    }
  },

  mounted: function mounted() {
    this.loadSettings();
    this.bind();
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'player',

  data: function data() {
    return {
      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('player')
    };
  },


  props: {
    isPaused: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    restart: function restart(e) {
      this.$emit('restart');
    },
    toggle: function toggle(e) {
      this.$emit('toggle');
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vis_controlPanel_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vis_controlPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_vis_controlPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_session_question_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vis_data_record_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vis_data_data_js__ = __webpack_require__(53);













var __needed_only_to_make_vscode_happy_about_Questionnaire__ = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'questionnaire-results',

  components: {
    'control-panel': __WEBPACK_IMPORTED_MODULE_4__components_vis_controlPanel_vue___default.a
  },

  data: function data() {
    return {
      questionnaire: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('vis', '_form', '_labels')
    };
  },


  props: {
    data: {
      type: __WEBPACK_IMPORTED_MODULE_7__vis_data_data_js__["a" /* default */],
      required: true
    }
  },

  computed: {
    title: function title() {
      var r = this.data.records[0];
      return this.tokens['hdr_quest'](r.task.name);
    }
  },

  filters: {
    name: function name(id) {
      return id.split(',')[0];
    },
    date: function date(id) {
      return id.split(',')[1];
    }
  },

  methods: {
    close: function close(e) {
      this.$emit('close');
    },
    getAnswerClass: function getAnswerClass(answers, question) {
      if (answers[question]) {
        var isCorrect = answers[question].isCorrect;
        return {
          isCorrect: isCorrect,
          isIncorrect: !isCorrect
        };
      } else {
        return {};
      }
    },
    getAnswerText: function getAnswerText(answers, question) {
      if (answers[question]) {
        return answers[question].text;
      } else {
        return '';
      }
    },
    getTotal: function getTotal(answers) {
      var correct = 0;
      var total = 0;
      for (var question in answers) {
        if (!answers[question]) {
          continue;
        }

        total++;
        correct += answers[question].isCorrect ? 1 : 0;
      }

      return (correct / total * 100).toFixed(1);
    },
    getRecordName: function getRecordName(record) {
      return record.student.name + ',' + __WEBPACK_IMPORTED_MODULE_2__utils_data_utils_js__["a" /* default */].sessionDate(record.session.date);
    },
    createQuestionnaire: function createQuestionnaire() {
      var _this = this;

      var sessions = {};

      var _questions = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();

      this.data.records.forEach(function (record) {
        if (!record.data.questionnaire) {
          return;
        }

        var id = _this.getRecordName(record);

        var answers = {};

        record.data.questionnaire.forEach(function (question) {
          _questions.add(question.question);
          answers[question.question] = question.answer;
        });

        sessions[id] = answers;
      });

      var questions = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_questions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var q = _step.value;

          questions.push(q);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return { sessions: sessions, questions: questions };
    }
  },

  mounted: function mounted() {
    console.log('Questionnaire results created');

    this.questionnaire = this.createQuestionnaire();
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_session_feedbacks_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vis_regressions_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vis_sgwmController_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__task_syllabifier_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_ProgressChart_vue__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_ProgressChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_ProgressChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_ModalContainer_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_ModalContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_ModalContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vis_controlPanel_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vis_controlPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_vis_controlPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_vis_Options_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_vis_Options_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_vis_Options_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_data_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_data_dataPage_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vis_data_data_js__ = __webpack_require__(53);






















__WEBPACK_IMPORTED_MODULE_4__vis_sgwmController_js__["a" /* default */].initializeSettings();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'student-summary',

  components: {
    'modal-container': __WEBPACK_IMPORTED_MODULE_7__components_widgets_ModalContainer_vue___default.a,
    'control-panel': __WEBPACK_IMPORTED_MODULE_8__components_vis_controlPanel_vue___default.a,
    'options': __WEBPACK_IMPORTED_MODULE_9__components_vis_Options_vue___default.a,
    'progress-chart': __WEBPACK_IMPORTED_MODULE_6__components_widgets_ProgressChart_vue___default.a
  },

  data: function data() {
    return {
      isOptionsDisplayed: false,

      students: [],

      options: {
        _sgwm: __WEBPACK_IMPORTED_MODULE_4__vis_sgwmController_js__["a" /* default */].createOptions()
      },

      sortedStatIndex: -1,
      nameSortDir: 1,

      progressChartData: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__["b" /* i10n */])('vis_summary', '_form', '_labels'),

      statistics: []
    };
  },


  props: {
    data: {
      type: __WEBPACK_IMPORTED_MODULE_13__vis_data_data_js__["a" /* default */],
      required: true
    }
  },

  computed: {
    headerNameClass: function headerNameClass() {
      return {
        sorted: this.sortedStatIndex < 0,
        up: this.sortedStatIndex < 0 && this.nameSortDir > 0,
        down: this.sortedStatIndex < 0 && this.nameSortDir < 0
      };
    },
    title: function title() {
      var grade = this.data.params.grade;
      return grade.studentCount + ' ' + grade.name;
    },
    isShowingProgress: function isShowingProgress() {
      return !!this.progressChartData;
    }
  },

  methods: {
    showOptions: function showOptions(e) {
      this.isOptionsDisplayed = true;
    },
    close: function close(e) {
      this.$emit('close');
    },
    applyOptions: function applyOptions(e) {
      __WEBPACK_IMPORTED_MODULE_4__vis_sgwmController_js__["a" /* default */].save();
      this.makeStudents();
    },
    closeOptions: function closeOptions(e) {
      this.isOptionsDisplayed = false;
    },
    statNameClass: function statNameClass(stat, index) {
      return {
        sorted: this.sortedStatIndex === index,
        up: this.sortedStatIndex === index && stat.sortDir > 0,
        down: this.sortedStatIndex === index && stat.sortDir < 0
      };
    },
    makeStudents: function makeStudents() {
      var _this = this;

      var students = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

      this.data.records.forEach(function (record) {
        var session = {
          data: record.data,
          feedbacks: record.session.feedbacks,
          name: record.task.name,
          date: record.session.date
        };

        if (students.has(record.student.id)) {
          var student = students.get(record.student.id);
          student.sessions.push(session);
        } else {
          var _student = {
            ref: record.student,
            sessions: [session],

            statistics: null
          };
          students.set(record.student.id, _student);
        }
      });

      var studentList = [];
      students.forEach(function (student) {
        student.statistics = _this.calculateStatistics(student);
        studentList.push(student);
      });

      this.students = studentList;
      this.sort(this.sortedStatIndex);
    },
    calculateStatistics: function calculateStatistics(student) {
      var result = [];

      result.push(student.sessions.length);

      var duration = 0;

      var wordCount = 0;
      var regressionCount = 0;
      var fixations = {
        count: 0,
        duration: 0,
        hyphenations: 0
      };
      var fixationAvg = 0;
      var fixationSD = 0;
      var syllab = {
        count: 0,
        sessions: 0
      };

      student.sessions.forEach(function (session) {
        var pages = session.data.pages;
        var syllabifier = session.feedbacks.syllabification.enabled ? new __WEBPACK_IMPORTED_MODULE_5__task_syllabifier_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__model_session_feedbacks_js__["c" /* SyllabOptions */].from(session.feedbacks.syllabification)) : null;

        var firstPage = void 0;
        var lastPage = void 0;
        pages.forEach(function (page, pageIndex) {
          if (!firstPage && page.fixations) {
            firstPage = page;
          }
          if (page.fixations) {
            lastPage = page;

            var fixRange = {
              first: page.fixations[0],
              last: page.fixations[page.fixations.length - 1]
            };

            duration += fixRange.last.ts + fixRange.last.duration - fixRange.first.ts;
            wordCount += page.text.length;

            if (syllabifier) {
              var text = page.text.map(function (word) {
                return word.text;
              }).join(' ');
              syllab.count += syllabifier.getSyllabCount(text);
              if (!pageIndex) {
                syllab.sessions++;
              }
            }
          }
        });

        if (!firstPage || !lastPage) {
          return;
        }

        fixations = pages.reduce(function (acc, page) {
          if (!page.fixations) {
            return acc;
          }

          return {
            count: acc.count + page.fixations.length,
            duration: acc.duration + page.fixations.reduce(function (sum, fix) {
              return sum + fix.duration;
            }, 0),
            hyphenations: acc.hyphenations + (page.syllabifications ? page.syllabifications.length : 0)
          };
        }, fixations);

        regressionCount += pages.reduce(function (acc, page) {
          if (!page.fixations) {
            return acc;
          }

          var mappedPage = __WEBPACK_IMPORTED_MODULE_4__vis_sgwmController_js__["a" /* default */].map(page);
          return acc + __WEBPACK_IMPORTED_MODULE_3__vis_regressions_js__["a" /* default */].compute(mappedPage.fixations);
        }, 0);
      });

      fixationAvg = fixations.count ? fixations.duration / fixations.count : 0;
      fixationSD = fixations.count > 1 ? student.sessions.reduce(function (acc, session) {
        session.data.pages.forEach(function (page) {
          if (page.fixations) {
            page.fixations.forEach(function (fix) {
              var d = fix.duration - fixationAvg;
              acc += d * d;
            });
          }
        });
        return acc;
      }, 0) : 0;

      var totalDuration = new Date(0, 0, 0, 0, 0, Math.round(duration / 1000));

      result.push(totalDuration.getMinutes() * 60 + totalDuration.getSeconds());
      result.push(wordCount ? (wordCount / (duration / 60000)).toFixed(0) : '-');
      result.push(syllab.count ? (syllab.count / (duration / 60000)).toFixed(0) + (' (' + syllab.sessions + ')') : '-');
      result.push(duration ? (duration / wordCount / 1000).toFixed(2) : '-');
      result.push(fixations.count ? Math.round(fixationAvg) : '-');
      result.push(fixations.count > 1 ? Math.round(Math.sqrt(fixationSD / (fixations.count - 1))) : '-');
      result.push((fixations.hyphenations / student.sessions.length).toFixed(2));
      result.push(regressionCount);

      return result;
    },
    secondsToString: function secondsToString(seconds) {
      var text = '' + seconds;
      if (text.length < 2) {
        text = '0' + text;
      }
      return text;
    },
    sort: function sort(statIndex) {
      var newSortDirection = this.computeSortDirection();

      this.nameSortDir = statIndex < 0 ? newSortDirection : 0;
      this.statistics.forEach(function (stat, index) {
        stat.sortDir = statIndex === index ? newSortDirection : 0;
      });

      this.sortData(statIndex, newSortDirection);

      this.sortedStatIndex = statIndex;
    },
    computeSortDirection: function computeSortDirection() {
      var currentSortDirection = 0;
      if (this.sortedStatIndex < 0) {
        currentSortDirection = this.nameSortDir;
      } else {
        currentSortDirection = this.statistics[this.sortedStatIndex].sortDir;
      }

      return currentSortDirection < 1 ? 1 : -1;
    },
    sortData: function sortData(statIndex, sortDirection) {
      var students = this.students.map(function (student) {
        return student;
      });

      students.sort(function (a, b) {
        if (statIndex < 0) {
          return sortDirection > 0 ? a.ref.name < b.ref.name ? 1 : 0 : a.ref.name > b.ref.name ? 1 : 0;
        } else {
          var valA = a.statistics[statIndex];
          var valB = b.statistics[statIndex];
          return sortDirection > 0 ? valB - valA : valA - valB;
        }
      });

      this.students = students;
    },
    computeDurationAndWords: function computeDurationAndWords(pages, onPage) {
      var duration = 0;
      var wordCount = 0;

      var firstPage = void 0;
      var lastPage = void 0;
      pages.forEach(function (page, pageIndex) {
        if (!firstPage && page.fixations) {
          firstPage = page;
        }
        if (page.fixations) {
          lastPage = page;

          var fixRange = {
            first: page.fixations[0],
            last: page.fixations[page.fixations.length - 1]
          };

          duration += fixRange.last.ts + fixRange.last.duration - fixRange.first.ts;
          wordCount += page.text.length;

          if (onPage) {
            onPage(page);
          }
        }
      });

      if (firstPage && lastPage) {
        return { duration: duration, wordCount: wordCount };
      } else {
        return null;
      }
    },
    computeWPM: function computeWPM(student) {
      var _this2 = this;

      var values = [];

      var labels = [];

      student.sessions.forEach(function (session) {
        var basicStat = _this2.computeDurationAndWords(session.data.pages, null);
        if (basicStat) {
          values.push(basicStat.wordCount ? basicStat.wordCount / (basicStat.duration / 60000) : 0);
          labels.push(session.name + '|' + session.date);
        }
      });

      return {
        title: this.tokens['tit_wpm'],
        values: values,
        labels: labels
      };
    },
    computeSPM: function computeSPM(student) {
      var _this3 = this;

      var values = [];

      var labels = [];

      student.sessions.forEach(function (session) {
        if (!session.feedbacks.syllabification.enabled) {
          return;
        }

        var syllabifier = new __WEBPACK_IMPORTED_MODULE_5__task_syllabifier_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__model_session_feedbacks_js__["c" /* SyllabOptions */].from(session.feedbacks.syllabification));

        var syllabCount = 0;

        var basicStat = _this3.computeDurationAndWords(session.data.pages, function (page) {
          var text = page.text.map(function (word) {
            return word.text;
          }).join(' ');
          syllabCount += syllabifier.getSyllabCount(text);
        });

        if (basicStat) {
          values.push(basicStat.duration ? syllabCount / (basicStat.duration / 60000) : 0);
          labels.push(session.name + '|' + session.date);
        }
      });

      return {
        title: this.tokens['tit_sylpm'],
        values: values,
        labels: labels
      };
    },
    computeSPW: function computeSPW(student) {
      var _this4 = this;

      var values = [];

      var labels = [];

      student.sessions.forEach(function (session) {
        var basicStat = _this4.computeDurationAndWords(session.data.pages, null);

        if (basicStat) {
          values.push(basicStat.duration ? basicStat.duration / basicStat.wordCount / 1000 : 0);
          labels.push(session.name + '|' + session.date);
        }
      });

      return {
        title: this.tokens['tit_spw'],
        values: values,
        labels: labels
      };
    },
    computeFixation: function computeFixation(student) {
      var _this5 = this;

      var values = [];

      var labels = [];

      student.sessions.forEach(function (session) {
        var fixations = {
          count: 0,
          duration: 0
        };
        var basicStat = _this5.computeDurationAndWords(session.data.pages, function (page) {
          fixations.count += page.fixations.length;
          fixations.duration += page.fixations.reduce(function (sum, fix) {
            return sum + fix.duration;
          }, 0);
        });

        if (basicStat) {
          values.push(fixations.count ? fixations.duration / fixations.count : 0);
          labels.push(session.name + '|' + session.date);
        }
      });

      return {
        title: this.tokens['tit_fd'],
        values: values,
        labels: labels
      };
    },
    computeSyllabifications: function computeSyllabifications(student) {
      var _this6 = this;

      var values = [];

      var labels = [];

      student.sessions.forEach(function (session) {
        var syllabifications = 0;
        var basicStat = _this6.computeDurationAndWords(session.data.pages, function (page) {
          syllabifications += page.syllabifications ? page.syllabifications.length : 0;
        });

        if (basicStat) {
          values.push(syllabifications);
          labels.push(session.name + '|' + session.date);
        }
      });

      return {
        title: this.tokens['tit_syllabs'],
        values: values,
        labels: labels
      };
    },
    computeRegressions: function computeRegressions(student) {
      var _this7 = this;

      var values = [];

      var labels = [];

      student.sessions.forEach(function (session) {
        var regressionCount = 0;

        var basicStat = _this7.computeDurationAndWords(session.data.pages, function (page) {
          var mappedPage = __WEBPACK_IMPORTED_MODULE_4__vis_sgwmController_js__["a" /* default */].map(page);
          regressionCount += __WEBPACK_IMPORTED_MODULE_3__vis_regressions_js__["a" /* default */].compute(mappedPage.fixations);
        });

        if (basicStat) {
          values.push(regressionCount);
          labels.push(session.name + '|' + session.date);
        }
      });

      return {
        title: this.tokens['tit_regrs'],
        values: values,
        labels: labels
      };
    },
    showProgress: function showProgress(student, statIndex) {
      var name = this.statistics[statIndex].name;
      var progressData = this['compute' + name](student);

      this.progressChartData = {
        title: progressData.title,
        labels: progressData.labels,
        datasets: [{
          label: '',
          data: progressData.values.map(function (v) {
            return parseFloat(v.toFixed(1));
          }),

          backgroundColor: '#f87979',
          borderColor: '#7979f8',

          fill: false,
          lineTension: 0.2,

          pointRadius: 6,
          pointBorderWidth: 3,
          pointHoverRadius: 10,
          pointHoverBorderWidth: 3
        }]
      };
    },
    closeChart: function closeChart() {
      this.progressChartData = null;
    }
  },

  created: function created() {
    this.statistics = [{ name: this.tokens['sessions'], sortDir: 0, hasProgress: false }, { name: this.tokens['lbl_time'], sortDir: 0, hasProgress: false }, { name: this.tokens['lbl_wpm'], title: this.tokens['tit_wpm'], sortDir: 0, hasProgress: true }, { name: this.tokens['lbl_spm'], title: this.tokens['tit_sylpm'], sortDir: 0, hasProgress: true }, { name: this.tokens['lbl_spw'], title: this.tokens['tit_spw'], sortDir: 0, hasProgress: true }, { name: this.tokens['lbl_fix'], title: this.tokens['tit_fd'], sortDir: 0, hasProgress: true }, { name: this.tokens['lbl_fsd'], title: this.tokens['tit_fsd'], sortDir: 0, hasProgress: false }, { name: this.tokens['tit_syllabs'], sortDir: 0, hasProgress: true }, { name: this.tokens['tit_regrs'], sortDir: 0, hasProgress: true }];
  },
  mounted: function mounted() {
    console.log('Student summary created');
    this.makeStudents();
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vis_optionsCreator_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vis_sgwmController_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_session_feedbacks__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vis_controlPanel_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vis_controlPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_vis_controlPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vis_Options_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vis_Options_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_vis_Options_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_TaskImages_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_TaskImages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_TaskImages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_AudioPlayer_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_AudioPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_AudioPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_data_dataPage_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_data_image_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vis_data_data_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_task_textPageImage_js__ = __webpack_require__(14);


















var COMMON_UI = {
  wordColor: '#666',
  wordHighlightColor: '#606',
  wordRectColor: '#f44',
  drawWordFrame: true
};

__WEBPACK_IMPORTED_MODULE_2__vis_sgwmController_js__["a" /* default */].initializeSettings();

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'control-panel': __WEBPACK_IMPORTED_MODULE_4__components_vis_controlPanel_vue___default.a,
    'options': __WEBPACK_IMPORTED_MODULE_5__components_vis_Options_vue___default.a,
    'task-images': __WEBPACK_IMPORTED_MODULE_6__components_widgets_TaskImages_vue___default.a,
    'audio-player': __WEBPACK_IMPORTED_MODULE_7__components_widgets_AudioPlayer_vue___default.a
  },

  data: function data() {
    return {
      isOptionsDisplayed: false,
      options: {},

      commonUI: COMMON_UI,

      pageIndex: -1,

      currentPages: [],
      defaultSession: this.data.records[0].session,
      defaultPages: this.data.records[0].data.pages,
      defaultFeedback: this.data.records[0].session.feedbacks,
      defaultQuestionnaire: this.data.records[0].data.questionnaire,

      isPlayerPaused: false,
      isWarningMessageVisible: false,

      audioPlayerProps: {
        visible: false,
        duration: 0,
        playing: false,
        time: 0,
        toggled: function toggled(e) {},
        slided: function slided(e) {}
      },

      currentImages: [],

      visibleImages: [],
      fixation: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('vis')
    };
  },


  props: {
    data: {
      type: __WEBPACK_IMPORTED_MODULE_10__vis_data_data_js__["a" /* default */],
      required: true
    }
  },

  computed: {
    textLength: function textLength() {
      return this.defaultPages.length;
    },
    initialPageIndex: function initialPageIndex() {
      return this.defaultPages[0].isIntro ? 1 : 0;
    },
    title: function title() {
      return '';
    },
    feedback: function feedback() {
      return new __WEBPACK_IMPORTED_MODULE_3__model_session_feedbacks__["b" /* Feedbacks */](this.defaultFeedback.speech, this.defaultFeedback.syllabification);
    }
  },

  methods: {
    changePage: function changePage() {},
    redraw: function redraw() {},
    createCommonOptions: function createCommonOptions() {
      return new __WEBPACK_IMPORTED_MODULE_1__vis_optionsCreator_js__["b" /* OptionGroup */]({
        id: '_common',
        title: this.tokens['hdr_commons'],
        options: __WEBPACK_IMPORTED_MODULE_1__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions({
          wordColor: new __WEBPACK_IMPORTED_MODULE_1__vis_optionsCreator_js__["c" /* OptionItem */]({
            type: '#',
            label: this.tokens['lbl_text_color']
          }),
          wordHighlightColor: new __WEBPACK_IMPORTED_MODULE_1__vis_optionsCreator_js__["c" /* OptionItem */]({
            type: '#',
            label: this.tokens['lbl_hl_color']
          }),
          wordRectColor: new __WEBPACK_IMPORTED_MODULE_1__vis_optionsCreator_js__["c" /* OptionItem */]({
            type: '#',
            label: this.tokens['lbl_frame_color']
          }),
          drawWordFrame: new __WEBPACK_IMPORTED_MODULE_1__vis_optionsCreator_js__["c" /* OptionItem */]({
            type: Boolean,
            label: this.tokens['lbl_draw_frame']
          })
        }, COMMON_UI),
        defaults: __WEBPACK_IMPORTED_MODULE_1__vis_optionsCreator_js__["a" /* OptionsCreator */].createDefaults(COMMON_UI)
      });
    },
    setPage: function setPage(e) {
      this.pageIndex = e.index;
      this.currentPages = this.data.records.map(function (record) {
        return record.data.pages[e.index];
      });
      this.currentImages = this.currentPages[0].images || [];
      this.changePage();
    },
    showOptions: function showOptions(e) {
      this.isOptionsDisplayed = true;
    },
    close: function close(e) {
      this.$emit('close');
    },
    applyOptions: function applyOptions(e) {
      __WEBPACK_IMPORTED_MODULE_2__vis_sgwmController_js__["a" /* default */].save();
      this.redraw();
    },
    closeOptions: function closeOptions(e) {
      this.isOptionsDisplayed = false;
    },
    restartPlayer: function restartPlayer(e) {},
    togglePlayer: function togglePlayer(e) {},
    map: function map(page) {
      return __WEBPACK_IMPORTED_MODULE_2__vis_sgwmController_js__["a" /* default */].map(page);
    }
  },

  created: function created() {
    this.options["_common"] = this.createCommonOptions();
    this.options["_sgwm"] = __WEBPACK_IMPORTED_MODULE_2__vis_sgwmController_js__["a" /* default */].createOptions();
  },
  mounted: function mounted() {
    this.setPage({ index: this.initialPageIndex });
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vis-title'
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vis_optionsCreator_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vis_sgwmController_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vis_wordTrack_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vis_controlPanel_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vis_controlPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_vis_controlPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vis_Options_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vis_Options_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_vis_Options_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vis_data_data_js__ = __webpack_require__(53);















__WEBPACK_IMPORTED_MODULE_3__vis_sgwmController_js__["a" /* default */].initializeSettings();

var UI = {
  levelDuration: 500
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'word-replay',

  components: {
    'control-panel': __WEBPACK_IMPORTED_MODULE_5__components_vis_controlPanel_vue___default.a,
    'options': __WEBPACK_IMPORTED_MODULE_6__components_vis_Options_vue___default.a
  },

  data: function data() {
    return {
      pageIndex: -1,
      isOptionsDisplayed: false,
      isPlayerPaused: false,

      defaultText: this.data.records[0].data.pages.map(function (page) {
        return page.text;
      }),
      defaultFeedback: this.data.records[0].session.feedbacks,

      words: [],

      tracks: null,

      options: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__["b" /* i10n */])('vis_word_replay')
    };
  },


  props: {
    data: {
      type: __WEBPACK_IMPORTED_MODULE_7__vis_data_data_js__["a" /* default */],
      required: true
    }
  },

  computed: {
    textLength: function textLength() {
      return this.defaultText.length;
    },
    initialPageIndex: function initialPageIndex() {
      return this.data.records[0].data.pages[0].isIntro ? 1 : 0;
    },
    title: function title() {
      var r = this.data.records[0];
      return this.tokens['hdr_word_replay'](this.data.params.student, r.task.name);
    }
  },

  methods: {
    setPage: function setPage(e) {
      var _this = this;

      if (this.tracks) {
        this.stopAll();
      }

      this.pageIndex = e.index;
      this.makeList();

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
        _this.start();
      });
    },
    showOptions: function showOptions(e) {
      this.isOptionsDisplayed = true;
    },
    close: function close(e) {
      this.$emit('close');
    },
    applyOptions: function applyOptions(e) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__vis_sgwmController_js__["a" /* default */].save();

      var rows = this.$refs.table.querySelectorAll('tr');
      this.tracks.forEach(function (track) {
        track.words.forEach(function (word) {
          _this2.colorizeCell(rows[word.id + 1].cells[track.id + 1], word.totalDuration);
        });
      });
    },
    closeOptions: function closeOptions(e) {
      this.isOptionsDisplayed = false;
    },
    restartPlayer: function restartPlayer(e) {
      var _this3 = this;

      this.stopAll();
      this.makeList();

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
        _this3.start();
      });
    },
    togglePlayer: function togglePlayer(e) {
      this.isPlayerPaused = !this.isPlayerPaused;
      this.tracks.forEach(function (track) {
        return track.togglePause();
      });
    },
    makeList: function makeList() {
      var _this4 = this;

      if (!this.tracks) {
        this.createTracks();
      }

      var hyphenRegExp = new RegExp('' + this.defaultFeedback.syllabification.hyphen, 'g');

      var words = this.defaultText[this.pageIndex].map(function (word) {
        return {
          text: word.text.replace(hyphenRegExp, ''),
          durations: _this4.tracks.map(function (_) {
            return 0;
          }),
          key: Math.random()
        };
      });

      this.words = words;
    },
    createTracks: function createTracks() {
      var _this5 = this;

      this.tracks = this.data.records.map(function (record, index) {
        return new __WEBPACK_IMPORTED_MODULE_4__vis_wordTrack_js__["a" /* WordTrack */](_this5.$refs.root, record.student.name, record.data.pages, index);
      });
    },
    start: function start() {
      var _this6 = this;

      this.isPlayerPaused = false;

      var rows = this.$refs.table.querySelectorAll('tr');

      this.tracks.forEach(function (track) {
        var words = track.session[_this6.pageIndex].text;
        var mappingResult = __WEBPACK_IMPORTED_MODULE_3__vis_sgwmController_js__["a" /* default */].map(track.session[_this6.pageIndex]);

        track.start(mappingResult ? mappingResult.fixations : null, words, _this6.onWordFixated(track, rows), _this6.onTrackCompleted());
      });

      this.$refs.root.scrollTop = 0;
    },
    stopAll: function stopAll() {
      this.tracks.forEach(function (track) {
        return track.stop();
      });
    },
    colorizeCell: function colorizeCell(cell, duration) {
      var levels = (duration ? 1 : 0) + Math.floor(duration / UI.levelDuration);
      var tone = 255 - 24 * Math.min(10, levels);
      var rgb = 'rgb(' + tone + ',' + tone + ',' + tone + ')';
      cell.style.backgroundColor = rgb;
    },
    hasNoData: function hasNoData(trackIndex) {
      return !this.tracks[trackIndex].hasData;
    },
    onWordFixated: function onWordFixated(track, rows) {
      var _this7 = this;

      return function (word, duration) {
        var rawWord = track.words[word.id];
        rawWord.totalDuration = rawWord.totalDuration + duration;

        var cell = rows[word.id + 1].cells[track.id + 1];
        _this7.colorizeCell(cell, rawWord.totalDuration);

        track.pointer.setAttribute('style', 'left: ' + (cell.offsetLeft + (cell.offsetWidth - track.pointerSize) / 2) + 'px; top: ' + (cell.offsetTop + (cell.offsetHeight - track.pointerSize) / 2) + 'px');
      };
    },
    onTrackCompleted: function onTrackCompleted() {
      return function () {};
    }
  },

  created: function created() {
    this.options = {
      wordReplay: new __WEBPACK_IMPORTED_MODULE_2__vis_optionsCreator_js__["b" /* OptionGroup */]({
        id: 'wordReplay',
        title: this.tokens['hdr_options'],
        options: __WEBPACK_IMPORTED_MODULE_2__vis_optionsCreator_js__["a" /* OptionsCreator */].createOptions({
          levelDuration: new __WEBPACK_IMPORTED_MODULE_2__vis_optionsCreator_js__["c" /* OptionItem */]({
            type: Number,
            step: 50,
            label: this.tokens['lbl_level_dur'] + ', ms'
          })
        }, UI),
        defaults: __WEBPACK_IMPORTED_MODULE_2__vis_optionsCreator_js__["a" /* OptionsCreator */].createDefaults(UI)
      }),
      _sgwm: __WEBPACK_IMPORTED_MODULE_3__vis_sgwmController_js__["a" /* default */].createOptions()
    };
  },
  mounted: function mounted() {
    console.log('Word replay created');

    this.setPage({ index: this.initialPageIndex });
  },
  beforeDestroy: function beforeDestroy() {
    this.stopAll();
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_session_feedbacks__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_session_question__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_vis_Player_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_vis_Player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_vis_Player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vis_VisTitle_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vis_VisTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_vis_VisTitle_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'control-panel',

  components: {
    'player': __WEBPACK_IMPORTED_MODULE_3__components_vis_Player_vue___default.a,
    'vis-title': __WEBPACK_IMPORTED_MODULE_4__components_vis_VisTitle_vue___default.a
  },

  data: function data() {
    return {
      pageIndex: this.initialPageIndex || 0,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('control_panel')
    };
  },


  props: {
    title: {
      type: String,
      required: true
    },

    feedback: {
      type: __WEBPACK_IMPORTED_MODULE_1__model_session_feedbacks__["b" /* Feedbacks */],
      default: null
    },

    questionnaire: {
      type: Array,
      default: null
    },

    initialPageIndex: {
      type: Number,
      default: 0
    },

    textLength: {
      type: Number,
      default: 0
    },

    showOptionsButton: {
      type: Boolean,
      default: true
    },

    showPlayer: {
      type: Boolean,
      default: false
    },

    isPlayerPaused: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    dispPage: function dispPage() {
      var hasIntroPage = this.initialPageIndex > 0;
      var introPageIndex = hasIntroPage ? 0 : -1;
      var textPageCount = hasIntroPage ? this.textLength - 1 : this.textLength;
      var delta = hasIntroPage ? 0 : 1;
      return this.pageIndex === introPageIndex ? this.tokens['lbl_intro'] : this.pageIndex + delta + '/' + textPageCount;
    },
    correctAnswers: function correctAnswers() {
      if (!this.questionnaire || !this.questionnaire.length) {
        return '-';
      }

      var correct = this.questionnaire.filter(function (question) {
        return question.answer.isCorrect;
      }).length / this.questionnaire.length * 100;
      return correct.toFixed(0) + '%';
    }
  },

  methods: {
    prevPage: function prevPage(e) {
      if (this.pageIndex > 0) {
        this.setPage(this.pageIndex - 1);
      }
    },
    nextPage: function nextPage(e) {
      if (this.pageIndex < this.textLength - 1) {
        this.setPage(this.pageIndex + 1);
      }
    },
    showOptions: function showOptions(e) {
      this.$emit('show-options');
    },
    restartPlayer: function restartPlayer(e) {
      this.$emit('restart-player');
    },
    togglePlayer: function togglePlayer(e) {
      this.$emit('toggle-player');
    },
    close: function close(e) {
      this.$emit('close');
    },
    setPage: function setPage(index) {
      this.pageIndex = index;
      this.$emit('page-changed', { index: index });
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isPlaying: this.playing,
      currentTime: this.time,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('audio')
    };
  },


  props: {
    duration: {
      type: Number,
      default: 100
    },

    playing: {
      type: Boolean,
      default: false
    },

    time: {
      type: Number,
      default: 0
    }
  },

  computed: {
    title: function title() {
      return this.isPlaying ? this.tokens['pause'] : this.tokens['play'];
    },
    durationMs: function durationMs() {
      return Math.round(this.duration * 1000);
    },
    currentTimeMs: function currentTimeMs() {
      return Math.round(this.currentTime * 1000);
    },
    currentTimeMin: function currentTimeMin() {
      var seconds = this.currentTime;
      var min = Math.floor(seconds / 60);
      var sec = Math.floor(seconds);
      var frac = Math.floor((seconds - sec) * 10);
      return min + ':' + (sec < 10 ? '0' + sec : sec) + '.' + frac;
    }
  },

  methods: {
    toggle: function toggle() {
      this.isPlaying = !this.isPlaying;
      this.$emit('toggled', { isPlaying: this.isPlaying });
    },
    updateTime: function updateTime(e) {
      this.$emit('slided', { time: e.target.value / 1000 });
    }
  },

  watch: {
    playing: function playing(value) {
      this.isPlaying = value;
    },
    time: function time(value) {
      this.currentTime = value;
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_intro_js__ = __webpack_require__(20);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'intro-editor',

  data: function data() {
    return {
      name: this.intro ? this.intro.name : '',
      calib: this.intro ? this.intro.calibInstruction : '',
      start: this.intro ? this.intro.startInstruction : '',
      firstPage: this.intro ? this.intro.firstPageAsText() : '',

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__["b" /* i10n */])('instruction_editor', '_form')
    };
  },


  props: {
    action: {
      type: String
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    nameEditable: {
      type: Boolean,
      default: true
    },
    intro: {
      type: __WEBPACK_IMPORTED_MODULE_2__model_intro_js__["a" /* default */],
      default: null
    },
    reload: Number
  },

  watch: {
    reload: function reload() {
      this.name = this.intro ? this.intro.name : '';
      this.calib = this.intro ? this.intro.calibInstruction : '';
      this.start = this.intro ? this.intro.startInstruction : '';
      this.firstPage = this.intro ? this.intro.firstPageAsText() : '';
    }
  },

  computed: {
    isNameValid: function isNameValid() {
      return this.name.length > 1;
    },
    isFirstPageValid: function isFirstPageValid() {
      return !this.firstPage.length || this.firstPage.length > 14;
    },
    isCalibInstructionValid: function isCalibInstructionValid() {
      return !this.calib.length || this.calib.length > 4;
    },
    isStartInstructionValid: function isStartInstructionValid() {
      return !this.start.length || this.start.length > 4;
    },
    hasAnyInstuction: function hasAnyInstuction() {
      return this.firstPage.length || this.calib.length || this.start.length;
    },
    canSave: function canSave() {
      return this.isNameValid && this.isCalibInstructionValid && this.isStartInstructionValid && this.isFirstPageValid && this.hasAnyInstuction;
    }
  },

  methods: {
    save: function save(e) {
      this.$emit('save', {
        name: this.name.trim(),
        texts: {
          calibInstruction: this.calib.trim(),
          startInstruction: this.start.trim(),
          firstPage: this.firstPage.trim()
        }
      });
    }
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__["b" /* i10n */])('instruction_editor', '_form');
    });
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_selectionBoxItem_js__ = __webpack_require__(133);






var __needed_only_to_make_vscode_happy_happy_about_Item__ = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'item-select-box',

  data: function data() {
    return {
      currentItem: null,

      groups: null,

      lastSelectionIndex: -1,
      lastSelectionGroup: '',

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('selection_box')
    };
  },


  props: {
    items: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    singleGroup: {
      type: Boolean,
      default: true
    },
    itemName: {
      type: String,
      required: true
    },
    subitemName: {
      type: String,
      required: true
    }
  },

  computed: {
    hasItemsSelected: function hasItemsSelected() {
      var items = this.items;
      return items.some(function (item) {
        return item.subitems.some(function (subitem) {
          return subitem.selected;
        });
      });
    }
  },

  methods: {
    groupedSubitems: function groupedSubitems() {
      if (!this.currentItem) {
        return null;
      }

      var groups = { '_': { items: [], hidden: false } };

      this.currentItem.subitems.forEach(function (subitem) {
        if (!subitem.group) {
          groups['_'].items.push(subitem);
        } else if (!groups[subitem.group]) {
          groups[subitem.group] = { items: [subitem], hidden: false };
        } else {
          groups[subitem.group].items.push(subitem);
        }
      });

      return groups;
    },
    selectItem: function selectItem(item, e) {
      this.currentItem = item;
      this.groups = this.groupedSubitems();
    },
    isItemSelected: function isItemSelected(item) {
      if (!this.currentItem) {
        return false;
      }

      return item ? this.currentItem.id === item.id : !!this.currentItem;
    },
    hasSubitems: function hasSubitems(item) {
      item = item || this.currentItem;
      return item && item.subitems ? !!item.subitems.length : false;
    },
    isGroupVisible: function isGroupVisible(group) {
      return !group.hidden;
    },
    toggleItemsVisibility: function toggleItemsVisibility(group, e) {
      group.hidden = !group.hidden;
    },
    selectMultipleSubitems: function selectMultipleSubitems(subitem, e) {
      if (e.shiftKey) {
        var index = this.currentItem.subitems.indexOf(subitem);
        var delta = this.lastSelectionIndex < index ? -1 : 1;
        var edge = this.lastSelectionIndex < index ? -1 : this.currentItem.subitems.length;

        for (var i = index + delta; i !== edge; i += delta) {
          var si = this.currentItem.subitems[i];
          if (si.selected) {
            break;
          }

          si.selected = this.singleGroup ? si.group === subitem.group : true;
        }
      }
    },
    selectSubitem: function selectSubitem(subitem, index, e) {
      if (!this.multiple) {
        this.items.forEach(function (item) {
          item.subitems.forEach(function (subitem) {
            subitem.selected = false;
          });
        });
      }

      subitem.selected = !subitem.selected;

      if (this.multiple && subitem.selected) {
        if (this.singleGroup && this.currentItem) {
          var group = subitem.group;
          this.currentItem.subitems.forEach(function (subitem) {
            if (subitem.group !== group) {
              subitem.selected = false;
            }
          });

          if (this.lastSelectionGroup !== subitem.group) {
            this.lastSelectionIndex = -1;
          }
        }

        this.selectMultipleSubitems(subitem, e);
      }

      this.lastSelectionIndex = index;
      this.lastSelectionGroup = subitem.group;
    },
    selectAllSubitems: function selectAllSubitems(e) {
      this.currentItem.subitems.forEach(function (subitem) {
        subitem.selected = true;
      });
    },
    removeAllSubitems: function removeAllSubitems(e) {
      this.currentItem.subitems.forEach(function (subitem) {
        subitem.selected = false;
      });
    },
    accept: function accept(e) {
      var _this = this;

      var selected = {};
      var selectedOnly = null;

      this.items.forEach(function (item) {
        item.subitems.forEach(function (subitem) {
          if (subitem.selected) {
            selected[subitem.id] = subitem.text;
            if (!_this.multiple) {
              selectedOnly = subitem;
            }
          }
        });
      });

      this.$emit('accept', {
        subitems: selected,
        selected: selectedOnly
      });
    }
  },

  created: function created() {
    if (this.items.length === 1) {
      this.selectItem(this.items[0], null);
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',

  data: function data() {
    return {};
  },


  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_login_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_actionError_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_TemporalNotification_vue__);









var checkValues = {
  INVALID: -1,
  UNKNOWN: 0,
  VALID: 1
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',

  components: {
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_3__components_widgets_TemporalNotification_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_actionError_js__["a" /* default */]],

  data: function data() {
    return {
      email: '',
      password: '',

      inProgress: false,

      checkValues: checkValues,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__["b" /* i10n */])('_form')
    };
  },


  computed: {
    isEmailValid: function isEmailValid() {
      if (!this.email) {
        return checkValues.UNKNOWN;
      } else if (this.email.indexOf('@') < 0) {
        return this.email.length > 4 ? checkValues.VALID : checkValues.INVALID;
      } else {
        return (/(.{2,})@(\w{2,}\.\w{2,})/.test(this.email) ? checkValues.VALID : checkValues.INVALID
        );
      }
    },
    isPasswordValid: function isPasswordValid() {
      if (!this.password) {
        return checkValues.UNKNOWN;
      } else {
        return !this.password || this.password.length > 5 ? checkValues.VALID : checkValues.INVALID;
      }
    },
    canLogIn: function canLogIn() {
      return !this.inProgress && this.isEmailValid === checkValues.VALID && this.isPasswordValid === checkValues.VALID;
    }
  },

  methods: {
    login: function login(e) {
      var _this = this;

      this.inProgress = true;

      __WEBPACK_IMPORTED_MODULE_0__utils_login_js__["a" /* default */].logIn(this.email, this.password, function (err) {
        _this.inProgress = false;

        if (err) {
          return _this.setError(err, 'Failed to log in');
        }
      });
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal-container',

  data: function data() {
    return {};
  },


  props: {
    title: {
      type: String,
      default: 'Editor'
    }
  },

  methods: {
    close: function close(e) {
      this.$emit('close', { cancelled: true });
    }
  },

  mounted: function mounted() {
    this.$emit('mounted');
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assignments',

  data: function data() {
    return {
      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('modal_error')
    };
  },


  props: {
    text: {
      type: String,
      default: ''
    }
  },

  methods: {
    close: function close(e) {
      this.$emit('close');
    }
  },

  watch: {
    text: function text(value) {
      if (value) {
        console.error('MODAL_ERROR:', value);
      }
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'progress-chart',

  extends: VueChartJs.Line,

  data: function data() {
    return {
      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('_labels')
    };
  },


  props: ['data'],

  mounted: function mounted() {
    this.renderChart(this.data, {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
        labels: {
          fontColor: 'rgb(255, 99, 132)'
        }
      },
      title: {
        display: false
      },
      tooltips: {
        displayColors: false,
        callbacks: {
          title: function title(tooltipItem, data) {
            return data.labels[tooltipItem[0].index].split('|')[0];
          }
        }
      },
      scales: {
        xAxes: [{
          ticks: {
            callback: function callback(value, index, values) {
              var p = value.split('|')[1].split('T');
              return p[0] + ' ' + p[1].split('.')[0];
            }
          },
          scaleLabel: {
            display: true,
            labelString: this.tokens['date'],
            fontSize: 18
          }
        }]
      }
    });
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'remove-warning',

  data: function data() {
    return {
      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('remove_warning', '_buttons')
    };
  },


  props: {
    object: String,
    name: String,
    data: Object
  },

  methods: {
    reject: function reject(e) {
      this.$emit('close', { confirm: false, data: this.data });
    },
    confirm: function confirm(e) {
      this.$emit('close', { confirm: true, data: this.data });
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_actionError_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_TemporalNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_RemoveWarning_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_RemoveWarning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_RemoveWarning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vis_data_session_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vis_data_student_js__ = __webpack_require__(77);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'session-edit-box',

  components: {
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_3__components_widgets_TemporalNotification_vue___default.a,
    'remove-warning': __WEBPACK_IMPORTED_MODULE_4__components_widgets_RemoveWarning_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_actionError_js__["a" /* default */]],

  data: function data() {
    return {
      sessionToDelete: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__["b" /* i10n */])('session_box')
    };
  },


  props: {
    student: {
      type: __WEBPACK_IMPORTED_MODULE_6__vis_data_student_js__["a" /* default */],
      required: true
    }
  },

  computed: {
    toDeleteName: function toDeleteName() {
      return this.sessionToString(this.sessionToDelete);
    }
  },

  methods: {
    sessionToString: function sessionToString(session) {
      if (!session) {
        return '';
      }

      return session.task.name + ' at ' + __WEBPACK_IMPORTED_MODULE_0__utils_data_utils_js__["a" /* default */].sessionDate(session.ref.date);
    },
    showDeleteWarning: function showDeleteWarning(session) {
      this.sessionToDelete = session;
    },
    deleteSession: function deleteSession() {
      var _this = this;

      var sessionID = this.sessionToDelete.ref.id;
      this.student.ref.deleteSession(sessionID, function (err) {
        if (err) {
          return _this.setError(err, _this.tokens['err_delete']);
        }

        _this.student.sessions = _this.student.sessions.filter(function (session) {
          return session.ref.id !== sessionID;
        });
        _this.$emit('deleted', { session: sessionID });
      });

      this.sessionToDelete = null;
    },
    cancel: function cancel() {
      this.sessionToDelete = null;
    },
    removeWarningClosed: function removeWarningClosed(e) {
      if (e.confirm) {
        this.deleteSession();
      } else {
        this.cancel();
      }
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_mixins_actionSuccess__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_ModalContainer_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_ModalContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_ModalContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_ItemSelectionBox_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_ItemSelectionBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_widgets_ItemSelectionBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_widgets_TemporalNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_school_js__ = __webpack_require__(25);























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'student-list',

  mixins: [__WEBPACK_IMPORTED_MODULE_7__components_mixins_actionError__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_mixins_actionSuccess__["a" /* default */]],

  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_9__components_widgets_Loading_vue___default.a,
    'modal-container': __WEBPACK_IMPORTED_MODULE_10__components_widgets_ModalContainer_vue___default.a,
    'item-selection-box': __WEBPACK_IMPORTED_MODULE_11__components_widgets_ItemSelectionBox_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_12__components_widgets_TemporalNotification_vue___default.a
  },

  data: function data() {
    return {
      currentClass: this.cls,

      students: null,

      schoolStudents: null,

      tasks: [],

      schoolGrades: [],

      isEditing: false,
      currentGrade: null,

      activeMenu: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__["b" /* i10n */])('student_list', '_buttons', '_form', '_labels', '_utils', '_failures')
    };
  },


  props: {
    cls: {
      type: __WEBPACK_IMPORTED_MODULE_5__model_class_js__["a" /* default */],
      default: null
    },
    teacher: {
      type: __WEBPACK_IMPORTED_MODULE_6__model_teacher_js__["a" /* default */],
      default: null
    },
    refresh: {
      type: Number,
      default: 0
    }
  },

  watch: {
    refresh: function refresh() {
      this.loadTasks();
    }
  },

  methods: {
    loadTasks: function loadTasks() {
      var _this = this;

      this.currentClass.getTasks(function (err, tasks) {
        if (err) {
          return _this.setError(err, _this.tokens['load'](_this.tokens['tasks']));
        }

        _this.tasks = tasks.sort(__WEBPACK_IMPORTED_MODULE_3__utils_data_utils_js__["a" /* default */].byName);

        _this.loadStudents();
      });
    },
    loadStudents: function loadStudents() {
      var _this2 = this;

      this.currentClass.getStudents(function (err, students) {
        if (err) {
          _this2.students = [];
          return _this2.setError(err, _this2.tokens['load'](_this2.tokens['students']));
        }

        _this2.students = students.sort(__WEBPACK_IMPORTED_MODULE_3__utils_data_utils_js__["a" /* default */].byName);
      });
    },
    loadAvailableStudents: function loadAvailableStudents(cb) {
      var _this3 = this;

      this.teacher.getSchool(function (err, school) {
        if (err) {
          _this3.setError(err, _this3.tokens['err_load_school']);
          return cb(err);
        }

        school.getStudents(function (err, students) {
          if (err) {
            return _this3.setError(err, _this3.tokens['err_load_school_students']);
          }

          _this3.schoolStudents = students;
          _this3.schoolGrades = _this3.makeGrades(students);

          cb();
        });
      });
    },
    makeGrades: function makeGrades(students) {
      var _this4 = this;

      var grades = [];
      students.forEach(function (student) {
        var grade = grades.find(function (item) {
          return item.text === student.grade.toLowerCase();
        });

        if (!grade) {
          grade = {
            id: Math.random(),
            text: student.grade.toLowerCase(),
            subitems: []
          };
          grades.push(grade);
        }

        if (_this4.students && !_this4.students.find(function (item) {
          return item.id === student.id;
        })) {
          grade.subitems.push({
            id: student.id,
            text: student.name,
            selected: false
          });
        }
      });

      grades.forEach(function (grade) {
        grade.subitems.sort(function (a, b) {
          return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1;
        });
      });

      return grades.sort(function (a, b) {
        var gradeA = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(a.text, 10);
        var gradeB = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(b.text, 10);
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(gradeA) && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(gradeB)) {
          if (gradeA === gradeB) {
            return a.text > b.text ? 1 : -1;
          } else {
            return gradeA > gradeB ? 1 : -1;
          }
        } else {
          return a.text > b.text ? 1 : -1;
        }
      });
    },
    openEditor: function openEditor(e) {
      var _this5 = this;

      this.loadAvailableStudents(function (err) {
        if (!err) {
          _this5.isEditing = true;
        }
      });
    },
    addNewStudents: function addNewStudents(e) {
      var _this6 = this;

      if (e.subitems) {
        this.currentClass.addStudents(e.subitems, function (err) {
          if (err) {
            _this6.setError(err, _this6.tokens['add_new'](_this6.tokens['students']));
          } else {
            _this6.setSuccess(_this6.tokens['msg_students_added']);
          }

          _this6.loadStudents();
        });
      }

      this.closeEditor(null);
    },
    closeEditor: function closeEditor(e) {
      this.isEditing = false;
    },
    addAssignment: function addAssignment(student, taskID, e) {
      var _this7 = this;

      this.hideTaskList();

      student.addAssignment(taskID, this.currentClass.id, function (err) {
        if (err) {
          _this7.setError(err, _this7.tokens['err_add_assig']);
        } else {
          _this7.setSuccess(_this7.tokens['msg_assig_added']);
        }
      });
    },
    removeAssignment: function removeAssignment(student, taskID, e) {
      var _this8 = this;

      student.removeAssignment(taskID, function (err) {
        if (err) {
          _this8.setError(err, _this8.tokens['err_remove_assig']);
        } else {
          _this8.setSuccess(_this8.tokens['msg_assig_removed']);
        }
      });
    },
    remove: function remove(student, e) {
      var _this9 = this;

      this.currentClass.removeStudent(student, function (err) {
        if (err) {
          _this9.setError(err, _this9.tokens['remove'](_this9.tokens['student']));
        } else {
          _this9.setSuccess(_this9.tokens['removed'](_this9.tokens['student']));
        }

        _this9.loadStudents();
      });
    },
    availableTasks: function availableTasks(student) {
      return this.tasks.filter(function (task) {
        return !student.assignments[task.id];
      });
    },
    toggleTaskList: function toggleTaskList(id) {
      if (this.activeMenu) {
        this.hideTaskList();
      } else {
        this.showTaskList(id);
      }
    },
    showTaskList: function showTaskList(id) {
      this.hideTaskList();

      this.activeMenu = this.$refs[id][0];
      this.activeMenu.classList.add('is-active');
    },
    hideTaskList: function hideTaskList() {
      if (this.activeMenu) {
        this.activeMenu.classList.remove('is-active');
        this.activeMenu = null;
      }
    },
    doesTaskBelongsToClass: function doesTaskBelongsToClass(id) {
      return this.tasks.some(function (task) {
        return task.id === id;
      });
    },
    getAssignmentName: function getAssignmentName(id) {
      return this.tasks.find(function (task) {
        return task.id === id;
      }).name;
    }
  },

  created: function created() {
    var _this10 = this;

    __WEBPACK_IMPORTED_MODULE_2__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this10.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_i10n_js__["b" /* i10n */])('student_list', '_buttons', '_form', '_labels', '_utils', '_failures');
    });

    window.document.body.addEventListener('click', this.hideTaskList);
  },
  destroyed: function destroyed() {
    window.document.body.removeEventListener('click', this.hideTaskList);
  },
  mounted: function mounted() {
    this.loadTasks();
    this.loadAvailableStudents(function () {});
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_fullscreen_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_taskPreview_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_taskPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_taskPreview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_taskEditorText_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_taskEditorText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_taskEditorText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_taskEditorFeedback_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_taskEditorFeedback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_taskEditorFeedback_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_taskEditorImages_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_taskEditorImages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_taskEditorImages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_taskEditorQuestionnaire_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_taskEditorQuestionnaire_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_taskEditorQuestionnaire_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_bulmaCheckbox_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_bulmaCheckbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_widgets_bulmaCheckbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_session_question_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__model_intro_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_session_feedbacks_js__ = __webpack_require__(7);
























var TASK_DEFAULTS = 'task-defaults';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-editor',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_fullscreen_js__["a" /* default */]],

  components: {
    'task-preview': __WEBPACK_IMPORTED_MODULE_6__components_widgets_taskPreview_vue___default.a,
    'task-editor-text': __WEBPACK_IMPORTED_MODULE_7__components_widgets_taskEditorText_vue___default.a,
    'task-editor-feedback': __WEBPACK_IMPORTED_MODULE_8__components_widgets_taskEditorFeedback_vue___default.a,
    'task-editor-images': __WEBPACK_IMPORTED_MODULE_9__components_widgets_taskEditorImages_vue___default.a,
    'task-editor-questionnaire': __WEBPACK_IMPORTED_MODULE_10__components_widgets_taskEditorQuestionnaire_vue___default.a,
    'bulma-checkbox': __WEBPACK_IMPORTED_MODULE_11__components_widgets_bulmaCheckbox_vue___default.a
  },

  data: function data() {
    return {
      ref: this.task || this.source || JSON.parse(window.localStorage.getItem(TASK_DEFAULTS)),

      name: '',
      alignment: '',
      fontname: '',
      text: '',

      intro: '',

      syllab: __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].defaultSyllab,
      speech: __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].defaultSpeech,
      syllabExceptions: '',
      highlight: __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].defaultHighlight,
      warning: __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].defaultWarning,

      images: [],

      questionnaire: [],

      useTimeout: false,
      timeout: 5,
      recordAudio: false,

      canPreview: true,
      inPreview: false,

      tabs: {
        text: {
          name: 'Text'
        },
        feedback: {
          name: 'Feedback'
        },
        images: {
          name: 'Images'
        },
        questionnaire: {
          name: 'Questionnaire'
        }
      },

      currentTab: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('task_editor', '_labels')
    };
  },


  props: {
    action: {
      type: String,
      default: 'Create'
    },
    task: {
      type: __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */],
      default: null
    },
    source: {
      type: __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */],
      default: null
    },
    intros: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },

  computed: {
    isTaskNameEditable: function isTaskNameEditable() {
      return !this.ref || !this.ref.name || !!this.source;
    },
    isCloningTask: function isCloningTask() {
      return !!this.source;
    },
    isNameValid: function isNameValid() {
      return this.name.length > 1;
    },
    isTextValid: function isTextValid() {
      return this.text.length > 14;
    },
    canSave: function canSave() {
      return this.isNameValid && this.isTextValid;
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.ref) {
        return;
      }

      if (this.ref.name) {
        this.name = !!this.source ? '' : this.ref.name;
      }
      if (this.ref.pages) {
        this.text = __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].pagesToText(this.ref.pages);
      }
      if (this.ref.alignment) {
        this.alignment = this.ref.alignment;
      }
      if (this.ref.fontname) {
        this.fontname = this.ref.fontname;
      }
      if (this.ref.intro) {
        this.intro = this.ref.intro;
      }

      if (this.ref.syllab) {
        this.syllab = this.ref.syllab;
      }
      if (this.ref.speech) {
        this.speech = this.ref.speech;
      }
      if (this.ref.syllab.exceptions) {
        this.syllabExceptions = __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].syllabsToText(this.ref.syllab.exceptions);
      }
      if (this.ref.highlight) {
        this.highlight = this.ref.highlight;
      }
      if (this.ref.warning) {
        this.warning = this.ref.warning;
      }

      if (this.ref.pages) {
        this.ref.pages.forEach(function (page, index) {
          if (!page.images) {
            return;
          }

          page.images.forEach(function (image) {
            _this.images.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ page: index }, image));
          });
        });
      }

      if (this.ref.questionnaire) {
        this.questionnaire = this.ref.questionnaire;
      }

      if (this.ref.useTimeout) {
        this.useTimeout = this.ref.useTimeout;
      }
      if (this.ref.timeout) {
        this.timeout = this.ref.timeout;
      }
      if (this.ref.recordAudio) {
        this.recordAudio = this.ref.recordAudio;
      }
    },
    isCurrentTab: function isCurrentTab(tab) {
      return tab === this.currentTab;
    },
    selectTab: function selectTab(tab) {
      this.currentTab = tab;
    },
    preview: function preview(e) {
      this.inPreview = true;
      this.makeFullscreen(this.$refs.fullscreen);
    },
    closePreview: function closePreview(e) {
      this.inPreview = false;
      this.closeFullscreen();
    },
    setTextInput: function setTextInput(e) {
      this.name = e.name;
      this.alignment = e.alignment;
      this.fontname = e.fontname;
      this.intro = e.intro;
      this.text = e.text;

      this.$emit('modified');
    },
    setFeedbackInput: function setFeedbackInput(e) {
      this.syllab = e.syllab;
      this.speech = e.speech;
      this.syllabExceptions = e.syllabExceptions;
      this.highlight = e.highlight;
      this.warning = e.warning;

      this.$emit('modified');
    },
    setImagesInput: function setImagesInput(e) {
      this.images = e.images;

      this.$emit('modified');
    },
    onImageEditing: function onImageEditing(e) {
      this.canPreview = !e;
    },
    setDefaultFeedback: function setDefaultFeedback(e) {
      var defaults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
        syllab: this.syllab,
        speech: this.speech,
        highlight: this.highlight,
        warning: this.warning
      });
      window.localStorage.setItem(TASK_DEFAULTS, defaults);
    },
    setQuestionnaireInput: function setQuestionnaireInput(e) {
      this.questionnaire = e.questionnaire;

      this.$emit('modified');
    },
    getCurrentTask: function getCurrentTask() {
      var result = new __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */]();
      result = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(result, {
        name: this.name.trim(),
        type: 'text',
        alignment: this.alignment,
        fontname: this.fontname,
        pages: __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].textToPages(this.text),
        syllab: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.syllab),
        speech: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.speech),
        highlight: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.highlight),
        warning: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.warning),
        useTimeout: this.useTimeout,
        timeout: this.timeout,
        recordAudio: this.recordAudio
      });

      __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].embedImagesIntoPages(result.pages, this.images);

      result.syllab.exceptions = __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].textToSyllabs(this.syllabExceptions);
      return result;
    },
    save: function save(e) {
      this.syllab.exceptions = this.syllabExceptions;

      this.$emit('save', {
        name: this.name.trim(),
        text: this.text,
        alignment: this.alignment,
        fontname: this.fontname,
        intro: this.intro,
        syllab: this.syllab,
        speech: this.speech,
        highlight: this.highlight,
        warning: this.warning,
        images: this.images,
        questionnaire: this.questionnaire,
        useTimeout: this.useTimeout,
        timeout: this.timeout,
        recordAudio: this.recordAudio
      });
    }
  },

  created: function created() {
    this.currentTab = this.tabs.text;
  },
  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__task_imageController_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_session_screenSize_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_data_image_js__ = __webpack_require__(52);










var ImageProps = function ImageProps(image) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ImageProps);

  this.location = image.location;
  this.src = __WEBPACK_IMPORTED_MODULE_4__model_task_textPageImage_js__["a" /* TextPageImage */].urlFromName(image.src);
  this.keepOriginalSize = !!image.keepOriginalSize;
  this.offset = image.offset || 0;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-images',

  data: function data() {
    return {
      imageProps: {
        left: null,
        right: null,
        bottom: null
      },

      imageController: null
    };
  },


  props: {
    images: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },

    fixation: {
      type: Object,
      default: null
    },

    viewport: {
      type: Object,
      default: null
    }
  },

  methods: {
    hasImageAt: function hasImageAt(props) {
      var images = this.images;
      if (!images || !props) {
        return false;
      }

      return images.some(function (image) {
        return image.location === props.location;
      });
    },
    getSource: function getSource(props) {
      return props ? props.src : '';
    },
    getClass: function getClass(props) {
      var _ref;

      if (!props) return null;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, props.location, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'has-original-size', props.keepOriginalSize), _ref;
    },
    getStyle: function getStyle(props) {
      if (!props) return '';

      if (this.viewport) {
        var offsetX = -1;
        var offsetY = -1;
        var translateX = 0;
        var translateY = 0;
        var width = 'auto';
        var height = 'auto';

        var SIZE = 0.15;

        if (props.location === 'bottom') {
          offsetY = this.viewport.height - (props.offset || 0);
          translateY = -100;
          translateX = -50;
          if (!props.keepOriginalSize) {
            height = (this.viewport.height * SIZE).toFixed(0) + 'px';
          }
        } else if (props.location === 'right') {
          offsetX = this.viewport.width - (props.offset || 0);
          translateX = -100;
          translateY = -50;
          if (!props.keepOriginalSize) {
            width = (this.viewport.width * SIZE).toFixed(0) + 'px';
          }
        } else if (props.location === 'left') {
          offsetX = props.offset || 0;
          translateY = -50;
          if (!props.keepOriginalSize) {
            width = (this.viewport.width * SIZE).toFixed(0) + 'px';
          }
        }

        return ['right: auto', 'bottom: auto', 'left: ' + (offsetX < 0 ? '50%' : offsetX + 'px'), 'top: ' + (offsetY < 0 ? '50%' : offsetY + 'px'), 'transform: translateX(' + translateX + '%) translateY(' + translateY + '%)', 'width: ' + width, 'height: ' + height].join(';');
      } else {
        return ['margin-' + props.location + ': ' + props.offset + 'px'].join(';');
      }
    }
  },

  watch: {
    images: function images(_images) {
      this.imageController.setImages(_images);
    },
    fixation: function fixation(_fixation) {
      this.imageController.fixate(_fixation.word, _fixation.duration);
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.imageController = new __WEBPACK_IMPORTED_MODULE_2__task_imageController_js__["a" /* default */]({
      onShow: function onShow(image) {
        console.log('IMC_CB', 'shown', image.src.split('_').pop().split('?')[0]);
        _this.imageProps[image.location] = new ImageProps(image);

        _this.$emit('show', { image: image });
        console.log('IMC_CB', '---');
      },
      onHide: function onHide(image) {
        console.log('IMC_CB', 'hidden', image.src.split('_').pop().split('?')[0]);
        _this.imageProps[image.location] = null;
        _this.$emit('hide', { image: image });
        console.log('IMC_CB', '---');
      }
    });
  },
  destroyed: function destroyed() {
    this.imageController.shutdown();
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__db_utils_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_actionSuccess__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_ModalContainer_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_ModalContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_ModalContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_TaskEditor_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_TaskEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_TaskEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_task_js__ = __webpack_require__(8);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-list',

  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_vue___default.a,
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue___default.a,
    'modal-container': __WEBPACK_IMPORTED_MODULE_8__components_widgets_ModalContainer_vue___default.a,
    'task-editor': __WEBPACK_IMPORTED_MODULE_9__components_widgets_TaskEditor_vue___default.a,
    'remove-warning': __WEBPACK_IMPORTED_MODULE_10__components_widgets_RemoveWarning_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__components_mixins_actionError__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__components_mixins_actionSuccess__["a" /* default */]],

  data: function data() {
    return {
      parent: this.cls,

      tasks: null,

      locked: null,

      toEdit: null,

      toCopy: null,

      toDelete: null,
      isCreating: false,

      isTaskModified: false,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('task_list', '_labels', '_buttons', '_utils', '_failures')
    };
  },


  props: {
    cls: {
      type: Object,
      default: null
    },
    intros: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  computed: {
    isEditing: function isEditing() {
      return !!this.toEdit || this.isCreating;
    },
    toDeleteName: function toDeleteName() {
      return this.toDelete ? this.toDelete.name : '';
    },
    action: function action() {
      if (this.isCreating) {
        return this.tokens['create'];
      } else if (this.toEdit) {
        return this.tokens['save'];
      }

      return '';
    },
    taskEditorTitle: function taskEditorTitle() {
      return this.tokens['hdr_editor'](this.toEdit ? ' - ' + this.toEdit.name : '');
    }
  },

  methods: {
    loadTasks: function loadTasks() {
      var _this = this;

      this.parent.getTasks(function (err, tasks) {
        if (err) {
          _this.tasks = [];
          return _this.setError(err, _this.tokens['load'](_this.tokens['tasks']));
        }

        _this.tasks = tasks.sort(__WEBPACK_IMPORTED_MODULE_2__utils_data_utils_js__["a" /* default */].byName);

        __WEBPACK_IMPORTED_MODULE_0__db_utils_js__["a" /* default */].areTasksLocked(_this.tasks.map(function (task) {
          return task.id;
        }), function (err, response) {
          if (err) {
            return console.error('DBUtils.isTaskLocked:', err);
          }

          _this.locked = response;
        });
      });
    },
    canCreate: function canCreate(newTask) {
      return this.tasks.every(function (task) {
        return task.name.toLowerCase() !== newTask.name.toLowerCase();
      });
    },
    edit: function edit(task, e) {
      this.toEdit = task;
      this.isTaskModified = false;
    },
    copy: function copy(task, e) {
      this.toCopy = task;
      this.isCreating = true;
      this.isTaskModified = false;
    },
    save: function save(e) {
      var _this2 = this;

      var task = e;
      if (this.toEdit) {
        this.toEdit.update(task, function (err) {
          _this2.$emit('saved', { err: err });
          _this2.loadTasks();
        });
      } else if (!this.canCreate(task)) {
        this.$emit('created', { err: this.tokens['err_same_name'] });
      } else {
        this.parent.createTask(task, 'text', function (err) {
          _this2.$emit('created', { err: err });

          if (err) {
            return;
          }

          _this2.loadTasks();
        });
      }

      this.isTaskModified = false;
      this.closeEditor(null);
    },
    onTaskModified: function onTaskModified(e) {
      this.isTaskModified = true;
    },
    closeEditor: function closeEditor(e) {
      var canClose = true;
      if (e && this.isTaskModified) {
        canClose = window.confirm(this.tokens['msg_cancel_warning']);
      }

      if (canClose) {
        this.toEdit = null;
        this.toCopy = null;
        this.isCreating = false;
      } else if (e) {
        e.cancelled = true;
      }
    },
    remove: function remove(task, e) {
      this.toDelete = task;
    },
    isLocked: function isLocked(id, e) {
      return this.locked === null || this.locked.indexOf(id) >= 0;
    },
    removeWarningClosed: function removeWarningClosed(e) {
      var _this3 = this;

      if (e.confirm) {
        var id = this.toDelete.id;

        this.parent.deleteTask(this.toDelete, function (err) {
          if (err) {
            return _this3.setError(err, _this3.tokens['delete'](_this3.tokens['task']));
          } else {
            __WEBPACK_IMPORTED_MODULE_0__db_utils_js__["a" /* default */].deleteTaskSessions(id, function (err) {
              if (err) {
                return console.error('DBUtils.deleteTaskSessions:', err);
              }
            });
            __WEBPACK_IMPORTED_MODULE_0__db_utils_js__["a" /* default */].deleteStudentTaskSessions(id, function (err) {
              if (err) {
                return console.error('DBUtils.deleteStudentTaskSessions:', err);
              }
            });

            _this3.setSuccess(_this3.tokens['deleted'](_this3.tokens['task']));
            _this3.$emit('deleted', { task: id });
          }

          _this3.loadTasks();
        });
      }

      this.toDelete = null;
    },
    openNewTextBox: function openNewTextBox(e) {
      this.isCreating = true;
      this.isTaskModified = false;
    }
  },

  created: function created() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_event_bus_js__["a" /* default */].$on('lang', function () {
      _this4.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('task_list', '_labels', '_buttons', '_utils', '_failures');
    });
  },
  mounted: function mounted() {
    this.loadTasks();
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-text',

  data: function data() {
    return {
      textStyle: {
        'color': '#333',
        'font-family': (this.fontname ? this.fontname : 'Calibri') + ', Arial, sans-serif',
        'font-size': '20pt',
        'font-style': 'normal',
        'font-weight': 'bold'
      }
    };
  },


  props: {
    fontname: {
      type: String,
      default: 'Calibri'
    }
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('task_text_format')
    };
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);



var MSG_SHOW_DURATION = 4000;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'temporal-notification',

  data: function data() {
    return {
      showState: false,

      timer: null
    };
  },


  props: {
    type: String,
    show: Number
  },

  watch: {
    show: function show() {
      var _this = this;

      this.log();

      this.showState = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this.showState = false;
        _this.timer = null;
      }, MSG_SHOW_DURATION);
    }
  },

  computed: {
    notificationClass: function notificationClass() {
      return 'is-' + this.type;
    }
  },

  methods: {
    getSlotItemText: function getSlotItemText(item) {
      var _this2 = this;

      var result = '';

      if (item.text) {
        result += item.text;
      }
      if (item.children) {
        result += item.children.reduce(function (acc, _item) {
          return acc + _this2.getSlotItemText(_item);
        }, '');
      }

      return result;
    },
    getSlotText: function getSlotText() {
      var _this3 = this;

      return this.$slots.default.reduce(function (acc, slot) {
        return acc + _this3.getSlotItemText(slot);
      }, '');
    },
    log: function log() {
      if (this.type === 'danger') {
        console.error('TEMP_ERROR: ', this.getSlotText());
      } else if (this.type === 'success') {
        console.log('TEMP_SUCCESS:', this.getSlotText());
      }
    }
  },

  mounted: function mounted() {
    this.showState = false;
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bulma-checkbox',

  data: function data() {
    return {
      checked: !!this.value || false
    };
  },


  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggle: function toggle(e) {
      if (this.disabled) {
        return;
      }

      this.checked = !this.checked;
      this.$emit('input', this.checked);
    }
  },

  watch: {
    value: function value(val) {
      this.checked = val;
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_bulmaCheckbox_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_bulmaCheckbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_bulmaCheckbox_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feedback-editor',

  components: {
    'bulma-checkbox': __WEBPACK_IMPORTED_MODULE_2__components_widgets_bulmaCheckbox_vue___default.a
  },

  data: function data() {
    return {
      language: __WEBPACK_IMPORTED_MODULE_1__utils_data_utils_js__["a" /* default */].convertLegacy(this.value.language),

      enabled: !!this.value.language,

      thresholdIsSmart: this.value.threshold.smart,

      thresholdMin: this.value.threshold.min,

      thresholdMax: this.value.threshold.max,

      thresholdValue: this.value.threshold.value,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('task_editor_feedback')
    };
  },


  props: {
    value: {
      type: Object,
      required: true
    },
    header: {
      type: String,
      required: true
    },
    languages: {
      type: Array,
      required: false
    }
  },

  computed: {
    canEditCalibThresholdParams: function canEditCalibThresholdParams() {
      return this.isEnabled && !!this.thresholdIsSmart;
    },
    isEnabled: function isEnabled() {
      return this.languages ? !!this.language : this.enabled;
    },
    hasThresholdOptions: function hasThresholdOptions() {
      return this.thresholdMin !== 0 || this.thresholdMax !== 0;
    },
    model: function model() {
      return {
        language: this.languages ? this.language : this.enabled ? 'any' : '',
        threshold: {
          smart: this.thresholdIsSmart,
          min: this.thresholdMin,
          max: this.thresholdMax,
          value: this.thresholdValue
        }
      };
    }
  },

  watch: {
    language: function language() {
      this.$emit('input', this.model);
    },
    enabled: function enabled() {
      this.$emit('input', this.model);
    },
    thresholdIsSmart: function thresholdIsSmart() {
      this.$emit('input', this.model);
    },
    thresholdMin: function thresholdMin() {
      this.$emit('input', this.model);
    },
    thresholdMax: function thresholdMax() {
      this.$emit('input', this.model);
    },
    thresholdValue: function thresholdValue() {
      this.$emit('input', this.model);
    }
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__task_syllabifier_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__task_speaker_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__task_highlighter_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__task_warningActor_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_feedbackEditor_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_feedbackEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_feedbackEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_bulmaCheckbox_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_bulmaCheckbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_bulmaCheckbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_session_feedbacks_js__ = __webpack_require__(7);

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-editor-feedback',

  components: {
    'feedback-editor': __WEBPACK_IMPORTED_MODULE_7__components_widgets_feedbackEditor_vue___default.a,
    'bulma-checkbox': __WEBPACK_IMPORTED_MODULE_8__components_widgets_bulmaCheckbox_vue___default.a
  },

  data: function data() {
    return {
      speech: this.task ? this.task.speech : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultSpeech,
      speechAdjustForWordLength: this.task ? this.task.speech.threshold.adjustForWordLength : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultSpeech.threshold.adjustForWordLength,
      speechLangs: __WEBPACK_IMPORTED_MODULE_4__task_speaker_js__["a" /* default */].LANGS,

      syllab: this.task ? this.task.syllab : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultSyllab,
      syllabExceptions: this.task ? __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].syllabsToText(this.task.syllab.exceptions) : '',
      syllabMode: this.task ? this.task.syllab.mode : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultSyllab.mode,
      syllabTemporary: this.task ? this.task.syllab.temporary : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultSyllab.temporary,
      syllabAdjustForWordLength: this.task ? this.task.syllab.threshold.adjustForWordLength : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultSyllab.threshold.adjustForWordLength,

      syllabModes: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__task_syllabifier_js__["a" /* default */].MODES),
      syllabLangs: __WEBPACK_IMPORTED_MODULE_3__task_syllabifier_js__["a" /* default */].LANGS,

      highlight: this.task ? this.task.highlight : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultHighlight,
      highlightColor: this.task ? this.task.highlight.color : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultHighlight.color,
      highlightAdjustForWordLength: this.task ? this.task.highlight.threshold.adjustForWordLength : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultHighlight.threshold.adjustForWordLength,

      warning: this.task ? this.task.warning : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultWarning,
      warningPhrase: this.task ? this.task.warning.phrase : __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */].defaultWarning.phrase,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__["b" /* i10n */])('task_editor_feedback')
    };
  },


  props: {
    task: {
      type: __WEBPACK_IMPORTED_MODULE_2__model_task_js__["a" /* default */],
      default: null
    }
  },

  computed: {
    model: function model() {
      var result = {
        syllab: this.syllab,
        speech: this.speech,
        syllabExceptions: this.syllabExceptions,
        highlight: this.highlight,
        warning: this.warning
      };

      result.syllab.mode = this.syllabMode;
      result.syllab.temporary = this.syllabTemporary;
      result.syllab.threshold.adjustForWordLength = this.syllabAdjustForWordLength;
      result.speech.threshold.adjustForWordLength = this.speechAdjustForWordLength;

      result.highlight.color = this.highlightColor;
      result.highlight.threshold.adjustForWordLength = this.highlightAdjustForWordLength;

      result.warning.phrase = this.warningPhrase;

      return result;
    }
  },

  watch: {
    speech: function speech() {
      this.$emit('input', this.model);
    },
    speechAdjustForWordLength: function speechAdjustForWordLength() {
      this.$emit('input', this.model);
    },
    syllab: function syllab() {
      this.$emit('input', this.model);
    },
    syllabExceptions: function syllabExceptions() {
      this.$emit('input', this.model);
    },
    syllabMode: function syllabMode() {
      this.$emit('input', this.model);
    },
    syllabTemporary: function syllabTemporary() {
      this.$emit('input', this.model);
    },
    syllabAdjustForWordLength: function syllabAdjustForWordLength() {
      this.$emit('input', this.model);
    },
    highlight: function highlight() {
      this.$emit('input', this.model);
    },
    highlightColor: function highlightColor() {
      this.$emit('input', this.model);
    },
    highlightAdjustForWordLength: function highlightAdjustForWordLength() {
      this.$emit('input', this.model);
    },
    warning: function warning() {
      this.$emit('input', this.model);
    },
    warningPhrase: function warningPhrase() {
      this.$emit('input', this.model);
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_actionError__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue__);














function getPages(text) {
  return text.split('\n\n').filter(function (page) {
    return !!page.trim();
  });
}

function removeFormatting(text) {
  return text.split('|')[0];
}

function getUniqueWords(text) {
  var useIDs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(text.trim().split(/\s+/gi).map(function (word) {
    return removeFormatting(word.trim());
  }).filter(function (word) {
    return word.length && word.charAt(0) !== '|';
  }))).map(function (word, index) {
    return new __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["b" /* Word */](word, useIDs ? index + '' : '');
  });
}

function getPageUniqueWords(text, pageIndex) {
  var page = getPages(text)[pageIndex];
  if (!page) {
    return [];
  }

  return getUniqueWords(page, true);
}

function getWords(text) {
  var useIDs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return text.trim().split(/\s+/gi).map(function (word) {
    return removeFormatting(word.trim());
  }).filter(function (word) {
    return word.length && word.charAt(0) !== '|';
  }).map(function (word, index) {
    return new __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["b" /* Word */](word, useIDs ? index + '' : '');
  });
}

function getPageWords(text, pageIndex) {
  var page = getPages(text)[pageIndex];
  if (!page) {
    return [];
  }

  return getWords(page, true);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-editor-images',

  components: {
    'temporal-notification': __WEBPACK_IMPORTED_MODULE_7__components_widgets_TemporalNotification_vue___default.a
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__components_mixins_actionError__["a" /* default */]],

  data: function data() {
    return {
      images: [],

      selectedFile: null,
      editingImageIndex: -1,
      uploadProgress: -1,

      page: '-1',
      location: 'bottom',
      offset: 0,
      keepOriginalSize: 'false',
      on: __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.none,
      fixationWords: [],
      fixationDuration: 1000,
      off: __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.none,
      delayDuration: 1,

      isDraggingFileOverDropzone: false,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('task_editor_images', '_form', '_labels', '_buttons', '_failures'),

      ON: {},
      OFF: {} };
  },


  props: {
    task: {
      type: __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */],
      default: null
    },

    currentText: {
      type: String,
      required: true
    }
  },

  computed: {
    pageCount: function pageCount() {
      return getPages(this.currentText).length;
    },
    currentWords: function currentWords() {
      return +this.page < 0 ? getUniqueWords(this.currentText) : getPageWords(this.currentText, +this.page);
    },
    isUploading: function isUploading() {
      return this.uploadProgress >= 0;
    },
    isEditing: function isEditing() {
      return this.editingImageIndex >= 0;
    },
    hasValidParams: function hasValidParams() {
      return this.constructImageEvent(this.on).isValid && this.constructImageEvent(this.off).isValid;
    }
  },

  methods: {
    listImages: function listImages() {
      var images = [];
      if (!this.task) {
        return;
      }

      this.task.pages.forEach(function (page) {
        if (!page.images) {
          return;
        }

        page.images.forEach(function (image) {
          if (!images.find(function (img) {
            return img.src === image.src;
          })) {
            images.push(image);
          }
        });
      });

      this.images = images;
    },
    edit: function edit(index) {
      var img = this.images[index];

      this.page = '' + img.page;
      this.location = img.location;
      this.offset = img.offset || 0;
      this.keepOriginalSize = '' + !!img.keepOriginalSize;
      this.on = this.deconstructImageEvent(img.on);
      this.off = this.deconstructImageEvent(img.off);

      this.editingImageIndex = index;

      this.$emit('editing', true);
    },
    saveEdited: function saveEdited() {
      var onEvent = this.constructImageEvent(this.on);
      var offEvent = this.constructImageEvent(this.off);
      this.images[this.editingImageIndex] = new __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */]({
        src: this.images[this.editingImageIndex].src,
        page: +this.page,
        location: this.location,
        offset: this.offset,
        keepOriginalSize: this.keepOriginalSize === 'true',
        on: onEvent,
        off: offEvent
      });

      this.editingImageIndex = -1;

      this.$emit('input', { images: this.images });
      this.$emit('editing', false);
    },
    cancelEditing: function cancelEditing() {
      this.editingImageIndex = -1;
      this.$emit('editing', false);
    },
    remove: function remove(index) {
      var _this = this;

      var deletedImage = this.images.splice(index, 1)[0];
      __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].deleteImage(deletedImage, function (err) {
        if (err) {
          _this.setError(err, _this.tokens['delete'](_this.tokens['image']));
        }
      });
      this.$emit('input', { images: this.images });
    },
    getImageURL: function getImageURL(file) {
      return window.URL.createObjectURL(file);
    },
    canShow: function canShow(image) {
      return !!image.file || !!image.src;
    },
    getCSSBackgroundImage: function getCSSBackgroundImage(image) {
      return 'background-image: url(\'' + (image.file ? this.getImageURL(image.file) : __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].urlFromName(image.src)) + '\')';
    },
    getImageName: function getImageName(image) {
      if (!image) {
        return '';
      } else if (image.file) {
        return image.file.name;
      } else if (image.src) {
        return decodeURIComponent(__WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].getNameFromSource(image.src));
      } else {
        return '-';
      }
    },
    getImagePage: function getImagePage(image) {
      return image.page < 0 ? this.tokens['item_any'] : image.page + 1;
    },
    getImageLocation: function getImageLocation(image) {
      return this.tokens['item_' + image.location] + (image.offset ? ' + ' + image.offset + 'px' : '');
    },
    hasParameters: function hasParameters(imageShowEvent) {
      return __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["c" /* TextPageImageEvent */].hasParameters(imageShowEvent);
    },
    formatEventName: function formatEventName(event) {
      if (event.name === __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.none) {
        return '-';
      } else if (event.name === __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.fixation) {
        return this.tokens['msg_fix_on_word'];
      } else {
        return event.name;
      }
    },
    formatEventParams: function formatEventParams(event) {
      if (event.name === __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.fixation) {
        var fixEvent = event;
        var words = (fixEvent.word ? [{ text: fixEvent.word }] : fixEvent.words).map(function (word) {
          return word.text;
        }).join(' ');
        return '"' + words + '"\n' + this.tokens['lbl_longer'] + ' ' + event.duration + ' ms';
      } else if (event.name === __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.delay) {
        return event.duration + ' ' + this.tokens['lbl_seconds'];
      } else {
        return '';
      }
    },
    dropFile: function dropFile(e) {
      this.isDraggingFileOverDropzone = false;
      var dt = e.dataTransfer;
      var files = dt.files;
      this.selectFile({ target: { files: files } });
    },
    selectFile: function selectFile(e) {
      var file = e.target.files[0];
      if (!file) {} else if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        return this.setError(this.tokens['err_image_type']);
      } else if (file.size > 100000) {
        return this.setError(this.tokens['err_image_size']);
      } else {
        this.selectedFile = file;
      }
    },
    uploadImage: function uploadImage(e) {
      var _this2 = this;

      this.uploadProgress = 0;

      var onEvent = this.constructImageEvent(this.on);
      var offEvent = this.constructImageEvent(this.off);
      var image = new __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */]({
        src: null,
        page: +this.page,
        location: this.location,
        offset: this.offset,
        keepOriginalSize: this.keepOriginalSize === 'true',
        on: onEvent,
        off: offEvent
      });

      __WEBPACK_IMPORTED_MODULE_4__model_task_js__["a" /* default */].uploadImage(this.selectedFile, image.meta, function (percentage) {
        _this2.uploadProgress = percentage;
      }, function (err, url) {
        _this2.uploadProgress = -1;

        if (err) {
          _this2.setError(err, _this2.tokens['err_upload']);
        } else {
          image.src = __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].nameFromURL(url);
          image.file = _this2.selectedFile;
          _this2.images.push(image);

          _this2.selectedFile = null;

          _this2.$emit('input', { images: _this2.images });
        }
      });
    },
    cancel: function cancel(e) {
      this.selectedFile = null;
    },
    constructImageEvent: function constructImageEvent(name) {
      if (name === __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.fixation) {
        return new __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["d" /* TextPageImageFixationEvent */](this.fixationWords, this.fixationDuration);
      } else if (name === __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.delay) {
        return new __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["e" /* TextPageImageDelayEvent */](this.delayDuration);
      } else {
        return new __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["c" /* TextPageImageEvent */](name);
      }
    },
    deconstructImageEvent: function deconstructImageEvent(event) {
      if (event.name === __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.fixation) {
        this.fixationWords = event.words || [event.word] || [];
        this.fixationDuration = event.duration;
      } else if (name === __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.delay) {
        this.delayDuration = event.duration;
      }

      return event.name;
    }
  },

  created: function created() {
    var _ON, _OFF;

    this.ON = (_ON = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ON, __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.none, this.tokens['item_initially']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ON, __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.fixation, this.tokens['item_on_fix']), _ON);

    this.OFF = (_OFF = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_OFF, __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.none, this.tokens['item_never']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_OFF, __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.image, this.tokens['item_when_other']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_OFF, __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.delay, this.tokens['item_after']), _OFF);

    this.listImages();
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_session_question_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_task_js__ = __webpack_require__(8);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-editor-questionnaire',

  data: function data() {
    return {
      type: null,
      word: '',
      question: '',

      answers: [],

      questions: this.task && this.task.questionnaire ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.task.questionnaire) : [],

      types: __WEBPACK_IMPORTED_MODULE_2__model_session_question_js__["a" /* Question */].types,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_i10n_js__["b" /* i10n */])('task_editor_quest', '_buttons')
    };
  },


  props: {
    task: {
      type: __WEBPACK_IMPORTED_MODULE_3__model_task_js__["a" /* default */],
      default: null
    }
  },

  computed: {
    canAdd: function canAdd() {
      return this.type === this.types['word'] ? this.word.length > 0 : true && this.question.length > 5 && this.answers.every(function (answer) {
        return !!answer.text.length;
      });
    },
    model: function model() {
      return {
        questionnaire: this.questions
      };
    }
  },

  watch: {
    questions: function questions() {
      this.$emit('input', this.model);
    }
  },

  methods: {
    answersToString: function answersToString(question) {
      return question.answers.map(function (answer) {
        return answer.text;
      }).join(', ');
    },
    getEmptyAnswers: function getEmptyAnswers() {
      return ['', '', '', ''].map(function (_, index) {
        return { text: '', isCorrect: index === 0 };
      });
    },
    add: function add(e) {
      this.questions.push(new __WEBPACK_IMPORTED_MODULE_2__model_session_question_js__["a" /* Question */](this.type.name, this.type === this.types['word'] ? this.word : '', this.question, this.answers));

      this.word = '';
      this.question = '';
      this.answers = this.getEmptyAnswers();
    },
    remove: function remove(question) {
      this.questions = this.questions.filter(function (item) {
        return item !== question;
      });
    },
    selectCorrect: function selectCorrect(answer) {
      this.answers.forEach(function (answer) {
        answer.isCorrect = false;
      });
      answer.isCorrect = true;
    }
  },

  created: function created() {
    this.type = this.types['text'];
    this.answers = this.getEmptyAnswers();
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_TaskTextFormattingInstructions_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_TaskTextFormattingInstructions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_TaskTextFormattingInstructions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_intro_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_task_textPage_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_task_textPageImage_js__ = __webpack_require__(14);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-editor-text',

  components: {
    'task-text-formatting-instructions': __WEBPACK_IMPORTED_MODULE_2__components_widgets_TaskTextFormattingInstructions_vue___default.a
  },

  data: function data() {
    return {
      name: this.task && this.task.name && !this.isCloning ? this.task.name : '',
      originalName: this.task && this.task.name && this.isCloning ? this.task.name : '',
      alignment: this.task && this.task.alignment ? this.task.alignment : 'center',
      fontname: this.task && this.task.fontname ? this.task.fontname : 'Calibri',
      intro: this.task && this.task.intro ? this.task.intro : '',
      text: this.task && this.task.pages ? __WEBPACK_IMPORTED_MODULE_1__model_task_js__["a" /* default */].pagesToText(this.task.pages) : '',

      FONTS: ['Arial', 'Arial Black', 'Bookman', 'Calibri', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino', 'Times New Roman', 'Times', 'Trebuchet MS', 'Verdana'],

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('task_editor', '_form', '_labels')
    };
  },


  props: {
    task: {
      type: __WEBPACK_IMPORTED_MODULE_1__model_task_js__["a" /* default */],
      default: null
    },
    isNameEditable: {
      type: Boolean
    },
    isCloning: {
      type: Boolean,
      default: false
    },
    intros: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  computed: {
    currentModel: function currentModel() {
      return {
        name: this.name,
        alignment: this.alignment,
        fontname: this.fontname,
        intro: this.intro,
        text: this.text
      };
    },
    hasTaskImagesBoundToWords: function hasTaskImagesBoundToWords() {
      return this.task && this.task.pages && this.task.pages.some(function (page) {
        return !!page.images && page.images.some(function (image) {
          return !!image.on.words || !!image.on.word;
        });
      });
    },
    placeholder: function placeholder() {
      return this.isCloning ? this.originalName : this.tokens['name'];
    }
  },

  watch: {
    name: function name() {
      this.$emit('input', this.currentModel);
    },
    alignment: function alignment() {
      this.$emit('input', this.currentModel);
    },
    fontname: function fontname() {
      this.$emit('input', this.currentModel);
    },
    intro: function intro() {
      this.$emit('input', this.currentModel);
    },
    text: function text() {
      this.$emit('input', this.currentModel);
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TaskText_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widgets_TaskText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_widgets_TaskText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_TaskImages_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_TaskImages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_TaskImages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__task_textPresenter_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__task_feedbackProvider_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(42);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-preview',

  components: {
    'task-text': __WEBPACK_IMPORTED_MODULE_1__components_widgets_TaskText_vue___default.a,
    'task-images': __WEBPACK_IMPORTED_MODULE_2__components_widgets_TaskImages_vue___default.a
  },

  data: function data() {
    return {
      textPresenter: null,

      feedbackProvider: null,

      fixatedWord: null,

      tokens: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_i10n_js__["b" /* i10n */])('preview')
    };
  },


  props: {
    firstPage: {
      type: Array,
      default: null
    },
    task: {
      type: __WEBPACK_IMPORTED_MODULE_3__model_task_js__["a" /* default */]
    }
  },

  computed: {
    hasNextPage: function hasNextPage() {
      return this.textPresenter ? this.textPresenter.hasNextPage : false;
    },
    hasPrevPage: function hasPrevPage() {
      return this.textPresenter ? this.textPresenter.hasPrevPage : false;
    },
    images: function images() {
      if (!this.textPresenter) {
        return [];
      }

      var pageIndex = this.textPresenter.originalPageIndex;
      if (pageIndex < 0) {
        return [];
      }

      return this.task.pages[pageIndex].images;
    },
    fixation: function fixation() {
      return { word: this.fixatedWord, duration: 900000 + Math.floor(Math.random() * 100000) };
    }
  },

  methods: {
    syllabifyAll: function syllabifyAll(e) {
      var _this = this;

      this.textPresenter.words.forEach(function (text, el) {
        _this.feedbackProvider.syllabifier.syllabifyElementText(el, text);
      });
    },
    next: function next(e) {
      this.fixatedWord = null;
      this.textPresenter.nextPage();
      this.feedbackProvider.reset();
    },
    prev: function prev(e) {
      this.fixatedWord = null;
      this.textPresenter.prevPage();
      this.feedbackProvider.reset();
    },
    close: function close(e) {
      this.$emit('close');
    },
    syllabify: function syllabify(e) {
      if (e.target.classList.contains('word')) {
        var text = this.feedbackProvider.syllabifier.unprepare(e.target.textContent);
        if (text) {
          this.feedbackProvider.syllabifier.syllabifyElementText(e.target, text);
        }
      }
    },
    pronounce: function pronounce(e) {
      if (e.target.classList.contains('word')) {
        var text = this.feedbackProvider.syllabifier.unprepare(e.target.textContent);
        if (text) {
          this.feedbackProvider.speaker.say(text);
        }
      }
    },
    fixate: function fixate(e) {
      var el = e.target;
      if (el.classList.contains('word')) {
        var text = this.feedbackProvider.syllabifier.unprepare(el.textContent);
        if (text) {
          this.fixatedWord = new __WEBPACK_IMPORTED_MODULE_6__model_task_textPageImage_js__["b" /* Word */](text, el.dataset.wordId);
        }
      }
    }
  },

  mounted: function mounted() {
    this.feedbackProvider = new __WEBPACK_IMPORTED_MODULE_5__task_feedbackProvider_js__["a" /* default */](this.task.syllab, this.task.speech, this.task.highlight, this.task.warning);
    this.feedbackProvider.init();

    var textEl = this.$refs.container.$refs.text;
    this.textPresenter = new __WEBPACK_IMPORTED_MODULE_4__task_textPresenter_js__["a" /* default */](this.task, this.firstPage, textEl, this.feedbackProvider.syllabifier);

    this.next(null);
  },
  beforeDestroy: function beforeDestroy() {
    this.feedbackProvider.cleanup();
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
var config = {
  apiKey: 'AIzaSyBeKdNAX1_JHeGnPouQTYH0d3APAYzRZVY',
  authDomain: 'eye-school-test.firebaseapp.com',
  databaseURL: 'https://eye-school-test.firebaseio.com',
  projectId: 'eye-school-test',
  storageBucket: 'eye-school-test.appspot.com',
  messagingSenderId: '1082968904935'
};

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
var config = {
  apiKey: 'AIzaSyBppBDnPTQMqo2YLDDUTaXVJN4jZuGRwOw',
  authDomain: 'uta-gasp-silko.firebaseapp.com',
  databaseURL: 'https://uta-gasp-silko.firebaseio.com',
  projectId: 'uta-gasp-silko',
  storageBucket: 'uta-gasp-silko.appspot.com',
  messagingSenderId: '312523900223'
};

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userBase_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_admin_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_user_js__ = __webpack_require__(43);










var AdminUser = function (_UserBase) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AdminUser, _UserBase);

  function AdminUser(user, admin, _user) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AdminUser);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AdminUser.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AdminUser)).call(this, user, _user));

    _this._ref = admin;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AdminUser, [{
    key: 'isAdmin',
    get: function get() {
      return true;
    }
  }]);

  return AdminUser;
}(__WEBPACK_IMPORTED_MODULE_5__userBase_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AdminUser);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userBase_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_school_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_user_js__ = __webpack_require__(43);










var SchoolUser = function (_UserBase) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SchoolUser, _UserBase);

  function SchoolUser(user, school, _user) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SchoolUser);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SchoolUser.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SchoolUser)).call(this, user, _user));

    _this._ref = school;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SchoolUser, [{
    key: 'isSchool',
    get: function get() {
      return true;
    }
  }]);

  return SchoolUser;
}(__WEBPACK_IMPORTED_MODULE_5__userBase_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SchoolUser);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userBase_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_user_js__ = __webpack_require__(43);










var StudentUser = function (_UserBase) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(StudentUser, _UserBase);

  function StudentUser(user, student, _user) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StudentUser);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StudentUser.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StudentUser)).call(this, user, _user));

    _this._ref = student;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(StudentUser, [{
    key: 'isStudent',
    get: function get() {
      return true;
    }
  }]);

  return StudentUser;
}(__WEBPACK_IMPORTED_MODULE_5__userBase_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (StudentUser);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userBase_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_user_js__ = __webpack_require__(43);










var TeacherUser = function (_UserBase) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TeacherUser, _UserBase);

  function TeacherUser(user, teacher, _user) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TeacherUser);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TeacherUser.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TeacherUser)).call(this, user, _user));

    _this._ref = teacher;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TeacherUser, [{
    key: 'isTeacher',
    get: function get() {
      return true;
    }
  }]);

  return TeacherUser;
}(__WEBPACK_IMPORTED_MODULE_5__userBase_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TeacherUser);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_admin_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_school_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_teacher_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__adminUser_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__schoolUser_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__teacherUser_js__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__studentUser_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_user_js__ = __webpack_require__(43);
















var UserCreator = function () {
  function UserCreator() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserCreator);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UserCreator, null, [{
    key: 'create',
    value: function create(user, ref, cb) {
      if (ref.id === 'admin') {
        console.log('logged as admin');
        return cb(null, new __WEBPACK_IMPORTED_MODULE_7__adminUser_js__["a" /* default */](user, new __WEBPACK_IMPORTED_MODULE_3__model_admin_js__["a" /* default */](), ref));
      } else if (ref && ref.path) {
        if (ref.path === __WEBPACK_IMPORTED_MODULE_4__model_school_js__["a" /* default */].db) {
          console.log('logged as school');
          return __WEBPACK_IMPORTED_MODULE_2__db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4__model_school_js__["a" /* default */], ref.id, function (err, school) {
            if (!err) {
              return cb(null, new __WEBPACK_IMPORTED_MODULE_8__schoolUser_js__["a" /* default */](user, school, ref));
            }
            cb(err);
          });
        } else if (ref.path === __WEBPACK_IMPORTED_MODULE_5__model_teacher_js__["a" /* default */].db) {
          console.log('logged as teacher');
          return __WEBPACK_IMPORTED_MODULE_2__db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_5__model_teacher_js__["a" /* default */], ref.id, function (err, teacher) {
            if (!err) {
              return cb(null, new __WEBPACK_IMPORTED_MODULE_9__teacherUser_js__["a" /* default */](user, teacher, ref));
            }
            cb(err);
          });
        } else if (ref.path === __WEBPACK_IMPORTED_MODULE_6__model_student_js__["a" /* default */].db) {
          console.log('logged as student');
          return __WEBPACK_IMPORTED_MODULE_2__db_js__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_6__model_student_js__["a" /* default */], ref.id, function (err, student) {
            if (!err) {
              return cb(null, new __WEBPACK_IMPORTED_MODULE_10__studentUser_js__["a" /* default */](user, student, ref));
            }
            cb(err);
          });
        }
      }

      cb(new Error('INTERNAL: invalid reference'));
    }
  }]);

  return UserCreator;
}();

/* harmony default export */ __webpack_exports__["a"] = (UserCreator);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_event_bus_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__ = __webpack_require__(3);





var tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('db');
__WEBPACK_IMPORTED_MODULE_2__utils_event_bus_js__["a" /* default */].$on('lang', function () {
  tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_i10n_js__["b" /* i10n */])('vis');
});

var configName =  false ? 'development' : 'production';
var config = __webpack_require__(162)("./db." + configName + '.js').config;

var path = 'https://us-central1-' + config.projectId + '.cloudfunctions.net/';

var DBUtils = function () {
  function DBUtils() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DBUtils);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DBUtils, null, [{
    key: 'isTaskLocked',
    value: function isTaskLocked(id, cb) {
      DBUtils._call('isTaskLocked', { id: id }, cb);
    }
  }, {
    key: 'areTasksLocked',
    value: function areTasksLocked(ids, cb) {
      DBUtils._call('areTasksLocked', { ids: ids.join(',') }, cb);
    }
  }, {
    key: 'deleteTaskSessions',
    value: function deleteTaskSessions(id, cb) {
      DBUtils._get('deleteTaskSessions', { id: id }, cb);
    }
  }, {
    key: 'deleteStudentTaskSessions',
    value: function deleteStudentTaskSessions(id, cb) {
      DBUtils._get('deleteStudentTaskSessions', { id: id }, cb);
    }
  }, {
    key: '_get',
    value: function _get(fnc, params, cb) {
      var headers = new Headers();
      headers.append('Content-Type', 'text/json');

      var mode = 'cors';

      var cache = 'no-cache';

      var init = {
        method: 'GET',
        headers: headers,
        mode: mode,
        cache: cache
      };

      var query = [];
      for (var name in params) {
        query.push(name + '=' + params[name]);
      }

      var request = new Request(path + fnc + '?' + query.join('&'));

      if (window.fetch) {
        window.fetch(request, init).then(function (response) {
          if (!response) {
            return cb(new Error(tokens['err_no_resp']));
          }
          return response.json();
        }).then(function (response) {
          cb(null, response);
        }).catch(function (err) {
          console.error(err);
        });
      } else {
        cb(new Error(tokens['err_not_supported']));
      }
    }
  }, {
    key: '_parseResponse',
    value: function _parseResponse(json) {
      var err = null;
      var response = null;

      try {
        response = typeof json === 'string' ? JSON.parse(json) : json;

        if (!response || response.err || !('result' in response)) {
          err = response.err || tokens['err_no_results'];
        } else {
          response = response.result;
        }
      } catch (e) {
        err = e && e.message ? e.message : tokens['err_unknown'];
      }

      return { err: err, response: response };
    }
  }, {
    key: '_call',
    value: function _call(name, params, cb) {
      DBUtils._get(name, params, function (error, json) {
        if (error) {
          return cb(error);
        }

        var _DBUtils$_parseRespon = DBUtils._parseResponse(json),
            err = _DBUtils$_parseRespon.err,
            response = _DBUtils$_parseRespon.response;

        cb(err, response);
      });
    }
  }]);

  return DBUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (DBUtils);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index_js__ = __webpack_require__(163);





new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router_index_js__["a" /* default */],
  template: '<app/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__components_App_vue___default.a }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var WordFeedback = function WordFeedback() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, WordFeedback);

  this.pronounced = false;

  this.syllabified = false;
};

/* harmony default export */ __webpack_exports__["a"] = (WordFeedback);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var WordFocusing = function () {
  function WordFocusing() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, WordFocusing);

    this.count = 0;

    this.first = 0;

    this.last = 0;

    this.duration = 0;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(WordFocusing, [{
    key: "start",
    value: function start(ts) {
      this.last = ts;
      if (!this.count) {
        this.first = this.last;
      }
      this.count++;
    }
  }, {
    key: "stop",
    value: function stop(ts) {
      this.duration += ts - this.last;
    }
  }, {
    key: "currentDuration",
    value: function currentDuration(ts) {
      return ts - this.last;
    }
  }]);

  return WordFocusing;
}();

/* harmony default export */ __webpack_exports__["a"] = (WordFocusing);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


/* harmony default export */ __webpack_exports__["a"] = (function () {

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
      var mediaRecorder = null;

      var audioChunks = [];

      var start = function start(cb) {
        if (mediaRecorder) {
          return console.error('AudioRecorder', 'cannot start new recorder');
        }

        mediaRecorder = new MediaRecorder(stream);
        mediaRecorder.addEventListener('dataavailable', function (e) {
          audioChunks.push(e.data);
        });
        mediaRecorder.addEventListener('start', function () {
          cb();
        });
        mediaRecorder.start();
      };

      var stop = function stop() {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          if (!mediaRecorder) {
            return resolve();
          }

          mediaRecorder.addEventListener('stop', function () {
            var audioBlob = new Blob(audioChunks);

            resolve(audioBlob);

            mediaRecorder = null;
            audioChunks = [];
          });

          mediaRecorder.stop();
        });
      };

      resolve({ start: start, stop: stop });
    });
  });
});;

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_data_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_session_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_session_screenSize_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_data_fixation_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_data_dataPage_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_data_dataPageFocusedWord_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_data_feedbackEvent_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_data_image_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__db_db_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_task_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__model_session_font_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_session_feedbacks_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__model_task_textPageImage_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__model_session_question_js__ = __webpack_require__(26);























var MIN_FIXATION_DURATION = 80;

var Timer = function () {
  function Timer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Timer);

    this._date = null;
    this._start = 0;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Timer, [{
    key: 'start',
    value: function start() {
      this._date = new Date().toJSON();
      this._start = window.performance.now();
    }
  }, {
    key: 'value',
    get: function get() {
      return Math.round(window.performance.now() - this._start);
    }
  }, {
    key: 'date',
    get: function get() {
      return this._date;
    }
  }]);

  return Timer;
}();

var Page = function Page(isIntroPage) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Page);

  this.words = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

  this.data = new __WEBPACK_IMPORTED_MODULE_7__model_data_dataPage_js__["a" /* default */]();

  this.data.isIntro = isIntroPage;
};

var Pages = function () {
  function Pages(hasIntroPage) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Pages);

    this.hasIntroPage = hasIntroPage;

    this.items = [];

    this.pageIndex = -1;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Pages, [{
    key: 'page',
    value: function page(index) {
      return this.items[index];
    }
  }, {
    key: 'add',
    value: function add() {
      var page = new Page(!this.items.length ? this.hasIntroPage : false);
      this.items.push(page);
      this.pageIndex++;
      return page;
    }
  }, {
    key: 'done',
    value: function done() {
      this.pageIndex = -1;
    }
  }, {
    key: 'current',
    get: function get() {
      return this.items[this.pageIndex];
    }
  }, {
    key: 'last',
    get: function get() {
      return this.items[this.items.length - 1];
    }
  }, {
    key: 'ready',
    get: function get() {
      return this.pageIndex >= 0;
    }
  }]);

  return Pages;
}();

;

var DataCollectorSession = function DataCollectorSession(task, student, font, feedbacks) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DataCollectorSession);

  this.date = new Date().toJSON();

  this.student = student.id;

  this.task = task.id;

  this.cls = task.cls;

  this.font = font;

  this.feedbacks = feedbacks;

  this.screen = __WEBPACK_IMPORTED_MODULE_5__model_session_screenSize_js__["a" /* default */].full;

  this.data = null;

  this.files = [];
};

var DataCollector = function () {
  function DataCollector(task, student, font, feedbacks) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DataCollector);

    this._session = new DataCollectorSession(task, student, font, feedbacks);

    this._pages = new Pages(!!task.intro);

    this._timer = new Timer();

    this._focusedElem = null;

    this._currentWord = null;

    this._audioFiles = null;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DataCollector, [{
    key: 'start',
    value: function start() {
      this._timer.start();
    }
  }, {
    key: 'stop',
    value: function stop(cb) {
      this.setFocusedWord(null);
      this._pages.done();
      this._save(cb);
    }
  }, {
    key: 'nextPage',
    value: function nextPage() {
      this._closeImages();
      this._pages.add().data.ts = this._timer.value;
    }
  }, {
    key: 'updatePageTimestamp',
    value: function updatePageTimestamp() {
      if (this._pages.current) {
        this._pages.current.data.ts = this._timer.value;
      }
    }
  }, {
    key: 'longGazedWords',
    value: function longGazedWords(threshold) {
      var result = [];
      var re = /\b([\w$%&]+\S*\b)/;
      this._pages.items.forEach(function (page) {
        page.words.forEach(function (word) {
          if (word.focusing.duration >= threshold) {
            var arr = re.exec(word.text);
            if (arr && arr.length > 0) {
              result.push(arr[0]);
            } else {
              console.log('DataCollector.longGazedWords ??', word.text);
            }
          }
        });
      });

      return result;
    }
  }, {
    key: 'setFocusedWord',
    value: function setFocusedWord(el) {
      if (this._focusedElem === el || !this._pages.ready) {
        return null;
      }

      if (this._currentWord) {
        this._currentWord.focusing.stop(this._timer.value);
        this._currentWord = null;
      }

      if (el) {
        var page = this._pages.current;
        this._currentWord = page.words.get(el);
        if (!this._currentWord) {
          this._currentWord = new __WEBPACK_IMPORTED_MODULE_8__model_data_dataPageFocusedWord_js__["a" /* default */](el, this._pages.pageIndex);
          page.words.set(el, this._currentWord);
        }

        this._currentWord.focusing.start(this._timer.value);
      }

      this._focusedElem = el;

      return this._currentWord ? this._currentWord.text : null;
    }
  }, {
    key: 'addGazePoint',
    value: function addGazePoint(gazePoint) {
      if (!this._pages.ready) {
        return;
      }

      this._pages.current.data.fixations.push(__WEBPACK_IMPORTED_MODULE_6__model_data_fixation_js__["a" /* default */].from(gazePoint, this._timer.value));
    }
  }, {
    key: 'syllabified',
    value: function syllabified(el) {
      if (!el || !this._pages.ready) {
        return;
      }

      var page = this._pages.current;
      var word = page.words.get(el);

      if (word) {
        word.feedback.syllabified = true;
        page.data.syllabifications.push(new __WEBPACK_IMPORTED_MODULE_9__model_data_feedbackEvent_js__["a" /* default */](this._timer.value, word.text, word.rect));
      }
    }
  }, {
    key: 'pronounced',
    value: function pronounced(el) {
      if (!el || !this._pages.ready) {
        return;
      }

      var page = this._pages.current;
      var word = page.words.get(el);

      if (word) {
        word.feedback.pronounced = true;
        page.data.speech.push(new __WEBPACK_IMPORTED_MODULE_9__model_data_feedbackEvent_js__["a" /* default */](this._timer.value, word.text, word.rect));
      }
    }
  }, {
    key: 'imageShow',
    value: function imageShow(image) {
      console.log('DC', 'shown');
      var page = this._pages.current;
      page.data.images.push(new __WEBPACK_IMPORTED_MODULE_10__model_data_image_js__["a" /* default */](image, this._timer.value));
      console.log('DC', '---');
    }
  }, {
    key: 'imageHide',
    value: function imageHide(image) {
      console.log('DC', 'hidden');
      var page = this._pages.current || this._pages.last;
      var currentImage = page.data.images.find(function (img) {
        return img.src === image.src && img.isCurrent;
      });

      if (currentImage) {
        currentImage.hide(this._timer.value);
      }

      console.log('DC', '---');
    }
  }, {
    key: 'setAudioFiles',
    value: function setAudioFiles(urls) {
      var _this = this;

      this._audioFiles = urls;
      urls.forEach(function (url) {
        _this._session.files.push(url);
      });
    }
  }, {
    key: '_closeImages',
    value: function _closeImages() {
      var _this2 = this;

      var page = this._pages.current || this._pages.last;
      if (!page) {
        return;
      }

      page.data.images.forEach(function (img) {
        if (img.isCurrent) {
          img.hide(_this2._timer.value);
        }
      });
    }
  }, {
    key: '_save',
    value: function _save(cb) {
      var _this3 = this;

      var data = {
        task: this._session.task,
        student: this._session.student,
        pages: this._pages.items.map(function (page, index) {
          page.data.filterFixations(MIN_FIXATION_DURATION);
          page.data.setWords(page.words);
          if (_this3._audioFiles) {
            page.data.audio = _this3._audioFiles[index] || null;
          }
          return page.data;
        }),

        questionnaire: null
      };

      __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].add(__WEBPACK_IMPORTED_MODULE_3__model_data_js__["a" /* default */], data, function (err, dataKey) {
        if (err) {
          return cb(err);
        }

        _this3._session.data = dataKey;
        __WEBPACK_IMPORTED_MODULE_11__db_db_js__["a" /* default */].add(__WEBPACK_IMPORTED_MODULE_4__model_session_js__["a" /* default */], _this3._session, function (err, sessionKey) {
          if (err) {
            return cb(err);
          }

          cb(null, { data: dataKey, session: sessionKey });
        });
      });
    }
  }, {
    key: 'focusedWord',
    get: function get() {
      if (!this._currentWord) {
        return null;
      } else {
        return {
          text: this._currentWord.text,
          duration: this._currentWord.focusing.currentDuration(this._timer.value)
        };
      }
    }
  }, {
    key: 'wordReadingDuration',
    get: function get() {
      var page = this._pages.current;
      if (!page) {
        return null;
      }

      var sum = 0;
      var count = 0;
      page.words.forEach(function (word) {
        if (word.focusing.duration > 200 && word.focusing.duration < 2000) {
          sum += word.focusing.duration;
          count++;
        }
      });

      if (!count) {
        return null;
      }

      return sum / count;
    }
  }]);

  return DataCollector;
}();

/* harmony default export */ __webpack_exports__["a"] = (DataCollector);
;

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_task_textPageImage_js__ = __webpack_require__(14);





var ImageController = function () {
  function ImageController(_ref) {
    var _ref$onShow = _ref.onShow,
        onShow = _ref$onShow === undefined ? function (_) {} : _ref$onShow,
        _ref$onHide = _ref.onHide,
        onHide = _ref$onHide === undefined ? function (_) {} : _ref$onHide;
    var images = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ImageController);

    this._onShow = onShow;

    this._onHide = onHide;

    this._images = images;

    this._locations = {
      left: null,
      right: null,
      bottom: null
    };

    this._prefetched = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

    this._timers = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

    this._prefetch();

    this._start();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ImageController, [{
    key: 'shutdown',
    value: function shutdown() {
      var _this = this;

      console.log('IMC', 'shutdown');
      this._timers.forEach(function (timer, image) {
        window.clearTimeout(timer);
        _this._hide(image);
      });

      for (var location in this._locations) {
        var image = this._locations[location];
        if (image) {
          this._hide(image);
        }
      }

      this._timers.clear();
      console.log('IMC', '---');
    }
  }, {
    key: 'setImages',
    value: function setImages(images) {
      console.log('IMC', 'setImages');
      this.shutdown();

      this._images = images;

      this._start();
      console.log('IMC', '---');
    }
  }, {
    key: 'fixate',
    value: function fixate(word, duration) {
      var _this2 = this;

      if (!word) {
        return;
      }

      this._images.forEach(function (image) {
        if (_this2._locations[image.location] === image) {
          return;
        }

        if (image.on.name === __WEBPACK_IMPORTED_MODULE_3__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.fixation) {
          var fixEvent = image.on;
          var words = fixEvent.word ? [fixEvent.word] : fixEvent.words;
          var hasWord = words.find(function (w) {
            return word.isEqual(w);
          });
          if (hasWord && fixEvent.duration < duration) {
            console.log('IMC', 'fixated "', words.map(function (v) {
              return '-' + v.text + '-';
            }).join(' '), '" ---');
            _this2._show(image);
          }
        }
      });
    }
  }, {
    key: '_prefetch',
    value: function _prefetch() {
      var _this3 = this;

      this._images.forEach(function (image) {
        var el = new Image();
        el.src = __WEBPACK_IMPORTED_MODULE_3__model_task_textPageImage_js__["a" /* TextPageImage */].urlFromName(image.src);
        el.width = 1;
        el.height = 1;
        el.style.position = 'absolute';
        el.style.left = '0';
        el.style.top = '0';
        window.document.body.appendChild(el);

        _this3._prefetched.set(image, el);
      });
    }
  }, {
    key: '_start',
    value: function _start() {
      var _this4 = this;

      console.log('IMC', '_start');
      this._images.forEach(function (image) {
        if (image.on.name === __WEBPACK_IMPORTED_MODULE_3__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.none) {
          _this4._show(image);
        }
      });
      console.log('IMC', '---');
    }
  }, {
    key: '_show',
    value: function _show(image) {
      var _this5 = this;

      console.log('IMC', '_show');

      for (var location in this._locations) {
        var tempImage = this._locations[location];
        if (tempImage && tempImage.off.name === __WEBPACK_IMPORTED_MODULE_3__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.image) {
          this._hide(tempImage);
        }
      }

      if (image.off.name === __WEBPACK_IMPORTED_MODULE_3__model_task_textPageImage_js__["a" /* TextPageImage */].EVENT.delay) {
        var timer = window.setTimeout(function () {
          _this5._hide(image);
          _this5._timers.delete(image);
        }, image.off.duration * 1000);

        this._timers.set(image, timer);
      }

      this._locations[image.location] = image;
      this._onShow(image);
      console.log('IMC', '---');
    }
  }, {
    key: '_hide',
    value: function _hide(image) {
      console.log('IMC', '_hide');
      this._locations[image.location] = null;
      this._onHide(image);
      console.log('IMC', '---');
    }
  }]);

  return ImageController;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImageController);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);






var enabled = !!window['webpackHotUpdate'];

function random() {
  var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  min = Math.ceil(min);
  max = Math.floor(max);
  var result = Math.round(Math.random() * (max - min));
  result = Math.round(result / step) * step;
  return result + min + 0;
}

var Logger = function () {
  function Logger(name) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Logger);

    this.enabled = true;

    this._name = name;

    this._css = ['background: hsl( ' + random(360, 10) + ', ' + random(100, 20) + '%, ' + random(100, 20) + '% )', 'display: inline-block'].join(';');

    this.info(this._name + ': __module_created___');
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Logger, [{
    key: 'info',
    value: function info() {
      if (this.enabled) {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _args = this._stringify(args);
        console.info('%c  ', this._css, this._format(_args));
      }
    }
  }, {
    key: 'ok',
    value: function ok() {
      if (this.enabled) {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var _args = this._stringify(args);
        console.log('%c  ', this._css, this._format(_args));
      }
    }
  }, {
    key: 'error',
    value: function error() {
      if (this.enabled) {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        var _args = this._stringify(args);
        console.error('%c  ', this._css, this._format(_args));
      }
    }
  }, {
    key: '_stringify',
    value: function _stringify(args) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(args).map(function (arg) {
        return (typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(arg)) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arg) : arg;
      }).join(' ');
    }
  }, {
    key: '_format',
    value: function _format(args) {
      return this._name + ': ' + args;
    }
  }]);

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (function (module) {
  return enabled ? new Logger(module) : {
    info: function info() {},
    ok: function ok() {},
    error: function error() {}
  };
});;

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vis_data_student_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vis_data_session_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_data_utils_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_class_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_student_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_session_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__task_js__ = __webpack_require__(78);












var Class = function () {
  function Class(ref, tasks) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Class);

    this.ref = ref;

    this.tasks = tasks;

    this.students = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Class, [{
    key: 'loadStudents',
    value: function loadStudents(cb) {
      var _this = this;

      this.ref.getStudents(function (err, students) {
        _this.students = [];
        if (err) {
          return cb(err);
        }

        students.sort(__WEBPACK_IMPORTED_MODULE_4__utils_data_utils_js__["a" /* default */].byName);

        students.forEach(function (student) {
          _this._loadStudentSessions(student, cb);
        });
      });
    }
  }, {
    key: '_loadStudentSessions',
    value: function _loadStudentSessions(student, cb) {
      var _this2 = this;

      student.getSessions(function (err, sessions) {
        if (err) {
          return cb(err);
        }

        var _student = new __WEBPACK_IMPORTED_MODULE_2__vis_data_student_js__["a" /* default */](student);

        sessions.forEach(function (session) {
          var task = _this2.tasks.find(function (task) {
            return task.id === session.task;
          });
          if (!task) {
            return;
          }

          var _session = new __WEBPACK_IMPORTED_MODULE_3__vis_data_session_js__["a" /* default */](session, student, task, _this2.ref);
          task.sessions.push(_session);
          task.students.add(_student);
          _student.sessions.push(_session);
        });

        if (_student.sessions.length) {
          _this2.students.push(_student);
        }

        cb();
      });
    }
  }]);

  return Class;
}();

/* harmony default export */ __webpack_exports__["a"] = (Class);
;

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vis_colors_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_data_dataPage__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_data_feedbackEvent__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_data_fixation__ = __webpack_require__(51);








var colorIndex = 0;

var FIXATION_GROW_INTERVAL = 100;

var ReplayTrack = function () {
  function ReplayTrack(root, userName, session, offset) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ReplayTrack);

    this._root = root;

    this._name = userName;

    this._session = session;

    this._offset = offset;

    this._color = __WEBPACK_IMPORTED_MODULE_2__vis_colors_js__["a" /* default */].colors[colorIndex++ % __WEBPACK_IMPORTED_MODULE_2__vis_colors_js__["a" /* default */].colors.length];

    this._pointerSize = 8;

    this._fixationEndTimer = null;

    this._fixationGrowTimer = null;

    this._nextTimer = null;

    this._syllabTimer = null;

    this._fixations = null;

    this._currentFixation = null;

    this._currentDuration = 0;

    this._fixationIndex = -1;

    this._callbacks = {};

    this._syllabifications = null;

    this._nextSyllabificationIndex = 0;

    this._pointer = null;

    this._lastPause = 0;

    this.__next = this._next.bind(this);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ReplayTrack, [{
    key: 'start',
    value: function start(pageIndex, callbacks) {
      this._callbacks = callbacks || {};
      this._callbacks.fixation = this._callbacks.fixation || function () {};
      this._callbacks.completed = this._callbacks.completed || function () {};
      this._callbacks.syllabification = this._callbacks.syllabification || function () {};

      this._fixations = this._session[pageIndex].fixations;
      if (!this._fixations) {
        this._callbacks.completed(true);
        return;
      }

      this._syllabifications = this._session[pageIndex].syllabifications;
      this._nextSyllabificationIndex = this._syllabifications ? 0 : -1;

      this._fixationIndex = 0;

      this._pointer = document.createElement('div');
      this._pointer.classList.add('track-pointer');
      this._pointer.classList.add('invisible');
      this._root.appendChild(this._pointer);

      this._nextTimer = setTimeout(this.__next, 1500);
    }
  }, {
    key: 'stop',
    value: function stop() {
      this._stopFixationTimers();

      if (this._nextTimer) {
        clearTimeout(this._nextTimer);
        this._nextTimer = null;
      }

      if (this._pointer) {
        this._root.removeChild(this._pointer);
        this._pointer = null;
      }
    }
  }, {
    key: 'togglePause',
    value: function togglePause() {
      if (!this._pointer) {
        return false;
      }

      if (this._nextTimer) {
        this._stopFixationTimers();

        clearTimeout(this._nextTimer);
        this._nextTimer = null;

        return true;
      } else {
        this._nextTimer = setTimeout(this.__next, this._lastPause);
        this._moveFixation(this._currentFixation);

        return false;
      }
    }
  }, {
    key: '_stopFixationTimers',
    value: function _stopFixationTimers() {
      if (this._fixationEndTimer) {
        clearTimeout(this._fixationEndTimer);
        this._fixationEndTimer = null;
      }

      if (this._fixationGrowTimer) {
        clearInterval(this._fixationGrowTimer);
        this._fixationGrowTimer = null;
      }

      if (this._syllabTimer) {
        clearTimeout(this._syllabTimer);
        this._syllabTimer = null;
      }
    }
  }, {
    key: '_next',
    value: function _next() {
      var fixation = this._fixations[this._fixationIndex];

      this._moveFixation(fixation);

      this._fixationIndex++;
      if (this._fixationIndex < this._fixations.length) {
        this._lastPause = this._fixations[this._fixationIndex].ts - fixation.ts;
        this._nextTimer = setTimeout(this.__next, this._lastPause);
      } else {
        this._callbacks.completed();
        this._root.removeChild(this._pointer);
        this._pointer = null;
        this._nextTimer = null;
      }
    }
  }, {
    key: '_moveFixation',
    value: function _moveFixation(fixation) {
      var _this = this;

      this._stopFixationTimers();

      if (fixation) {
        this._checkSyllabification(fixation);

        this._callbacks.fixation(fixation, this._pointer);

        if (fixation.x > 0 && fixation.y > 0) {
          this._currentDuration = 100;
          this._updatePointer();
          this._pointer.classList.remove('invisible');
        }

        this._fixationEndTimer = setTimeout(function () {
          _this._stopFixationTimers();
          if (_this._pointer) {
            _this._pointer.classList.add('invisible');
          }
        }, fixation.duration);

        this._fixationGrowTimer = setInterval(function () {
          _this._updatePointer();
        }, FIXATION_GROW_INTERVAL);
      } else {
        this._pointer.classList.add('invisible');
      }

      this._currentFixation = fixation;
    }
  }, {
    key: '_updatePointer',
    value: function _updatePointer() {
      if (!this._currentFixation || !this._pointer) {
        return;
      }

      var size = Math.round(Math.sqrt(this._currentDuration));
      this._pointer.setAttribute('style', '\n      left: ' + (this._currentFixation.x + this._offset.x - size / 2) + 'px;\n      top: ' + (this._currentFixation.y + this._offset.y - size / 2) + 'px;\n      width: ' + size + 'px;\n      height: ' + size + 'px;\n      border-radius: ' + size / 2 + 'px;\n      background-color: ' + this._color + ';');

      this._currentDuration += FIXATION_GROW_INTERVAL;
    }
  }, {
    key: '_checkSyllabification',
    value: function _checkSyllabification(fixation) {
      var _this2 = this;

      if (this._nextSyllabificationIndex < 0) {
        return;
      }

      var syllabification = this._syllabifications[this._nextSyllabificationIndex];
      var fixationEndsAt = fixation.tsSync + fixation.duration;
      if (syllabification.ts < fixationEndsAt) {
        this._nextSyllabificationIndex++;
        if (this._nextSyllabificationIndex === this._syllabifications.length) {
          this._nextSyllabificationIndex = -1;
        }

        this._syllabTimer = setTimeout(function () {
          _this2._syllabTimer = null;
          _this2._callbacks.syllabification(syllabification);
        }, fixationEndsAt - syllabification.ts);
      }
    }
  }, {
    key: 'name',
    get: function get() {
      return this._name;
    }
  }, {
    key: 'color',
    get: function get() {
      return this._color;
    }
  }], [{
    key: 'resetColors',
    value: function resetColors() {
      colorIndex = 0;
    }
  }]);

  return ReplayTrack;
}();

/* harmony default export */ __webpack_exports__["a"] = (ReplayTrack);
;

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_data_dataPage__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_data_fixation__ = __webpack_require__(51);






var ReplayTrack = function () {
  function ReplayTrack(root, session, offset) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ReplayTrack);

    this._root = root;

    this._session = session;

    this._offset = offset;

    this._fixations = null;

    this._fixationIndex = -1;

    this._lastTimestamp = -1;

    this._pointer = document.createElement('div');
    this._pointer.classList.add('track-pointer');
    this._pointer.classList.add('invisible');
    this._root.appendChild(this._pointer);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ReplayTrack, [{
    key: 'setPage',
    value: function setPage(pageIndex) {
      this._fixationIndex = -1;
      this._updatePointer(null);

      this._fixations = this._session[pageIndex].fixations;
      if (!this._fixations) {
        return;
      }
    }
  }, {
    key: 'cleanup',
    value: function cleanup() {
      if (this._pointer) {
        this._root.removeChild(this._pointer);
        this._pointer = null;
      }
    }
  }, {
    key: 'setTime',
    value: function setTime(time) {
      if (!this._fixations) {
        console.log('fix', '!fixs');
        return;
      }

      var fixation = null;
      var fixationIndex = -1;

      for (var i = 0; i < this._fixations.length; i += 1) {
        var fix = this._fixations[i];
        if (fix.tsSync <= time && time <= fix.tsSync + fix.duration) {
          fixation = fix;
          fixationIndex = i;
          this._lastTimestamp = time;
          break;
        }
      }

      var isNew = fixationIndex != this._fixationIndex;
      if (isNew) {
        this._fixationIndex = fixationIndex;
        this._updatePointer(fixation);
      }
    }
  }, {
    key: '_updatePointer',
    value: function _updatePointer(fixation) {
      if (!this._pointer) {
        return;
      }

      var isFixationHidden = !fixation;
      var isFixationShown = fixation;
      var isFixationValid = fixation && fixation.x > 0 && fixation.y > 0;

      if (isFixationHidden || !isFixationValid) {
        this._pointer.classList.add('invisible');
      }

      if (isFixationValid) {
        var size = Math.round(Math.sqrt(fixation.duration));
        this._pointer.setAttribute('style', '\n        left: ' + (fixation.x + this._offset.x - size / 2) + 'px;\n        top: ' + (fixation.y + this._offset.y - size / 2) + 'px;\n        width: ' + size + 'px;\n        height: ' + size + 'px;\n        border-radius: ' + size / 2 + 'px;\n        background-color: #289AE5;\n      ');
        this._pointer.classList.remove('invisible');
      }
    }
  }, {
    key: 'fixation',
    get: function get() {
      return this._fixationIndex < 0 ? null : this._fixations[this._fixationIndex];
    }
  }, {
    key: 'pointer',
    get: function get() {
      return this._pointer;
    }
  }]);

  return ReplayTrack;
}();

/* harmony default export */ __webpack_exports__["a"] = (ReplayTrack);
;

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReplayWord */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WordTrack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_data_dataPage__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_data_dataPageTextWord__ = __webpack_require__(91);







var ReplayWord = function ReplayWord(ref) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ReplayWord);

  this.id = ref.id;

  this.totalDuration = 0;
};

var WordTrack = function () {
  function WordTrack(root, userName, session, id) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WordTrack);

    this._root = root;

    this._name = userName;

    this._id = id;

    this._pointerSize = 8;

    this._pointer = null;

    this._fixationTimer = null;

    this._nextTimer = null;

    this._session = session;

    this._fixations = null;

    this._words = null;

    this._fixationIndex = -1;

    this._onWordFixated = null;

    this._onCompleted = null;

    this.__next = this._next.bind(this);

    this.tokens = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_i10n_js__["b" /* i10n */])('vis_word_replay');
  }

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(WordTrack, [{
    key: 'start',
    value: function start(fixations, words, onWordFixated, onCompleted) {
      this._onWordFixated = onWordFixated;
      this._onCompleted = onCompleted;

      this._fixations = fixations;
      this._words = words.map(function (word) {
        return new ReplayWord(word);
      });

      this._words.forEach(function (word) {
        word.totalDuration = 0;
      });

      this._fixationIndex = 0;

      if (!fixations) {
        onCompleted();
        return;
      }

      this._pointer = document.createElement('div');
      this._pointer.classList.add('pointer');
      this._pointer.classList.add('invisible');
      this._root.appendChild(this._pointer);

      this._nextTimer = setTimeout(this.__next, 1500);
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this._nextTimer) {
        clearTimeout(this._nextTimer);
        this._nextTimer = null;
      }

      if (this._fixationTimer) {
        clearTimeout(this._fixationTimer);
        this._fixationTimer = null;
      }

      if (this._pointer) {
        this._root.removeChild(this._pointer);
        this._pointer = null;
      }
    }
  }, {
    key: 'togglePause',
    value: function togglePause() {
      if (!this._pointer) {
        return false;
      }

      if (this._nextTimer) {
        clearTimeout(this._nextTimer);
        this._nextTimer = null;

        return true;
      } else {
        this._nextTimer = setTimeout(this.__next, 500);


        return false;
      }
    }
  }, {
    key: '_next',
    value: function _next() {
      var fixation = this._fixations[this._fixationIndex];

      this._moveFixation(fixation.word, fixation.duration);

      this._fixationIndex++;
      if (this._fixationIndex < this._fixations.length) {
        var pause = this._fixations[this._fixationIndex].ts - fixation.ts;
        this._nextTimer = setTimeout(this.__next, pause);
      } else {
        this._onCompleted();
        this._root.removeChild(this._pointer);
        this._pointer = null;
        this._nextTimer = null;
      }
    }
  }, {
    key: '_moveFixation',
    value: function _moveFixation(word, duration) {
      var _this = this;

      if (this._fixationTimer) {
        clearTimeout(this._fixationTimer);
        this._fixationTimer = null;
      }

      if (word) {
        this._onWordFixated(word, duration, this._pointer);

        this._pointer.classList.remove('invisible');

        this._fixationTimer = setTimeout(function () {
          _this._fixationTimer = null;
          if (_this._pointer) {
            _this._pointer.classList.add('invisible');
          }
        }, duration);
      } else {
        this._pointer.classList.add('invisible');
      }
    }
  }, {
    key: 'name',
    get: function get() {
      return this._name;
    }
  }, {
    key: 'id',
    get: function get() {
      return this._id;
    }
  }, {
    key: 'doneMessage',
    get: function get() {
      return this.tokens['lbl_done'];
    }
  }, {
    key: 'pointerSize',
    get: function get() {
      return this._pointerSize;
    }
  }, {
    key: 'pointer',
    get: function get() {
      return this._pointer;
    }
  }, {
    key: 'session',
    get: function get() {
      return this._session;
    }
  }, {
    key: 'words',
    get: function get() {
      return this._words;
    }
  }, {
    key: 'hasData',
    get: function get() {
      return !!this._fixations;
    }
  }]);

  return WordTrack;
}();;

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(324)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(417),
  /* scopeId */
  "data-v-425b4d8b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(311)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(405),
  /* scopeId */
  "data-v-0cb43a53",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  "data-v-e5029da0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(341)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(432),
  /* scopeId */
  "data-v-690d1f10",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(333)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  "data-v-5b4bf9e5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(409),
  /* scopeId */
  "data-v-248409ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(332)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(424),
  /* scopeId */
  "data-v-5850bae0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(345)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  "data-v-7112b42e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(346)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  "data-v-73b91f1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(434),
  /* scopeId */
  "data-v-7024c5d7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(330)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  "data-v-5669a8c7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(446),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(337)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  "data-v-5e4a4003",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(343)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(433),
  /* scopeId */
  "data-v-6e5a70c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(411),
  /* scopeId */
  "data-v-30436e93",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  "data-v-7f8a5885",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(182),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(183),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(342)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(184),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(338)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(429),
  /* scopeId */
  "data-v-634297ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  "data-v-a05465c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(325)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(418),
  /* scopeId */
  "data-v-47a95014",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(415),
  /* scopeId */
  "data-v-3dcb22e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)
__webpack_require__(348)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  "data-v-7d5d875b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(336)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  "data-v-5d6be80c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(327)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(420),
  /* scopeId */
  "data-v-52f54fae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(408),
  /* scopeId */
  "data-v-1f310dde",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(200),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  "data-v-c82dcd74",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(412),
  /* scopeId */
  "data-v-332a2e2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  "data-v-a42f22a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(413),
  /* scopeId */
  "data-v-3b33b144",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(312)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(406),
  /* scopeId */
  "data-v-0fb9d777",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  "data-v-ec8f61e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(410),
  /* scopeId */
  "data-v-2b86d2b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(339)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(430),
  /* scopeId */
  "data-v-65010d36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(438),
  /* scopeId */
  "data-v-7519dcc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(407),
  /* scopeId */
  "data-v-11eeeada",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(414),
  /* scopeId */
  "data-v-3b6ac658",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'is-modal': _vm.isModal
    },
    attrs: {
      "id": "loading"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "assignment"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.task ? _vm.task.name : ''))])]), (_vm.state === _vm.STATES.calibrate) ? _c('calib-page', {
    attrs: {
      "texts": _vm.introTexts
    },
    on: {
      "close": _vm.calibrate
    }
  }) : _vm._e(), (_vm.intro) ? _c('start-page', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state === _vm.STATES.start),
      expression: "state === STATES.start"
    }],
    attrs: {
      "texts": _vm.introTexts,
      "task": _vm.task,
      "student": _vm.student
    },
    on: {
      "close": _vm.startPageClosed,
      "saved": _vm.gazeDataSaved
    }
  }) : _vm._e(), (_vm.state === _vm.STATES.questionnaire) ? _c('questionnaire-page', {
    attrs: {
      "questionnaire": _vm.task.questionnaire,
      "longGazedWords": _vm.longGazedWords
    },
    on: {
      "finished": _vm.questionnaireDone
    }
  }) : _vm._e(), (_vm.state === _vm.STATES.finished) ? _c('finished-page', {
    attrs: {
      "texts": _vm.introTexts,
      "saving": !_vm.isDataSaved
    }
  }) : _vm._e(), _c('modal-error', {
    attrs: {
      "text": _vm.errorText
    },
    on: {
      "close": _vm.exit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "panel notification is-paddingless",
    attrs: {
      "id": "task-text-formatting-instructions"
    }
  }, [_c('p', {
    staticClass: "panel-block"
  }), _c('h4', {
    staticClass: "heading is-4 has-text-centered"
  }, [_vm._v(_vm._s(_vm.tokens['rules']))]), _c('p'), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("[" + _vm._s(_vm.tokens['empty_line']) + "]")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['separator']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("|")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['styles'])), _c('span', {
    staticClass: "explanation is-inline-block"
  }, [_vm._v(_vm._s(_vm.tokens['word']) + ":"), _vm._m(0)]), _c('span', {
    staticClass: "explanation is-inline-block"
  }, [_vm._v(_vm._s(_vm.tokens['line']) + ":"), _vm._m(1)])])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_c('a', {
    attrs: {
      "href": "https://www.w3schools.com/cssref/css_colors.asp",
      "target": "_blank"
    }
  }, [_vm._v("red")]), _c('span'), _c('a', {
    attrs: {
      "href": "https://www.w3schools.com/colors/colors_rgb.asp",
      "target": "_blank"
    }
  }, [_vm._v("#22aaff")]), _c('span'), _c('abbr', {
    attrs: {
      "title": _vm.tokens['lighter']
    }
  }, [_vm._v("light")]), _c('span'), _c('abbr', {
    attrs: {
      "title": _vm.tokens['darker']
    }
  }, [_vm._v("dark")])]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['color']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("22pt")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['size']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("italic regular")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['style']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("normal bold")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['weight']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('span', {
    staticClass: "has-text-centered"
  }, [_c('h4', {
    staticClass: "heading is-4 is-inline has-text-centered"
  }, [_vm._v(_vm._s(_vm.tokens['example']))]), _c('i', {
    staticClass: "is-block"
  }, [_vm._v("A big grey line with blue|#22aaff & italic|italic words |grey,18pt")]), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "example"
  }, [_c('i', [_vm._v("Iso koulupiha|bold")]), _c('span', [_vm._v("= Iso")]), _c('b', [_vm._v("koulupiha")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "example"
  }, [_c('i', [_vm._v("Iso koulupiha |bold")]), _c('span', [_vm._v("=")]), _c('b', [_vm._v("Iso koulupiha")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-block",
    staticStyle: {
      "color": "grey",
      "font-size": "18pt"
    }
  }, [_c('span', [_vm._v("A big grey line with")]), _c('span', {
    staticStyle: {
      "color": "#22aaff"
    }
  }, [_vm._v("blue")]), _c('span', [_vm._v("&")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("italic")]), _c('span', [_vm._v("words")])])
}]}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field",
    attrs: {
      "id": "task-editor-text"
    }
  }, [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "columns is-inlined"
  }, [(_vm.isNameEditable) ? _c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['name']))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_alignment']))]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alignment),
      expression: "alignment"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.alignment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "center"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_center']))]), _c('option', {
    attrs: {
      "value": "left"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_left']))])])])]), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_font']))]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fontname),
      expression: "fontname"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fontname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.FONTS), function(name) {
    return _c('option', {
      key: name
    }, [_vm._v(_vm._s(name))])
  }))])]), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['instructions']))]), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.intro),
      expression: "intro"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.intro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_none']))]), _vm._l((_vm.intros), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])])]), _c('p'), _c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "columns is-inlined tip-parent"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['text']))])]), _c('div', {
    staticClass: "column is-narrow tip-header"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_formatting']))]), _c('task-text-formatting-instructions', {
    staticClass: "is-tip"
  })], 1), _c('p'), (_vm.hasTaskImagesBoundToWords) ? _c('div', {
    staticClass: "notification is-warning"
  }, [_vm._v(_vm._s(_vm.tokens['msg_not_editable']))]) : _vm._e(), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "textarea text",
    attrs: {
      "placeholder": _vm.tokens['text'],
      "disabled": _vm.hasTaskImagesBoundToWords
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.isEmailValid === _vm.checkValues.INVALID
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.tokens['email_id'],
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._m(0), (_vm.isEmailValid === _vm.checkValues.INVALID) ? _c('span', {
    staticClass: "icon is-small is-right"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]) : _vm._e()]), _c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.isPasswordValid === _vm.checkValues.INVALID
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.tokens['password']
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._m(1), (_vm.isPasswordValid === _vm.checkValues.INVALID) ? _c('span', {
    staticClass: "icon is-small is-right"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]) : _vm._e()]), _c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canLogIn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Log in")])]), _c('p')]), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-user-secret"
  })])
}]}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "instructions"
    }
  }, [_c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['instructions']))]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.intros === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.intros.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_instructions']))])]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['text']))]), _c('th', [_c('div', {
    staticClass: "is-pulled-right"
  }, [_vm._v(_vm._s(_vm.tokens['actions']))])])])]), _c('tbody', _vm._l((_vm.intros), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _c('td', {
      staticClass: "keep-lines"
    }, [_vm._v(_vm._s(item.textsSummary()))]), _c('td', [_c('div', {
      staticClass: "is-pulled-right is-flex"
    }, [_c('button', {
      staticClass: "button is-light",
      attrs: {
        "title": _vm.tokens['tit_edit']
      },
      on: {
        "click": function($event) {
          _vm.edit(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _c('button', {
      staticClass: "button is-danger",
      attrs: {
        "title": _vm.tokens['tit_delete']
      },
      on: {
        "click": function($event) {
          _vm.remove(item)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])])
  }))])])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_new']))]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [_c('intro-editor', {
    staticClass: "control",
    attrs: {
      "action": _vm.tokens['create'],
      "name-editable": true,
      "reload": _vm.resetNew
    },
    on: {
      "save": _vm.tryToCreate
    }
  })], 1)]), (_vm.toEdit) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['hdr_editor']
    },
    on: {
      "close": _vm.closeEditor
    }
  }, [_c('intro-editor', {
    attrs: {
      "action": _vm.tokens['save'],
      "show-labels": true,
      "intro": _vm.toEdit
    },
    on: {
      "save": _vm.saveEdited
    }
  })], 1) : _vm._e(), (_vm.toDelete) ? _c('remove-warning', {
    attrs: {
      "object": "instruction",
      "name": _vm.toDeleteName
    },
    on: {
      "close": _vm.removeWarningClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-editor-feedback"
    }
  }, [_c('div', {
    staticClass: "columns is-paddingless is-marginless"
  }, [_c('div', {
    staticClass: "column is-paddingless is-marginless is-narrow"
  }, [_c('feedback-editor', {
    attrs: {
      "header": _vm.tokens['lbl_speech'],
      "languages": _vm.speechLangs
    },
    model: {
      value: (_vm.speech),
      callback: function($$v) {
        _vm.speech = $$v
      },
      expression: "speech"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_word'],
      "disabled": !_vm.speech.language
    },
    model: {
      value: (_vm.speechAdjustForWordLength),
      callback: function($$v) {
        _vm.speechAdjustForWordLength = $$v
      },
      expression: "speechAdjustForWordLength"
    }
  })], 1)])]), _c('feedback-editor', {
    attrs: {
      "header": _vm.tokens['lbl_syllab'],
      "languages": _vm.syllabLangs
    },
    model: {
      value: (_vm.syllab),
      callback: function($$v) {
        _vm.syllab = $$v
      },
      expression: "syllab"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syllabMode),
      expression: "syllabMode"
    }],
    attrs: {
      "disabled": !_vm.syllab.language
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.syllabMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.syllabModes), function(mode) {
    return _c('option', {
      domProps: {
        "value": mode
      }
    }, [_vm._v(_vm._s(_vm.tokens[("item_" + mode)]))])
  }))])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_temp'],
      "disabled": !_vm.syllab.language
    },
    model: {
      value: (_vm.syllabTemporary),
      callback: function($$v) {
        _vm.syllabTemporary = $$v
      },
      expression: "syllabTemporary"
    }
  })], 1), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_word'],
      "disabled": !_vm.syllab.language
    },
    model: {
      value: (_vm.syllabAdjustForWordLength),
      callback: function($$v) {
        _vm.syllabAdjustForWordLength = $$v
      },
      expression: "syllabAdjustForWordLength"
    }
  })], 1)])]), _c('feedback-editor', {
    attrs: {
      "header": _vm.tokens['lbl_highlight']
    },
    model: {
      value: (_vm.highlight),
      callback: function($$v) {
        _vm.highlight = $$v
      },
      expression: "highlight"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_word'],
      "disabled": !_vm.highlight.language
    },
    model: {
      value: (_vm.highlightAdjustForWordLength),
      callback: function($$v) {
        _vm.highlightAdjustForWordLength = $$v
      },
      expression: "highlightAdjustForWordLength"
    }
  })], 1)])]), _c('feedback-editor', {
    attrs: {
      "header": _vm.tokens['lbl_warning'],
      "languages": _vm.speechLangs
    },
    model: {
      value: (_vm.warning),
      callback: function($$v) {
        _vm.warning = $$v
      },
      expression: "warning"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control-line"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_phrase']))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.warningPhrase),
      expression: "warningPhrase"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": !_vm.warning.language
    },
    domProps: {
      "value": (_vm.warningPhrase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.warningPhrase = $event.target.value
      }
    }
  })])])])], 1), _c('div', {
    staticClass: "column is-paddingless is-marginless"
  }, [_c('div', {
    staticClass: "columns is-paddingless is-marginless"
  }, [_c('div', {
    staticClass: "column is-paddingless is-marginless is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_exceptions']))])]), _c('div', {
    staticClass: "column has-text-right is-paddingless is-marginless"
  }, [_c('i', {
    staticClass: "instruction"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_example']) + " ")])])]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syllabExceptions),
      expression: "syllabExceptions"
    }],
    staticClass: "textarea exceptions",
    attrs: {
      "disabled": !_vm.syllab.language,
      "placeholder": _vm.tokens['lbl_syllabs']
    },
    domProps: {
      "value": (_vm.syllabExceptions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.syllabExceptions = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-page"
    }
  }, [_c('task-text', {
    ref: "container",
    attrs: {
      "fontname": _vm.task.fontname
    }
  }), _c('task-images', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.images),
      expression: "images"
    }],
    attrs: {
      "images": _vm.images,
      "fixation": _vm.fixation
    },
    on: {
      "show": _vm.onImageShow,
      "hide": _vm.onImageHide
    }
  }), _c('div', {
    staticClass: "is-bottom-right"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasNextPage),
      expression: "hasNextPage"
    }],
    staticClass: "button is-primary is-large",
    attrs: {
      "disabled": _vm.isWaitingToFinilizePage
    },
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['btn_next']))])]), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLastPage),
      expression: "isLastPage"
    }],
    staticClass: "button is-primary is-large",
    attrs: {
      "disabled": _vm.isWaitingToFinilizePage
    },
    on: {
      "click": _vm.finish
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['btn_finish']))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    attrs: {
      "id": "student-list"
    }
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_vm._v(_vm._s(_vm.tokens['num_student'](_vm.students)))])]), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openEditor
    }
  }, [_vm._v(_vm._s(_vm.tokens['add']))])])])])]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.students === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [(_vm.students && _vm.students.length) ? _c('tr', {
    staticClass: "is-subheader"
  }, [_c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), _c('th', {
    staticClass: "is-narrow"
  }, [_c('div', {
    staticClass: "has-text-centered"
  }, [_vm._v(_vm._s(_vm.tokens['assignments']))])]), _c('th', {
    staticClass: "is-narrow"
  })]) : _vm._e()]), _c('tbody', _vm._l((_vm.students), function(student) {
    return _c('tr', {
      key: _vm.currentClass.id + student.id
    }, [_c('td', [_vm._v(_vm._s(student.name))]), _c('td', {
      staticClass: "is-narrow"
    }, [_c('div', {
      staticClass: "tags"
    }, _vm._l((student.assignments), function(cls, task) {
      return (_vm.doesTaskBelongsToClass(task)) ? _c('div', {
        staticClass: "tag is-medium"
      }, [_vm._v(_vm._s(_vm.getAssignmentName(task))), _c('button', {
        staticClass: "delete is-small",
        on: {
          "click": function($event) {
            _vm.removeAssignment(student, task)
          }
        }
      })]) : _vm._e()
    })), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.availableTasks(student).length),
        expression: "availableTasks( student ).length"
      }],
      ref: _vm.currentClass.id + student.id,
      refInFor: true,
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "dropdown-trigger",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "aria-haspopup": "true",
        "aria-controls": "dropdown-menu"
      },
      on: {
        "click": function($event) {
          _vm.toggleTaskList(_vm.currentClass.id + student.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.tokens['lbl_add']))]), _vm._m(0, true)])]), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu"
      }
    }, [_c('div', {
      staticClass: "dropdown-content"
    }, _vm._l((_vm.availableTasks(student)), function(task) {
      return _c('div', {
        staticClass: "dropdown-item",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.addAssignment(student, task.id, $event)
          }
        }
      }, [_vm._v(_vm._s(task.name))])
    }))])])]), _c('td', {
      staticClass: "is-narrow"
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "title": _vm.tokens['tit_remove']
      },
      on: {
        "click": function($event) {
          _vm.remove(student)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))])]), (_vm.isEditing) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['tit_students']
    },
    on: {
      "close": _vm.closeEditor
    }
  }, [_c('item-selection-box', {
    attrs: {
      "items": _vm.schoolGrades,
      "multiple": true,
      "single-group": false,
      "item-name": _vm.tokens['data_grade'],
      "subitem-name": _vm.tokens['data_student']
    },
    on: {
      "accept": _vm.addNewStudents
    }
  })], 1) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    attrs: {
      "id": "task-list"
    }
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_vm._v(_vm._s(_vm.tokens['num_task'](_vm.tasks)))])]), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openNewTextBox
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_new']))])])])])]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.tasks === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : _c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.tasks), function(task) {
    return _c('tr', {
      key: _vm.parent.id + task.id
    }, [_c('td', [_c('span', {
      staticClass: "is-inline-block"
    }, [_vm._v(_vm._s(task.name))]), (!!task.pages) ? _c('span', {
      staticClass: "is-inline-block"
    }, [_vm._v(" (" + _vm._s(_vm.tokens['lbl_pages'](task.pages.length)) + ")")]) : _vm._e()]), _c('td', {
      staticClass: "is-narrow"
    }, [_c('button', {
      staticClass: "button is-light",
      attrs: {
        "title": _vm.tokens['tit_edit'](_vm.isLocked(task.id)),
        "disabled": _vm.isLocked(task.id)
      },
      on: {
        "click": function($event) {
          _vm.edit(task)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-edit"
    })]), _c('button', {
      staticClass: "button is-light",
      attrs: {
        "title": _vm.tokens['tit_copy']
      },
      on: {
        "click": function($event) {
          _vm.copy(task)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-copy"
    })]), _c('button', {
      staticClass: "button is-danger",
      attrs: {
        "title": _vm.tokens['tit_delete']
      },
      on: {
        "click": function($event) {
          _vm.remove(task)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])
  }))])]), (_vm.isEditing) ? _c('modal-container', {
    attrs: {
      "title": _vm.taskEditorTitle
    },
    on: {
      "close": _vm.closeEditor
    }
  }, [_c('task-editor', {
    attrs: {
      "action": _vm.action,
      "task": _vm.toEdit,
      "source": _vm.toCopy,
      "intros": _vm.intros
    },
    on: {
      "save": _vm.save,
      "modified": _vm.onTaskModified
    }
  })], 1) : _vm._e(), (_vm.toDelete) ? _c('remove-warning', {
    attrs: {
      "object": "task",
      "name": _vm.toDeleteName
    },
    on: {
      "close": _vm.removeWarningClosed
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['msg_delete_warning']) + ". ")])]) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-preview"
    }
  }, [_c('div', {
    staticClass: "notification is-info has-text-centered on-top"
  }, [_c('div', {
    staticClass: "columns"
  }, [(_vm.task.syllab.language) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_syllab_word']))]) : _vm._e(), (_vm.task.syllab.language) ? _c('div', {
    staticClass: "column"
  }, [_c('button', {
    staticClass: "button is-primary is-small",
    on: {
      "click": _vm.syllabifyAll
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_syllab_all']))])]) : _vm._e(), (_vm.task.speech.language) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_speak_word']))]) : _vm._e()])]), _c('task-text', {
    ref: "container",
    nativeOn: {
      "click": [function($event) {
        if (!$event.ctrlKey) { return null; }
        _vm.syllabify($event)
      }, function($event) {
        if (!$event.altKey) { return null; }
        _vm.pronounce($event)
      }, function($event) {
        _vm.fixate($event)
      }]
    }
  }), _c('task-images', {
    attrs: {
      "images": _vm.images,
      "fixation": _vm.fixation
    }
  }), _c('div', {
    staticClass: "columns at-bottom"
  }, [_c('div', {
    staticClass: "column has-text-right"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.hasPrevPage
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('span', [_vm._v("<")])])]), _c('div', {
    staticClass: "column has-text-centered is-narrow"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.close
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['btn_close']))])])]), _c('div', {
    staticClass: "column has-text-left"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.hasNextPage
    },
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v(">")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "vis-title"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    attrs: {
      "id": "vis-plot"
    }
  }, [_c('canvas', {
    ref: "canvas"
  }), _c('task-images', {
    attrs: {
      "images": _vm.visibleImages,
      "fixation": _vm.fixation,
      "viewport": _vm.defaultSession.screen
    }
  }), (_vm.isWarningMessageVisible) ? _c('div', {
    staticClass: "message is-danger below-title"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_missing_data']))]), _c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_missing_data']))])]) : _vm._e(), _c('control-panel', {
    attrs: {
      "title": _vm.title,
      "feedback": _vm.feedback,
      "questionnaire": _vm.data.records.length === 1 ? _vm.defaultQuestionnaire : null,
      "text-length": _vm.textLength,
      "initial-page-index": _vm.initialPageIndex,
      "options": _vm.options,
      "show-player": _vm.data.name.indexOf('Replay') >= 0,
      "is-player-paused": _vm.isPlayerPaused
    },
    on: {
      "page-changed": _vm.setPage,
      "show-options": _vm.showOptions,
      "restart-player": _vm.restartPlayer,
      "toggle-player": _vm.togglePlayer,
      "close": _vm.close
    }
  }), _c('options', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOptionsDisplayed),
      expression: "isOptionsDisplayed"
    }],
    attrs: {
      "values": _vm.options
    },
    on: {
      "close": _vm.closeOptions,
      "apply": _vm.applyOptions
    }
  }), (_vm.audioPlayerProps.visible) ? _c('audio-player', {
    staticClass: "audio-player",
    attrs: {
      "duration": _vm.audioPlayerProps.duration,
      "playing": _vm.audioPlayerProps.playing,
      "time": _vm.audioPlayerProps.time
    },
    on: {
      "toggled": function($event) {
        _vm.audioPlayerProps.toggled($event)
      },
      "slided": function($event) {
        _vm.audioPlayerProps.slided($event)
      }
    }
  }) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAssignment),
      expression: "!isAssignment"
    }],
    staticClass: "nav has-shadow"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/"
    }
  }, [_c('h2', {
    staticClass: "logo"
  }, [_vm._v("Silko")])]), (_vm.isAdmin) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/schools"
    }
  }, [_c('i', {
    staticClass: "fa fa-university"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['schools']))])]) : _vm._e(), (_vm.isAdmin || _vm.isSchool) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/teachers"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['teachers']))])]) : _vm._e(), (_vm.isAdmin || _vm.isSchool || _vm.isTeacher) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/students"
    }
  }, [_c('i', {
    staticClass: "fa fa-child"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['students']))])]) : _vm._e(), (_vm.isTeacher) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/instructions"
    }
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['instructions']))])]) : _vm._e(), (_vm.isTeacher) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/classes"
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['classes']))])]) : _vm._e(), (_vm.isTeacher) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/results"
    }
  }, [_c('i', {
    staticClass: "fa fa-chart-pie"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['results']))])]) : _vm._e(), (_vm.isStudent) ? _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/assignments"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['assignments']))])]) : _vm._e()], 1), (_vm.user) ? _c('div', {
    staticClass: "nav-right"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.manualLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.tokens['manual']))]), _c('div', {
    staticClass: "dropdown is-right",
    class: {
      'is-active': _vm.isUsermenuDropped
    },
    attrs: {
      "id": "usermenu"
    }
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-primary': _vm.isUsermenuDropped
    },
    attrs: {
      "aria-haspopup": "true",
      "aria-controls": "dropdown-menu"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isUsermenuDropped = !_vm.isUsermenuDropped
      },
      "mouseover": function($event) {
        _vm.isUsermenuHover = true
      },
      "mouseleave": function($event) {
        _vm.isUsermenuHover = false
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user.ref.name))]), _c('span', {
    staticClass: "icon is-small",
    style: ({
      'color': (_vm.isUsermenuHover && !_vm.isUsermenuDropped) ? 'hsl(171, 100%, 41%)' : 'inherit',
      'transform': 'translateY(0.1em)'
    })
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('div', {
    staticClass: "select",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('select', {
    domProps: {
      "value": _vm.user.prefs.lang
    },
    on: {
      "input": _vm.updateLanguage
    }
  }, _vm._l((_vm.langs), function(lang) {
    return _c('option', {
      key: lang
    }, [_vm._v(_vm._s(lang))])
  }))]), _c('hr', {
    staticClass: "dropdown-divider"
  }), _c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v(_vm._s(_vm.tokens['logout']))])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "student-summary"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    class: _vm.headerNameClass,
    on: {
      "click": function($event) {
        _vm.sort(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.tokens['name']))]), _vm._l((_vm.statistics), function(stat, index) {
    return _c('th', {
      key: index,
      class: _vm.statNameClass(stat, index),
      attrs: {
        "title": stat.title || ''
      },
      on: {
        "click": function($event) {
          _vm.sort(index)
        }
      }
    }, [_vm._v(_vm._s(stat.name))])
  })], 2)]), _c('tbody', _vm._l((_vm.students), function(student) {
    return _c('tr', {
      key: student.ref.id
    }, [_c('td', [_vm._v(_vm._s(student.ref.name))]), _vm._l((student.statistics), function(stat, index) {
      return _c('td', {
        key: index
      }, [(index === 1) ? _c('span', [_vm._v(_vm._s(((Math.floor(stat / 60).toFixed(0)) + ":" + (_vm.secondsToString( stat % 60 )))))]) : _c('span', [(_vm.statistics[index].hasProgress) ? _c('span', {
        class: {
          'progressLink': true
        },
        on: {
          "click": function($event) {
            _vm.showProgress(student, index)
          }
        }
      }, [_vm._v(_vm._s(stat))]) : _c('span', [_vm._v(_vm._s(stat))])])])
    })], 2)
  }))])]), (_vm.isShowingProgress) ? _c('modal-container', {
    attrs: {
      "title": _vm.progressChartData.title
    },
    on: {
      "close": _vm.closeChart
    }
  }, [_c('progress-chart', {
    staticClass: "chart",
    attrs: {
      "data": _vm.progressChartData
    }
  })], 1) : _vm._e(), _c('control-panel', {
    attrs: {
      "title": _vm.title,
      "options": _vm.options
    },
    on: {
      "show-options": _vm.showOptions,
      "close": _vm.close
    }
  }), _c('options', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOptionsDisplayed),
      expression: "isOptionsDisplayed"
    }],
    attrs: {
      "values": _vm.options
    },
    on: {
      "close": _vm.closeOptions,
      "apply": _vm.applyOptions
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bulma-checkbox",
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "button is-primary is-inverted",
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])]), _c('label', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "intro-editor"
    }
  }, [_c('div', {
    staticClass: "field",
    class: {
      squeezed: _vm.showLabels
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLabels),
      expression: "showLabels"
    }],
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['name']))]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.name.length && !_vm.isNameValid
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['name'],
      "disabled": !_vm.nameEditable
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.name.length && !_vm.isNameValid),
      expression: "name.length && !isNameValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['name_invalid']))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLabels),
      expression: "showLabels"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_texts']))])]), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calib),
      expression: "calib"
    }],
    staticClass: "textarea low",
    class: {
      'is-danger': !_vm.isCalibInstructionValid
    },
    attrs: {
      "placeholder": _vm.tokens['ph_calib_inst']
    },
    domProps: {
      "value": (_vm.calib)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.calib = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCalibInstructionValid),
      expression: "!isCalibInstructionValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['msg_instruction_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start),
      expression: "start"
    }],
    staticClass: "textarea low",
    class: {
      'is-danger': !_vm.isStartInstructionValid
    },
    attrs: {
      "placeholder": _vm.tokens['ph_start_inst']
    },
    domProps: {
      "value": (_vm.start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isStartInstructionValid),
      expression: "!isStartInstructionValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['msg_instruction_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstPage),
      expression: "firstPage"
    }],
    staticClass: "textarea",
    class: {
      'is-danger': !_vm.isFirstPageValid
    },
    attrs: {
      "placeholder": _vm.tokens['ph_first_page']
    },
    domProps: {
      "value": (_vm.firstPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstPage = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFirstPageValid),
      expression: "!isFirstPageValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['msg_instruction_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.action))])])])])
},staticRenderFns: []}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-text"
    }
  }, [_c('div', {
    ref: "text",
    staticClass: "text median",
    style: (_vm.textStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calib-page"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isETUDConnected),
      expression: "isETUDConnected"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content is-large"
  }, _vm._l((_vm.calibInstruction), function(line) {
    return _c('p', [_vm._v(_vm._s(line))])
  })), _c('button', {
    staticClass: "button is-large is-primary",
    attrs: {
      "disabled": !_vm.isConnected
    },
    on: {
      "click": _vm.calibrate
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_calib']))]), _c('button', {
    staticClass: "button is-large",
    attrs: {
      "disabled": !_vm.isCalibrated
    },
    on: {
      "click": _vm.skip
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_skip_calib']))]), _c('button', {
    staticClass: "button is-large",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isETUDConnected),
      expression: "!isETUDConnected"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "message is-danger is-centered"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_cannot_conect']))]), _c('div', {
    staticClass: "message-body"
  }, [_c('div', {
    staticClass: "content has-text-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['msg_cannot_conect_1']))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.tokens['msg_cannot_conect_2']))]), _c('li', [_vm._v(_vm._s(_vm.tokens['msg_cannot_conect_3']))])])])])])]), _c('div', {
    staticClass: "is-bottom-right"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.isETUDConnected
    },
    on: {
      "click": _vm.showETUDOptions
    }
  }, [_vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])
}]}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "heading has-text-centered"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])]), _vm._t("default")], 2)]), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.close
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "results"
    }
  }, [(_vm.classes === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.classes.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_data']))])]) : _vm._e(), _vm._l((_vm.classes), function(cls) {
    return _c('nav', {
      key: cls.ref.id,
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "panel-block is-marginless is-paddingless"
    }, [_c('div', {
      staticClass: "card is-fullwidth"
    }, [_c('header', {
      staticClass: "card-header notification is-info is-paddingless"
    }, [_c('div', {
      staticClass: "card-header-title"
    }, [_vm._v(_vm._s(cls.ref.name))])]), _c('div', {
      staticClass: "card-content"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['tasks']))]), _c('th'), _c('th'), _c('th'), _c('th')])]), _c('tbody', _vm._l((_vm.tasksWithSessions(cls.tasks)), function(task) {
      return _c('tr', {
        key: task.id
      }, [_c('td', [_vm._v(_vm._s(task.name))]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectTaskStudents(task, _vm.VISUALIZATIONS.durations)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_durations']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectTaskStudents(task, _vm.VISUALIZATIONS.gazeReplay)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_gaze_replay']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectTaskStudents(task, _vm.VISUALIZATIONS.wordReplay)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_word_replay']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded || !task.hasQuestionnaire
        },
        on: {
          "click": function($event) {
            _vm.selectTaskStudents(task, _vm.VISUALIZATIONS.questionnaireResults)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_questionnaire']))])])])
    }))]), (cls.students === null) ? _c('div', {
      staticClass: "container"
    }, [_c('loading')], 1) : (!cls.students.length) ? _c('div', {
      staticClass: "container"
    }) : _c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['students']))]), _c('th'), _c('th'), _c('th'), _c('th'), _c('th'), _c('th', [_c('button', {
      staticClass: "button is-primary is-pulled-right",
      attrs: {
        "disabled": !_vm.isLoaded
      },
      on: {
        "click": function($event) {
          _vm.selectClassStudents(cls, _vm.VISUALIZATIONS.studentsSummary)
        }
      }
    }, [_vm._v(_vm._s(_vm.tokens['btn_summary']))])])])]), _c('tbody', _vm._l((cls.students), function(student) {
      return _c('tr', {
        key: student.ref.id
      }, [_c('td', [_vm._v(_vm._s(student.ref.name))]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-warning",
        attrs: {
          "disabled": !_vm.isLoaded || !student.sessions.length
        },
        on: {
          "click": function($event) {
            _vm.editSessions(student)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_edit']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.gazePlot)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_gaze_plot']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded || !_vm.hasItems(student, _vm.filterHasAudio)
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.audioReplay, _vm.filterHasAudio)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_audio_replay']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.durations)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_durations']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.gazeReplay)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_gaze_replay']))])]), _c('td', {
        staticClass: "is-narrow"
      }, [_c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !_vm.isLoaded
        },
        on: {
          "click": function($event) {
            _vm.selectSession(student, _vm.VISUALIZATIONS.wordReplay)
          }
        }
      }, [_vm._v(_vm._s(_vm.tokens['btn_word_replay']))])])])
    }))])])])])])
  }), (_vm.gradeWithStudents) ? _c('modal-container', {
    attrs: {
      "title": _vm.gradeWithStudents[0].text
    },
    on: {
      "close": _vm.closeStudentSelectionBox
    }
  }, [_c('item-selection-box', {
    attrs: {
      "items": _vm.gradeWithStudents,
      "item-name": _vm.tokens['data_grade'],
      "subitem-name": _vm.tokens['data_student']
    },
    on: {
      "accept": _vm.continueDeferredWithStudents
    }
  })], 1) : _vm._e(), (_vm.studentWithSessions) ? _c('modal-container', {
    attrs: {
      "title": _vm.studentWithSessions[0].text
    },
    on: {
      "close": _vm.closeSessionSelectionBox
    }
  }, [_c('item-selection-box', {
    attrs: {
      "multiple": !_vm.isMultipleSessions,
      "single-group": !_vm.isMultipleSessions && !_vm.studentWithSessions[0].multiGroup,
      "items": _vm.studentWithSessions,
      "item-name": _vm.tokens['data_grade'],
      "subitem-name": _vm.tokens['data_session']
    },
    on: {
      "accept": _vm.continueDeferredWithSessions
    }
  })], 1) : _vm._e(), (_vm.editingStudent) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['tit_sessions'](_vm.editingStudent.ref.name)
    },
    on: {
      "close": _vm.closeSessionEditingBox
    }
  }, [_c('session-editing-box', {
    attrs: {
      "student": _vm.editingStudent
    },
    on: {
      "deleted": _vm.sessionDeleted
    }
  })], 1) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.gazePlot)) ? _c('gaze-plot', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.audioReplay)) ? _c('gaze-with-audio', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.durations)) ? _c('durations', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.gazeReplay)) ? _c('gaze-replay', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.wordReplay)) ? _c('word-replay', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.questionnaireResults)) ? _c('questionnaire-results', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), (_vm.isShowing(_vm.VISUALIZATIONS.studentsSummary)) ? _c('students-summary', {
    attrs: {
      "data": _vm.visualization
    },
    on: {
      "close": _vm.closeVisualization
    }
  }) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 2)
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title logo"
  }, [_vm._v("Silko")]), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_subtitle']))])])])]), (_vm.isConnecting) ? _c('section', {
    staticClass: "connecting"
  }, [_c('div', [_vm._v(_vm._s(_vm.tokens['msg_connecting']))]), _c('loading')], 1) : (!_vm.user) ? _c('section', [_c('login'), _c('p', {
    staticClass: "control extra-tools"
  }), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_request_account']))]), _c('button', {
    staticClass: "button is-link",
    on: {
      "click": _vm.remindPassword
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_forgot_password']))])]), _c('p')], 1) : _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_c('p', [_vm._v(_vm._s(_vm.tokens['hdr_info_title'](_vm.userTitle)))])]), _c('div', {
    staticClass: "message-body is-paddingless"
  }, [_c('div', {
    staticClass: "panel"
  }, [(_vm.isAdmin || _vm.isSchool) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_adm_1']))]) : _vm._e(), (_vm.isAdmin) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_adm_2']))]) : _vm._e(), (_vm.isAdmin || _vm.isSchool || _vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_adm_3']))]) : _vm._e(), (_vm.isAdmin) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_adm_3']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_1']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_2']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_3']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_4']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_5']))]) : _vm._e(), (_vm.isTeacher) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_tch_6']))]) : _vm._e(), (_vm.isStudent) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_std_1']))]) : _vm._e(), (_vm.isStudent) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_std_2']))]) : _vm._e(), (_vm.isStudent) ? _c('div', {
    staticClass: "panel-block"
  }, [_vm._v(_vm._s(_vm.tokens['info_std_3']))]) : _vm._e()])])])]), (!_vm.user) ? _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "columns is-32"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', [_vm._v("TAUCHI, COMS, " + _vm._s(_vm.tokens['msg_contact_uta']))])]), _c('div', {
    staticClass: "column is-narrow"
  }, [_c('a', {
    staticClass: "manual",
    attrs: {
      "href": "https://uta-gasp.gitbooks.io/silko/"
    }
  }, [_vm._v(_vm._s(_vm.tokens['manual']))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "browser-info"
  }, [_vm._v(_vm._s(_vm.tokens['msg_test_info']))]), _vm._m(0)])])]) : _vm._e(), (_vm.schools) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['tit_registration']
    },
    on: {
      "close": _vm.closeSelectionBox
    }
  }, [_c('div', {
    staticClass: "has-text-centered"
  }, [_c('div', [_vm._v(_vm._s(_vm.tokens['msg_contact_info']))]), _c('div', [_vm._v("Oleg Špakov @ " + _vm._s(_vm.tokens['msg_contact_uta']))]), _c('div', [_vm._v("oleg.spakov at uta dot fi")])])]) : _vm._e(), (_vm.isGettingEmail) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['tit_pass_reset']
    },
    on: {
      "close": _vm.closeEmailBox,
      "mounted": _vm.passwordResetAppeared
    }
  }, [(!_vm.schoolToRegester) ? _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['hdr_password_reset']))])])]) : _vm._e(), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "email",
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": _vm.tokens['email']
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.sendPasswordResetRequest($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), (!_vm.isEmailValid) ? _c('span', {
    staticClass: "icon is-small is-right"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]) : _vm._e()])]), _c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.sendPasswordResetRequest
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_send']))])]), _c('p')]) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isStudent && _vm.showWsSecurityError
    },
    attrs: {
      "id": "ws-security-error"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "notification is-danger"
  }, [_c('h3', {
    staticClass: "title is-3"
  }, [_vm._v(_vm._s(_vm.tokens['ws_err_title']))]), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.tokens['ws_err_subtitle']))]), (_vm.isFirefox) ? _c('ul', {
    staticClass: "unblock-ws-instruction"
  }, [_c('li', {
    staticClass: "step"
  }, [_vm._v("- " + _vm._s(_vm.tokens['ws_unblock_1'][0]) + " \""), _c('span', {
    staticClass: "code"
  }, [_vm._v("about:config")]), _vm._v("\" " + _vm._s(_vm.tokens['ws_unblock_1'][1]))]), _c('li', {
    staticClass: "step"
  }, [_vm._v("- " + _vm._s(_vm.tokens['ws_unblock_2'][0]) + " \""), _c('span', {
    staticClass: "code"
  }, [_vm._v("network.websocket.allowInsecureFromHTTPS")]), _vm._v("\" " + _vm._s(_vm.tokens['ws_unblock_2'][1]))]), _c('li', {
    staticClass: "step"
  }, [_vm._v("- " + _vm._s(_vm.tokens['ws_unblock_3'][0]) + " \""), _c('span', {
    staticClass: "code"
  }, [_vm._v("false")]), _vm._v("\", " + _vm._s(_vm.tokens['ws_unblock_3'][1]) + " \""), _c('span', {
    staticClass: "code"
  }, [_vm._v("true")]), _vm._v("\"" + _vm._s(_vm.tokens['ws_unblock_3'][2]))])]) : _c('div', {
    staticClass: "unblock-ws-instruction"
  }, [_vm._v(_vm._s(_vm.tokens['ws_unblock_4']))])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-inline-block"
  }, [_c('div', {
    staticClass: "browser-name chrome"
  }, [_vm._v("Chrome 55+")]), _c('div', {
    staticClass: "browser-name firefox"
  }, [_vm._v("Firefox 47+")])])
}]}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "options"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "options-title"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_settings']))]), _c('div', {
    ref: "container",
    staticClass: "options"
  }), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_save_close']))]), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_apply']))]), _c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_reset']))])])])])
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "audio-player"
    }
  }, [_c('div', {
    staticClass: "icon-btn",
    class: {
      play: !_vm.isPlaying, pause: _vm.isPlaying
    },
    attrs: {
      "title": _vm.title
    },
    on: {
      "click": _vm.toggle
    }
  }), _c('input', {
    staticClass: "slider is-fullwidth is-small is-circle",
    attrs: {
      "type": "range",
      "step": "1",
      "min": "0",
      "max": _vm.durationMs,
      "disabled": _vm.isPlaying
    },
    domProps: {
      "value": _vm.currentTimeMs
    },
    on: {
      "input": _vm.updateTime
    }
  }), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.currentTimeMin))])])
},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "questionnaire-page"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [(_vm.question) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content is-large"
  }, [_c('p', [_vm._v(_vm._s(_vm.question.question))])]), _c('div', {
    staticClass: "answers"
  }, _vm._l((_vm.question.answers), function(answer) {
    return _c('button', {
      staticClass: "button answer is-large is-light",
      class: _vm.asnwerRevealedClass(answer),
      on: {
        "click": function($event) {
          _vm.reply(answer)
        }
      }
    }, [_vm._v(_vm._s(answer.text))])
  }))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "player"
    }
  }, [_c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_restart']
    }
  }, [_c('button', {
    staticClass: "icon-btn restart",
    on: {
      "click": _vm.restart
    }
  })]), _c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_pause_cont']
    }
  }, [_c('button', {
    staticClass: "icon-btn",
    class: {
      play: _vm.isPaused, pause: !_vm.isPaused
    },
    on: {
      "click": _vm.toggle
    }
  })]), _c('div', {
    staticClass: "track"
  })])
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-editor-images"
    }
  }, [(!_vm.isEditing) ? _c('section', {
    staticClass: "top-only"
  }, [(_vm.images.length) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['lbl_preview']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_page']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_location']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_size']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_on']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['lbl_off']))]), _c('th')])]), _c('tbody', _vm._l((_vm.images), function(image, index) {
    return _c('tr', {
      key: index,
      staticClass: "is-64"
    }, [_c('td', [(_vm.canShow(image)) ? _c('p', {
      staticClass: "image is-64x64 preview",
      style: (_vm.getCSSBackgroundImage(image))
    }) : _vm._e()]), _c('td', [_vm._v(_vm._s(_vm.getImageName(image)))]), _c('td', [_vm._v(_vm._s(_vm.getImagePage(image)))]), _c('td', [_vm._v(_vm._s(_vm.getImageLocation(image)))]), _c('td', [_vm._v(_vm._s(_vm.tokens['lbl_keep_size'](image.keepOriginalSize)))]), _c('td', [_c('div', {
      staticClass: "event-name"
    }, [_vm._v(_vm._s(_vm.formatEventName(image.on)))]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasParameters(image.on)),
        expression: "hasParameters( image.on )"
      }],
      staticClass: "event-param"
    }, [_vm._v(_vm._s(_vm.formatEventParams(image.on)))])]), _c('td', [_c('div', {
      staticClass: "event-name"
    }, [_vm._v(_vm._s(_vm.formatEventName(image.off)))]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasParameters(image.off)),
        expression: "hasParameters( image.off )"
      }],
      staticClass: "event-param"
    }, [_vm._v(_vm._s(_vm.formatEventParams(image.off)))])]), _c('td', [_c('button', {
      staticClass: "button",
      attrs: {
        "title": _vm.tokens['tit_params']
      },
      on: {
        "click": function($event) {
          _vm.edit(index)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-edit"
    })])]), _c('td', [_c('button', {
      staticClass: "button",
      attrs: {
        "title": _vm.tokens['tit_remove']
      },
      on: {
        "click": function($event) {
          _vm.remove(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))]) : _c('section', [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_images']))])])]) : _vm._e(), _c('section', {
    staticClass: "absolute-parent"
  }, [(!_vm.isEditing) ? _c('div', {
    staticClass: "has-text-centered"
  }, [_c('section', {
    staticClass: "is-fullwidth is-dropzone",
    class: {
      'is-dragover': _vm.isDraggingFileOverDropzone
    },
    on: {
      "drag": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "dragstart": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = false
      },
      "dragend": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = false
      },
      "dragleave": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = false
      },
      "dragenter": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = true
      },
      "dragover": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDraggingFileOverDropzone = true
      },
      "drop": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.dropFile($event)
      }
    }
  }, [_c('div', {
    staticClass: "file is-centered is-boxed"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.selectFile($event)
      }
    }
  }), _c('span', {
    staticClass: "file-cta"
  }, [_vm._m(0), _c('span', {
    staticClass: "file-label"
  }, [_vm._v(_vm._s(_vm.tokens['msg_choose']))]), _c('span', {
    staticClass: "help"
  }, [_vm._v(_vm._s(_vm.tokens['msg_drag']))])])])])])]) : _vm._e(), (_vm.selectedFile || _vm.isEditing) ? _c('div', {
    class: {
      'sticked': !_vm.isEditing, 'at-top': !_vm.images.length, 'at-bottom': _vm.images.length
    }
  }, [(_vm.selectedFile) ? _c('article', {
    staticClass: "media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image is-64x64"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImageURL(_vm.selectedFile)
    }
  })])]), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.selectedFile.name))])]), _c('div', [_c('small', [_vm._v(_vm._s(_vm.selectedFile.size) + " " + _vm._s(_vm.tokens['lbl_bytes']))])]), _c('progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUploading),
      expression: "isUploading"
    }],
    staticClass: "progress is-small is-primary",
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": _vm.uploadProgress
    }
  })])]), _c('div', {
    staticClass: "media-right"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.isUploading || !_vm.hasValidParams
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_upload']))]), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.isUploading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])])])]) : _vm._e(), _c('article', [(_vm.isEditing) ? _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }), _c('div', {
    staticClass: "field-body"
  }, [_c('h4', {
    staticClass: "heading is-4"
  }, [_vm._v(_vm._s(_vm.getImageName(_vm.images[_vm.editingImageIndex])))])])]) : _vm._e(), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_page']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_any']))]), _vm._l((_vm.pageCount), function(index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index - 1
      }
    }, [_vm._v(_vm._s(index))])
  })], 2)])])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_location']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.offset),
      expression: "offset",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input is-inline",
    attrs: {
      "type": "number",
      "step": "5",
      "min": "0",
      "max": "800"
    },
    domProps: {
      "value": (_vm.offset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.offset = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "info-label"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_pixels']))]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location),
      expression: "location"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.location = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "left"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_left']))]), _c('option', {
    attrs: {
      "value": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_bottom']))]), _c('option', {
    attrs: {
      "value": "right"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_right']))])])])])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_size']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keepOriginalSize),
      expression: "keepOriginalSize"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.keepOriginalSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_original']))]), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_15']))])])])])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_show']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.on),
      expression: "on"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.on = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.ON), function(text, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [_vm._v(_vm._s(text))])
  }))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.on === 'fixation'),
      expression: "on === 'fixation'"
    }],
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal is-inner-label no-wrap"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_at']))]), _c('div', {
    staticClass: "field-body select-container"
  }, [_c('div', {
    staticClass: "select is-multiple"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fixationWords),
      expression: "fixationWords"
    }],
    attrs: {
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fixationWords = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.currentWords), function(word) {
    return _c('option', {
      key: word.text + Math.random(),
      domProps: {
        "value": word
      }
    }, [_vm._v(_vm._s(word.text))])
  }))])]), _c('div', {
    staticClass: "field-label is-normal is-inner-label no-wrap"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_longer']))]), _c('div', {
    staticClass: "field-body number-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fixationDuration),
      expression: "fixationDuration"
    }],
    staticClass: "input is-number",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fixationDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fixationDuration = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "field-label is-normal is-inner-label no-wrap"
  }, [_vm._v("ms")])])])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_hide']))]), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.off),
      expression: "off"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.off = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.OFF), function(text, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [_vm._v(_vm._s(text))])
  }))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.off === 'delay'),
      expression: "off === 'delay'"
    }],
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-body number-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delayDuration),
      expression: "delayDuration"
    }],
    staticClass: "input is-number",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.delayDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delayDuration = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "field-label is-normal is-inner-label no-wrap"
  }, [_vm._v("sec")])])])]), (_vm.isEditing) ? _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "is-grouped is-right"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.saveEdited()
      }
    }
  }, [_vm._v(_vm._s(_vm.tokens['save']))]), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.cancelEditing()
      }
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])])])]) : _vm._e()])]) : _vm._e()]), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })])
}]}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-mobile",
    attrs: {
      "id": "control-panel"
    }
  }, [_c('div', {
    staticClass: "column title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "column is-narrow"
  }, [(_vm.showPlayer) ? _c('player', {
    staticClass: "player",
    attrs: {
      "is-paused": _vm.isPlayerPaused
    },
    on: {
      "restart": _vm.restartPlayer,
      "toggle": _vm.togglePlayer
    }
  }) : _vm._e(), (_vm.feedback) ? _c('div', {
    staticClass: "props"
  }, [_c('abbr', {
    staticClass: "prop speech",
    class: {
      off: !_vm.feedback.speech.enabled
    },
    attrs: {
      "title": _vm.tokens['tit_speech']
    }
  }), _c('abbr', {
    staticClass: "prop syllab",
    class: {
      off: !_vm.feedback.syllabification.enabled
    },
    attrs: {
      "title": _vm.tokens['tit_syllab']
    }
  }, [(_vm.feedback.syllabification.enabled) ? _c('span', [_vm._v(_vm._s(_vm.feedback.syllabification.threshold.value))]) : _vm._e()])]) : _vm._e(), (_vm.questionnaire && _vm.questionnaire.length) ? _c('div', {
    staticClass: "props"
  }, [_c('abbr', {
    staticClass: "prop questionnaire",
    attrs: {
      "title": _vm.tokens['tit_quest']
    }
  }, [_vm._v(_vm._s(_vm.correctAnswers))])]) : _vm._e(), _c('div', {
    staticClass: "menu"
  }, [(_vm.textLength) ? [_c('div', {
    staticClass: "navigation"
  }, [_c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_prev']
    }
  }, [_c('button', {
    staticClass: "icon-btn prev",
    class: {
      disabled: !_vm.pageIndex
    },
    on: {
      "click": _vm.prevPage
    }
  })]), _c('div', {
    staticClass: "page"
  }, [_vm._v(_vm._s(_vm.dispPage))]), _c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_next']
    }
  }, [_c('button', {
    staticClass: "icon-btn next",
    class: {
      disabled: _vm.pageIndex === _vm.textLength - 1
    },
    on: {
      "click": _vm.nextPage
    }
  })])]), _c('div', {
    staticClass: "separator"
  })] : _vm._e(), (_vm.showOptionsButton) ? [_c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_settings']
    }
  }, [_c('button', {
    staticClass: "icon-btn settings",
    on: {
      "click": _vm.showOptions
    }
  })]), _c('div', {
    staticClass: "separator"
  })] : _vm._e(), _c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_close']
    }
  }, [_c('button', {
    staticClass: "icon-btn close",
    on: {
      "click": _vm.close
    }
  })])], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "classes"
    }
  }, [_c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['classes']))]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.classes === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['tasks']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['students']))])])]), _c('tbody', _vm._l((_vm.classes), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('div', {
      staticClass: "title is-4 no-wrapping"
    }, [_vm._v(_vm._s(item.name))]), _c('button', {
      staticClass: "button is-danger",
      attrs: {
        "title": _vm.tokens['tit_delete_class']
      },
      on: {
        "click": function($event) {
          _vm.removeClass(item)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])]), _c('td', [_c('task-list', {
      attrs: {
        "cls": item,
        "intros": _vm.intros
      },
      on: {
        "saved": _vm.taskSaved,
        "created": _vm.taskCreated,
        "deleted": _vm.taskDeleted
      }
    })], 1), _c('td', [_c('student-list', {
      attrs: {
        "cls": item,
        "teacher": _vm.teacher,
        "refresh": _vm.refreshStudents
      }
    })], 1)])
  }))])])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_new']))]), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "field control"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.newName.length && !_vm.canCreate
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['name']
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newName.length && !_vm.canCreate),
      expression: "newName.length && !canCreate"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['name_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canCreate
    },
    on: {
      "click": _vm.tryToCreate
    }
  }, [_vm._v(_vm._s(_vm.tokens['create']))])])])])]), (_vm.toDelete) ? _c('remove-warning', {
    attrs: {
      "object": "class",
      "name": _vm.toDeleteName
    },
    on: {
      "close": _vm.removeWarningClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "start-page"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isConnected),
      expression: "isConnected"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content is-large"
  }, _vm._l((_vm.startInstruction), function(line) {
    return _c('p', [_vm._v(_vm._s(line))])
  })), _c('button', {
    staticClass: "button is-large is-primary",
    attrs: {
      "disabled": !_vm.isCalibrated
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v(_vm._s(_vm.tokens['start']))]), _c('button', {
    staticClass: "button is-large",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])])]), _c('div', {
    ref: "fullscreen",
    staticClass: "fullscreen"
  }, [(_vm.isRunning) ? _c('task-page', {
    attrs: {
      "texts": _vm.texts,
      "task": _vm.task,
      "student": _vm.student,
      "finilize": _vm.finilizeTask
    },
    on: {
      "finished": _vm.finishedReading,
      "saved": _vm.gazeDataSaved
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFullscreen && !_vm.isRunning),
      expression: "isFullscreen && !isRunning"
    }],
    staticClass: "container tracking-lost-error-container"
  }, [_c('div', {
    staticClass: "message is-danger tracking-lost-error"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_tracking_lost']))])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCalibrated),
      expression: "!isCalibrated"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_tracker_not_calibrated']))])]), _c('article', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_calib_window_not_visible']))])])])])
},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "teachers"
    }
  }, [_c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_new']))]), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "field control"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.newName.length && !_vm.isNewNameValid
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['name']
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newName.length && !_vm.isNewNameValid),
      expression: "newName.length && !isNewNameValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['name_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.newEmail.length && !_vm.isNewEmailValid
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.tokens['email']
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newEmail.length && !_vm.isNewEmailValid),
      expression: "newEmail.length && !isNewEmailValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['email_invalid']))]), (_vm.isAdmin) ? _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSchool),
      expression: "newSchool"
    }],
    attrs: {
      "required": "required"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newSchool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled",
      "selected": "selected",
      "hidden": "hidden"
    }
  }, [_vm._v(_vm._s(_vm.tokens['school']))]), _vm._l((_vm.schoolItems), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  })], 2)])]) : _vm._e(), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canCreate
    },
    on: {
      "click": _vm.tryToCreate
    }
  }, [_vm._v(_vm._s(_vm.tokens['create']))])])])])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['teachers']))]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.teachers === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.teachers.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_teachers']))])]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), (_vm.isAdmin) ? _c('th', [_vm._v(_vm._s(_vm.tokens['school']))]) : _vm._e(), (!_vm.isAdmin) ? _c('th', [_vm._v(_vm._s(_vm.tokens['classes']))]) : _vm._e()])]), _c('tbody', _vm._l((_vm.teachers), function(teacher) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(teacher.name))]), (_vm.isAdmin) ? _c('td', [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      domProps: {
        "value": teacher.school
      },
      on: {
        "input": function($event) {
          _vm.moveTeacher(teacher, $event)
        }
      }
    }, _vm._l((_vm.schools), function(school) {
      return _c('option', {
        domProps: {
          "value": school.id
        }
      }, [_vm._v(_vm._s(school.name))])
    }))])]) : _vm._e(), (!_vm.isAdmin) ? _c('td', [_c('span', {
      staticClass: "ellipsis"
    }, [_vm._v(_vm._s(_vm.getListOfTeacherClasses(teacher)))])]) : _vm._e()])
  }))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      'is-active': !!_vm.text
    },
    attrs: {
      "id": "modal-error"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "notification is-danger"
  }, [_c('div', {
    staticClass: "heading has-text-centered"
  }, [_vm._v(_vm._s(_vm.tokens['title']))]), _c('div', {
    staticClass: "has-text-centered"
  }, [_vm._v(_vm._s(_vm.text))])])]), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.close
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "schools"
    }
  }, [_c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("New school")]), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "field control"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canCreate
    },
    on: {
      "click": _vm.tryToCreate
    }
  }, [_vm._v("Create")])])])])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("Schools")]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.schools === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.schools.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v("No school exists yet")])]) : _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.schools), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _c('td', [_vm._v(_vm._s(_vm._f("count")(item.teachers)))]), _c('td', [_vm._v(_vm._s(_vm._f("count")(item.students)))])])
  }))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _c('th', [_vm._v("Teachers")]), _c('th', [_vm._v("Students")])])])
}]}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "students"
    }
  }, [_c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_new']))]), _c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "field control"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.newName.length && !_vm.isNewNameValid
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['name']
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newName.length && !_vm.isNewNameValid),
      expression: "newName.length && !isNewNameValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['name_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.newEmail.length && !_vm.isNewEmailValid
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.tokens['email_id']
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newEmail.length && !_vm.isNewEmailValid),
      expression: "newEmail.length && !isNewEmailValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['email_invalid']))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRealEmail),
      expression: "!isRealEmail"
    }],
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.newPassword.length && !_vm.isNewPasswordValid
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['password']
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newPassword.length && !_vm.isNewPasswordValid),
      expression: "newPassword.length && !isNewPasswordValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['password_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGrade),
      expression: "newGrade"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['grade']
    },
    domProps: {
      "value": (_vm.newGrade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newGrade = $event.target.value
      }
    }
  })]), (_vm.isAdmin) ? _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSchool),
      expression: "newSchool"
    }],
    attrs: {
      "required": "required"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newSchool = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled",
      "selected": "selected",
      "hidden": "hidden"
    }
  }, [_vm._v(_vm._s(_vm.tokens['school']))]), _vm._l((_vm.schoolItems), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))])
  })], 2)])]) : _vm._e(), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canCreateStudent
    },
    on: {
      "click": _vm.tryToCreateStudent
    }
  }, [_vm._v(_vm._s(_vm.tokens['create']))])])])])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['students']))]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.students === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.students.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_students']))])]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), (_vm.isAdmin) ? _c('th', [_vm._v(_vm._s(_vm.tokens['school']))]) : _vm._e(), _c('th', [_vm._v(_vm._s(_vm.tokens['grade']))]), (!_vm.isAdmin) ? _c('th', [_vm._v(_vm._s(_vm.tokens['classes']))]) : _vm._e(), (_vm.isAdmin) ? _c('th', [_c('div', {
    staticClass: "is-pulled-right"
  }, [_vm._v(_vm._s(_vm.tokens['actions']))])]) : _vm._e()])]), _c('tbody', _vm._l((_vm.students), function(student) {
    return (!student.deleted) ? _c('tr', [_c('td', [_vm._v(_vm._s(student.name))]), (_vm.isAdmin) ? _c('td', [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      domProps: {
        "value": student.school
      },
      on: {
        "input": function($event) {
          _vm.moveStudent(student, $event)
        }
      }
    }, _vm._l((_vm.schools), function(school) {
      return _c('option', {
        domProps: {
          "value": school.id
        }
      }, [_vm._v(_vm._s(school.name))])
    }))])]) : _vm._e(), _c('td', [_vm._v(_vm._s(student.grade))]), (!_vm.isAdmin) ? _c('td', [_c('span', {
      staticClass: "ellipsis"
    }, [_vm._v(_vm._s(_vm.getListOfStudentClasses(student)))])]) : _vm._e(), (_vm.isAdmin) ? _c('td', {
      staticClass: "is-narrow"
    }, [_c('button', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          _vm.remove(student)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])]) : _vm._e()]) : _vm._e()
  }))])])]), (_vm.toDelete) ? _c('remove-warning', {
    attrs: {
      "object": "student",
      "name": _vm.toDeleteName
    },
    on: {
      "close": _vm.removeWarningClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-editor-questionnaire"
    }
  }, [_c('nav', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-block"
  }, [_c('div', {
    staticClass: "field control"
  }, [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "columns is-inlined"
  }, [_c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "control-line"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_for']))]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(_vm.tokens[("item_" + (item.name))]))])
  }))])]), _c('div', {
    staticClass: "column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.word),
      expression: "word"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.type === _vm.types.word),
      expression: "type === types.word"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['ph_word']
    },
    domProps: {
      "value": (_vm.word)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.word = $event.target.value
      }
    }
  })])]), _c('p'), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question),
      expression: "question"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['ph_question']
    },
    domProps: {
      "value": (_vm.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.question = $event.target.value
      }
    }
  })]), _c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "columns is-inlined"
  }, _vm._l((_vm.answers), function(answer) {
    return _c('div', {
      staticClass: "column"
    }, [_c('p', {
      staticClass: "control has-icon"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (answer.text),
        expression: "answer.text"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": _vm.tokens['ph_answer']
      },
      domProps: {
        "value": (answer.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(answer, "text", $event.target.value)
        }
      }
    }), (answer.text) ? [(!answer.isCorrect) ? _c('span', {
      staticClass: "icon is-small is-left checkbox"
    }, [_c('i', {
      staticClass: "fa fa-check",
      on: {
        "click": function($event) {
          _vm.selectCorrect(answer)
        }
      }
    })]) : _c('span', {
      staticClass: "icon is-small is-left checkbox is-success"
    }, [_c('i', {
      staticClass: "fa fa-check-circle",
      on: {
        "click": function($event) {
          _vm.selectCorrect(answer)
        }
      }
    })])] : _vm._e()], 2)])
  })), _c('p'), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canAdd
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.tokens['add']))])])])]), _c('div', {
    staticClass: "panel-block questions is-paddingless"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.questions), function(question) {
    return _c('tr', {
      key: question.question
    }, [_c('td', {
      staticClass: "is-narrow"
    }, [(question.type === 'word') ? [_c('p', {
      staticClass: "word is-inline-block"
    }, [_vm._v(_vm._s(question.word))])] : [_c('div', {
      staticClass: "heading is-inline-block"
    }, [_vm._v(_vm._s(_vm.tokens[("lbl_" + (question.type))]))])]], 2), _c('td', [_c('span', {
      staticClass: "is-inline-block"
    }, [_vm._v(_vm._s(question.question))]), _c('i', {
      staticClass: "is-inline-block is-pulled-right answers"
    }, _vm._l((question.answers), function(answer) {
      return _c('span', {
        staticClass: "answer",
        class: {
          'is-correct': answer.isCorrect
        }
      }, [_vm._v(_vm._s(answer.text))])
    }))]), _c('td', {
      staticClass: "is-narrow"
    }, [_c('button', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          _vm.remove(question)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])
  }))])])])])
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "word-replay"
    }
  }, [_c('div', {
    ref: "root",
    staticClass: "list"
  }, [_c('table', {
    ref: "table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._l((_vm.data.records), function(record) {
    return _c('th', [_vm._v(_vm._s(record.student.name))])
  })], 2)]), _c('tbody', _vm._l((_vm.words), function(word) {
    return _c('tr', {
      key: word.key
    }, [_c('td', {
      staticClass: "word"
    }, [_vm._v(_vm._s(word.text))]), _vm._l((word.durations), function(duration, index) {
      return _c('td', {
        staticClass: "duration",
        class: {
          'is-danger': _vm.hasNoData(index)
        }
      })
    })], 2)
  })), _c('tfoot', [_c('tr', [_c('td'), _vm._l((_vm.tracks), function(track) {
    return _c('td', [_c('span', {
      class: {
        hidden: track.pointer
      }
    }, [_vm._v(_vm._s(track.doneMessage))])])
  })], 2)])])]), _c('control-panel', {
    attrs: {
      "title": _vm.title,
      "feedback": null,
      "text-length": _vm.textLength,
      "initial-page-index": _vm.initialPageIndex,
      "options": _vm.options,
      "show-player": true,
      "is-player-paused": _vm.isPlayerPaused
    },
    on: {
      "page-changed": _vm.setPage,
      "show-options": _vm.showOptions,
      "restart-player": _vm.restartPlayer,
      "toggle-player": _vm.togglePlayer,
      "close": _vm.close
    }
  }), _c('options', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOptionsDisplayed),
      expression: "isOptionsDisplayed"
    }],
    attrs: {
      "values": _vm.options
    },
    on: {
      "close": _vm.closeOptions,
      "apply": _vm.applyOptions
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "vis-durations"
    }
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.words), function(word) {
    return _c('div', {
      staticClass: "record"
    }, [_c('div', {
      staticClass: "word"
    }, [_vm._v(_vm._s(word.text))]), _c('div', {
      staticClass: "duration"
    }, [_vm._v(_vm._s(word.value))])])
  })), _c('control-panel', {
    attrs: {
      "title": _vm.title,
      "feedback": _vm.feedback,
      "text-length": _vm.textLength,
      "initial-page-index": _vm.initialPageIndex,
      "options": _vm.options
    },
    on: {
      "page-changed": _vm.setPage,
      "show-options": _vm.showOptions,
      "close": _vm.close
    }
  }), _c('options', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOptionsDisplayed),
      expression: "isOptionsDisplayed"
    }],
    attrs: {
      "values": _vm.options
    },
    on: {
      "close": _vm.closeOptions,
      "apply": _vm.applyOptions
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "temporal-notification"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showState) ? _c('div', {
    staticClass: "modal on-top is-active"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "notification has-text-centered is-rounded",
    class: _vm.notificationClass
  }, [_vm._t("default")], 2)])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoggedIn),
      expression: "isLoggedIn"
    }]
  }), _c('section', {
    staticClass: "section is-paddingless"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-images"
    }
  }, _vm._l((_vm.imageProps), function(props) {
    return _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasImageAt(props)),
        expression: "hasImageAt( props )"
      }],
      staticClass: "image",
      class: _vm.getClass(props),
      style: (_vm.getStyle(props)),
      attrs: {
        "src": _vm.getSource(props)
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "questionnaire-results"
    }
  }, [(_vm.questionnaire) ? _c('div', {
    staticClass: "list"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), _c('th', {
    staticClass: "is-narrow"
  }, [_vm._v(_vm._s(_vm.tokens['date']))]), _vm._l((_vm.questionnaire.questions), function(question) {
    return _c('th', [_vm._v(_vm._s(question))])
  }), _c('th', {
    staticClass: "is-narrow"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_total']))])], 2)]), _c('tbody', _vm._l((_vm.questionnaire.sessions), function(answers, id) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("name")(id)))]), _c('td', {
      staticClass: "is-narrow"
    }, [_vm._v(_vm._s(_vm._f("date")(id)))]), _vm._l((_vm.questionnaire.questions), function(question) {
      return _c('td', {
        staticClass: "is-paddingless"
      }, [_c('div', {
        staticClass: "answer",
        class: _vm.getAnswerClass(answers, question)
      }, [_vm._v(_vm._s(_vm.getAnswerText(answers, question)))])])
    }), _c('td', {
      staticClass: "is-narrow"
    }, [_c('div', {
      staticClass: "total"
    }, [_vm._v(_vm._s(_vm.getTotal(answers)))])])], 2)
  }))])]) : _vm._e(), _c('control-panel', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": _vm.close
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-editor"
    }
  }, [_c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab, id) {
    return _c('li', {
      key: id,
      class: {
        'is-active': _vm.isCurrentTab(tab)
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectTab(tab)
        }
      }
    }, [_vm._v(_vm._s(_vm.tokens[tab.name.toLowerCase()]))])])
  }))]), _c('div', {
    staticClass: "field expand"
  }, [_c('task-editor-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.text),
      expression: "currentTab === tabs.text"
    }],
    attrs: {
      "task": _vm.ref,
      "intros": _vm.intros,
      "is-name-editable": _vm.isTaskNameEditable,
      "is-cloning": _vm.isCloningTask
    },
    on: {
      "input": _vm.setTextInput
    }
  }), _c('task-editor-feedback', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.feedback),
      expression: "currentTab === tabs.feedback"
    }],
    attrs: {
      "task": _vm.ref
    },
    on: {
      "input": _vm.setFeedbackInput
    }
  }), _c('task-editor-images', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.images),
      expression: "currentTab === tabs.images"
    }],
    attrs: {
      "task": _vm.ref,
      "current-text": _vm.text
    },
    on: {
      "input": _vm.setImagesInput,
      "editing": function($event) {
        _vm.onImageEditing($event)
      }
    }
  }), _c('task-editor-questionnaire', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.questionnaire),
      expression: "currentTab === tabs.questionnaire"
    }],
    attrs: {
      "task": _vm.ref
    },
    on: {
      "input": _vm.setQuestionnaireInput
    }
  })], 1), _c('p', {
    staticClass: "control bottom-panel"
  }, [_c('span', {
    staticClass: "is-inline-block"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.action))]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab === _vm.tabs.feedback),
      expression: "currentTab === tabs.feedback"
    }],
    staticClass: "button stacked",
    on: {
      "click": _vm.setDefaultFeedback
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_set_default']))]), _c('span', {
    staticClass: "is-inline-block stacked"
  }, [_c('bulma-checkbox', {
    staticClass: "is-inline-block",
    attrs: {
      "label": _vm.tokens['lbl_use_timeout'],
      "disabled": false
    },
    model: {
      value: (_vm.useTimeout),
      callback: function($$v) {
        _vm.useTimeout = $$v
      },
      expression: "useTimeout"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.timeout),
      expression: "timeout",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input is-inline-block timeout",
    attrs: {
      "type": "number",
      "step": "1",
      "disabled": !_vm.useTimeout,
      "min": "1",
      "max": "1000"
    },
    domProps: {
      "value": (_vm.timeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.timeout = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.tokens['lbl_minute']))])], 1), _c('span', {
    staticClass: "is-inline-block stacked"
  }, [_c('bulma-checkbox', {
    staticClass: "is-inline-block",
    attrs: {
      "label": _vm.tokens['lbl_record_audio']
    },
    model: {
      value: (_vm.recordAudio),
      callback: function($$v) {
        _vm.recordAudio = $$v
      },
      expression: "recordAudio"
    }
  })], 1)]), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canPreview
    },
    on: {
      "click": _vm.preview
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_preview']))])]), _c('div', {
    ref: "fullscreen",
    staticClass: "fullscreen"
  }, [(_vm.inPreview) ? _c('task-preview', {
    attrs: {
      "task": _vm.getCurrentTask()
    },
    on: {
      "close": _vm.closePreview
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "finished-page"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "button is-large is-primary",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_thanks']))])])])])
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "session-edit-box"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.student.sessions), function(session) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "name is-inline-block"
    }, [_vm._v(_vm._s(_vm.sessionToString(session)))])]), _c('td', [_c('button', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          _vm.showDeleteWarning(session)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))]), (_vm.sessionToDelete) ? _c('remove-warning', {
    attrs: {
      "object": "session",
      "name": _vm.toDeleteName
    },
    on: {
      "close": _vm.removeWarningClosed
    }
  }) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "item-select-box"
    }
  }, [(_vm.items.length > 0) ? _c('header', {
    staticClass: "tabs is-centered is-boxed"
  }, [_c('ul', {
    staticClass: "ul"
  }, _vm._l((_vm.items), function(item) {
    return (_vm.items.length > 1) ? _c('li', {
      key: item.id,
      class: {
        'is-active': _vm.isItemSelected(item)
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectItem(item)
        }
      }
    }, [_vm._v(_vm._s(item.text))])]) : _vm._e()
  }))]) : _vm._e(), _c('main', {
    staticClass: "subitems"
  }, [(!_vm.isItemSelected()) ? _c('div', {
    staticClass: "has-text-centered"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['lbl_select'](_vm.itemName)))])]) : _vm._e(), (_vm.currentItem) ? _c('div', [_vm._l((_vm.groups), function(group, name) {
    return (group.items.length) ? _c('article', {
      key: name,
      staticClass: "message is-primary group"
    }, [(name !== '_') ? _c('div', {
      staticClass: "message-header",
      on: {
        "click": function($event) {
          _vm.toggleItemsVisibility(group)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(name))])]) : _vm._e(), _c('div', {
      staticClass: "message-body is-paddingless"
    }, _vm._l((group.items), function(subitem, index) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.isGroupVisible(group)),
          expression: "isGroupVisible( group )"
        }],
        key: subitem.id,
        staticClass: "card subitem",
        class: {
          'is-selected': subitem.selected
        }
      }, [_c('div', {
        staticClass: "card-content",
        on: {
          "click": function($event) {
            _vm.selectSubitem(subitem, index, $event)
          }
        }
      }, [_vm._v(_vm._s(subitem.text))])])
    }))]) : _vm._e()
  }), (!_vm.hasSubitems(_vm.currentItem)) ? _c('div', {
    staticClass: "has-text-centered"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['lbl_no_avail'](_vm.subitemName)))])]) : _vm._e()], 2) : _vm._e()]), _c('footer', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.hasItemsSelected
    },
    on: {
      "click": _vm.accept
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_select']))])]), _c('div', {
    staticClass: "level-item"
  })]), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [(_vm.multiple && !_vm.singleGroup) ? _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.hasSubitems()
    },
    on: {
      "click": _vm.selectAllSubitems
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_select_all']))]) : _vm._e()]), _c('div', {
    staticClass: "level-item"
  }, [(_vm.multiple) ? _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.hasSubitems()
    },
    on: {
      "click": _vm.removeAllSubitems
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_remove_all']))]) : _vm._e()])])]), _c('p')])])
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section",
    attrs: {
      "id": "assignments"
    }
  }, [(_vm.student && _vm.student.deleted) ? _c('article', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.tokens['msg_removed_account']))])]) : _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_assignments']))]), _c('div', {
    staticClass: "panel-block"
  }, [(_vm.assignments === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.assignments.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_assignments']))])]) : _c('div', {
    staticClass: "tile is-ancestor"
  }, _vm._l((_vm.assignments), function(assignment) {
    return _c('div', {
      staticClass: "tile is-parent"
    }, [_c('div', {
      staticClass: "tile is-child"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('header', {
      staticClass: "card-header notification is-info is-paddingless"
    }, [_c('div', {
      staticClass: "card-header-title"
    }, [_vm._v(_vm._s(assignment.cls.name))]), _c('div', {
      staticClass: "card-header-icon"
    }, [(assignment.task.syllab.language) ? _c('span', {
      staticClass: "icon",
      attrs: {
        "title": _vm.tokens['tit_syllab']
      }
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-h"
    })]) : _vm._e(), (assignment.task.speech.language) ? _c('span', {
      staticClass: "icon",
      attrs: {
        "title": _vm.tokens['tit_voice']
      }
    }, [_c('i', {
      staticClass: "fa fa-headphones"
    })]) : _vm._e(), (assignment.task.recordAudio) ? _c('span', {
      staticClass: "icon",
      attrs: {
        "title": _vm.tokens['tit_rec']
      }
    }, [_c('i', {
      staticClass: "fa fa-microphone"
    })]) : _vm._e()])]), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(assignment.task.name))])]), _c('div', {
      staticClass: "card-footer"
    }, [_c('a', {
      staticClass: "card-footer-item",
      on: {
        "click": function($event) {
          _vm.start(assignment)
        }
      }
    }, [_vm._v(_vm._s(_vm.tokens['start']))])])])])])
  }))])]), _c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_completed']))]), _c('div', {
    staticClass: "panel-block"
  }, [(_vm.sessions === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : (!_vm.sessions.length) ? _c('div', {
    staticClass: "container"
  }, [_c('i', [_vm._v(_vm._s(_vm.tokens['msg_no_completed']) + " ")])]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.tokens['class']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['task']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['hdr_wpm']))]), _c('th', [_vm._v(_vm._s(_vm.tokens['date']))])])]), _c('tbody', _vm._l((_vm.sessions), function(session) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(session.cls.name))]), _c('td', [_vm._v(_vm._s(session.task.name))]), _c('td', [_vm._v(_vm._s(_vm.getWPM(session.data)))]), _c('td', [_vm._v(_vm._s(_vm._f("prettifyDate")(session.session.date)))])])
  }))])])]), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "feedback-editor"
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.header))])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [(_vm.languages) ? _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.language),
      expression: "language"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_none']))]), _vm._l((_vm.languages), function(lang) {
    return _c('option', {
      domProps: {
        "value": lang
      }
    }, [_vm._v(_vm._s(lang))])
  })], 2)]) : _c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_enabled']
    },
    model: {
      value: (_vm.enabled),
      callback: function($$v) {
        _vm.enabled = $$v
      },
      expression: "enabled"
    }
  }), _vm._t("first")], 2), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thresholdIsSmart),
      expression: "thresholdIsSmart"
    }],
    attrs: {
      "disabled": !_vm.isEnabled || !_vm.hasThresholdOptions
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.thresholdIsSmart = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_fixed']))]), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_calib']))])])]), (_vm.thresholdIsSmart) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.thresholdMin),
      expression: "thresholdMin",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "100",
      "disabled": !_vm.canEditCalibThresholdParams,
      "min": "1000",
      "max": _vm.thresholdMax
    },
    domProps: {
      "value": (_vm.thresholdMin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thresholdMin = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "control-line"
  }, [_vm._v("-")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.thresholdMax),
      expression: "thresholdMax",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "100",
      "disabled": !_vm.canEditCalibThresholdParams,
      "max": "5000",
      "min": _vm.thresholdMin
    },
    domProps: {
      "value": (_vm.thresholdMax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thresholdMax = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "control-line"
  }, [_vm._v("ms")])] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.thresholdValue),
      expression: "thresholdValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "100",
      "disabled": !_vm.isEnabled
    },
    domProps: {
      "value": (_vm.thresholdValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thresholdValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "control-line"
  }, [_vm._v("ms")])], _vm._t("second")], 2), _c('div', {
    staticClass: "field is-horizontal"
  }, [_vm._t("default")], 2), _c('p')])
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "remove-warning"
    }
  }, [_c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-content"
  }, [_c('article', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_c('p', [_vm._v(_vm._s(_vm.tokens['header'](_vm.object)) + ".")]), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.reject
    }
  })]), _c('div', {
    staticClass: "message-body"
  }, [_c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('span', [_c('span', [_vm._v(_vm._s(_vm.tokens['warning'](_vm.object, _vm.name)) + ". ")]), _vm._t("default"), _c('span', [_vm._v(_vm._s(_vm.tokens['continue']))])], 2)])]), _c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.tokens['ok']))]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.reject
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])])])])])])])])
},staticRenderFns: []}

/***/ })
],[225]);


// WEBPACK FOOTER //
// static/js/app.1ec692a149a85251f72a.js